webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



//import axios from 'axios'
//import {API_BASE} from '../config'

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        //heroku
        // this.apiToken = '$2y$10$7ucEJMDN7gIUjT3ekVDGHOuhX8ANfDOaVfV5vjE3lTO4LlWPhg9ua';
        // this.market_app_name = "gw_melon";
        //used 
        // this.apiToken = '$2y$10$0JXSvkSvP1hPKTheUBvQcewPYjl2Q0wZmhMuCdPhNJPhqFZ.stKo2';
        // this.market_app_name = "ntm_melon"; 
        //used
        this.apiToken = '$2y$10$0JXSvkSvP1hPKTheUBvQcewPYjl2Q0wZmhMuCdPhNJPhqFZ.stKo2';
        // this.market_app_name = "lookbookgallery"; 
        this.market_app_name = "stanelworld";
        this.app_url = "https://lookbookgallery.com";
        this.app_name = "Stanel World";
        // this.app_name = "Lookbook Gallery";
        this.sp_url = "https://wspk.herokuapp.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';
        this.video_exts = ['mp4', 'mp3'];
        this.general_banner_image = "/static/assets/images/banner-general.jpg";
        this.upload_wait_period = 60000; //40sec 
        this.max_media_upload = "7MB"; //40sec 
        //heroku
        // this.baseURL = 'https://spap.herokuapp.com/';
        // this.baseURL = 'https://spap.afiahub.com/api/';
        this.baseURL = 'https://spattle.afiahub.com/api/';
        //cloud files
        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';
    }

    //settings


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "formatCurrency",
        value: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", ""); //if sign showing as in Edge browser
            currency = currency.replace("NGN", ""); //strip off NGN
            return currency;
        }
        //------data services
        //get states

    }, {
        key: "getStates",
        value: function getStates(context, id) {
            return context.$http.get(this.baseURL + 'states', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get cities

    }, {
        key: "getCities",
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        ///----business-market-app-services

        //users

        // User registration

    }, {
        key: "regUser",
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        // Loging in user

    }, {
        key: "loginUser",
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //

    }, {
        key: "activateUserToken",
        value: function activateUserToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/activate/user/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //forgot password

    }, {
        key: "forgotPassword",
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //verify reset password token

    }, {
        key: "verifyResetPasswordToken",
        value: function verifyResetPasswordToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/verify/reset/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //reset forgot password

    }, {
        key: "resetForgotPassword",
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //reset password

    }, {
        key: "resetPassword",
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //change email

    }, {
        key: "changeEmail",
        value: function changeEmail(context, data) {
            return context.$http.post(this.baseURL + 'settings/email/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //session guard
        // sessionGuard(context, data) {
        //     return context.$http.post(this.baseURL + 'auth/sessions', data, {
        //         headers: {
        //             'Origin-Host': this.apiToken
        //         }
        //     });
        // }

        //session-guard-updated

    }, {
        key: "sessionGuard",
        value: function sessionGuard(context, data) {
            //before return check if passed
            //if not call session reauth
            //then return sessoin reauth data
            ///....
            //.....also once called provide or rewrite new session details if success
            //.....provide null or undefined defaults as session details 
            //..///this is to help headers and co pick accurate session details without preseting
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //session sync set

    }, {
        key: "sessionSyncSet",
        value: function sessionSyncSet(context, id) {
            return context.$http.get(this.baseURL + 'auth/sessions/sync/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //session sync

    }, {
        key: "sessionSync",
        value: function sessionSync(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        // Check User details

    }, {
        key: "checkUserDetails",
        value: function checkUserDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/checks', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit user

    }, {
        key: "editProfileDetails",
        value: function editProfileDetails(context, data) {
            return context.$http.put(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //--users

        //post subscriptions request

    }, {
        key: "makeAppSubscriptionOrder",
        value: function makeAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //update

    }, {
        key: "updateAppSubscriptionOrder",
        value: function updateAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //businesses
        //can edit a sellpoint

    }, {
        key: "can_edit",
        value: function can_edit(context, data) {
            return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //get business market

    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //get all users businesses

    }, {
        key: "getBusinesses",
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get all users businesses

    }, {
        key: "getAppBusinesses",
        value: function getAppBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get single business

    }, {
        key: "getBusinessByUserName",
        value: function getBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get single business

    }, {
        key: "getAppBusinessByUserName",
        value: function getAppBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //get business products

    }, {
        key: "getBusinessProducts",
        value: function getBusinessProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessProducts",
        value: function getAppBusinessProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/app/businesses/' + id + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addNewBusiness",
        value: function addNewBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/new', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addExistingBusiness",
        value: function addExistingBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/existing', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //validateUserName

    }, {
        key: "validateBusinessUserName",
        value: function validateBusinessUserName(context, data) {
            return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarketUpgradeDetails",
        value: function getBusinessMarketUpgradeDetails(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/markets/upgrades/' + id, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "upgradeBusinessMarketSubscription",
        value: function upgradeBusinessMarketSubscription(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }

        //get business categories

    }, {
        key: "getCategories",
        value: function getCategories(context) {
            return context.$http.get(this.baseURL + 'categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get main categories in parent

    }, {
        key: "getMainCategories",
        value: function getMainCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/main/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get sub  business categories

    }, {
        key: "getBusinessSubCategories",
        value: function getBusinessSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get business categories

    }, {
        key: "getBusinessCategories",
        value: function getBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addGallery",
        value: function addGallery(context, data) {
            return context.$http.post(this.baseURL + 'posts/gallery', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getPointGalleryPosts",
        value: function getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
            return context.$http.get(this.baseURL + 'posts/gallery/points/' + id + '/' + offset + '/' + limit + '/' + posts_offset + '/' + posts_limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get single gallery with name search

    }, {
        key: "getGallerySearch",
        value: function getGallerySearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/gallery/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Edit business details

    }, {
        key: "editBusinessDetails",
        value: function editBusinessDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //businesses set processing fees options

    }, {
        key: "setShippingFeeStatus",
        value: function setShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Add delivery_option to business

    }, {
        key: "addDeliveryOption",
        value: function addDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Edit DeliveryOptions to business

    }, {
        key: "editDeliveryOption",
        value: function editDeliveryOption(context, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Delete DeliveryOptions to business

    }, {
        key: "deleteDeliveryOption",
        value: function deleteDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //business processing fee switch

    }, {
        key: "switchProcessingFeePay",
        value: function switchProcessingFeePay(context, data) {
            return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get business discounts and coupons

    }, {
        key: "getBusinessDiscountsAndCoupons",
        value: function getBusinessDiscountsAndCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discounts/coupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //set business discounts and coupons

    }, {
        key: "setDiscountsAndCoupons",
        value: function setDiscountsAndCoupons(context, data) {
            return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit business discounts and coupons

    }, {
        key: "editDiscountsAndCoupons",
        value: function editDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //deactivate business discounts and coupons

    }, {
        key: "deactivateDiscountsAndCoupons",
        value: function deactivateDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //businesses

        //products

        //get sproduct images

    }, {
        key: "getProductImages",
        value: function getProductImages(context, id) {
            return context.$http.get(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductImage",
        value: function deleteProductImage(context, id) {
            return context.$http.delete(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //./products
        //uploads
        //Upload Image

    }, {
        key: "uploadDataPhoto",
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }

        //Upload Business Images

    }, {
        key: "uploadBusinessDataPhoto",
        value: function uploadBusinessDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'businesses/uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
        //..uploads


        ////--------gw-services


        //get single user

    }, {
        key: "getUser",
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //businesses local 

    }, {
        key: "getProductsInBusinessCategories",
        value: function getProductsInBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get market categories

    }, {
        key: "getMarketCategories",
        value: function getMarketCategories(context) {
            return context.$http.get(this.baseURL + 'market/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get site filters

    }, {
        key: "getFilters",
        value: function getFilters(context) {
            return context.$http.get(this.baseURL + 'filters', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Add business

    }, {
        key: "addBusiness",
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get business products

    }, {
        key: "getBusinessNotifications",
        value: function getBusinessNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get business messages

    }, {
        key: "getBusinessMessages",
        value: function getBusinessMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //get business orders

    }, {
        key: "getBusinessOrders",
        value: function getBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //read notifications

    }, {
        key: "readNotifications",
        value: function readNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //categories
        //Add category to business

    }, {
        key: "addCategory",
        value: function addCategory(context, data) {
            return context.$http.post(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Edit category to business

    }, {
        key: "editCategory",
        value: function editCategory(context, data) {
            return context.$http.put(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //products calls
        //get products

    }, {
        key: "getProducts",
        value: function getProducts(context, offset, limit) {
            return context.$http.get(this.baseURL + 'products/all/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get market products

    }, {
        key: "getMarketProducts",
        value: function getMarketProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get market activity products

    }, {
        key: "getMarketActivityProducts",
        value: function getMarketActivityProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/activities/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get business market

    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get category products

    }, {
        key: "getCategoryProducts",
        value: function getCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //search category products

    }, {
        key: "searchCategoryProducts",
        value: function searchCategoryProducts(context, name, type) {
            return context.$http.get(this.baseURL + 'products/search/categories/' + name + '/' + type, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //searchproducts

    }, {
        key: "searchProducts",
        value: function searchProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //searchbusinessproducts

    }, {
        key: "searchBusinessProducts",
        value: function searchBusinessProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //get single products with name search

    }, {
        key: "getProductSearch",
        value: function getProductSearch(context, id) {
            return context.$http.get(this.baseURL + 'products/product/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Add products

    }, {
        key: "addProduct",
        value: function addProduct(context, data) {
            return context.$http.post(this.baseURL + 'products', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductItem",
        value: function addProductItem(context, data) {
            return context.$http.post(this.baseURL + 'products/items', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        // Add product details

    }, {
        key: "addProductDetail",
        value: function addProductDetail(context, data) {
            return context.$http.post(this.baseURL + 'products/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }

        // Add product reviews

    }, {
        key: "addProductReview",
        value: function addProductReview(context, data) {
            return context.$http.post(this.baseURL + 'products/reviews', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }

        //edit product

    }, {
        key: "editProduct",
        value: function editProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit product settings

    }, {
        key: "editProductSettings",
        value: function editProductSettings(context, id, data) {
            return context.$http.put(this.baseURL + 'products/settings/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit product item single

    }, {
        key: "editProductItemSingle",
        value: function editProductItemSingle(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/singles/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit product item

    }, {
        key: "editProductItem",
        value: function editProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //remove product item

    }, {
        key: "removeProductItem",
        value: function removeProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit product item group

    }, {
        key: "editProductItemGroup",
        value: function editProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //remove product item group

    }, {
        key: "removeProductItemGroup",
        value: function removeProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //remove product item

    }, {
        key: "removeProduct",
        value: function removeProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit product info
        // editProductInformation(context, data) {
        //     return context.$http.put(this.baseURL + 'products/information', data, {
        //          headers: {
        //            'Origin-Host': this.apiToken
        //         }
        //     });
        // }

        //

    }, {
        key: "editProductDetail",
        value: function editProductDetail(context, id, data) {
            return context.$http.put(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //delete product detail

    }, {
        key: "deleteProductDetail",
        value: function deleteProductDetail(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get product delivey

    }, {
        key: "getProductDeliveryOptions",
        value: function getProductDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'products/delivery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //product delivery

    }, {
        key: "setProductDelivery",
        value: function setProductDelivery(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductShippingFeeStatus",
        value: function setProductShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Set Product Delivery Options 

    }, {
        key: "setProductDeliveryOption",
        value: function setProductDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //product info

    }, {
        key: "getProductInformation",
        value: function getProductInformation(context, id) {
            return context.$http.get(this.baseURL + 'products/information/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //add product info

    }, {
        key: "addProductInformation",
        value: function addProductInformation(context, data) {
            return context.$http.post(this.baseURL + 'products/information', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
        //

    }, {
        key: "editProductInformation",
        value: function editProductInformation(context, id, data) {
            return context.$http.put(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //delete product detail

    }, {
        key: "deleteProductInformation",
        value: function deleteProductInformation(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //./product info

        //gallery info
        //edit gallery

    }, {
        key: "editGallery",
        value: function editGallery(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //delete gallery

    }, {
        key: "deleteGallery",
        value: function deleteGallery(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //edit gallery post

    }, {
        key: "editGalleryPost",
        value: function editGalleryPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //delete gallery post

    }, {
        key: "deleteGalleryPost",
        value: function deleteGalleryPost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //./posts
        //./gallery info

        //reset

    }, {
        key: "resetData",
        value: function resetData(context, type, id) {
            return context.$http.get(this.baseURL + 'data/reset/' + type + '/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteImages",
        value: function deleteImages(context, id, data) {
            return context.$http.put(this.baseURL + 'data/images/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //checkout

    }, {
        key: "checkout",
        value: function checkout(context, data) {
            return context.$http.post(this.baseURL + 'orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //checkout orders

    }, {
        key: "getCheckoutOrder",
        value: function getCheckoutOrder(context, url) {
            return context.$http.get(this.baseURL + 'orders/url/' + url, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //checkout orders

    }, {
        key: "getCheckoutOrders",
        value: function getCheckoutOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/topays/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //checkout orders

    }, {
        key: "getUserDeliveryDetails",
        value: function getUserDeliveryDetails(context, id) {
            return context.$http.get(this.baseURL + 'users/deliverydetails/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //update

    }, {
        key: "updatePayment",
        value: function updatePayment(context, data) {
            return context.$http.post(this.baseURL + 'payments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //get orders

    }, {
        key: "getOrders",
        value: function getOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //services
        //Add service to business

    }, {
        key: "addService",
        value: function addService(context, data) {
            return context.$http.post(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //Edit services to business

    }, {
        key: "editService",
        value: function editService(context, data) {
            return context.$http.put(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //product info

    }, {
        key: "getBusinessDeliveryOptions",
        value: function getBusinessDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'businesses/deliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //product info

    }, {
        key: "checkBusinessPayOnDelivery",
        value: function checkBusinessPayOnDelivery(context, id) {
            return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }

        //business contact form

    }, {
        key: "sendBusinessContactForm",
        value: function sendBusinessContactForm(context, data) {
            return context.$http.post(this.baseURL + 'businesses/contacts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //business filter options

    }, {
        key: "setBusinessFilterOptions",
        value: function setBusinessFilterOptions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeBusinessFilterOption",
        value: function removeBusinessFilterOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
        //business bank details

    }, {
        key: "setBusinessBankDetails",
        value: function setBusinessBankDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e1755e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(121);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e1755e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e1755e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46e8de69_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(123);
function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46e8de69"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46e8de69_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALL_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALL_SELLPOINTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return VIEW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ERROR_MSG; });
/* unused harmony export SUCCESS_MSG */
var ALL_SELLPOINTS = 'ALL_SELLPOINTS';
var ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS';

var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var VIEW_CART = 'VIEW_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = 'SUCCESS_MSG';

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rightsidebar_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c67e86e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rightsidebar_vue__ = __webpack_require__(125);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rightsidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c67e86e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rightsidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftsidebar_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efe307a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftsidebar_vue__ = __webpack_require__(126);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leftsidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efe307a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leftsidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchbox_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff3adca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchbox_vue__ = __webpack_require__(127);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff3adca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    //default validation
    //strings


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validate_array",
        value: function validate_array(str_array, error_msg) {
            var process_errors = [];

            //default testers
            var reg_num = /^[0-9]+$/;
            var reg_name = /^[\w\-\s]+$/;
            var reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var reg_phone = /^\d{4}\d{3}\d{4}$/;

            for (var i = 0; i < str_array.length; i++) {
                //rows
                var arr_in_str_array = str_array[i]; //initialising the individual array row in str_array //row
                // for(var j = 0; j < arr_in_str_array.length; j++) { ///looping through the individual array //columns in row
                if (arr_in_str_array[1] == undefined || arr_in_str_array[1] == "") {
                    process_errors.push(error_msg + arr_in_str_array[0]);

                    //only alpha test
                    if (arr_in_str_array[2] == "alpha") {
                        if (!reg_name.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    //only number test
                    if (arr_in_str_array[2] == "num") {
                        if (!reg_num.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    //email test
                    if (arr_in_str_array[2] == "email") {
                        if (!reg_email.test(String(arr_in_str_array[1]).toLowerCase())) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    //phone test
                    if (arr_in_str_array[2] == "phone") {
                        if (!reg_phone.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    //date test

                    //datetime test

                }

                //tester test
                //display("row[" + i + "][" + j + "] = " + arr_in_str_array[j]);
                // }
            }

            return process_errors;

            // if(item.order_delivery_address == undefined || item.order_delivery_address == ""){
            //     process_errors.push("Please enter delivery address for "+item.product_name);
            // }
            // if(item.order_delivery_name == undefined || item.order_delivery_name == ""){
            //     process_errors.push("Please enter delivery Name for "+item.product_name);
            // }
            // if(item.order_delivery_phone == undefined || item.order_delivery_phone == ""){
            //     process_errors.push("Please enter delivery Phone Number for "+item.product_name);
            // }
            // if(phone_test == false){
            //     process_errors.push("Use format (09077665544) for "+item.product_name+" 's Phone Number ");
            // }
            // if(item.order_delivery_email == undefined || item.order_delivery_email == ""){
            //     process_errors.push("Please enter delivery Email for "+item.product_name);
            // }
            // if(email_test == false){
            //     process_errors.push("Email seems incorrect for "+item.product_name+" 's Email ");
            // }
            // if(item.order_delivery_words == undefined || item.order_delivery_words == ""){
            //     process_errors.push("Please enter delivery Gift Message for "+item.product_name);
            // }
        }
        //for all form validation

        //email

    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        //alphabets names inputs

    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
        //phone number nigeria format

    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }

        //website 

    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            //let re = /^(ftp|http|https):\/\/[^ "]+$/;
            //let re = /^((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/;
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__(51);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778d34f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__(124);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778d34f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemForm_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4fc807_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemForm_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4fc807_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116cbab3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116cbab3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utility__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__ = __webpack_require__(22);
 // Service Class
 // Utility Class
 // Main Header
 // Main Footer





// import Settings from './../../components/tools/settings.vue'; //Settings

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var util = new __WEBPACK_IMPORTED_MODULE_1__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            products: {},
            product: {},
            search_words: "",
            search_type: "business",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__["a" /* default */],
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__["a" /* default */],
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__["a" /* default */],
        'search-box': __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__["a" /* default */]
        // 'c-settings':Settings,
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {
                        //this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                    }
                });
            } else {
                //this.$router.push('login');
            }
        },
        search: function search() {
            this.$router.push("search?search=" + this.search_type + "&k=" + this.search_words);
        },
        setProducts: function setProducts() {
            this.getProducts(0, 20);
        },


        // getProducts(){
        //     let offset = 45; let limit = 20;
        //     service.getProducts(this,offset,limit).then(response => {
        //         if(response.body.status == 200) {
        //             this.products = response.body.data;
        //         }else{
        //             //reloop fake
        //             service.getProducts(this,offset,limit).then(response => {
        //                 if(response.body.status == 200) {
        //                     this.products = response.body.data;
        //                 }
        //             }).catch((err) => {})
        //         }
        //     }).catch((err) => {})

        // },

        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    util.setMarketStoreForage(_this2.market);
                    // util.setBusinessStoreForage(this.sellpoint);
                }
            }).catch(function (err) {
                //maybe no connection ..load from local
                // this.setSellpointLocal(); //removed...caused slower loading
            });
        },
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this3 = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.setMarketRemote();
        this.preset();
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.market_store = 'm1010store';
        // this.business_store = 'm1010store';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'setMarketStoreForage',
        value: function setMarketStoreForage(data) {
            localforage.setItem(this.market_store, data).then(function (value) {
                // Do other things once the value has been saved.
                //console.log(value);
            }).catch(function (err) {
                // This code runs if there were any errors
                // console.log(err);
            });
        }
    }, {
        key: 'setBusinessStoreForage',
        value: function setBusinessStoreForage(data) {
            localforage.setItem(this.business_store, data).then(function (value) {
                // Do other things once the value has been saved.
                //console.log(value);
            }).catch(function (err) {
                // This code runs if there were any errors
                // console.log(err);
            });
        }
    }, {
        key: 'getBusinessStoreForage',
        value: function getBusinessStoreForage() {}
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utility__ = __webpack_require__(48);
 // Service Class
 // Utility Class
// import SettingsLib from './../../components/tools/settings.vue'; // Settings
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var util = new __WEBPACK_IMPORTED_MODULE_1__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            user: '',
            user_slug: {},
            market: {},
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL,
            loggedIn: false
        };
    },

    components: {
        // 'c-settings':SettingsLib,
    },

    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
        setMarketLocal: function setMarketLocal() {
            //quick settings for get store from froage
            var self = this;
            setTimeout(function () {
                localforage.getItem(util.market_store, function (err, value) {
                    self.market = value;
                });
            }, 1500);
        },


        // mountid: (function() { console.log("hy6qdd")
        slide: function slide() {
            console.log("hy6qdd111");
            // "use strict";
            /*-----------------
            MAIN SLIDER
            -----------------*/
            $('.main-slider').bxSlider({
                pagerCustom: '.pager-container',
                controls: false,
                easing: 'ease-in',
                speed: 800,
                auto: true,
                pause: 6000
            });

            /*-------------
                VIDEO
            -------------*/
            $('#video .radial-progress').on('click', function () {
                $('#video > iframe').show();
            });

            /*----------------
                TOOLTIP
            ----------------*/
            $('.tooltip').tooltipster({
                animation: 'grow',
                position: 'bottom'
            });

            /*-----------------
                RESIZE IMAGE
            -----------------*/
            $("figure.imgLiquidFill").imgLiquid();

            /*----------------
                IMAGE POPUP
            ----------------*/
            $('ul.dishes > li > div > a').magnificPopup({
                type: 'image',
                removalDelay: 300,
                mainClass: 'mfp-fade',
                image: {
                    tError: 'The image could not be loaded.'
                },
                closeMarkup: '<span class="mfp-close"></span>'
            });
        }
        // })

    },
    created: function created() {
        // window.addEventListener('load', this.mountid());
        // window.addEventListener('load', this.slide());
        // this.slide();
        this.checkLoggedIn();
        this.setMarketLocal();
    },
    destroyed: function destroyed() {
        //destroy the load event to load all extended javascripts
        // window.removeEventListener('load', this.mountid);
    }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

//import ProductItem from './ProductItem.vue'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-list',
  created: function created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },

  computed: {
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RightSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeftSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            search_words: "",
            search_type: "business"
        };
    },


    methods: {
        search: function search() {
            location.replace("search?search=" + this.search_type + "&k=" + this.search_words);
        }
    }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(17);
 // Service Class
 // Main Header
 // Main Footer



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__["a" /* default */],
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__["a" /* default */],
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__["a" /* default */]
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {
                        //this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                    }
                });
            } else {
                //this.$router.push('login');
            }
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, "nudeberry").then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                    //    this.getProducts();
                }
            }).catch(function (err) {
                //maybe no connection ..load from local
                // this.setSellpointLocal(); //removed...caused slower loading
            });
        }
    },
    created: function created() {
        this.preset();
        this.setMarketRemote();
    }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__ = __webpack_require__(136);
 // Service Class
 // Main Header
 // Main Footer





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Search',
    data: function data() {
        return {
            user: {},
            products: {},
            product: {},
            search_data: "",
            loggedIn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__["a" /* default */],
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__["a" /* default */],
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__["a" /* default */],
        'search-box': __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__["a" /* default */],
        'active-products': __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__["a" /* default */]
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {
                        //this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                    }
                });
            } else {
                //this.$router.push('login');
            }
        },
        getSearchProducts: function getSearchProducts() {
            var _this2 = this;

            service.searchProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this2.products = response.body.data;
                    _this2.search_data = _this2.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getBusinessSearchProducts: function getBusinessSearchProducts() {
            var _this3 = this;

            service.searchBusinessProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.search_data = _this3.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getCategorySearchProducts: function getCategorySearchProducts() {
            var _this4 = this;

            service.searchCategoryProducts(this, this.$route.query.s, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.search_data = response.body.data_search;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.search == "business") {
            this.getBusinessSearchProducts();
        } else if (this.$route.query.search == "product") {
            this.getSearchProducts();
        } else if (this.$route.query.s) {
            this.getCategorySearchProducts();
        }
    }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            products: {}
        };
    },


    methods: {
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__ = __webpack_require__(75);

 // Service Class
 // Main Header
 // Main Footer





var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            place_order: false,
            //boarding_messages:[],
            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            disable_btn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__["a" /* default */],
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__["a" /* default */],
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__["a" /* default */],
        'search-box': __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__["a" /* default */],
        'c-settings': __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__["default"]
    },
    computed: {},
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {
                        //this.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('/login/');
                    }
                });
            } else {
                //this.$router.push('/login/');
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
        },
        toggleFAQComponent: function toggleFAQComponent(action, show, hide, head, body) {
            if (action == 'show') {
                // document.getElementById("faqAction").innerHTML = "-";
                document.getElementById(show).style.display = "none";
                document.getElementById(hide).style.display = "block";
                document.getElementById(head).style.color = "#ff0000";
                document.getElementById(body).style.display = "block";
            }
            if (action == 'hide') {
                // document.getElementById("faqAction").innerHTML = "+";
                document.getElementById(show).style.display = "block";
                document.getElementById(hide).style.display = "==none";
                document.getElementById(head).style.color = "#777b92";
                document.getElementById(body).style.display = "none";
            }
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    //document.title = this.sellpoint.business_name;

                    //get market details
                    _this2.getMarketMainProductsAsSubscriptions();

                    _this2.loading = false;
                }
            }).catch(function (err) {
                //recall this functions till it loads not error(500 and co)
                //  this.getSellpointMarket(); //wrong //call and wait //set timer then call after some minutes //break //report cannot load
                //log it
                //location.replace("/");
                //console.log(err);
                _this2.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this3 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.subscriptions = response.body.data;
                    _this3.plan1 = _this3.subscriptions[2];
                    _this3.plan2 = _this3.subscriptions[1];
                    _this3.plan3 = _this3.subscriptions[0];
                }
            }).catch(function (err) {});
        },
        purchase_plan: function purchase_plan(plan, plan_product_service_item_index) {
            this.loading = true;
            this.selected_plan = plan;
            this.place_order = true;
            //$('#purchaseModal').modal('show');
            // this.$router.push('purchase/?purchase='+plan.product_url_name);
            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan.product_items[0].product_item_price == 0) {
                //free account
                this.updatePayment("gw-free-account");
            } else {
                //proceed to pay
                this.processPayment();
            }

            //test-switch
            // this.updatePayment("reffy");
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        // toastr.warning("Sorry, Sellpoint does not exist on this account", 'Warning!');
                    } else {
                        //all good proceed
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan.product_items[0].product_item_price == 0) {
                            //free account
                            this.updatePayment("gw-free-account");
                        } else {
                            //proceed to pay
                            this.processPayment();
                        }

                        //test-switch
                        // this.updatePayment("reffy");
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                    // toastr.warning("Sorry, Account does not exist", 'Warning!');
                }
            }).catch(function (err) {});
        },


        //connect to a payment gateway
        processPayment: function processPayment() {
            //test data
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                //process online payment
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;
                //this.amount_paid = data.plan_amount;
                var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan.product_items[0].product_item_price * 100), //(data.plan_amount * 100), //in kobo
                    ref: "GWLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },


        // update payments
        updatePayment: function updatePayment(payment_ref) {

            //notify server
            //.......................................

            // var payload = {
            //     payment_order_ref: payment_ref,
            //     payment_user_id: this.user.user_id
            // }
            //.......................................


            var navi = this.$router;
            this.payment_successful = true;
            this.payment_successful_message = "Payment Successful...";

            //set up account on gw
            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this5 = this;

            //register users business to gallery app
            this.disable_btn = true;
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan.product_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this4 = this;

                if (data.body.status == 201) {
                    this.boarding_messages.push("Sellpoint Setup Successful...");
                    //navi.push('/'+this.user.user_business);
                    //log user in
                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            //all good
                            //and ask user for business name to create the sp
                            $('#purchaseModal').modal('hide');
                            navi.push('/' + _this4.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');
                            _this4.disable_btn = false;
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    toastr.warning("Something went wrong", 'Warning!');
                    _this5.disable_btn = false;
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            //create account by registering user
            this.disable_btn = true;
            this.loading = true; //activate loading
            //this.user.agree = true; ///change 
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            //test data
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this6 = this;

                        if (data.body.status == 201) {
                            // toastr.success("Registration Successful", 'Success!');
                            this.data_boarding_message = "Registration Successful...";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    //all good
                                    //reauth and preset to get actual user details
                                    _this6.preset();
                                    //and ask user for business name to create the sp
                                    setTimeout(function () {
                                        this.set_up_business = true;
                                        $('#purchaseModal').modal('hide');
                                        $('#newBusinessModal').modal('show');
                                    }, 3000); //wait for 3sec and c
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    //toastr.warning("invalid login credentials", 'Warning!'); 
                                    _this6.data_error_message = "invalid login credentials..";
                                    _this6.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            this.disable_btn = false;
                        }
                    });
                } else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    this.disable_btn = false;
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this7 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this7.validate_user_name_error = true;
                    _this7.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                //log it
                _this7.validate_user_name_error = true;
                _this7.validate_user_name_message = "This username already exist";
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this8 = this;

            this.resetMessages();
            this.disable_btn = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: this.business.business_view_layout || 3, //gallery
                business_subscription: this.selected_plan.product_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                //  toastr.error('This Username already exists', 'Warning!');
                this.data_error_message = "This Username already exists..";
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            $('#newBusinessModal').modal('hide');
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                        }
                    }).catch(function (err) {
                        if (err) {
                            //  toastr.warning("Something went wrong", 'Warning!'); 
                            _this8.data_error_message = "Something went wrong";
                            _this8.disable_btn = false;
                        }
                    });
                } else {
                    // toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields";
                    this.disable_btn = false;
                }
            }
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        creation_thread: function creation_thread() {
            //promises hub
            var promises = [];
            for (var i = 0; i < 9; ++i) {
                if (i == 1) {
                    promises.push(this.preset());
                }
                if (i == 2) {
                    promises.push(this.getSellpointMarket());
                }
            }

            //process all promises
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                //process one by one to implement wait time
                var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                promises.forEach(function (promise) {
                    //loop through each promise and resolve one after the other
                    result.then(function () {});
                });
            }).catch(function (e) {});
            //..promises hub
        }
    },

    created: function created() {
        var self = this;
        setTimeout(function () {
            //menu routes
            // let menu = self.$route.query.go;
            var menu = self.$route.params.menu;
            if (menu == "features") {
                var top = document.getElementById("features").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "pricing") {
                var top = document.getElementById("pricing").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "blog") {
                var top = document.getElementById("blog").offsetTop;
                window.scrollTo(0, top);
            }
        }, 1500);
        this.creation_thread();
    }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd24f856_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__(169);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd24f856_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 76 */
/***/ (function(module, exports) {

//

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_searchbox_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tools_settings_vue__ = __webpack_require__(75);
 // Service Class
 // Main Header
 // Main Footer





var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            business_service_categories: [],
            business_product_categories: [],
            business_category_type: 0,
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            selected_plan_product_service_item: {},
            upgradable_plans: {},
            upgrade_business: "",
            set_upgrade_plans: false,
            place_order: false,
            //boarding_messages:[],
            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            validate_user_name_message: "",
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            payment_ref: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            setup_error_message: "",
            newBusinessForm: false,
            product_service_items_select: "",
            set_upgrade_plan_process: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__["a" /* default */],
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__["a" /* default */],
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__["a" /* default */],
        'search-box': __WEBPACK_IMPORTED_MODULE_6__components_templates_searchbox_vue__["a" /* default */],
        'c-settings': __WEBPACK_IMPORTED_MODULE_7__components_tools_settings_vue__["default"]
    },
    computed: {},
    methods: {
        setCurrency: function setCurrency(currency) {
            return service.formatCurrency(currency);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
            if (attr1 == 'not-setup-existing') {
                this.set_up_with_existing_account = false;
            }
            if (attr1 == 'show-new-business-form') {
                this.newBusinessForm = true;
            }
            if (attr1 == 'display-product_service_items') {
                //toggle display
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        },
        reset: function reset() {
            this.set_upgrade_plan_process = false;
        },
        toggleDisplayFeatures: function toggleDisplayFeatures() {
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        selectProductServiceItem: function selectProductServiceItem(item) {
            this.selected_plan_product_service_item = item;
        },
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            service.getUser(this, this.user.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user.user_name = data.body.data.user_name;
                                    _this.user.user_email = data.body.data.user_email;
                                    _this.user.user_phone = data.body.data.user_phone;
                                }
                            }).catch(function (err) {});
                            //check for upgrade request
                            if (this.$route.query.upgrade) {
                                this.prepareUpgradePlans();
                            }
                        }, _this2);
                    } else {
                        //this.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('/login/');
                    }
                });
            } else {
                //this.$router.push('/login/');
            }
        },
        setPurchase: function setPurchase() {
            //get the route query
            var query_plan = this.$route.query.purchase; //the subscription product-service
            var query_plan_item = this.$route.query.item; //the actual subscription product-service item array index

            //set the matching plan
            var found = false;
            //loop through subscriptions
            this.subscriptions.forEach(function (element) {
                if (element.product_url_name == query_plan) {
                    this.selected_plan = element;
                    if (query_plan_item != 'n') {
                        // 'n' is a default mark to show no product item assigned
                        if (element.product_items[query_plan_item]) {
                            //check/confirm if array index exists recode later
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        } else {
                            this.selected_plan_product_service_item = element.product_items[0]; //assign ist in array
                        }
                    } else {
                        this.selected_plan_product_service_item = element.product_items[0]; //still assign ist in array
                    }

                    found = true;
                    //disable loading
                    this.loading = false;
                }
            }, this);

            //if noot found
            if (!found) {
                this.setup_error_message = "Something went wrong with your selection, please pick another plan";
            }
            //disable loading
            this.loading = false;
        },
        prepareUpgradePlans: function prepareUpgradePlans() {
            this.loading = true;

            var navi = this.$router;
            service.getBusinessMarketUpgradeDetails(this, this.$route.query.upgrade).then(function (data) {
                this.upgradable_plans = data.body.data;
                this.upgrade_business = this.$route.query.upgrade;
                //set payment details
                this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];
                //
                this.set_upgrade_plans = true;
                this.loading = false;
            });
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this3 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market = response.body.data;
                    //document.title = this.sellpoint.business_name;

                    //get market details
                    _this3.getMarketMainProductsAsSubscriptions();

                    _this3.loading = false;
                }
            }).catch(function (err) {
                //log it
                //location.replace("/");
                //console.log(err);
                _this3.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this4 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.subscriptions = response.body.data;
                    _this4.plan1 = _this4.subscriptions[2];
                    _this4.plan2 = _this4.subscriptions[1];
                    _this4.plan3 = _this4.subscriptions[0];
                }
                //set up route if available
                if (_this4.$route.query.purchase) {
                    _this4.setPurchase();
                }
            }).catch(function (err) {});
        },
        purchase_plan_2: function purchase_plan_2(plan, plan_product_service_item_index) {
            this.loading = true;
            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
            this.setPurchase();
            //srolls to the very top
            var top = document.getElementById("topwrap").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top);
        },
        purchase_plan: function purchase_plan(plan) {
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
        },
        upgrade_plan: function upgrade_plan(plan) {
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
            this.loading = false;
            //show top
            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.selected_plan_product_service_item = {}, this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedUpgradePlan: function proceedUpgradePlan() {
            //loop through plan to get matching price
            var found = false;
            this.selected_plan.product_items_upgrade_details.forEach(function (element) {
                if (this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id) {
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true;
                }
            }, this);

            if (found) {
                //prepare payment details

                //process pay
                this.processPayment();
            }
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.loggedIn) {
                this.processOrder(1);
            } else {
                //create new user's account
                //create account by registering user
                // this.disable_btn = true;
                this.activate_processing();
                var credentials = {
                    user_name: this.payment_payer_name,
                    user_phone: this.payment_payer_phone,
                    user_email: this.payment_payer_email,
                    user_address: '',
                    user_state: '',
                    user_city: '',
                    user_password: this.user.user_password
                };

                var navi = this.$router;

                //test data
                var data_test = false;
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var email_test = re.test(String(this.payment_payer_email).toLowerCase());
                var re_phone = /^\d{4}\d{3}\d{4}$/;
                var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
                if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                    data_test = false;
                    this.data_error_message = "Some errors were found in your form, please fill correctly";
                    this.deactivate_processing();
                } else {
                    data_test = true;
                    this.data_error_message = "";
                }
                if (data_test) {
                    if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                        service.regUser(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                // toastr.success("Registration Successful", 'Success!');
                                this.data_boarding_message = "Registration Successful...";
                                //set user
                                this.user.user_name = this.payment_payer_name;
                                this.user.user_email = this.payment_payer_email;
                                this.user.user_phone = this.payment_payer_phone;
                                //process order
                                this.processOrder(1);
                            } else if (data.body.status == 409) {
                                //toastr.warning("This User is already registered", 'Warning!');
                                this.data_error_message = "This User is already registered..";
                                // this.disable_btn = false;
                                this.deactivate_processing();
                            }
                        });
                    } else {
                        //toastr.error('Kindly fill all fields', 'Warning!');
                        this.data_error_message = "Kindly fill all fields...";
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                }
            }

            //test-switch
            // this.updatePayment("reffy");
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        this.deactivate_processing();
                        // toastr.warning("Sorry, Sellpoint does not exist on this account", 'Warning!');
                    } else {
                        this.data_boarding_message = "Account verified...";
                        //update user's details
                        this.user.user_name = data.body.data.user_name;
                        this.user.user_email = data.body.data.user_email;
                        this.user.user_phone = data.body.data.user_phone;
                        //all good proceed
                        this.processOrder(0);
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                    // toastr.warning("Sorry, Account does not exist", 'Warning!');
                }
            }).catch(function (err) {});
        },
        processOrder: function processOrder(user_status) {
            var _this5 = this;

            //log user in
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password
            };
            service.loginUser(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    localStorage.setItem("sp_token_key", data.user_token_key);

                    //do settings
                    _this5.preset();
                    _this5.data_boarding_message = "Logging you in...";
                }
            }).catch(function (err) {
                if (err.status == 404) {
                    _this5.data_error_message = "invalid login credentials";
                    // this.disable_btn = false;
                    _this5.deactivate_processing();
                }
            });

            //continue
            if (this.loggedIn) {
                //make order
                var payload = {
                    order_new_user: user_status, //0=existing user //1=not-existing-user
                    order_user_email: this.user.user_email,
                    order_product: this.selected_plan.product_id,
                    order_product_item: this.selected_plan_product_service_item.product_item_id,
                    order_amount_to_pay: this.selected_plan_product_service_item.product_item_price,
                    order_details: "Order Request For Gallery Website: " + this.selected_plan.product_name
                };
                service.makeAppSubscriptionOrder(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this5.data_boarding_message = "Preparing your Order....";

                        _this5.payment_payer_name = _this5.user.user_name;
                        _this5.payment_payer_email = _this5.user.user_email;
                        _this5.payment_payer_phone = _this5.user.user_phone;
                        _this5.payment_ref = response.body.data_payref;

                        // if(this.selected_plan.product_items[0].product_item_price == 0){ //free account
                        if (_this5.selected_plan_product_service_item.product_item_price == 0) {
                            //free account
                            _this5.updatePayment("gw-free-account");
                        } else {
                            //proceed to pay
                            _this5.processPayment();
                        }
                    } else {
                        //if status is either 400 or 500
                        _this5.data_error_message = "Something went wrong";
                        _this5.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this5.data_error_message = "invalid, Something went wrong";
                    _this5.deactivate_processing();
                });
            }
        },


        //connect to a payment gateway
        processPayment: function processPayment() {
            //some onboarding
            this.data_boarding_message = "Preparing Payment Information";
            //test data
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                //process online payment
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan_product_service_item.product_item_price + ")";
                var obj = this;
                //this.amount_paid = data.plan_amount;
                var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan_product_service_item.product_item_price * 100), //(data.plan_amount * 100), //in kobo
                    ref: this.payment_ref, //"GWLOG"+(new Date().getTime()),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        obj.data_boarding_message = "You Stopped Payment..";
                        obj.deactivate_processing();
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },


        //connect to a payment gateway with ///RAVEPAY-SETUP
        processPaymentRave: function processPaymentRave() {
            //some onboarding
            this.data_boarding_message = "Preparing Payment Information";
            //test data
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctlyaaa" + this.payment_payer_name + "se" + this.payment_payer_phone + "33" + this.payment_payer_email;
                this.data_boarding_message = "";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                var self = this;
                //RAVEPAY-SETUP
                var x = getpaidSetup({
                    // PBFPubKey: "FLWPUBK-2369bd1229e8ed1b28b21370100f73e8-X", //api public key//live //ch@wbn
                    PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X", //test //devlot
                    customer_email: self.payment_payer_email, // "mail@gmail.com"
                    amount: Math.round(self.selected_plan_product_service_item.product_item_price), //(Math.round(this.total_orders_amount * 100)),
                    customer_phone: self.payment_payer_phone, //"234099940409"
                    currency: "NGN",
                    payment_method: "both",
                    txref: self.payment_ref, //"GWLOG"+(new Date().getTime()),
                    meta: [{
                        metaname: "GalleryWebsiteOrders",
                        metavalue: self.payment_payer_name,
                        metaservice: self.payment_payer_name + " - " + self.payment_payer_phone + " - ORDER - " + self.selected_plan.product_name
                    }],
                    onclose: function onclose() {
                        self.data_boarding_message = "Payment was Stopped.";
                    },
                    callback: function callback(response) {
                        var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                        var tx_amount = response.tx.amount;
                        if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                            self.processing = true;

                            // redirect to a success page
                            // console.log("good to go!"+txref)

                            //server validation
                            // let payload =
                            // {
                            //    "SECKEY": "FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X", //use API secret key
                            //     "txref": txref
                            // };
                            // service.verifyRavePayment(self, payload).then(response => {
                            //     // console.log(response); // 42
                            //     // console.log(response.body.data.status); // 42
                            //     if ((response.body.data.status === "successful") && (response.body.data.chargecode == "00")) {
                            //         //check if the amount is same as amount you wanted to charge just to be very sure
                            //         self.payment_message = "Payment processed successfully, check your email for your receipts."

                            //         if (response.body.data.amount === tx_amount) {
                            //             //enter into db


                            // let txn_payload={
                            //     "txn_ref": txref,
                            //     "pay": self.user.user_id,
                            //     "txn_amount": self.wallet_transaction.topay_amt,
                            //     "processing_fee": self.wallet_transaction.processing_fee,
                            //     "topup_by_admin": 0,
                            //     "total_amount": tx_amount
                            // };

                            self.updatePayment(txref);
                            //     }
                            // }


                            // }).catch((err) => {
                            //     //console.log(34545)
                            //    // console.log(err)
                            // })
                            //...//....server validation
                        } else {
                                // redirect to a failure page.
                                //console.log("bad to go!"+txref)
                                // self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us"
                            }

                        x.close(); // use this to close the modal immediately after payment.
                    }
                });
                //RAVEPAY-SETUP
            }
        },


        // update payments
        updatePayment: function updatePayment(payment_ref) {
            //notify server of payment
            this.notifyPayments(15, payment_ref, 0); //15--Subscription-Paid
            //log transctions
            //.......................................

            // var payload = {
            //     payment_order_ref: payment_ref,
            //     payment_user_id: this.user.user_id
            // }
            //.......................................

            //then proceed
            var navi = this.$router;

            this.payment_successful = true;
            if (this.selected_plan_product_service_item.product_item_price != 0) {
                //not free account
                this.payment_successful_message = "Payment Successful...";
            }

            //set up account on gw
            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }

            //if upgrade process
            if (this.set_upgrade_plan_process) {
                this.upgradePlan();
            }
        },


        //notify payment
        notifyPayments: function notifyPayments(status, payment_ref, business_ordered) {
            var _this6 = this;

            var payload = {
                order_status: status,
                order_payment_ref: payment_ref,
                order_business: business_ordered
            };
            service.updateAppSubscriptionOrder(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this6.data_boarding_message = "Payment Updated....";
                }
            }).catch(function (err) {});
        },


        //flow-01
        //changed because of flow02
        setUpExistingAccountB4Flow01: function setUpExistingAccountB4Flow01() {
            var _this8 = this;

            //register users business to gallery app
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this7 = this;

                if (data.body.status == 201 || data.body.status == 200) {
                    //data.body.status == 200...already exists so login and move to sellpoint..//recode later to inform user
                    //.....usually happens during testings
                    //data.body.status == 201 ...successfully registered..proceed
                    // this.user.user_business = data.body.data_business_username; //overide from server
                    this.data_boarding_message = "Sellpoint Setup Successful...";
                    //navi.push('/'+this.user.user_business);
                    //log user in
                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            //all good
                            //and ask user for business name to create the sp
                            ////DEPRAC $('#purchaseModal').modal('hide');
                            navi.push('/' + _this7.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');
                            // this.disable_btn = false;
                            _this7.deactivate_processing();
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    // console.log(err)
                    //toastr.warning("Something went wrong", 'Warning!'); 
                    // this.disable_btn = false;
                    _this8.deactivate_processing();
                }
            });
        },


        //flow-02
        //changes user-reg/validates-account->order-is-made->payment-is-made-and-updated-at-server->business-is-created
        setUpExistingAccount: function setUpExistingAccount() {
            var _this9 = this;

            //register users business to gallery app
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                if (data.body.status == 201 || data.body.status == 200) {
                    //data.body.status == 200...already exists so login and move to sellpoint..//recode later to inform user
                    //.....usually happens during testings
                    //data.body.status == 201 ...successfully registered..proceed
                    // this.user.user_business = data.body.data_business_username; //overide from server
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    //notify server of Order-Delivered
                    this.notifyPayments(16, this.payment_ref, this.user.user_business); //15--Subscription-Delivered

                    //move to sellpoint
                    navi.push('/' + this.user.user_business);
                }
            }).catch(function (err) {
                if (err) {
                    // console.log(err)
                    //toastr.warning("Something went wrong", 'Warning!'); 
                    // this.disable_btn = false;
                    _this9.deactivate_processing();
                }
            });
        },


        //flow-01
        setUpNewAccountB4Flow02: function setUpNewAccountB4Flow02() {
            //create account by registering user
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            //test data
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this10 = this;

                        if (data.body.status == 201) {
                            // toastr.success("Registration Successful", 'Success!');
                            this.data_boarding_message = "Registration Successful...";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: this.user.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    //all good
                                    //reauth and preset to get actual user details
                                    _this10.preset();
                                    //and ask user for business name to create the sp
                                    var self = _this10;
                                    setTimeout(function () {
                                        self.set_up_business = true;
                                        // $('#purchaseModal').modal('hide');
                                        //DEPRAC $('#newBusinessModal').modal('show');
                                        self.data_boarding_message = " "; //reset
                                        self.setComponent('show-new-business-form', '');
                                        self.deactivate_processing();
                                        //srolls to the very top
                                        var top = document.getElementById("banner").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
                                        window.scrollTo(0, top);
                                    }, 3000); //wait for 3sec and c
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    //toastr.warning("invalid login credentials", 'Warning!'); 
                                    _this10.data_error_message = "invalid login credentials..";
                                    // this.disable_btn = false;
                                    _this10.deactivate_processing();
                                }
                            });
                        } else if (data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    });
                } else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },


        //flow-02
        setUpNewAccount: function setUpNewAccount() {
            //ask user for business name to create the sp
            var self = this;
            setTimeout(function () {
                self.set_up_business = true;
                // $('#purchaseModal').modal('hide');
                //DEPRAC $('#newBusinessModal').modal('show');
                self.data_boarding_message = " "; //reset
                self.setComponent('show-new-business-form', '');
                self.deactivate_processing();
                //srolls to the very top
                var top = document.getElementById("banner").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
                window.scrollTo(0, top);
            }, 3000); //wait for 3sec and c
        },
        validateUserName: function validateUserName() {
            var _this11 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this11.validate_user_name_error = true;
                    _this11.validate_user_name_message = "This username already exist";
                    _this11.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
                _this11.validate_user_name_error = true;
                _this11.validate_user_name_message = "This username already exist";
                _this11.deactivate_processing();
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this12 = this;

            this.resetMessages();
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3, //gallery
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                //toastr.error('This Username already exists', 'Warning!');
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.business.business_user_name = data.body.data_business_username; //overide from server
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            //notify server of Order-Delivered
                            this.notifyPayments(16, this.payment_ref, this.business.business_user_name); //16--Subscription-Delivered


                            ///DEPRAC//$('#newBusinessModal').modal('hide');
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            // toastr.warning("Something went wrong", 'Warning!'); 
                            _this12.data_error_message = "Something went wrong";
                            // this.disable_btn = false;
                            _this12.deactivate_processing();
                        }
                    });
                } else {
                    // toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },
        upgradePlan: function upgradePlan() {
            var _this13 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price
            };

            var navi = this.$router;
            service.upgradeBusinessMarketSubscription(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    //move to the business
                    navi.push('/' + this.upgrade_business);
                }
            }).catch(function (err) {
                if (err) {
                    _this13.data_error_message = "Something went wrong";
                    _this13.deactivate_processing();
                }
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
                //seperate products and services categories
                this.categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        }
    },
    mounted: function mounted() {
        //always jump to top of page hack
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top);
        //continue
    },

    created: function created() {
        if (this.$route.query.upgrade) {
            this.set_upgrade_plans = true; //mus not show purchase section
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(3);
 // Service Class
 // Main Header
 // Main Footer
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Register',
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_purchase: false,
            terms: true,
            disable_btn: false,
            loading: false,
            action_loading: false,
            data_proccessing_message: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__["a" /* default */]
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        reg: function reg() {
            this.disable_btn = true;
            this.user.agree = true; ///change 
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                if (this.terms) {
                    this.activate_processing();
                    service.regUser(this, credentials).then(function (data) {
                        var _this = this;

                        if (data.body.status == 201) {
                            this.data_proccessing_message = "Account Created";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data = response.body.data;
                                    localStorage.setItem("sp_user", _data.user_name);
                                    localStorage.setItem("sp_token", _data.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", _data.user_token_key);
                                    if (_this.user_purchase) {
                                        navi.push("/getstarted");
                                    } else {
                                        navi.push('/account');
                                    }
                                    //  navi.push('account');
                                    // location.replace('/')
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this.data_proccessing_message = "invalid login credentials";
                                    _this.deactivate_processing();
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_proccessing_message = "You already have a Sellpoint Account";
                            ////Info-+loging-prompt
                            this.deactivate_processing();
                        }
                    });
                } else {
                    this.data_proccessing_message = 'Please agree to Terms';
                    this.disable_btn = false;
                }
            } else {
                this.data_proccessing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(3);

 // Service Class
 // Main Header
 // Main Footer
var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Register',
    data: function data() {
        var _ref;

        return _ref = {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message: ""
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activate_token', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'set_forgot_password', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'reset_password', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'display_reset_password_form', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'data_processing_message', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'set_cta', false), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__["a" /* default */]
    },
    computed: {
        checkPasswordMatch: function checkPasswordMatch() {
            this.data_processing_message = "";
            if (this.user.new_password != '' && this.user.new_password != undefined && this.user.confirm_password != '' && this.user.confirm_password != undefined) {
                if (this.user.new_password != this.user.confirm_password) {
                    this.data_processing_message = "Password does not match";
                } else {
                    this.data_processing_message = "";
                }
            } else {
                this.data_processing_message = "";
            }
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'forgot') {
                this.set_forgot_password = true;
            }
            if (attr1 == 'login') {
                this.set_forgot_password = false;
            }
            if (attr1 == 'reset') {
                this.reset_password = true;
                this.loading = true;
                this.verifyResetToken();
            }
            if (attr1 == 'activate') {
                this.activate_token = true;
                this.loading = true;
                this.activateUserToken();
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        showPassword: function showPassword() {
            var x = document.getElementById("password1");
            var y = document.getElementById("password2");
            if (x.type === "password") {
                x.type = "text";
                y.type = "text";
            } else {
                x.type = "password";
                y.type = "password";
            }
        },
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        login: function login() {
            var _this = this;

            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);
                        localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                        localStorage.setItem("sp_token_key", data.user_token_key);
                        navi.push('/account');
                    } else {
                        // toastr.warning("invalid login credentials", 'Warning!'); 
                        _this.data_error_message = "invalid login credentials";
                        // this.disable_btn = false;
                        _this.deactivate_processing();
                    }
                }).catch(function (err) {
                    //  console.log(err)
                    // toastr.warning("invalid login credentials", 'Warning!'); 
                    _this.data_error_message = "Sorry, could not process request";
                    // this.disable_btn = false;
                    _this.deactivate_processing();
                });
            } else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        activateUserToken: function activateUserToken() {
            var _this2 = this;

            var navi = this.$router;
            service.activateUserToken(this, this.$route.params.activatetoken).then(function (response) {
                if (response.body.status == 200) {
                    _this2.data_processing_message = "Your Account Activation was successful. redirecting....";
                } else {
                    _this2.data_processing_message = "Your Account Activation was not successful, please try again. redirecting....";
                }
                setTimeout(function () {
                    navi.push('/');
                }, 5250);
            }).catch(function (err) {
                _this2.data_processing_message = "Your Account Activation was not successful, please try again. redirecting....";
                setTimeout(function () {
                    navi.push('/');
                }, 5250);
            });
        },
        forgot: function forgot() {
            var _this3 = this;

            this.data_processing_message = "";
            this.activate_processing();
            var credentials = {
                user_email: this.user.email
            };

            var navi = this.$router;
            if (credentials.user_email) {
                service.forgotPassword(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.set_cta = true;
                        _this3.data_processing_message = "Request was successful, please check your email for a link to reset password";
                    }
                    if (response.body.status == 404) {
                        _this3.data_processing_message = "Could not find this email";
                    }
                    if (response.body.status == 400) {
                        _this3.data_processing_message = "Request could not be completed, please try again";
                    }
                    _this3.deactivate_processing();
                }).catch(function (err) {
                    _this3.data_processing_message = "Request could not be completed, please try again";
                    _this3.deactivate_processing();
                });
            } else {
                this.data_processing_message = "Please enter your email";
                tthis.deactivate_processing();
            }
        },
        verifyResetToken: function verifyResetToken() {
            var _this4 = this;

            service.verifyResetPasswordToken(this, this.$route.params.resettoken).then(function (response) {
                if (response.body.status == 200) {
                    // this.display_reset_password_form =  true; 
                    _this4.loading = false;
                    _this4.user.email = response.body.data; //save the email
                } else {
                    _this4.data_processing_message = "Password reset failed, please reset againj";
                    _this4.reset_password = false;
                    _this4.set_forgot_password = true;
                }
                _this4.deactivate_processing();
            }).catch(function (err) {
                _this4.data_processing_message = "Password reset failed, please reset againn";
                _this4.reset_password = false;
                _this4.set_forgot_password = true;
                _this4.loading = false;
            });
        },
        resetForgotPassword: function resetForgotPassword() {
            var _this5 = this;

            this.data_processing_message = "";
            //check passwords
            if (this.user.new_password != '' && this.user.new_password != undefined) {
                if (this.user.new_password != this.user.confirm_password) {
                    this.data_processing_message = "Passwords does not match";
                } else {
                    this.activate_processing();
                    var credentials = {
                        user_email: this.user.email,
                        new_password: this.user.new_password
                    };

                    var navi = this.$router;

                    service.resetForgotPassword(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            _this5.data_processing_message = "Password Request was successful";
                            _this5.user.password = _this5.user.new_password;
                            _this5.loading = true; //prep login
                            var self = _this5;
                            setTimeout(function () {
                                //login
                                self.login();
                            }, 6750);
                        } else {
                            _this5.data_processing_message = "Request could not be completed, please try again";
                            _this5.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this5.data_processing_message = "Request could not be completed, please try again";
                        _this5.deactivate_processing();
                    });
                }
            } else {
                this.data_processing_message = "Please enter passwords";
            }
        }
    },
    created: function created() {
        this.reset();
        //check for activate token
        if (this.$route.params.activatetoken) {
            this.setComponent("activate", "");
        }
        //check for reset token
        if (this.$route.params.resettoken) {
            this.setComponent("reset", "");
        }
    }
});

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);

 // Service Class
 // Service Class
 // Main Header
 // Main Footer


var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Account',
    data: function data() {
        var componentInstance = this;
        return {
            //defaults
            user: {},
            sellpoints: {},
            sellpoint: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},
            //.../defaults

            //more settings
            states: {},
            cities: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            managePanel: false,
            manageBusinesses: true, //default view
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            //productitems settings
            showProductItemGroups: true,
            //...more--settings

            //loobook settings
            viewing_lookbook: {}, //store viewing lookbook for product swich
            viewing_lookbook_post: {},
            is_viewing_lookbook: false,

            drag_options: {
                // dropzoneSelector: 'ul',
                // draggableSelector: 'li',
                //     showDropzoneAreas: true,
                //     multipleDropzonesItemsDraggingEnabled: true,
                //     onDrop(event) {
                //       console.log(event);
                //     },
                //     onDragstart(event) {
                //       event.stop();
                //     },
                onDragend: function onDragend(event) {
                    // if you need to stop d&d
                    // event.stop();

                    // you can call component methods, just don't forget 
                    // that here `this` will not reference component scope,
                    // so out from this returned data object make reference
                    // to component instance
                    // componentInstance.onDragChangerr();

                    // to detect if draggable element is dropped out
                    if (!event.droptarget) {
                        console.log('event is dropped out');
                    }
                }
            }

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__["a" /* default */],
        'product-item-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__["a" /* default */]
    },

    methods: {
        onDragChangerr: function onDragChangerr() {
            console.log("jku");
        },
        onDragChange: function onDragChange(gallery) {

            console.log(gallery);
        },

        // allowDrop(ev) {
        //     ev.preventDefault();
        //   },

        //  drag(ev,gallery) {
        //      if(ev){
        //         ev.dataTransfer.setData("text", ev.target.id);
        //         console.log(gallery)
        //      }

        //   },

        //  drop(ev) {
        //     ev.preventDefault();
        //     var data = ev.dataTransfer.getData("text");
        //     ev.target.appendChild(document.getElementById(data));
        // },
        //---default--settings
        setComponent: function setComponent(attr1, attr2) {
            this.resetAll();
            this.data_processing_message = ""; //refresh
            this.deactivate_processing(); //first deactivate any active processing

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true; //default
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state, 'edit'); //option edit
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
                // this.component_view.viewLookbooks = true
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }
        },
        setInnerComponent: function setInnerComponent(attr1, attr2) {
            //product-items--add--imports
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2;
                //styling to show selecte active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }
                // document.getElementById(attr2+"PRTGR").style.border = "1px solid #0000CC";
                document.getElementById(attr2 + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                    //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            //product-items--add-imports
        },


        //reset main substitute
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        setMenuComponent: function setMenuComponent(go_to) {
            this.setPanel = false;
            this.managePanel = false;
            //cont
            var section = document.getElementById(go_to).offsetTop;
            window.scrollTo(0, section);
        },
        setComponentView: function setComponentView(attr1, attr2, attr3) {
            this.resetAll();
            if (attr1 == 'switch-to-viewing-loobook') {
                //a special toggle switch case
                //switcth to lookbook view
                this.setComponent('manage-lookbooks', ''); //topmost layout
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks', this.viewing_lookbook_post, 'viewLookbookPost');

                //reset
                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};
            }
            if (attr1 == 'products') {
                if (this.component_view.viewProducts) {
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;
                    //some products settings
                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                    // localStorage.setItem("viewing-01", this.product.product_url_name);
                } else if (this.component_view.viewProduct) {
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
            }
            if (attr1 == 'lookbooks') {
                if (attr3 == 'viewLookbookPost') {
                    //setting post in lookbook
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                    //some lookbook_post settings
                    //localStorage.setItem("viewing-02", this.lookbook_post.post_url_name);
                } else if (attr3 == 'viewLookbook') {
                    //sets lookbook in lookbooks
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                } else if (attr3 == 'viewLookbooks') {
                    //sets lookbooks ../default
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
            }
        },
        setBusinessComponent: function setBusinessComponent(component) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.businessComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var arr = _step.value;

                    if (arr == this.businessComponents[component]) {
                        this.businessComponents[component] = true;
                    } else {
                        // console.log(this.businessComponents[this.businessComponents.indexOf(arr)])
                        this.businessComponents[this.businessComponents.indexOf(arr)] = false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        setProductComponent: function setProductComponent(component, attr2, attr3) {
            this.deactivate_processing(); //first deactivate any active processing
            this.discount_coupon = {}; //reset
            // if(attr2 == 'product'){   ////already set by default..//commented to avoid empty / null override
            //     this.product = attr3;
            // }
            if (attr2 == 'productitemgroup') {
                this.product_item_group = attr3;
            }
            if (attr2 == 'productitem') {
                this.product_item = attr3;
            }

            //some settings
            if (component == "addProductItemPanel") {
                if (this.product.product_set_groups == 0) {
                    this.showProductItemGroups = 'showfalse'; //no items found
                }
            }
            if (component == 'setProductDeliveryInformation') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (component == 'editDiscount') {
                this.discount_coupon = attr3;
            }
            if (component == 'deactivateDiscount') {
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3);
            }

            this.product_details = {};
            this.product_details[component] = true;
        },
        setLookbookComponent: function setLookbookComponent(component, attr2, attr3) {
            this.deactivate_processing(); //first deactivate any active processing

            if (component == "viewProductLookbookPost") {
                //navigate to product lookbook page //store parent lookbook
                this.viewing_lookbook = this.lookbook; //store parent lookbook
                this.viewing_lookbook_post = attr3; //store the product post
                this.is_viewing_lookbook = true; //save activity

                //switch to product view
                this.setComponent('manage-products', ''); //topmost layout
                this.setComponentView('products', attr3.gallery_post_product_details, ''); //set the product view
            } else {
                //other settings

                this.lookbook_details = {};
                this.lookbook_details[component] = true;
            }
        },
        toggleSwitchBusiness: function toggleSwitchBusiness() {
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        switchBusiness: function switchBusiness(sellpoint) {
            this.sellpoint = sellpoint;
            this.galleria = {}; //a hack for refresh
            this.setSellpoint();
            //check if toggle effect
            this.toggleSwitchBusiness();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this2 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            // this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this4.user = data.body.data;
                                    //get sellpoints
                                    _this4.getSellpoints(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {
                                    // toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            });
                            //../special case for profile
                        }, _this3);
                    } else {
                        //reauth or ..login
                        _this3.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {
                        //console.log(err)
                        //  this.$router.push('/login/');
                    }
                });
            } else {
                //this.$router.push('/login/');
            }
        },
        syncset: function syncset(request_page) {
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page
            };
            if (credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //redirect to sp with session ref
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {
                        // console.log(err)
                        // this.$router.push('/login/');
                    }
                });
            }
        },


        //profile
        editProfileDetails: function editProfileDetails() {
            var _this5 = this;

            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email

                //test data
            };var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_processing_message = "";
            }
            if (data_test) {
                if (payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        } else {
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        }
                    }).catch(function (err) {
                        //log it
                        _this5.data_processing_message = "Could not edit details, something went wrong, please try again";
                        _this5.deactivate_processing();
                        _this5.setSettings = false;
                        _this5.setting_details = {};
                    });
                }
            }
        },

        //./profile

        getSellpoints: function getSellpoints(user) {
            var _this6 = this;

            // this.loading = true; //disable for now
            this.loading = false;
            service.getAppBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this6.sellpoints = data.body.data;
                    _this6.sellpoint = _this6.sellpoints[0];
                    _this6.business_set_shipping_fee_status = _this6.sellpoint.business_set_shipping_fee_status;
                    //get the gallery of the sellpoint
                    _this6.setSellpoint();
                    _this6.loading = false; //disable for now
                }
            }).catch(function (err) {
                if (err) {
                    //log it
                    // console.log(err)
                }
            });
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.activate_processing();
            service.getAppBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint_gallery = response.body.data;

                    //get this sellpoint products
                    _this7.getSellpointProducts();

                    //dummy settings
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Free Plan') {
                        _this7.max_plan_lookbooks = 2;
                        _this7.max_plan_lookbook_posts = 5;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Basic Plan') {
                        _this7.max_plan_lookbooks = 10;
                        _this7.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Premium Plan') {
                        _this7.max_plan_lookbooks = 50; //unlimited
                        _this7.max_plan_lookbook_posts = 50; //unlimited
                        _this7.can_add_product_lookbook = true; //online shop functionality
                    }

                    var self = _this7;
                    setTimeout(function () {
                        self.setGallery();
                    }, 3000); //wait for 3sec and call posts in gallery

                    //continue
                    //new-get new categories
                    _this7.getCategories(_this7.sellpoint.business_category_id);
                    //set sellpoint categories
                    _this7.getSellpointCategories();
                }
            }).catch(function (err) {});
        },
        setGallery: function setGallery() {
            var _this8 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this8.galleria = response.body.data;
                //settings
                _this8.total_lookbooks_added = response.body.total_data;

                if (_this8.total_lookbooks_added < _this8.max_plan_lookbooks) {
                    _this8.can_add_more_lookbook = true;
                }
                _this8.deactivate_processing();
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },


        ////../default settings

        /*----------------------Adminboarding------------------------------------------*/
        //business--settings
        getCategories: function getCategories(category) {
            var _this10 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this10.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },


        //categories settings
        getSellpointCategories: function getSellpointCategories() {
            var _this11 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this11, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this11.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {
                //log it
                // this.$router.push("/")
                //console.log(err)
            });
        },


        //editbusiness
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this12 = this;

            // this.activate_processing();
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            } else {
                var payload = {
                    business_main_details: true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Sellpoint edited";
                    if (attr == "delivery") {
                        this.business_details = {};
                    } else {
                        this.manageBusinessDetails = false;
                        //show top
                        var top = document.getElementById("top").offsetTop;
                        window.scrollTo(0, top);
                        this.deactivate_processing();
                    }

                    // setTimeout(function(){ 
                    //     location.reload(); //reload page
                    // }, 600);
                } else {
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
                _this12.data_processing_message = "Could not edit details, something went wrong, please try again";
                _this12.deactivate_processing();
            });
        },


        //delivery
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    } //for edit
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    } //for edit
                    this.other_delivery_option = false;
                }
            }
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            // toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        _this13.delivery_option = {};
                        _this13.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
                //this.delivery_option.business_id = this.sellpoint.business_id;
            };if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            // toastr.success("Sellpoint Delivery Details edited",'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};
                            // this.editDeliveryInformation = false;
                            //this.delivery_option = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this14.delivery_option.edit_set = false;
                        _this14.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    // toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
                _this15.delivery_option = {};
                _this15.deactivate_processing();
            });
        },


        //set shipping fee status
        setShippingFeeStatus: function setShippingFeeStatus() {
            this.activate_processing();
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                // if(data.body.status == 200) {
                // toastr.success("Shipping Fee Ordering Set", 'Reset!');
                this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                this.deactivate_processing();
                // }
            }).catch(function (err) {
                //log it
            });
        },

        //.../delivery

        //coupons and discounts
        //set coupons and discount
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var _this16 = this;

            this.activate_processing();
            this.data_processing_message = "";
            //settings for product and producitems
            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1; //HACK..TO LET GO ../ASSIGNED 1 instead of 0.
            }

            //validate entry
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    //set for business category
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    //set for product and product items
                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }
                    //set for product and product items

                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                        coupon_business_category: discount_category,
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            // toastr.success("New Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;
                                        var _iteratorNormalCompletion3 = true;
                                        var _didIteratorError3 = false;
                                        var _iteratorError3 = undefined;

                                        try {
                                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                var row = _step3.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                            // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                    _iterator3.return();
                                                }
                                            } finally {
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        //log it
                        _this16.deactivate_processing();
                    });
                } //date reset check
            } else {
                validated_arr.forEach(function (error) {
                    // toastr.error(error); 
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },


        // edit coupons and discount
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            var _this17 = this;

            this.data_processing_message = "";
            //validate entry
            var entry_arr = [["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                        if (data.body.status == 200) {
                            // toastr.success("Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var item = _step4.value;
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var row = _step5.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                            // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        //log it
                        _this17.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    // toastr.error(error); 
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },


        // edit coupons and discount
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            var _this18 = this;

            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    // toastr.success("Discount Set", 'Update!');
                    // this.sellpoint.business_discounts_coupons = data.body.data;
                    this.business_details.viewDiscounts = true;
                    if (this.product.product_id) {
                        var res = data.body.data;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var item = _step6.value;
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var row = _step7.value;

                                        if (row.product_item_id == item.product_item_id) {
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    } else {
                        this.sellpoint.business_discounts_coupons = data.body.data;
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch(function (err) {
                //log it
                _this18.deactivate_processing();
            });
        },


        //../coupons and discounts

        //
        //../...business--settings

        //.....product--settings------/

        //images
        getProductImages: function getProductImages() {
            var _this19 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_images = response.body.data;
                    _this19.product_display_image = _this19.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            var _this20 = this;

            this.activate_processing();
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this20.deactivate_processing();
            });
        },

        //images
        //edit product
        editProduct: function editProduct() {
            var _this21 = this;

            this.activate_processing();
            //this.business.agree = true;
            //some settings
            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                //if either of 2 where selected
                set_product_category = 0; //make product_category 0
            } else {
                if (this.product.product_category != undefined) {
                    //if new product_category is selected
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id; //current product_category
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                // product_category: this.product.product_category || this.product.product_category_id, //before

                //new
                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                //

                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id //new to help with category settings
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //toastr.success("Product Updated", 'Success!');
                        _this21.product = response.body.data;
                        _this21.product_details = {};
                        // navi.push("/"+this.product.product_business_ownername+"/"+this.product.product_url_name);
                    } else {
                        _this21.product_details = {};
                        _this21.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        //toastr.warning("Something went wrong", 'Warning!'); 
                        _this21.data_processing_message = "Something went wrong";
                        _this21.product_details = {}; //manage with this for now
                        _this21.deactivate_processing();
                    }
                });
            } else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        editProductSingleProductItem: function editProductSingleProductItem() {
            var _this22 = this;

            this.activate_processing();
            //quick check for product item
            var set_product_item = 0;
            var current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if (this.product.product_items[0].product_item_actual_price != 0) {
                set_product_item = this.product.product_items[0].product_item_actual_price;
            } else {
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this22.product.product_items[0] = response.body.data;
                        _this22.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price; //rehack later
                        _this22.deactivate_processing();
                        _this22.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this22.data_processing_message = "Update failed, Something went wrong";
                        _this22.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },


        //edit product
        editProductSettings: function editProductSettings() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item'
            };

            var navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this23.product = response.body.data;
                    _this23.product_details = {};
                } else {
                    _this23.product_details = {};
                    _this23.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this23.data_processing_message = "Something went wrong";
                    _this23.product_details = {}; //manage with this for now
                    _this23.deactivate_processing();
                }
            });
        },
        addProductItem: function addProductItem() {
            var _this24 = this;

            this.activate_processing();
            if (this.product_details.addProductItemToGroup) {
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1, //default add to ist group

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            } else {
                var new_product_item_group = false;
                var product_item_group_is_color_image = 'IMG';
                if (this.product.product_item_group == undefined) {
                    new_product_item_group = true;
                }
                if (this.product.product_item_group_color == undefined) {
                    product_item_group_is_color_image = 'IMG';
                } else {
                    product_item_group_is_color_image = 'COL';
                    this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    //new product_items_group_details
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,
                    //./..new .product_items_group_details

                    product_item_group: this.product.product_item_group || 1, //default add to ist group

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            }
            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;
                        // this.product_details.addProductItemPanel = false;
                        this.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this24.data_error_message = "Something went wrong", 'Warning!';
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        //  console.log(err)
                        // this.disable_btn = false;
                        _this24.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                // this.disable_btn = false;
                this.deactivate_processing();
            }
        },


        //edit product item
        editProductItem: function editProductItem() {
            var _this25 = this;

            this.activate_processing();
            //quick check for product item
            var set_product_item = 0;
            if (this.product_item.product_item_actual_price != 0) {
                set_product_item = this.product_item.product_item_actual_price;
            } else {
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this25.product_item = response.body.data;
                        _this25.deactivate_processing();
                        _this25.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        // console.log(err)
                        _this25.data_processing_message = "Update failed, Something went wrong";
                        _this25.deactivate_processing();
                    }
                });
            } else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },


        //edit product item group
        editProductItemGroup: function editProductItemGroup() {
            var _this26 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            //set only color if defined
            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new; //a new one
                this.product_item_group.product_item_group_image = 0; //set image to 0
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill"; //set color to nill
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //this.product_item_group = response.body.data;

                        _this26.product.product_item_groups = response.body.data;

                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    } else {
                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        // console.log(err)
                        _this26.data_processing_message = 'Update failed, Something went wrong';
                        _this26.deactivate_processing();
                    }
                });
            } else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    location.reload(true);
                    // this.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    location.reload(true);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this27 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this27.redir(_this27.$route.params.id); //go to sellpoint
                    }
                    _this27.product.product_item_groups = response.body.data;
                    // location.reload(true)
                    //this.product.product_item = response.body.data;
                    //maually delete from array
                    //product_item_group.product_items.splice(this.product_item.product_item_id, 1 );
                    _this27.deactivate_processing();
                    _this27.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this27.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this28 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this28.redir(_this28.$route.params.id); //go to sellpoint
                    }
                    _this28.product.product_item_groups = response.body.data;
                    _this28.deactivate_processing();
                    _this28.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this28.deactivate_processing();
                }
            });
        },
        setProductDelivery: function setProductDelivery() {
            var _this29 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product_details = {};
                }
                this.deactivate_processing();
            }).catch(function (err) {
                //log it
                _this29.product_details = {};
                _this29.deactivate_processing();
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                // if(data.body.status == 200) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
                // }
            }).catch(function (err) {
                //log it
            });
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this30 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            // toastr.success("Sellpoint Delivery Details edited",'Success!');
                            // this.product.product_delivery_options = data.body.data;
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.product_details = {};
                            //this.delivery_option = {};
                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this30.delivery_option.edit_set = false;
                        _this30.product_details = {};
                        _this30.deactivate_processing();
                    });
                } else {
                    //toastr.warning("Select a delivery option", 'Warning!');
                    this.deactivate_processing();
                }
            }
        },


        //---./product-settings---------/

        //---lookbook-settings---------/
        addPostToGallery: function addPostToGallery() {
            var _this32 = this;

            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this31 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        //log user in
                        this.post = data.body.data;

                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                //this.product.product_image = data.body.data;
                                // location.reload(true);
                                // this.product_info = true;
                                _this31.setGallery();
                                _this31.gallery = data.body.data_gallery;
                                _this31.addNewPost = false;
                                _this31.edit_mode = false;
                                //this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {
                                // log it
                                console.log(err);
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        // console.log(err)
                        _this32.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editLookbook: function editLookbook() {
            var _this33 = this;

            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description: this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";
                        //log user in
                        // this.gallery = data.body.data;
                        //reset lookbook
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this33.data_processing_message = "Something went wrong";
                        // console.log(err)
                        _this33.deactivate_processing();
                        _this33.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },
        deleteLookbook: function deleteLookbook() {
            var _this34 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {
                    //return to sellpoint
                    //location.replace('/'+this.$route.params.id); //go to sellpoint
                    // reset data
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this34.deactivate_processing();
                    _this34.lookbook_details = {};
                    _this34.data_processing_message = "Something went wrong";
                    // console.log(err)
                    // this.disable_btn = false;
                }
            });
        },
        editLookbookPost: function editLookbookPost() {
            var _this35 = this;

            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details: this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";
                        //log user in
                        // this.gallery = data.body.data;
                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data; //refresh data
                    } else {
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this35.data_processing_message = "Something went wrong";
                        // console.log(err)
                        _this35.deactivate_processing();
                        _this35.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        deleteLookbookPost: function deleteLookbookPost() {
            var _this36 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.lookbook = data.body.data; //refresh data
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this36.deactivate_processing();
                    _this36.data_processing_message = "Something went wrong";
                    _this36.lookbook_details = {};
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },

        //---./lookbook-settings---------/

        //resets
        resetComponentData: function resetComponentData(component) {
            var _this37 = this;

            if (component == 'lookbook') {
                service.resetData(this, "gallery", this.lookbook.gallery_posts_group_url_name).then(function (response) {
                    if (response.body.status == 200) {
                        var lookbook = response.body.data;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lookbook.gallery_posts_group_posts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var post = _step8.value;

                                if (post.gallery_post_id == _this37.lookbook_post.gallery_post_id) {
                                    _this37.lookbook_post = post;
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }

                        _this37.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
        },


        //uploads
        onFileChange: function onFileChange(e, type, data_id) {
            var _this38 = this;

            this.product_details = {}; //hack
            this.product_details.uploading_image = true;
            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;

                // if(!this.product_details.uploading_image){ //hack for disable double request
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        // if(type == "product_item"){
                        //     this.product_item.product_item_image = data.body.data;
                        // }
                        if (type == "products") {
                            _this38.getProductImages();
                            if (_this38.product_details.editProductItemGroup) {
                                //ie product_item_group edit going on
                                _this38.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this38.getProductInformation();
                        }
                        _this38.deactivate_processing();
                    } else {
                        _this38.data_processing_message = "Something went wrong uploading media, please try again";
                        _this38.deactivate_processing();
                    }
                    _this38.product_details.uploading_image = false;
                }).catch(function (err) {
                    _this38.data_processing_message = "Something went wrong uploading media, please try again";
                    _this38.deactivate_processing();
                    _this38.product_details.uploading_image = false;
                });
            }
            // }   
        },

        //productitems
        onFileChangeProductItems: function onFileChangeProductItems(e, type, data_id) {
            var _this39 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this39.product.product_item_group_image = data.body.data_id;
                            _this39.data_media_error_message = "";
                            _this39.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        // log it
                    }
                });
                //if uploading takes time continue with reload
                this.data_media_error_message = service.media_upload_timeout_msg;
                var self = this;
                setTimeout(function () {
                    self.data_media_error_message;
                }, 65000); //wait for 1min and timeout
                setTimeout(function () {
                    // location.reload(true); 
                    self.data_media_error_message = "";
                }, 95000); //wait for 1min and timeout
            }
        },

        //lookbooks
        //uploads for adding media to gallery post
        onFileChangeLookbook: function onFileChangeLookbook(e, type, data_id) {
            var _this40 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "gallery_media") {
                            _this40.resetComponentData("lookbook");
                        }
                    } else {
                        _this40.data_processing_message = "Sorry Upload Failed";
                    }
                    _this40.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        // log it
                        _this40.data_processing_message = "Sorry Upload Failed";
                        _this40.deactivate_processing();
                    }
                });
            }
        }
    },
    created: function created() {
        document.title = "Account" + " | Gallery";
        this.getStates();
        this.preset();
    }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ProductItemForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            product: {},
            product_items: {},
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            //this.setPanel = true;
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'reset-edit') {

                //  document.getElementsByClassName('add-prd-item').style.display = 'none';
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                        //get sellpoint categories
                        _this.setProduct();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setProduct: function setProduct() {
            var _this2 = this;

            service.getProductSearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.product = response.body.data;
                }
            }).catch(function (err) {
                //log it
                _this2.$router.push("/");
            });
        },
        addProductItem: function addProductItem() {
            var _this3 = this;

            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        // toastr.success("Product Item Added Successfully", 'Success!');

                        //add image
                        var result = data.body.data;
                        this.imageForm.append("data_id", result.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                //this.product.product_image = data.body.data;
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {
                                // log it
                            }
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        console.log(err);
                        _this3.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },


        //uploads
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                // formData.append('data_id', data);
                // formData.append('data_type', type);   

                this.imageForm = formData;
                // service.uploadDataPhoto(this, formData).then(data => {
                //     if(data.body.status == 200){
                //         this.product.product_image = data.body.data;
                //     }
                //     }).catch((err) => {
                //         if(err) {
                //            // log it
                //         }
                //     })
            }
        }
    },
    created: function created() {
        //this.preset();
        this.imageForm = new FormData();
        this.setProduct();
    }
});

/***/ }),
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__ = __webpack_require__(201);
 // Service Class
 // Main Header
 // Main Footer






// import MenuLeftBar from '../../../components/menuleftbar.vue'
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories: {},
            main_category: {},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            other_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item_group: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel: false,
            removeProductPanel: false,
            product_details_descr: true, //default view
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setProductDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},
            action_loading: false,
            product_is_ready_to_cart: false,
            product_item_selected: [],
            product_item_group_selected: [],
            data_cart_message: "",
            data_cart_group_message: "",
            data_cart_item_message: "",
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,
            check_order_quantity: ""

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__["a" /* default */],
        'product-form': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__["a" /* default */],
        "product-item-form": __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__["a" /* default */],
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__["a" /* default */],
        'product-cta-button': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__["a" /* default */]
        // 'menu-left-bar': MenuLeftBar,

    },
    computed: {},

    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkOrderQuantity: function checkOrderQuantity(qty) {
            if (this.product_item_selected.product_item_price > 0 && this.product_item.product_item_order_quantity != 0) {
                if (Number(qty) > this.product_item.product_item_quantity) {
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                } else {
                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            } else {
                this.check_order_quantity = "";
            }
        },
        trackevent: function trackevent(e) {
            // $('#category-type-3').disabled = true;
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = true; //check
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            // this.action_loading = true;
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-item_group') {
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if (attr1 == 'remove-product-item_group') {
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product_item_group.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                    //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-product-delivery-option') {
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state, 'edit'); //option edit
            }
            if (attr1 == 'set-product-item') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item = attr2;
                this.product_item_selected = attr2;

                //styling to show selected active group
                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                //don't apply if product item size or service group or any product item specific attr is not available
                if (attr2.product_item_size != "Nill" && attr2.product_item_size != "") {
                    document.getElementById(attr2.product_item_id + "PRT").style = "border:1px solid #0000CC;";
                }

                //some settings
                this.data_cart_item_message = '';
                this.data_cart_message = ''; //recheck
                this.prep_set_product_is_ready_to_cart();
            }
            if (attr1 == 'set-product-item-group') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                //set display image
                this.product_display_image.product_image = attr2.product_item_group_image;

                ///resets
                //first--reset ready to cart
                this.product_is_ready_to_cart = false;
                this.product_item_selected = [];
                //second--remove styling for product items
                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }
                ////...resets

                //then style to show selected active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    // grps[i].style = "border:none;"; //REMOVED COS IT REMOVES ALL STYES ESP. BACKGROUD COLOR
                    grps[i].style.border = "none";
                    // grps[i].classList.add('sp-remove-active-border-color')
                }

                // document.getElementById(attr2.product_item_group_id+"PRTGR").style= "border:1px solid #0000CC;";
                document.getElementById(attr2.product_item_group_id + "PRTGR").style.border = "1px solid #0000CC";

                //some settings
                this.data_cart_group_message = '';
                //if this group does not have size entered, then auto activate its product item so that you would not select size
                if (attr2.product_items[0].product_item_size == "Nill" || attr2.product_items[0].product_item_size == "") {
                    //auto activate
                    this.setComponent('set-product-item', attr2.product_items[0]);
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                }
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                // console.log(location.href);
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                // location.replace(location.href.replace('#productDetails',''))
                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', '')); //refresh url to allow next click
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
            var self = this;

            setTimeout(function () {
                self.action_loading = false;
            }, 2000); //wait for 3sec and turn off loading
            // this.action_loading = false;
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.product.product_business_id;
                            //set seller options
                            this.is_editing();
                            //loggedIn options
                            this.loggedIn = true;
                        }, _this);
                    } else {
                        //this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                    }
                });
            } else {
                //this.$router.push('login');
            }
        },
        is_editing: function is_editing() {
            var _this2 = this;

            //preseting if seller
            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true; //important
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false; //important
                }
            }).catch(function (err) {
                if (err) {
                    //log error
                }
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing(); //revalidate seller
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    } //for edit
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    } //for edit
                    this.other_delivery_option = false;
                }
            }
        },
        set_data_messages: function set_data_messages(data, action) {
            if (this.product.product_service == 'P') {
                if (action == 'set') {
                    if (data == 'product-item') {}
                }
                if (action == 'unset') {}
            } else {}
        },
        prep_set_product_is_ready_to_cart: function prep_set_product_is_ready_to_cart() {
            if (this.product_item_selected.length != 0) {
                this.product_is_ready_to_cart = true;
            } else {
                this.data_cart_message = "make a selection before you proceed";
                if (this.product_item_group_selected.length != 0) {
                    //check group first
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                } else {
                    //group not yet selected
                    if (this.product.product_service == 'P') {
                        this.data_cart_group_message = "please select Colour";
                    } else {
                        this.data_cart_group_message = "please select a Service Package";
                    }
                }
            }
        },
        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        set_product_is_ready_to_cart: function set_product_is_ready_to_cart() {
            //first checkpoint on product load
            //check if product has only one group and group has only one item
            // if check then set product_is_ready_to_cart as true

            // if(this.product_item_group.length <= 1){   //merged in AND below
            //check items
            // if(this.product_item.length <= 1){
            if (this.product.product_set_groups <= 1 && this.product.product_set_items <= 1) {
                //can-add
                //some settings
                this.product_item_selected = this.product_item; //item
                this.product_item_group_selected = this.product_item_group; //group
                this.product_is_ready_to_cart = true;
            }
            // }
            //else leave as false
        },
        setProduct: function setProduct() {
            var _this5 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product = response.body.data;

                    document.title = _this5.product.product_name + " | " + _this5.product.product_business_name + " | SP";

                    _this5.product_display_image = _this5.product.product_images[0];
                    _this5.product_item = _this5.product.product_items[0];
                    if (_this5.product.product_item_groups.length != 0) {
                        _this5.product_item_group = _this5.product.product_item_groups[0];
                    } else {
                        _this5.product_item_group = [];
                    }

                    _this5.product_set_shipping_fee_status = _this5.product.product_set_shipping_fee_status;

                    //set product_is_ready_to_cart
                    _this5.set_product_is_ready_to_cart();

                    _this5.siteUrl = service.siteUrl + "?p=" + _this5.product.product_url_name + "&p1=" + _this5.product.product_business_ownername + "&p2=" + _this5.product.product_url_name + "&p3=" + encodeURI(_this5.product.product_name) + "&p4=" + encodeURI(_this5.product.product_description) + "&p5=" + _this5.product_item.product_item_image + " ";

                    _this5.product.product_share_url = "http://sellpoints.com.ng/" + _this5.product.product_business_ownername + "/" + _this5.product.product_url_name;
                    //
                    _this5.preset();
                    //set other products
                    _this5.setOtherProducts(_this5.product.product_business_id);
                    //new-get new categories
                    _this5.getCategories(_this5.product.product_business_category_id);
                    //set sellpoint categories
                    _this5.getSellpointCategories();
                    //check if already added to cart
                    _this5.check_in_cart();
                    _this5.loading = false;
                }
            }).catch(function (err) {
                // console.log(err)
                //   this.redir(this.$route.params.id1); //go to sellpoint
                //log it
                //location.replace("/")
            });
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        },
        setOtherProducts: function setOtherProducts(sellpoint_id) {
            var _this7 = this;

            service.getBusinessProducts(this, sellpoint_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.other_products = response.body.data;
                }
            }).catch(function (err) {});
        },


        //other product settings
        //images
        getProductImages: function getProductImages() {
            var _this8 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this8.product.product_images = response.body.data;
                    _this8.product_display_image = _this8.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch(function (err) {});
        },

        //images
        //edit product
        editProduct: function editProduct() {
            var _this9 = this;

            this.activate_processing();
            //this.business.agree = true;
            //some settings
            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                //if either of 2 where selected
                set_product_category = 0; //make product_category 0
            } else {
                if (this.product.product_category != undefined) {
                    //if new product_category is selected
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id; //current product_category
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                // product_category: this.product.product_category || this.product.product_category_id, //before

                //new
                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                //

                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id //new to help with category settings
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //toastr.success("Product Updated", 'Success!');
                        _this9.editProductPanel = false;
                        _this9.product = response.body.data;
                        navi.push("/" + _this9.product.product_business_ownername + "/" + _this9.product.product_url_name);
                    } else {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        //toastr.warning("Something went wrong", 'Warning!'); 
                        _this9.editProductPanel = false; //manage with this for now
                        _this9.deactivate_processing();
                    }
                });
            } else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },


        //edit product item
        editProductItem: function editProductItem() {
            var _this10 = this;

            this.activate_processing();
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this10.product_item = response.body.data;
                        _this10.deactivate_processing();
                        _this10.editProductItemPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        // console.log(err)
                        _this10.deactivate_processing();
                    }
                });
            } else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.deactivate_processing();
            }
        },


        //edit product item group
        editProductItemGroup: function editProductItemGroup() {
            var _this11 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            //set only color if defined
            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new; //a new one
                this.product_item_group.product_item_group_image = 0; //set image to 0
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill"; //set color to nill
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //this.product_item_group = response.body.data;

                        _this11.product.product_item_groups = response.body.data;

                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    } else {
                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        // console.log(err)
                        _this11.deactivate_processing();
                    }
                });
            } else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            var _this12 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this12.redir(_this12.$route.params.id1); //go to sellpoint

                    _this12.removeProductPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this12.disable_btn = false;
                    _this12.redir(_this12.$route.params.id1); //go to sellpoint
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this13.redir(_this13.$route.params.id); //go to sellpoint
                    }
                    _this13.product.product_item_groups = response.body.data;
                    // location.reload(true)
                    //this.product.product_item = response.body.data;
                    //maually delete from array
                    //product_item_group.product_items.splice(this.product_item.product_item_id, 1 );
                    _this13.deactivate_processing();
                    _this13.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this13.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this14.redir(_this14.$route.params.id); //go to sellpoint
                    }
                    _this14.product.product_item_groups = response.body.data;
                    _this14.deactivate_processing();
                    _this14.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this14.deactivate_processing();
                }
            });
        },
        addProductDetail: function addProductDetail() {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            };
            service.addProductDetail(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    //toastr.success("Product Detail Added", 'Ok!');
                    this.product.product_details = data.body.data;
                    this.details = {};
                    this.deactivate_processing();
                } else {
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
                _this15.details = {};
                _this15.deactivate_processing();
            });
        },
        editProductDetail: function editProductDetail() {
            var _this16 = this;

            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                //log it
                _this16.service = {};
            });
        },
        deleteProductDetail: function deleteProductDetail(details) {
            var _this17 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                //log it
                _this17.service = {};
            });
        },
        setProductDelivery: function setProductDelivery() {
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.details = {};
                    // this.product.product_delivery_details = this.product.product_delivery;
                    this.details.edit_product_delivery = false;
                }
            }).catch(function (err) {
                //log it
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
            });
        },


        //commwnta,reviews
        addProductReview: function addProductReview() {
            var _this18 = this;

            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            };
            service.addProductReview(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    //toastr.success("Product Detail Added", 'Ok!');
                    // console.log(data.body.data)
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch(function (err) {
                //log it
                _this18.reviews = {};
            });
        },


        //more information
        getProductInformation: function getProductInformation() {
            var _this19 = this;

            service.getProductInformation(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_information = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProductInformation: function addProductInformation() {
            var _this20 = this;

            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            };
            if (payload.product_information != "nill") {
                service.addProductInformation(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        //toastr.success("Product Detail Added", 'Ok!');
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch(function (err) {
                    //log it
                    _this20.details = {};
                });
            }
        },
        editProductInformation: function editProductInformation() {
            var _this21 = this;

            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                //log it
                _this21.service = {};
            });
        },
        deleteProductInformation: function deleteProductInformation(details) {
            var _this22 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                //log it
                _this22.service = {};
            });
        },


        //delivery options
        //new
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            // toastr.success("Sellpoint Delivery Details edited",'Success!');
                            // this.product.product_delivery_options = data.body.data;
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.setProductDeliveryInformation = false;
                            //this.delivery_option = {};
                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this23.delivery_option.edit_set = false;
                        _this23.setProductDeliveryInformation = false;
                        _this23.deactivate_processing();
                    });
                } else {
                    //toastr.warning("Select a delivery option", 'Warning!');
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryFee: function deleteDeliveryFee(id) {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    //toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                //log it
                _this24.delivery_option = {};
            });
        },

        //.//new
        addDeliveryOption: function addDeliveryOption() {
            var _this25 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            //toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        //log it
                        _this25.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this26 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
                //this.delivery_option.business_id = this.sellpoint.business_id;
            };if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            // toastr.success("Sellpoint Delivery Details edited",'Success!');
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                            //this.delivery_option = {};
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this26.delivery_option.edit_set = false;
                        _this26.editDeliveryInformation = false;
                    });
                } else {
                    //toastr.warning("Select a delivery option", 'Warning!');

                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    //toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                //log it
                _this27.delivery_option = {};
            });
        },


        //./delivery option

        //set coupons and discount
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D', //or coupon
                coupon_business_category: 0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date
            };
            service.setDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setDiscount = false;
                }
            }).catch(function (err) {
                //log it
            });
        },


        // edit coupons and discount
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    //toastr.success("Discount Set", 'Update!');
                    //this.product_item.product_item_discounts = data.body.data;
                    this.editDiscount = false;
                }
            }).catch(function (err) {
                //log it
            });
        },


        // edit coupons and discount
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    payload.discount_status_id = 6; //temp setting

                    // toastr.success("Discount Set", 'Update!');
                    //  this.product_item.product_item_discounts = data.body.data;
                    //this.setComponentActions('reset-discount-coupon','');
                }
            }).catch(function (err) {
                //log it
            });
        },


        //uploads
        onFileChange: function onFileChange(e, type, data_id) {
            var _this28 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        // if(type == "product_item"){
                        //     this.product_item.product_item_image = data.body.data;
                        // }
                        if (type == "products") {
                            _this28.getProductImages();
                            if (_this28.editProductItemGroupPanel) {
                                //ie product_item_group edit going on
                                _this28.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this28.getProductInformation();
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        // log it
                    }
                });
            }
        },


        //-- /.other product settings

        //categories settings
        getSellpointCategories: function getSellpointCategories() {
            var _this29 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this29, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this29.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {
                //log it
                // this.$router.push("/")
                //console.log(err)
            });
        },


        //--./categories settings 
        handleScrollFix: function handleScrollFix(event) {
            // Any code to be executed when the window is scrolled
            var x = document.getElementById("menuHeader");
            // device detection
            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (isMobile) {
                //    if ($(window).scrollTop() >= 300) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block"; //mobile sort and filters
                } else {
                    x.style.display = "none";
                }
            }
        }
    },
    mounted: function mounted() {
        // var top = document.getElementById("wrap").offsetTop; 
        // window.scrollTo(0, top); 
    },
    created: function created() {
        // let ckeditor = document.createElement('link');   
        // ckeditor.setAttribute('href',"static/assets/css/style.css");
        // document.head.appendChild(ckeditor);
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            product: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {}
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            // $('#category-type-3').disabled = true;
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                        //get sellpoint categories
                        _this.getSellpointCategories();
                    } else {
                        //this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                    }
                });
            } else {
                //this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;
                    //let sellpoint_data = response.body.data;
                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {
                //log it
                // this.$router.push("/")
                console.log(err);
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProduct: function addProduct() {
            var _this5 = this;

            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                product_name: this.product.product_name,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');
                        //log user in
                        this.product = data.body.data;

                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.product.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                //this.product.product_image = data.body.data;
                                // location.reload(true);
                                _this4.product_info = true;
                                _this4.product_url = "/" + _this4.$route.params.id + "/" + _this4.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {
                                // log it
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        // console.log(err)
                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },


        // addProductItem(){
        //     this.disable_btn = true;
        //     //this.business.agree = true;
        //     var credentials = {
        //         product_id: this.product.product_id,
        //         product_price: this.product_item.product_item_price,
        //     }

        //     let navi = this.$router;
        //    if(credentials.product_price != undefined) {
        //         service.addProductItem(this, credentials).then(function(data) {
        //             if(data.body.status == 201) {
        //                 toastr.success("Product Item Added Successfully", 'Success!');
        //                 //log user in
        //                 this.setComponent('add-product-item','');
        //             }
        //         }).catch((err) => {
        //             if(err) {
        //                 toastr.warning("Something went wrong", 'Warning!'); 
        //                 //console.log(err)
        //                 this.disable_btn = false;
        //             }
        //         })
        //     }else {
        //         toastr.error('Kindly fill all fields', 'Warning!');
        //         this.disable_btn = false;
        //     }
        // },

        //uploads
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      // return this.cart.indexOf(this.productItem) < 0
      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      }); //best removal
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem._id = this.productItem.product_item_id;
      //config qty if not set
      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.productItem.product_item_quantity = this.productItem.product_item_quantity;
      //some settings 
      //for product items images
      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        //is color or error
        this.productItem.product_item_image = '';
      }
      //for product_shipping_calculation_method
      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;
      //../some settings 

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* ADD_TO_CART */], this.productItem);
    },

    // removeFromCart (id) {
    //   this.$store.commit(REMOVE_FROM_CART, id)
    // },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // Service Class
var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      user: {},
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      // return this.cart.indexOf(this.productItem) < 0
      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      }); //best removal
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem.active_order = true;
      this.productItem._id = this.productItem.product_item_id;
      //config qty if not set
      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_order_url = this.productMain.product_business_ownername + "-" + this.productMain.product_url_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.productItem.product_item_quantity = this.productItem.product_item_quantity;
      //some settings 
      //for product items images
      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        //is color or error
        this.productItem.product_item_image = '';
      }
      //for product_shipping_calculation_method
      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;
      //../some settings 

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["a" /* ADD_TO_CART */], this.productItem);

      this.redir('order'); //push to order
    },

    // removeFromCart (id) {
    //   this.$store.commit(REMOVE_FROM_CART, id)
    // },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    },
    configureCTAButton: function configureCTAButton() {}
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__ = __webpack_require__(43);

 // Service Class
 // Validation
 // Main Header
 // Main Footer


var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            loading: false,
            page_set: false,
            user: {},
            sellpoint: {},
            categories: {},
            voucher: {},
            voucher_name: "",
            voucher_amount: 0,
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products: {},
            product: {},
            market: {},
            product_item: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addProductPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0,

            ///
            default_banner_image: service.default_banner_image
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__["a" /* default */],
        'product-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__["a" /* default */]
    },
    methods: {
        setMenuComponent: function setMenuComponent() {},
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
            }
            if (attr1 == 'sellpoint-panel') {
                this.addProductPanel = false;
            }
            if (attr1 == 'spProductsPanel') {
                this.spMarketPanel = false;
                this.spProductsPanel = true;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                //check for market
                if (attr2 == 'market') {
                    this.spMarketPanel = true;
                }
            }
            if (attr1 == 'spProfilePanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = true;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if (attr1 == 'spContactPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if (attr1 == 'spDeliveryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
            }
            if (attr1 == 'spMessagesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
            }
            if (attr1 == 'spOrdersPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
            }
            if (attr1 == 'spSettingsPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'edit-category') {
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if (attr1 == 'reset-edit-category') {
                this.category.edit = false;
                this.category = {};
            }

            if (attr1 == 'view-all-products') {
                this.viewAllProductsBanner = false;
                this.getSellpointProducts();
            }
            if (attr1 == 'list-view') {
                this.marketView = false;
                this.listView = true;
            }
            if (attr1 == 'market-view') {
                this.marketView = true;
                this.listView = false;
            }
            if (attr1 == 'add-delivery-information') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if (attr1 == 'view-discounts') {
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'edit-service') {
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state, 'edit'); //option edit
            }
            if (attr1 == 'edit-tagline') {
                this.details = {};
                this.details.tagline_edit = true;
            }
            if (attr1 == 'edit-profile') {
                this.details = {};
                this.details.profile_edit = true;
            }
            if (attr1 == 'edit-contact-info') {
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if (attr1 == 'edit-delivery-information') {
                this.details = {};
                this.details.delivery_edit = true;
            }
            if (attr1 == 'edit-bank-details') {
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if (attr1 == 'reset-delivery-information') {
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if (attr1 == 'edit-discount-coupon') {
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if (attr1 == 'reset-discount-coupon') {
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },


        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");
            //return Home;
            return parts[0];
        },

        toggleSidebar: function toggleSidebar() {
            if (this.showSidebarMobile == true) {
                this.showSidebarMobile = false;
            } else {
                this.showSidebarMobile = true;
            }
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            //set sellpoint and seller options
                            this.setSellpoint();
                        }, _this);
                    } else {
                        //  console.log(response)
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this.$router.push('login');
                    }
                });
            } else {
                //console.log("error 2")
                this.$router.push('login');
            }
        },
        is_editing: function is_editing() {
            var _this2 = this;

            //preseting if seller
            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                        _this2.can_edit = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        //log error
                    }
                });
            }
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing(); //revalidate seller
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },


        //getIPAddress
        getIPAddress: function getIPAddress() {
            // service.getIPAddress(this).then(response => {
            //     this.ipaddress = response.data
            // }).catch((err) => {})
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    } //for edit
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    } //for edit
                    this.other_delivery_option = false;
                }
            }
        },
        viewCategoriesProducts: function viewCategoriesProducts() {},
        setSellpoint: function setSellpoint() {
            var _this5 = this;

            this.loading = true;
            var sp = "";
            if (this.$route.params.id != undefined) {
                sp = this.$route.params.id;
            } else {
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(function (response) {
                if (response.body.status == 200) {
                    _this5.sellpoint = response.body.data;
                    localStorage.setItem("sp_#_sellpoint", _this5.sellpoint.business_username); //use storage for now if buggy set in as url get param
                    _this5.is_editing();
                    _this5.getCategories(_this5.sellpoint.business_category_id);
                    _this5.getSellpointProducts(); // if basic sellpoint
                    if (_this5.sellpoint.business_market_category_id != 1) {
                        _this5.getSellpointMarket();
                        _this5.getSellpointMarketProducts();
                        // localStorage.setItem("sp_#_sellpoint",this.sellpoint.business_username);
                    }
                    _this5.spProductsPanel = true; //use loaders subsequently to make sure other above is loaded
                    _this5.loading = false;

                    //get other info
                    // this.getSellpointNotifications();
                    // this.getSellpointMessages();
                    // this.getSellpointOrders();
                    //promises hub
                    var promises = [];
                    for (var i = 0; i < 5; ++i) {
                        if (i == 1) {
                            //check for available coupons
                            promises.push(_this5.getSellpointNotifications());
                        }

                        if (i == 2) {
                            //prep delivery options
                            promises.push(_this5.getSellpointMessages());
                        }

                        if (i == 3) {
                            // check pay on delivery
                            promises.push(_this5.getSellpointOrders());
                        }
                    }

                    //process all promises
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {}).catch(function (e) {});
                    //..promises hub
                } else {
                    location.reload(true); //manage with this for now
                    // console.log(response)
                    //this.$router.push('login');
                }
            }).catch(function (err) {
                //log it
                location.replace("/");
                //console.log(err);
                _this5.loading = true;
            });
        },
        getSellpointNotifications: function getSellpointNotifications() {
            var _this6 = this;

            service.getBusinessNotifications(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this6.notifications = response.body.data;
                    _this6.notifications_unread = response.body.data_1;
                }
            }).catch(function (err) {});
        },
        getSellpointMessages: function getSellpointMessages() {
            var _this7 = this;

            service.getBusinessMessages(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.messages = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointOrders: function getSellpointOrders() {
            var _this8 = this;

            service.getBusinessOrders(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this8.orders = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarketProducts: function getSellpointMarketProducts() {
            var _this10 = this;

            service.getMarketProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this10.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this11 = this;

            service.getBusinessMarket(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.market = response.body.data;
                }
            }).catch(function (err) {
                _this11.getIPAddress();
                _this11.market = {};
                // set error payload
                var err_payload = {
                    err_int_id: _this11.user.user_id || 0,
                    err_mod_id: 5, //sellpoint page
                    err_route: _this11.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::" + err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: _this11.ipaddress
                    //service.sendErrorLog(this, err_payload).then().catch(() => {})
                    //send error to log
                };
            });
        },
        getCategories: function getCategories(category) {
            var _this12 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this12.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addCategory: function addCategory() {
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            };
            service.addCategory(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {
                //log it
            });
        },
        editCategory: function editCategory() {
            var _this13 = this;

            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {
                //log it
                _this13.category = {};
            });
        },
        getCategoryProducts: function getCategoryProducts(category) {
            var _this14 = this;

            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this14.products = response.body.data;
                    _this14.viewAllProductsBanner = true;
                    _this14.showSidebarMobile = false;
                }
            }).catch(function (err) {});
        },


        //     createSellpoint(){
        //         this.disable_btn = true;
        //         this.business.agree = true;
        //         var credentials = {
        //             business_name: this.business.business_name,
        //             business_category: this.business.business_category || 1,
        //             business_owner: this.user.user_id,
        //         }
        //         let navi = this.$router;
        //        if(credentials.business_name != undefined && credentials.business_category != undefined) {
        //             if(this.business.agree) {
        //                 service.addBusiness(this, credentials).then(function(data) {
        //                     if(data.body.status == 201) {
        //                         toastr.success("Sellpoint Creation Successfull", 'Success!');
        //                         //log user in
        //                         this.business = data.body.data;
        //                         this.setComponent('add-product','');
        //                     }
        //                 }).catch((err) => {
        //                     if(err) {
        //                         toastr.warning("Something went wrong", 'Warning!'); 
        //                         this.disable_btn = false;
        //                         console.log(err)
        //                     }
        //                 })
        //             }else {
        //                 toastr.error('Please agree to Terms', 'Warning!');
        //                 this.disable_btn = false;
        //             }
        //         }else {
        //             toastr.error('Kindly fill all fields', 'Warning!');
        //             this.disable_btn = false;
        //         }
        // },

        //uploads
        onFileChange: function onFileChange(e, type) {
            var _this15 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this15.sellpoint.business_banner_image = data.body.data;
                        }
                        if (type == "business_brand_image") {
                            _this15.sellpoint.business_brand_image = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        // log it
                    }
                });
            }
        },
        addService: function addService() {
            var _this16 = this;

            var payload = {
                business_service: this.service.service_name || "Service Details",
                business_id: this.sellpoint.business_id
            };
            service.addService(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Service Added Successfully", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service = {};
                }
            }).catch(function (err) {
                //log it
                _this16.service = {};
            });
        },
        editService: function editService() {
            var _this17 = this;

            this.service.business_id = this.sellpoint.business_id;
            service.editService(this, this.service).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Service edited", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service.edit_set = false;
                    this.service = {};
                }
            }).catch(function (err) {
                //log it
                _this17.service = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this18 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        //log it
                        _this18.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this19 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
                //this.delivery_option.business_id = this.sellpoint.business_id;
            };if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Sellpoint Delivery Details edited", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                            //this.delivery_option = {};
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this19.delivery_option.edit_set = false;
                        _this19.editDeliveryInformation = false;
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this20 = this;

            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details deleted", 'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                //log it
                _this20.delivery_option = {};
            });
        },


        //delivery option

        editBusinessDetails: function editBusinessDetails(attr) {
            var _this21 = this;

            if (attr == "tagline") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_tagline: this.sellpoint.business_tagline
                };
            }
            if (attr == "profile") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_profile: this.sellpoint.business_profile
                };
            }
            if (attr == "contact_info") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint edited", 'Success!');
                }
                this.details = {};
            }).catch(function (err) {
                //log it
                _this21.details = {};
            });
        },
        sendBusinessContactForm: function sendBusinessContactForm() {
            var _this22 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            };
            service.sendBusinessContactForm(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch(function (err) {
                //log it
                _this22.contact_form = {};
            });
        },


        //set coupons and discount
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            //validate entry
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    product_item_id: 0,
                    is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                    coupon_business_category: this.discount_coupon.discount_category,
                    coupon_percentage: this.discount_coupon.discount_percentage,
                    coupon_start_date: this.discount_coupon.discount_start_date,
                    coupon_end_date: this.discount_coupon.discount_end_date
                };
                service.setDiscountsAndCoupons(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("New Discount Set", 'Update!');
                        this.sellpoint.business_discounts_coupons = data.body.data;
                        this.setComponentActions('reset-discount-coupon', '');
                    }
                }).catch(function (err) {
                    //log it
                });
            } else {
                validated_arr.forEach(function (error) {
                    toastr.error(error);
                }, this);
            }
        },


        // edit coupons and discount
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {
                //log it
            });
        },


        // edit coupons and discount
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {
                //log it
            });
        },


        //set bank details
        setBankDetails: function setBankDetails() {
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Bank Details Set", 'Update!');
                }
                this.set_bank_details = false;
            }).catch(function (err) {
                //log it
            });
        },


        //processing fee switch
        switchProcessingFee: function switchProcessingFee(to) {
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Processing Fee Set", 'Reset!');
                    this.sellpoint.business_processing_fee_pay_status = to;
                }
            }).catch(function (err) {
                //log it
            });
        },


        //read general notifications for all messages, orders and notifications
        readNotifications: function readNotifications() {
            this.notifications_unread = 0; //read all
            var payload = {
                notification_type: "business",
                notification_module: "notifications",
                notification_business: this.sellpoint.business_username
            };
            service.readNotifications(this, payload).then(function (data) {}).catch(function (err) {});
        },


        /////********vstore */
        createVoucher: function createVoucher() {
            // this.disable_btn = true;
            // //this.business.agree = true;
            // var credentials = {
            //     business_id: this.sellpoint.business_id,
            //     business_voucher_name: this.voucher_name,
            //     business_voucher_amount: this.voucher_amount || 1000,
            //     business_voucher_duration: this.voucher.duration || 10,
            //     business_voucher_paid_by: this.voucher.paid_by || 0
            // }

            // let navi = this.$router;
            // if(credentials.business_voucher_name != undefined) {
            //     service.createBusinessVoucher(this, credentials).then(function(data) {
            //         if(data.body.status == 201) {
            //             toastr.success("Voucher Added Successfully", 'Success!');
            //            // this.product = data.body.data;

            //generate image
            // var cnvs = document.getElementById('cnvs'),
            // ctx = cnvs.getContext('2d'),
            // mirror = document.getElementById('mirror');

            // cnvs.width = mirror.width = window.innerWidth;
            // cnvs.height = mirror.height = window.innerHeight;

            // html2canvas(document.querySelector("#vouchercapture")).then(canvas => {
            //     console.log(canvas)
            //     document.body.appendChild(canvas)
            //      // Convert and download as image 
            //   // Canvas2Image.saveAsPNG(canvas); 
            //     $("#doty").append("canvas");
            //     $("#doty").append(canvas);
            //     let formData = new FormData();
            //     let imagedata = canvas.toDataURL('image/png');
            //     let imgdata = imagedata.replace(/^data:image\/(png|jpg);base64,/, "");
            //     formData.append('photo', imgdata);
            //     formData.append('data_id', this.sellpoint.business_id); 
            //     formData.append('data_type', "business_voucher"); 
            //     service.uploadBusinessDataPhoto(this, formData).then(data => {
            //         if(data.body.status == 200){
            //         //close modal and reload
            //         }
            //         }).catch((err) => {
            //                 if(err) {console.log(err)
            //                 // log it
            //                 }
            //             toastr.warning("Something went wrong.", 'Warning!');
            //     })
            // }); 


            //         }
            //     }).catch((err) => {
            //         if(err) {
            //             toastr.warning("Something went wrong", 'Warning!'); 
            //            // console.log(err)
            //             this.disable_btn = false;
            //         }
            //     })
            // }else {
            //     toastr.error('Kindly fill all fields', 'Warning!');
            //     this.disable_btn = false;
            // }
        }
    },
    mounted: function mounted() {
        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.setSellpoint();
        }
    },
    created: function created() {
        this.loading = true;
        // //this.setSellpoint();
        // if((localStorage.getItem("sp_token")) != undefined){
        //    // this.preset();
        // }else{
        //     this.setSellpoint();
        // }
        this.getStates();
        this.getIPAddress();
    }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__ = __webpack_require__(43);
 // Service Class
 // Validation
 // Main Header
 // Main Footer


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SellpointTemplate',
    data: function data() {
        return {
            loading: false,
            page_set: false,
            user: {},
            sellpoint: {},
            categories: {},
            voucher: {},
            voucher_name: "",
            voucher_amount: 0,
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products: {},
            product: {},
            market: {},
            product_item: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addProductPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__["a" /* default */],
        'product-form': __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__["a" /* default */]
    },
    methods: {}
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);

 // Service Class
 // Service Class
 // Main Header
 // Main Footer


var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Account',
    data: function data() {
        var componentInstance = this;
        return {
            //defaults
            user: {},
            sellpoints: {},
            sellpoint: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},
            //.../defaults

            //more settings
            states: {},
            cities: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            managePanel: false,
            manageBusinesses: true, //default view
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            //productitems settings
            showProductItemGroups: true,
            //...more--settings

            //loobook settings
            viewing_lookbook: {}, //store viewing lookbook for product swich
            viewing_lookbook_post: {},
            is_viewing_lookbook: false,

            drag_options: {
                // dropzoneSelector: 'ul',
                // draggableSelector: 'li',
                //     showDropzoneAreas: true,
                //     multipleDropzonesItemsDraggingEnabled: true,
                //     onDrop(event) {
                //       console.log(event);
                //     },
                //     onDragstart(event) {
                //       event.stop();
                //     },
                onDragend: function onDragend(event) {
                    // if you need to stop d&d
                    // event.stop();

                    // you can call component methods, just don't forget 
                    // that here `this` will not reference component scope,
                    // so out from this returned data object make reference
                    // to component instance
                    // componentInstance.onDragChangerr();

                    // to detect if draggable element is dropped out
                    if (!event.droptarget) {
                        console.log('event is dropped out');
                    }
                }
            }

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__["a" /* default */],
        'product-item-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__["a" /* default */]
    },

    methods: {
        onDragChangerr: function onDragChangerr() {
            console.log("jku");
        },
        onDragChange: function onDragChange(gallery) {

            console.log(gallery);
        },

        // allowDrop(ev) {
        //     ev.preventDefault();
        //   },

        //  drag(ev,gallery) {
        //      if(ev){
        //         ev.dataTransfer.setData("text", ev.target.id);
        //         console.log(gallery)
        //      }

        //   },

        //  drop(ev) {
        //     ev.preventDefault();
        //     var data = ev.dataTransfer.getData("text");
        //     ev.target.appendChild(document.getElementById(data));
        // },
        //---default--settings
        setComponent: function setComponent(attr1, attr2) {
            this.resetAll();
            this.data_processing_message = ""; //refresh
            this.deactivate_processing(); //first deactivate any active processing

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true; //default
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state, 'edit'); //option edit
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
                // this.component_view.viewLookbooks = true
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }
        },
        setInnerComponent: function setInnerComponent(attr1, attr2) {
            //product-items--add--imports
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2;
                //styling to show selecte active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }
                // document.getElementById(attr2+"PRTGR").style.border = "1px solid #0000CC";
                document.getElementById(attr2 + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                    //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            //product-items--add-imports
        },


        //reset main substitute
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        setMenuComponent: function setMenuComponent(go_to) {
            this.setPanel = false;
            this.managePanel = false;
            //cont
            var section = document.getElementById(go_to).offsetTop;
            window.scrollTo(0, section);
        },
        setComponentView: function setComponentView(attr1, attr2, attr3) {
            this.resetAll();
            if (attr1 == 'switch-to-viewing-loobook') {
                //a special toggle switch case
                //switcth to lookbook view
                this.setComponent('manage-lookbooks', ''); //topmost layout
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks', this.viewing_lookbook_post, 'viewLookbookPost');

                //reset
                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};
            }
            if (attr1 == 'products') {
                if (this.component_view.viewProducts) {
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;
                    //some products settings
                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                    // localStorage.setItem("viewing-01", this.product.product_url_name);
                } else if (this.component_view.viewProduct) {
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
            }
            if (attr1 == 'lookbooks') {
                if (attr3 == 'viewLookbookPost') {
                    //setting post in lookbook
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                    //some lookbook_post settings
                    //localStorage.setItem("viewing-02", this.lookbook_post.post_url_name);
                } else if (attr3 == 'viewLookbook') {
                    //sets lookbook in lookbooks
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                } else if (attr3 == 'viewLookbooks') {
                    //sets lookbooks ../default
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
            }
        },
        setBusinessComponent: function setBusinessComponent(component) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.businessComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var arr = _step.value;

                    if (arr == this.businessComponents[component]) {
                        this.businessComponents[component] = true;
                    } else {
                        // console.log(this.businessComponents[this.businessComponents.indexOf(arr)])
                        this.businessComponents[this.businessComponents.indexOf(arr)] = false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        setProductComponent: function setProductComponent(component, attr2, attr3) {
            this.deactivate_processing(); //first deactivate any active processing
            this.discount_coupon = {}; //reset
            // if(attr2 == 'product'){   ////already set by default..//commented to avoid empty / null override
            //     this.product = attr3;
            // }
            if (attr2 == 'productitemgroup') {
                this.product_item_group = attr3;
            }
            if (attr2 == 'productitem') {
                this.product_item = attr3;
            }

            //some settings
            if (component == "addProductItemPanel") {
                if (this.product.product_set_groups == 0) {
                    this.showProductItemGroups = 'showfalse'; //no items found
                }
            }
            if (component == 'setProductDeliveryInformation') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (component == 'editDiscount') {
                this.discount_coupon = attr3;
            }
            if (component == 'deactivateDiscount') {
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3);
            }

            this.product_details = {};
            this.product_details[component] = true;
        },
        setLookbookComponent: function setLookbookComponent(component, attr2, attr3) {
            this.deactivate_processing(); //first deactivate any active processing

            if (component == "viewProductLookbookPost") {
                //navigate to product lookbook page //store parent lookbook
                this.viewing_lookbook = this.lookbook; //store parent lookbook
                this.viewing_lookbook_post = attr3; //store the product post
                this.is_viewing_lookbook = true; //save activity

                //switch to product view
                this.setComponent('manage-products', ''); //topmost layout
                this.setComponentView('products', attr3.gallery_post_product_details, ''); //set the product view
            } else {
                //other settings

                this.lookbook_details = {};
                this.lookbook_details[component] = true;
            }
        },
        toggleSwitchBusiness: function toggleSwitchBusiness() {
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        switchBusiness: function switchBusiness(sellpoint) {
            this.sellpoint = sellpoint;
            this.galleria = {}; //a hack for refresh
            this.setSellpoint();
            //check if toggle effect
            this.toggleSwitchBusiness();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this2 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            // this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this4.user = data.body.data;
                                    //get sellpoints
                                    _this4.getSellpoints(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {
                                    // toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            });
                            //../special case for profile
                        }, _this3);
                    } else {
                        //reauth or ..login
                        _this3.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {
                        //console.log(err)
                        //  this.$router.push('/login/');
                    }
                });
            } else {
                //this.$router.push('/login/');
            }
        },
        syncset: function syncset(request_page) {
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page
            };
            if (credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //redirect to sp with session ref
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {
                        // console.log(err)
                        // this.$router.push('/login/');
                    }
                });
            }
        },


        //profile
        editProfileDetails: function editProfileDetails() {
            var _this5 = this;

            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email

                //test data
            };var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_processing_message = "";
            }
            if (data_test) {
                if (payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        } else {
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        }
                    }).catch(function (err) {
                        //log it
                        _this5.data_processing_message = "Could not edit details, something went wrong, please try again";
                        _this5.deactivate_processing();
                        _this5.setSettings = false;
                        _this5.setting_details = {};
                    });
                }
            }
        },

        //./profile

        getSellpoints: function getSellpoints(user) {
            var _this6 = this;

            // this.loading = true; //disable for now
            this.loading = false;
            service.getAppBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this6.sellpoints = data.body.data;
                    _this6.sellpoint = _this6.sellpoints[0];
                    _this6.business_set_shipping_fee_status = _this6.sellpoint.business_set_shipping_fee_status;
                    //get the gallery of the sellpoint
                    _this6.setSellpoint();
                    _this6.loading = false; //disable for now
                }
            }).catch(function (err) {
                if (err) {
                    //log it
                    // console.log(err)
                }
            });
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.activate_processing();
            service.getAppBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint_gallery = response.body.data;

                    //get this sellpoint products
                    _this7.getSellpointProducts();

                    //dummy settings
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Free Plan') {
                        _this7.max_plan_lookbooks = 2;
                        _this7.max_plan_lookbook_posts = 5;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Basic Plan') {
                        _this7.max_plan_lookbooks = 10;
                        _this7.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Premium Plan') {
                        _this7.max_plan_lookbooks = 50; //unlimited
                        _this7.max_plan_lookbook_posts = 50; //unlimited
                        _this7.can_add_product_lookbook = true; //online shop functionality
                    }

                    var self = _this7;
                    setTimeout(function () {
                        self.setGallery();
                    }, 3000); //wait for 3sec and call posts in gallery

                    //continue
                    //new-get new categories
                    _this7.getCategories(_this7.sellpoint.business_category_id);
                    //set sellpoint categories
                    _this7.getSellpointCategories();
                }
            }).catch(function (err) {});
        },
        setGallery: function setGallery() {
            var _this8 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this8.galleria = response.body.data;
                //settings
                _this8.total_lookbooks_added = response.body.total_data;

                if (_this8.total_lookbooks_added < _this8.max_plan_lookbooks) {
                    _this8.can_add_more_lookbook = true;
                }
                _this8.deactivate_processing();
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },


        ////../default settings

        /*----------------------Adminboarding------------------------------------------*/
        //business--settings
        getCategories: function getCategories(category) {
            var _this10 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this10.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },


        //categories settings
        getSellpointCategories: function getSellpointCategories() {
            var _this11 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this11, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this11.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {
                //log it
                // this.$router.push("/")
                //console.log(err)
            });
        },


        //editbusiness
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this12 = this;

            // this.activate_processing();
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            } else {
                var payload = {
                    business_main_details: true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Sellpoint edited";
                    if (attr == "delivery") {
                        this.business_details = {};
                    } else {
                        this.manageBusinessDetails = false;
                        //show top
                        var top = document.getElementById("top").offsetTop;
                        window.scrollTo(0, top);
                        this.deactivate_processing();
                    }

                    // setTimeout(function(){ 
                    //     location.reload(); //reload page
                    // }, 600);
                } else {
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
                _this12.data_processing_message = "Could not edit details, something went wrong, please try again";
                _this12.deactivate_processing();
            });
        },


        //delivery
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    } //for edit
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    } //for edit
                    this.other_delivery_option = false;
                }
            }
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            // toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        _this13.delivery_option = {};
                        _this13.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
                //this.delivery_option.business_id = this.sellpoint.business_id;
            };if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            // toastr.success("Sellpoint Delivery Details edited",'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};
                            // this.editDeliveryInformation = false;
                            //this.delivery_option = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this14.delivery_option.edit_set = false;
                        _this14.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    // toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                //log it
                _this15.delivery_option = {};
                _this15.deactivate_processing();
            });
        },


        //set shipping fee status
        setShippingFeeStatus: function setShippingFeeStatus() {
            this.activate_processing();
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                // if(data.body.status == 200) {
                // toastr.success("Shipping Fee Ordering Set", 'Reset!');
                this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                this.deactivate_processing();
                // }
            }).catch(function (err) {
                //log it
            });
        },

        //.../delivery

        //coupons and discounts
        //set coupons and discount
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var _this16 = this;

            this.activate_processing();
            this.data_processing_message = "";
            //settings for product and producitems
            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1; //HACK..TO LET GO ../ASSIGNED 1 instead of 0.
            }

            //validate entry
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    //set for business category
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    //set for product and product items
                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }
                    //set for product and product items

                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                        coupon_business_category: discount_category,
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            // toastr.success("New Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;
                                        var _iteratorNormalCompletion3 = true;
                                        var _didIteratorError3 = false;
                                        var _iteratorError3 = undefined;

                                        try {
                                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                var row = _step3.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                            // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                    _iterator3.return();
                                                }
                                            } finally {
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        //log it
                        _this16.deactivate_processing();
                    });
                } //date reset check
            } else {
                validated_arr.forEach(function (error) {
                    // toastr.error(error); 
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },


        // edit coupons and discount
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            var _this17 = this;

            this.data_processing_message = "";
            //validate entry
            var entry_arr = [["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                        if (data.body.status == 200) {
                            // toastr.success("Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var item = _step4.value;
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var row = _step5.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                            // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        //log it
                        _this17.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    // toastr.error(error); 
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },


        // edit coupons and discount
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            var _this18 = this;

            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    // toastr.success("Discount Set", 'Update!');
                    // this.sellpoint.business_discounts_coupons = data.body.data;
                    this.business_details.viewDiscounts = true;
                    if (this.product.product_id) {
                        var res = data.body.data;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var item = _step6.value;
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var row = _step7.value;

                                        if (row.product_item_id == item.product_item_id) {
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    } else {
                        this.sellpoint.business_discounts_coupons = data.body.data;
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch(function (err) {
                //log it
                _this18.deactivate_processing();
            });
        },


        //../coupons and discounts

        //
        //../...business--settings

        //.....product--settings------/

        //images
        getProductImages: function getProductImages() {
            var _this19 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_images = response.body.data;
                    _this19.product_display_image = _this19.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            var _this20 = this;

            this.activate_processing();
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this20.deactivate_processing();
            });
        },

        //images
        //edit product
        editProduct: function editProduct() {
            var _this21 = this;

            this.activate_processing();
            //this.business.agree = true;
            //some settings
            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                //if either of 2 where selected
                set_product_category = 0; //make product_category 0
            } else {
                if (this.product.product_category != undefined) {
                    //if new product_category is selected
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id; //current product_category
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                // product_category: this.product.product_category || this.product.product_category_id, //before

                //new
                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                //

                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id //new to help with category settings
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //toastr.success("Product Updated", 'Success!');
                        _this21.product = response.body.data;
                        _this21.product_details = {};
                        // navi.push("/"+this.product.product_business_ownername+"/"+this.product.product_url_name);
                    } else {
                        _this21.product_details = {};
                        _this21.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        //toastr.warning("Something went wrong", 'Warning!'); 
                        _this21.data_processing_message = "Something went wrong";
                        _this21.product_details = {}; //manage with this for now
                        _this21.deactivate_processing();
                    }
                });
            } else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        editProductSingleProductItem: function editProductSingleProductItem() {
            var _this22 = this;

            this.activate_processing();
            //quick check for product item
            var set_product_item = 0;
            var current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if (this.product.product_items[0].product_item_actual_price != 0) {
                set_product_item = this.product.product_items[0].product_item_actual_price;
            } else {
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this22.product.product_items[0] = response.body.data;
                        _this22.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price; //rehack later
                        _this22.deactivate_processing();
                        _this22.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this22.data_processing_message = "Update failed, Something went wrong";
                        _this22.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },


        //edit product
        editProductSettings: function editProductSettings() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item'
            };

            var navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this23.product = response.body.data;
                    _this23.product_details = {};
                } else {
                    _this23.product_details = {};
                    _this23.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this23.data_processing_message = "Something went wrong";
                    _this23.product_details = {}; //manage with this for now
                    _this23.deactivate_processing();
                }
            });
        },
        addProductItem: function addProductItem() {
            var _this24 = this;

            this.activate_processing();
            if (this.product_details.addProductItemToGroup) {
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1, //default add to ist group

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            } else {
                var new_product_item_group = false;
                var product_item_group_is_color_image = 'IMG';
                if (this.product.product_item_group == undefined) {
                    new_product_item_group = true;
                }
                if (this.product.product_item_group_color == undefined) {
                    product_item_group_is_color_image = 'IMG';
                } else {
                    product_item_group_is_color_image = 'COL';
                    this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    //new product_items_group_details
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,
                    //./..new .product_items_group_details

                    product_item_group: this.product.product_item_group || 1, //default add to ist group

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            }
            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;
                        // this.product_details.addProductItemPanel = false;
                        this.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this24.data_error_message = "Something went wrong", 'Warning!';
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        //  console.log(err)
                        // this.disable_btn = false;
                        _this24.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                // this.disable_btn = false;
                this.deactivate_processing();
            }
        },


        //edit product item
        editProductItem: function editProductItem() {
            var _this25 = this;

            this.activate_processing();
            //quick check for product item
            var set_product_item = 0;
            if (this.product_item.product_item_actual_price != 0) {
                set_product_item = this.product_item.product_item_actual_price;
            } else {
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this25.product_item = response.body.data;
                        _this25.deactivate_processing();
                        _this25.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        // console.log(err)
                        _this25.data_processing_message = "Update failed, Something went wrong";
                        _this25.deactivate_processing();
                    }
                });
            } else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },


        //edit product item group
        editProductItemGroup: function editProductItemGroup() {
            var _this26 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            //set only color if defined
            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new; //a new one
                this.product_item_group.product_item_group_image = 0; //set image to 0
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill"; //set color to nill
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        //this.product_item_group = response.body.data;

                        _this26.product.product_item_groups = response.body.data;

                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    } else {
                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        // console.log(err)
                        _this26.data_processing_message = 'Update failed, Something went wrong';
                        _this26.deactivate_processing();
                    }
                });
            } else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    location.reload(true);
                    // this.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    location.reload(true);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this27 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this27.redir(_this27.$route.params.id); //go to sellpoint
                    }
                    _this27.product.product_item_groups = response.body.data;
                    // location.reload(true)
                    //this.product.product_item = response.body.data;
                    //maually delete from array
                    //product_item_group.product_items.splice(this.product_item.product_item_id, 1 );
                    _this27.deactivate_processing();
                    _this27.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this27.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this28 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this28.redir(_this28.$route.params.id); //go to sellpoint
                    }
                    _this28.product.product_item_groups = response.body.data;
                    _this28.deactivate_processing();
                    _this28.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    //console.log(err)
                    _this28.deactivate_processing();
                }
            });
        },
        setProductDelivery: function setProductDelivery() {
            var _this29 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product_details = {};
                }
                this.deactivate_processing();
            }).catch(function (err) {
                //log it
                _this29.product_details = {};
                _this29.deactivate_processing();
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                // if(data.body.status == 200) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
                // }
            }).catch(function (err) {
                //log it
            });
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this30 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            // toastr.success("Sellpoint Delivery Details edited",'Success!');
                            // this.product.product_delivery_options = data.body.data;
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.product_details = {};
                            //this.delivery_option = {};
                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        //log it
                        //this.delivery_option = {};
                        _this30.delivery_option.edit_set = false;
                        _this30.product_details = {};
                        _this30.deactivate_processing();
                    });
                } else {
                    //toastr.warning("Select a delivery option", 'Warning!');
                    this.deactivate_processing();
                }
            }
        },


        //---./product-settings---------/

        //---lookbook-settings---------/
        addPostToGallery: function addPostToGallery() {
            var _this32 = this;

            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this31 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        //log user in
                        this.post = data.body.data;

                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                //this.product.product_image = data.body.data;
                                // location.reload(true);
                                // this.product_info = true;
                                _this31.setGallery();
                                _this31.gallery = data.body.data_gallery;
                                _this31.addNewPost = false;
                                _this31.edit_mode = false;
                                //this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {
                                // log it
                                console.log(err);
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        // console.log(err)
                        _this32.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editLookbook: function editLookbook() {
            var _this33 = this;

            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description: this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";
                        //log user in
                        // this.gallery = data.body.data;
                        //reset lookbook
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this33.data_processing_message = "Something went wrong";
                        // console.log(err)
                        _this33.deactivate_processing();
                        _this33.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },
        deleteLookbook: function deleteLookbook() {
            var _this34 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {
                    //return to sellpoint
                    //location.replace('/'+this.$route.params.id); //go to sellpoint
                    // reset data
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this34.deactivate_processing();
                    _this34.lookbook_details = {};
                    _this34.data_processing_message = "Something went wrong";
                    // console.log(err)
                    // this.disable_btn = false;
                }
            });
        },
        editLookbookPost: function editLookbookPost() {
            var _this35 = this;

            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details: this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";
                        //log user in
                        // this.gallery = data.body.data;
                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data; //refresh data
                    } else {
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this35.data_processing_message = "Something went wrong";
                        // console.log(err)
                        _this35.deactivate_processing();
                        _this35.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        deleteLookbookPost: function deleteLookbookPost() {
            var _this36 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.lookbook = data.body.data; //refresh data
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this36.deactivate_processing();
                    _this36.data_processing_message = "Something went wrong";
                    _this36.lookbook_details = {};
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },

        //---./lookbook-settings---------/

        //resets
        resetComponentData: function resetComponentData(component) {
            var _this37 = this;

            if (component == 'lookbook') {
                service.resetData(this, "gallery", this.lookbook.gallery_posts_group_url_name).then(function (response) {
                    if (response.body.status == 200) {
                        var lookbook = response.body.data;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lookbook.gallery_posts_group_posts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var post = _step8.value;

                                if (post.gallery_post_id == _this37.lookbook_post.gallery_post_id) {
                                    _this37.lookbook_post = post;
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }

                        _this37.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
        },


        //uploads
        onFileChange: function onFileChange(e, type, data_id) {
            var _this38 = this;

            this.product_details = {}; //hack
            this.product_details.uploading_image = true;
            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;

                // if(!this.product_details.uploading_image){ //hack for disable double request
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        // if(type == "product_item"){
                        //     this.product_item.product_item_image = data.body.data;
                        // }
                        if (type == "products") {
                            _this38.getProductImages();
                            if (_this38.product_details.editProductItemGroup) {
                                //ie product_item_group edit going on
                                _this38.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this38.getProductInformation();
                        }
                        _this38.deactivate_processing();
                    } else {
                        _this38.data_processing_message = "Something went wrong uploading media, please try again";
                        _this38.deactivate_processing();
                    }
                    _this38.product_details.uploading_image = false;
                }).catch(function (err) {
                    _this38.data_processing_message = "Something went wrong uploading media, please try again";
                    _this38.deactivate_processing();
                    _this38.product_details.uploading_image = false;
                });
            }
            // }   
        },

        //productitems
        onFileChangeProductItems: function onFileChangeProductItems(e, type, data_id) {
            var _this39 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this39.product.product_item_group_image = data.body.data_id;
                            _this39.data_media_error_message = "";
                            _this39.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {
                        // log it
                    }
                });
                //if uploading takes time continue with reload
                this.data_media_error_message = service.media_upload_timeout_msg;
                var self = this;
                setTimeout(function () {
                    self.data_media_error_message;
                }, 65000); //wait for 1min and timeout
                setTimeout(function () {
                    // location.reload(true); 
                    self.data_media_error_message = "";
                }, 95000); //wait for 1min and timeout
            }
        },

        //lookbooks
        //uploads for adding media to gallery post
        onFileChangeLookbook: function onFileChangeLookbook(e, type, data_id) {
            var _this40 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "gallery_media") {
                            _this40.resetComponentData("lookbook");
                        }
                    } else {
                        _this40.data_processing_message = "Sorry Upload Failed";
                    }
                    _this40.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        // log it
                        _this40.data_processing_message = "Sorry Upload Failed";
                        _this40.deactivate_processing();
                    }
                });
            }
        }
    },
    created: function created() {
        document.title = "Account" + " | Gallery";
        this.getStates();
        this.preset();
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(3);
 // Service Class
 // Main Header
 // Main Footer


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__["a" /* default */],
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__["a" /* default */]
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    //set the banner image 
                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        //assign gw general banner image
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        //use the sellpoints banner image
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    //dummy settings
                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50; //unlimited
                        _this.max_plan_lookbook_posts = 50; //unlimited
                        _this.can_add_product_lookbook = true; //online shop functionality
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
                //move
                //maybe no connection ..load from local
                // this.setSellpointLocal(); //removed...caused slower loading
            });
        }
    },

    created: function created() {
        this.setSellpoint();
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(10);
 // Service Class


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//let service = new services();


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__["a" /* default */]
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Cart" + " | SP";
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a358831_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(226);
function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a358831"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a358831_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(10);



 // Service Class

var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//let service = new services();


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            product_delivery_fee: "",
            sellpoint_delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            loggedIn: false,
            buy_now_order: false
        };
    },

    components: {},
    computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["i" /* REMOVE_FROM_CART */], item_id);

            //new
            this.prepCart(); //refresh hack
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            }); //best removal
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            //sort min cart into sorted carts
            var sorted_cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.cart.reduce(function (result, obj) {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));
            //../sort min cart into sorted carts

            var count = 0;var sorted_cart_array = [];
            sorted_cart.forEach(function (element) {
                var _this = this;

                var pre_sort = [];

                //some watchers
                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                //loop through cart items to keep default settings
                element.forEach(function (item) {
                    //some settings
                    item.can_remove = true; //help in switching delete and not delete
                    item.display_delivery_details = false;

                    item.has_delivery = false; //reset
                    if (item.product_checked) {
                        item.product_checked = false;
                    }
                    //check products with specific delivery details
                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        //recheck
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        } else {
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort[0] = element[0].product_business;
                pre_sort[1] = element; //the cart items
                pre_sort.items_in_checkout = 0; // assign true if products are assigned to cart
                pre_sort.total_order_amt = 0.0; //assign shop total orders
                pre_sort.delivery_option_fee = 0.0; //asign delivery fee
                pre_sort.total_delivery_charge = 0.0; //including products individual delivery
                pre_sort.order_coupons_discounts = []; // for all selectedcoupons

                //promises hub
                var promises = [];
                for (var i = 0; i < 5; ++i) {
                    if (i == 1) {
                        //check for available coupons
                        promises.push(service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                            //recheck
                            if (response.body.status == 200) {
                                pre_sort[4] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 2) {
                        //prep delivery options
                        promises.push(service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                            //recheck
                            if (response.body.status == 200) {
                                var delivery_options = response.body.data;
                                //initially
                                // pre_sort[2] = response.body.data;
                                //../initially

                                //updated
                                //check if this business sorted cart has only one item and if that item has product id set
                                //check element length
                                if (element.length == 1) {
                                    delivery_options.forEach(function (item) {
                                        var fees = item.business_products_delivery_fees;
                                        //check first if has products delivery fee
                                        if (fees.length != 0) {
                                            //loop through the product_delivery fees of each one
                                            fees.forEach(function (fee) {
                                                //check if element has set product delivery fee
                                                if (element[0].product_main_id == fee.product_delivery_product) {
                                                    //attach has_product_delivery_fee
                                                    item.has_product_delivery_fee = true;
                                                    item.business_product_delivery_fee = fee.product_delivery_fee;
                                                    pre_sort[2] = delivery_options;
                                                }
                                            }, this);
                                        } else {
                                            pre_sort[2] = delivery_options;
                                        }
                                    }, _this);
                                } else {
                                    pre_sort[2] = delivery_options;
                                }
                                //--./updated

                                //also updated ... business_shipping_calculation_method ../handle undefined errors later
                                pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;
                            } else {
                                pre_sort.delivery_option = "Free Delivery"; //set by default
                            }

                            // check pay on delivery
                            // service.checkBusinessPayOnDelivery(this, element[0].product_business).then(response => {
                            //     if(response.body.status == 200) {
                            //         pre_sort[3] = response.body.data;
                            //         sorted_cart_array.push(pre_sort);
                            //     }
                            // }).catch((err) => {})
                            // sorted_cart_array.push(pre_sort);
                        }).catch(function (err) {}));
                    }

                    if (i == 3) {
                        // check pay on delivery
                        promises.push(service.checkBusinessPayOnDelivery(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[3] = response.body.data;
                                // sorted_cart_array.push(pre_sort);
                            }
                        }).catch(function (err) {}));
                    }
                }

                //process all promises
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    // for(i=0;i<promises.length;i++){
                    sorted_cart_array.push(pre_sort);
                    // }
                }).catch(function (e) {
                    // handle errors here
                });
                //..promises hub
            }, this);

            this.sorted_cart = sorted_cart_array;

            return this.sorted_cart;
            // return []
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            //this.checkout();
                            this.prepCart();
                        }, _this2);
                        _this2.loggedIn = true;
                    } else {
                        //this.$router.push('login');
                    }
                    _this2.loading = false;
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                        //console.log(err)
                    }
                });
            } else {
                this.$router.push('login');
            }
        },


        //add or remove selected coupons
        set_coupons: function set_coupons(i, coupon, coupon_percentage) {
            var calc = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                //check if a product from this group had been added to checkout 
                if (!coupon.added) {
                    //not selected
                    //calc the percentage value with sellpoint current order amount
                    calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                    // add to sellpoint used coupons
                    coupon.added = true; //set coupon
                    coupon.value = calc; //set coupon
                    this.sorted_cart[i].order_coupons_discounts.push(coupon);

                    // remove from sellpoint current order amount
                    this.sorted_cart[i].total_order_amt -= calc;

                    // remove from total current order price
                    this.total_order_amt -= calc;
                } else {
                    //selected before
                    //get the coupon percentage valu
                    calc = coupon.value;

                    // remove to sellpoint used coupons
                    coupon.added = false; //set coupon
                    var index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    }); //best removal
                    this.sorted_cart[i].order_coupons_discounts.splice(index, 1);

                    // add to sellpoint current order amount
                    this.sorted_cart[i].total_order_amt += calc;

                    // add to total current order price
                    this.total_order_amt += calc;
                    coupon.value = 0; //reset coupon percentage value
                }
            } else {
                //toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
        },


        // calc_delivery_fee(i,option,option_fee){
        //     //first check if already calculated delivery fee
        //     if(this.sorted_cart[i].delivery_option_fee != 0.0){
        //         this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee
        //     }
        //     this.sorted_cart[i].delivery_option = option;
        //     this.sorted_cart[i].delivery_option_fee = option_fee;
        //     //update delivery fee with new one
        //     this.total_delivery_fee += option_fee
        // }, // when radio button

        //for type of product(P) or sellpoint(SP)
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            //first check if this product's delivery option has been added
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option; //for display

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);

            //update delivery fees with new one
            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },


        //sellpoint
        calc_sellpoint_delivery_fee_XXX: function calc_sellpoint_delivery_fee_XXX(i, option) {
            //first check if already calculated delivery fee and deduct
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option; //for display

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            //cos product delivery may occur
            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            //update delivery fee with new one
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },

        //NEW with independent delivery_option product delivery fee calculations and CONSTRAINTS inclusions
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            //first check if already calculated delivery fee and deduct
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            //display
            this.sorted_cart[i].selected_business_delivery_option = option; //for display
            //assign
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            //calculate

            //....b4.... this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            //...new--now
            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;

            //check: if option does not have product delivery fees set
            var fees = option.business_products_delivery_fees;
            if (fees.length == 0) {
                //calculate delivery with Business Constraints
                if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                    //one charge for all items ordered in this business
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                } else {
                    //constraints would affect/charge each item in this business
                    // filter get items of this business sorted cart that has been selected for checkout
                    var items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                        return item.product_checked == true;
                    });
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items_to_checkout), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                //charge each item
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                            }
                            if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                //charge each item and the quantities
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } else {
                //option has product delivery fees set
                //so
                // filter get items of this business sorted cart that has been selected for checkout
                var _items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                    return item.product_checked == true;
                });

                //calculate for each item that has set delivery fee
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _item = _step2.value;

                        //some resets ... in situations wherby has been set by previous delivery options
                        if (_item.has_calculated_product_delivery_fee == true) {
                            _item.has_calculated_product_delivery_fee = false;
                            _item.calculated_product_delivery_fee = 0;
                        };
                        //some resets../
                        //loop in fees
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(fees), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var fee = _step4.value;

                                if (_item.product_main_id == fee.product_delivery_product) {
                                    //product has shipping fee
                                    //check product delivery fee calculation constraints
                                    if (_item.product_shipping_calculation_method == 13) {
                                        //shipping fee charges all product quantity ordered
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                    }
                                    if (_item.product_shipping_calculation_method == 12) {
                                        //shipping fee does not charge product quantity ordered
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                                    }
                                    //mark as calculated
                                    _item.has_calculated_product_delivery_fee = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                    //restock sorted items
                    // this.sorted_cart[i][1] = items;
                    //.../..calculate for each item that has set delivery fee

                    //then calculate for general sellpoint delivery option

                    //check: if no of items with calculated product delivery fee for this option is == to the total no of items in this business cart
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var sorted_fees = _items_to_checkout.filter(function (item) {
                    return item.has_calculated_product_delivery_fee == true;
                });
                //if less than, more calculations to be made
                if (sorted_fees.length < _items_to_checkout.length) {
                    //more calculations to be made
                    //calculate delivery with Business Constraints
                    if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                        //one charge for all items ordered in this business
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        //constraints would affect/charge each item in this business
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _item2 = _step3.value;

                                if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                    //charge each item
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                                }
                                if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                    //charge each item and the quantities
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item2.product_item_order_quantity * option.business_delivery_option_price);
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
                //end more calculations
            }

            //totalling
            this.sorted_cart[i].delivery_option_fee = Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            //cos product delivery may occur
            this.sorted_cart[i].total_delivery_charge += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);
            //update delivery fee with new one
            this.total_delivery_fee += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);
            //..totalling

            //../calculate
        },
        calc_total_delivery_fee: function calc_total_delivery_fee() {
            this.sorted_cart.forEach(function (element) {
                //console.log(element['delivery_option_fee'])
                /////this.total_delivery_fee += element['delivery_option_fee']
            });
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },


        ///--=
        pre_checkout: function pre_checkout() {
            //check login
            this.preset();
        },


        //when quntity is increased or reduced
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            this.sorted_cart[group_index].total_order_amt = 0;
            this.total_order_amt = 0;
            this.checked_out.forEach(function (item) {
                this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;
                //calculate general total order amount
                this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            }, this);
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            this.sorted_cart[group_index][1][item_index].can_remove = false; //disable remove item
            this.sorted_cart[group_index].products_in_checkout = true; //for this group checkout

            //for product delivery checks
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true; //[1] means the position of the items in a sellpoint as added in sorted_cart
            //caculate group store total order amount
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;
            //calculate general total order amount
            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            //some settings
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true; //show delivery details set for this item
            }

            //new ... recalculate sellpoint shipping fee if already selected
            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }

            ///...for displaying totals and delivery options for buy_now_order
            if (this.buy_now_order) {
                document.getElementById(item.item_index + "PRT_CART").style = "display:block;";
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            }); //best removal
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            //for product delivery checks
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index, 1);;
            } else {
                var _index2 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index2, 1);;
            }

            //deduct group store total order amount
            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            //deduct general total order amount
            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--; //deduct

            this.sorted_cart[group_index][1][item_index].can_remove = true; //enable remove item

            //some checking to make sure shipping fee is reset when products are unchecked
            //and no products selected
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee; //reset
                this.sorted_cart[group_index].delivery_option_fee = 0; //reset
                this.sorted_cart[group_index].delivery_option = 0; //very funny - hard reset, cos some delivery option are strings eg. "Free delivery"
                this.sorted_cart[group_index].total_delivery_charge = 0; //reset
            }

            //new ... recalculate sellpoint shipping fee if already selected
            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }
        },
        process_checkout: function process_checkout(group) {
            var processed_checkout = {};
            // if((group.delivery_option != 0) && (group.delivery_option != undefined)){
            processed_checkout.order_user_id = this.user.user_id;
            processed_checkout.order_mode = 1; //loggedIn
            processed_checkout.order_business = group[0];
            var order_url = group[0] + new Date().getTime(); //set order url
            processed_checkout.order_url = order_url, processed_checkout.order_delivery_option = group.delivery_option;
            processed_checkout.order_payment_mode = group.payment_mode || 1; //default -pay now
            processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
            processed_checkout.order_items = [];
            this.checked_out.forEach(function (element) {
                //groups
                if (element.product_business == group[0]) {
                    //product_business
                    processed_checkout.order_items.push(element);
                }
                processed_checkout.status = "processed";
            }, this);
            if (processed_checkout.status == "processed") {
                ///UPDATE -- process to save in localforage
                if (this.loggedIn) {
                    service.checkout(this, processed_checkout).then(function (data) {
                        if (data.body.status == 201) {
                            this.process_count++;
                            //remove from sorted cart and cart
                            processed_checkout.order_items.forEach(function (item) {
                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["i" /* REMOVE_FROM_CART */], item._id); //remove from cart
                                var index = this.checked_out.findIndex(function (p) {
                                    return p._id === item._id;
                                }); //best removal
                                this.checked_out.splice(index, 1);
                                //remove from checkout, later find group id and remove from sorted cart
                                // const index = this.sorted_cart[group_index][1].findIndex(p => p._id === item._id) //best removal
                                // this.sorted_cart[group_index][1].splice(index, 1);
                            }, this);
                            // console.log(this.process_count)
                        }
                        // if(this.process_count == this.sorted_cart.length){
                        if (this.process_count == this.processed_groups) {
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;
                            //move to checkout page with particular order url
                            location.replace("/checkout/" + order_url);
                        }
                    }).catch(function (err) {
                        if (err) {
                            //toastr.warning("Something went wrong", 'Warning!'); 
                            // console.log(err) //possibly a load payment error
                        }
                    });
                } else {
                    //return to be saved in localforage
                    this.process_count++;
                    //remove from sorted cart and cart
                    processed_checkout.order_items.forEach(function (item) {
                        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["i" /* REMOVE_FROM_CART */], item._id); //remove from cart
                        var index = this.checked_out.findIndex(function (p) {
                            return p._id === item._id;
                        }); //best removal
                        this.checked_out.splice(index, 1);
                    }, this);

                    // if(this.process_count == this.sorted_cart.length){
                    if (this.process_count == this.processed_groups) {
                        this.total_delivery_fee = 0;
                        this.total_order_amt = 0;
                        //return to be saved for checkout in localforage
                        return processed_checkout;
                    }
                }
                ///...///UPDATE -- process to save in localforage
            }
        },
        process_orders: function process_orders() {
            var processed = [];
            var product_errors = 0;
            //prepare and validate process checkout
            this.checked_out.forEach(function (item) {
                if (item.has_delivery && item.delivery_option == 0) {
                    //check if item delivery is set
                    product_errors++;
                    //toastr.error("Please select a delivery option for "+item.product_name, 'Warning!'); 
                }
            }, this);

            this.sorted_cart.forEach(function (group) {
                //check for only contain specific product with delivery
                var with_delivery = group.products_with_delivery_details_checked.length;
                var without_delivery = group.products_without_delivery_details_checked.length;

                if (with_delivery != 0 && without_delivery == 0) {
                    group.delivery_option = "Product Specific Delivery Set";
                }

                if (group.items_in_checkout) {
                    //check if has items in cart
                    if (group.delivery_option != 0 && group.delivery_option != undefined) {
                        //check product with specific product details
                        processed.push(group);
                    } else {
                        product_errors++;
                        //toastr.error("Please select a delivery option for "+group[0], 'Warning!'); 
                    }
                }
            }, this);

            ///UPDATE -- Don't process checkout except if user is logged instead save in localforage
            if (this.loggedIn) {
                if (processed.length != 0 && product_errors == 0) {
                    this.processed_groups = processed.length;
                    processed.forEach(function (group) {
                        this.process_checkout(group);
                    }, this);
                }
            } else {
                //save the whole processed in in local forage
                //localforage.setItem('buy_now_order', processed).then(function (value) { }).catch(function(err) {});
                //process and save
                var processed_to_store_in_forage = [];
                if (processed.length != 0 && product_errors == 0) {
                    this.processed_groups = processed.length;
                    processed.forEach(function (group) {
                        processed_to_store_in_forage.push(this.process_checkout(group));
                    }, this);
                    localforage.setItem('buy_now_order', processed_to_store_in_forage).then(function (value) {}).catch(function (err) {});
                }
                //then push to checkout
                this.$router.push("checkout");
                // window.location.href = "checkout";
            }
        },


        // process_processed_orders(){
        //     let count = 0;
        //     if(this.processed_checkout_orders.length > 0){
        //         this.processed_checkout_orders.forEach(function(order) { 
        //             count++;
        //             //process checkout
        //             var payload = {
        //                 order_user_id: this.user.user_id,
        //                 order_business: order.order_business,
        //                 order_delivery_option: order.order_delivery_option,
        //                 order_payment_mode: order.order_payment_mode,
        //                 order_items: order.order_items
        //             }
        //             let wait_count = 0;

        //             service.checkout(this, payload).then(function(data) {
        //                 wait_count++;
        //                 if(data.body.status == 201) {
        //                     //remove from sorted cart and cart
        //                     // order.order_items.forEach(function(item) { 
        //                     //     console.log("rrr"+item._id)
        //                     //     this.removeFromSortedCart(item);
        //                     //     this.removeFromCart(item);

        //                     // }, this);
        //                     //process payment
        //                 // this.processPayment(data.body.payment_data);
        //                     //move to checkout page
        //                     console.log(data.body.payment_data)
        //                 }
        //                 if(wait_count == this.processed_checkout_orders.length){
        //                     console.log("i very done")
        //                 }
        //             }).catch((err) => {
        //                 if(err) {
        //                 //toastr.warning("Something went wrong", 'Warning!'); 
        //                 console.log(err) //possibly a load payment error
        //                 }
        //             })
        //         }, this);
        //     }
        //     console.log("i bh done")

        // },

        // process_orders(){
        //     console.log(this.checked_out)
        //     console.log(this.checked_out)
        //     this.checked_out.forEach(function(order) { 
        //         var payload = {
        //             order_user_id: this.user.user_id,
        //             order_business: order.product_business,
        //             order_delivery_option: order.order_delivery_option,
        //             order_payment_mode: order.order_payment_mode,
        //             order_items: order.order_items
        //         }
        //         console.log("here11")
        //         service.checkout(this, payload).then(function(data) {
        //             if(data.body.status == 201) {
        //                 //remove from sorted cart and cart
        //                 this.sorted_cart[group_i][1][item_i].check_out = true;

        //                 //process payment
        //                 //this.processPayment(data.body.payment_data);
        //                 //move to checkout page
        //                 console.log(data.body.payment_data)
        //             }
        //         }).catch((err) => {
        //             if(err) {
        //             //toastr.warning("Something went wrong", 'Warning!'); 
        //             console.log(err) //possibly a load payment error
        //             }
        //         })
        //     }, this);
        // },


        // process_orders(){
        //     if(this.checked_out.length == 0){
        //         this.checked_out = this.cart;
        //     }
        //     var payload = {
        //         order_user_id: this.user.user_id,
        //         order_items: this.checked_out
        //       }
        //     service.checkout(this, payload).then(function(data) {
        //         if(data.body.status == 201) {
        //           //process payment
        //           this.processPayment(data.body.payment_data);
        //         }
        //     }).catch((err) => {
        //         if(err) {
        //           //toastr.warning("Something went wrong", 'Warning!'); 
        //           console.log(err) //possibly a load payment error
        //         }
        //     })
        // },


        //connect to a payment gateway
        processPayment: function processPayment(data) {
            var obj = this;
            //this.amount_paid = data.plan_amount;
            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,
                // email: data.plan_user_email || "admin@sellpoints.ng",
                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100), //(data.plan_amount * 100), //in kobo
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },


        // update payments
        updatePayment: function updatePayment(payment_ref) {
            var _this3 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_user_id: this.user.user_id
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        //toastr.success("Payment Processed!", "Success!");

                        if (_this3.request_page != '') {
                            _this3.$router.push(_this3.request_page);
                        } else {
                            _this3.$router.go('/');
                        }
                    } else {
                        //toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                //toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        if (this.$route.path == '/order') {
            this.buy_now_order = true;
        }
        document.title = "Cart" + " | SP";
        //this.preset();
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.prepCart();
        }
        // this.prepCart();
    }
});

/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(10);
 // Service Class

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Cart',
    data: function data() {
        return {
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_orders_amount: 0.0,
            total_shipping_fee: 0.0,
            states: {},
            cities: [],
            loggedIn: false,
            new_account: true,
            process_count: 0,
            checkout_processed: false,
            data_error_message: "",
            data_success_message: "",
            is_logged_in_order_mode: 0,
            disable_btn: false,
            loading: true,
            action_loading: false,
            selected_order_shipping_details_state: "",
            selected_order_shipping_details_city: "",
            selected_order_shipping_details_address: ""
        };
    },

    components: {},
    computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'login') {
                this.new_account = false;
            }
            if (attr1 == 'new-account') {
                this.new_account = true;
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["i" /* REMOVE_FROM_CART */], payload);
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this2 = this;

            this.activate_processing();
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        login: function login() {
            var _this3 = this;

            this.activate_processing();
            service.loginUser(this, this.user).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    localStorage.setItem("sp_token_key", data.user_token_key);
                    _this3.user = data;
                    if (!_this3.new_account) {
                        ///not new account
                        _this3.is_logged_in_order_mode = 1;
                        _this3.process_checkout();
                        _this3.deactivate_processing();
                    }
                } else {
                    _this3.data_error_message = "Sorry, these login details are invalid.";
                    _this3.deactivate_processing();
                }
            }).catch(function (err) {
                _this3.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this4 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            //this.checkout();
                            this.loggedIn = true;
                            //check if order has a specified url
                            if (this.$route.params.ckid != null) {
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            } else {
                                //get orders with this user id
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true; //already processed
                            this.loading = false;
                            //..DEPRAC
                            // if(this.$route.query["order"]){
                            //     this.getCheckoutOrder()
                            // }else{
                            //     this.getCheckoutOrders();
                            // }
                            //..DEPRAC
                            this.getUserDeliveryDetails();
                        }, _this4);
                    } else {
                        // this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        //this.$router.push('login');
                        // console.log(err)
                    }
                });
            } else {
                // this.$router.push('login');
            }
        },


        //local orders stored in forage for NOT-LoggedIn users
        getCheckoutLocalOrder: function getCheckoutLocalOrder() {
            this.loading = false;
            //use localforage to store and get for now ... if not working well accross points then send to hostdb
            //get from localforage
            this.activate_processing();
            var self = this;
            //serve from forage first
            setTimeout(function () {
                localforage.getItem('buy_now_order').then(function (value) {
                    if (value != null) {
                        self.checkout_orders = value;
                    }
                }).catch(function (err) {
                    //report error
                    this.deactivate_processing();
                    this.$router.push("orders"); //no checkout items
                });
            }, 500);
        },


        //logged In User
        getCheckoutOrders: function getCheckoutOrders() {
            var _this5 = this;

            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.setCheckoutOrders(response);
                } else {
                    _this5.$router.push("orders"); //no checkout items
                }
            }).catch(function (err) {
                _this5.deactivate_processing();
                _this5.$router.push("orders"); //no checkout items
            });
        },


        //Order with specified URL
        getCheckoutOrdersByURL: function getCheckoutOrdersByURL() {
            var _this6 = this;

            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(function (response) {
                if (response.body.status == 200) {
                    _this6.setCheckoutOrders(response);
                } else {
                    _this6.deactivate_processing();
                    _this6.$router.push("orders"); //no checkout items
                }
            }).catch(function (err) {
                _this6.deactivate_processing();
                _this6.$router.push("orders"); //no checkout items
            });
        },


        //set the order responses
        setCheckoutOrders: function setCheckoutOrders(response) {
            //after successful request from remote 
            this.checkout_orders = response.body.data;
            this.total_orders_amount = response.body.data_total_orders_amount;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.payment_details = response.body.payment_data;

            //add some settings
            this.checkout_orders.forEach(function (order) {
                order.display_delivery = false; //initiate toggle effect
                order.cities = {};
            }, this);

            //show processed
            this.checkout_processed = true;
            if (this.new_account) {
                this.login();
            }
            this.deactivate_processing();
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this7 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.delivery_details = response.body.data;
                }
            }).catch(function (err) {
                //console.log(err) //possibly a load payment error
            });
        },


        //processing
        //new
        prep_process_checkout: function prep_process_checkout() {
            //validate user details
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                //get from localforage and send to db with users details
                //some settings
                //new-user settings
                this.user.user_has_shipping_details = true;
                this.user.user_password = this.user.user_name; //dummy
                this.user.new_set_account = true;

                //process
                this.process_checkout();
            } //end validate
        },
        process_checkout: function process_checkout() {
            this.activate_processing();
            //get from localforage and send to db with users details
            this.checkout_orders.forEach(function (processed_checkout) {
                var _this8 = this;

                //groups
                this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                processed_checkout.order_mode = this.is_logged_in_order_mode; //not loggedIn
                processed_checkout.order_url = this.order_url;
                if (!this.new_account) {
                    processed_checkout.order_user_id = this.user.user_id;
                } else {
                    processed_checkout.order_user_details = this.user;
                }
                //add each order batch
                service.checkout(this, processed_checkout).then(function (data) {
                    if (data.body.status == 201) {
                        this.process_count++;
                    }
                    if (this.process_count == this.checkout_orders.length) {
                        //get tht new users details for login
                        // this.user = data.body.data_user_details;
                        this.getCheckoutOrdersByURL();
                    }
                    this.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        _this8.deactivate_processing();
                    }
                });
            }, this);
        },


        //...new
        pre_checkout: function pre_checkout() {
            //check login
            this.preset();
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            //subtract current delivery fee from sellpoint total order and general total order
            this.total_order_amt -= this.checkout_orders[i].order_delivery_fee; //general
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_delivery_fee; //sellpoint

            //set new sellpoint delivery charge
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

            //add the delivery charge to ellpoint total order and general total order
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;

            //update delivery fee with new one
            this.total_order_amt += option.business_delivery_option_price; //general
            this.checkout_orders[i].order_total += option.business_delivery_option_price; //sellpoint

            //update address
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == option.business_delivery_option) {
                    //empty previous city delivery addresses
                    this.checkout_orders[i].order_user_delivery_addresses = [];
                    //now push matching addresses to this city
                    this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                }
            }, this);
        },
        calc_product_specific_delivery_fee: function calc_product_specific_delivery_fee(i, i2, option) {
            //subtract current delivery fee from sellpoint total order and general total order
            this.total_order_amt -= this.checkout_orders[i].order_items[i2].order_delivery_fee; //general
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_items[i2].order_delivery_fee; //sellpoint

            //set new product delivery charge
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_delivery_city = option.business_delivery_option;

            //add the delivery charge to sellpoint total order and general total order
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;

            //update delivery fee with new one
            this.total_order_amt += option.business_delivery_option_price; //general
            this.checkout_orders[i].order_total += option.business_delivery_option_price; //sellpoint

            //update address
            //empty previous city delivery addresses
            this.checkout_orders[i].order_items[i2].order_user_delivery_addresses = [];

            this.delivery_details.forEach(function (detail) {
                if (detail.address_city == option.business_delivery_option_city_id) {
                    //now push matching addresses to this city
                    this.checkout_orders[i].order_items[i2].order_user_delivery_addresses.push(detail);
                } else {
                    //  console.log("pho"+" "+detail.address_city+"--"+option.business_delivery_option_city_id);
                }
            }, this);
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    //console.log
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },


        //../processing


        //payments
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        processPayment: function processPayment() {
            var process_errors = [];
            //validate all addresses are set
            this.checkout_orders.forEach(function (order) {
                if (order.order_user_delivery_address == undefined && order.order_user_new_delivery_address == undefined) {
                    process_errors.push("Please enter delivery address for " + order.order_business);
                }
                // if(order.order_delivery_not_set && (order.order_delivery_city == undefined)){
                //     process_errors.push("Please select delivery location for "+order.order_business)
                // }//commented for now till city issue fixed
                //for order items
                order.order_items.forEach(function (item) {
                    if (item.order_delivery_city) {
                        if (item.order_user_delivery_address == undefined && item.order_user_new_delivery_address == undefined) {
                            process_errors.push("Please enter delivery address for " + item.product_name);
                        }
                    }
                }, this);
            }, this);
            if (process_errors.length != 0) {
                process_errors.forEach(function (error) {
                    toastr.error(error);
                }, this);
            } else {
                this.processCardPayment(this.payment_details);
                // if(this.payment_mode == "card"){
                //     this.processCardPayment(this.payment_details);
                //     //this.updatePayment(this.payment_details.payment_ref);
                // }
                // if(this.payment_mode == "paycode"){
                //     this.processPayCodePayment();
                // }        
            }
        },


        //a mini quick process payment
        processPaymentMini: function processPaymentMini() {
            var process_errors = [];
            //validate shipping details are set
            if (this.selected_order_shipping_details_state != '' && this.selected_order_shipping_details_city != '' && this.selected_order_shipping_details_address != '') {
                this.processCardPayment(this.payment_details);
            }
        },


        //connect to a payment gateway
        processCardPayment: function processCardPayment(data) {
            //test--//this.updatePayment("ppp")
            var obj = this;
            //this.amount_paid = data.plan_amount;
            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,
                // email: data.plan_user_email || "admin@sellpoints.ng",
                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100), //(data.plan_amount * 100), //in kobo
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },


        // update payments
        updatePayment: function updatePayment(payment_ref) {
            var _this9 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_order_amount_paid: this.payment_details.payment_amount,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service,
                payment_order_delivery_details: { state: this.selected_order_shipping_details_state,
                    city: this.selected_order_shipping_details_city,
                    address: this.selected_order_shipping_details_address }
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this9.request_page != '') {
                            _this9.$router.push(_this9.request_page);
                        } else {
                            _this9.$router.go('/');
                        }
                    } else {
                        //console.log("error")
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        // console.log(err)
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | Gallery";
        //this.preset();
        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined || localStorage.getItem("sp_token") != null) {
            this.new_account = false;
            this.preset();
        } else {
            this.getCheckoutLocalOrder();
        }
        this.getStates();
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
 // Service Class

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Orders',
    data: function data() {
        return {
            user: {},
            orders: {},
            order: {},
            img_product_url: service.imageProductsURL
        };
    },

    components: {},

    methods: {
        setOrder: function setOrder(order) {
            this.order = order;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                        //console.log(err)
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getOrders: function getOrders() {
            var _this2 = this;

            service.getOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.orders = response.body.data;
                    _this2.orders.set = true;
                }
            }).catch(function (err) {
                //console.log(err) //possibly a load payment error
            });
        }
    },
    created: function created() {
        document.title = "Orders" + " | SP";
        //this.prepCart();
        this.preset();
    }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(93);
 // Service Class


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Order',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__["a" /* default */]
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Order" + " | Gallery";
    }
});

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_clipboard__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(237);
//new vue structure


// import VeeValidate from 'vee-validate'




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
// Vue.use(VeeValidate)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_v_clipboard___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__businesses__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getstarted__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__purchase__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__register__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__account__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sellpoint__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buypoint__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__orderpoint__ = __webpack_require__(215);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [__WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__businesses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__getstarted__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__purchase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__register__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__buypoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__orderpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__sellpoint__["a" /* default */], { path: '*', redirect: '/' // 404
    }]
}));

/***/ }),
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__(113);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Home__["a" /* default */]
  // export default {
  //     path: '/',
  //     name: 'Home',
  //     component: function() {
  //         var reg = new RegExp("www.sellpoints.com.ng|test|localhost:2082");
  //         var parts = window.location.host.split(".");
  //         //return Home;
  //         // return reg.test(parts[0]) ? require('@/pages/Home') : require('@/pages/Points');
  //         return reg.test(parts[0]) ? require('@/pages/Home') : require('@/pages/Sellpoint/Sellpoint');
  //     }()
  // }

  // export default {
  //     path: '/',
  //     name: 'Home',
  //     component: function() {
  //         var reg = new RegExp("www|sitename|test|localhost:2082");
  //         var parts = window.location.host.split(".");
  //         //return Home;
  //         return reg.test(parts[0]) ? require('@/pages/Home') : require('@/pages/Points');
  //     }()
  // }

});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea0c1644_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea0c1644"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea0c1644_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',{attrs:{"id":"main-nav"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tour Places")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Contact")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Events")])])]),_vm._v(" "),_c('ul',{staticClass:"responsive-nav"},[_c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tour Places")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Contact")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Events")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#","id":"pull"}})]),_vm._v(" "),_c('figure',[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/assets/images/main-logo.png","alt":"logo"}}),_vm._v(" "),_c('figcaption',[_vm._v("Stanel World")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('section',{staticStyle:{"display":"none"},attrs:{"id":"info"}},[_c('article',[_c('h5',[_vm._v("About Mozzarella")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, consectetur. Do re eiusmod tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, consectetur.")]),_vm._v(" "),_c('ul',{staticClass:"c-info"},[_c('li',[_vm._v("Fake street 123 - Springfield, USA")]),_vm._v(" "),_c('li',[_vm._v("inquiries@mozzarellabar.com")]),_vm._v(" "),_c('li',[_vm._v("(+044) 555 - 123 - 1234 / 35")])])]),_vm._v(" "),_c('article',{staticClass:"side-posts latests"},[_c('h5',[_vm._v("Our Latests Posts")]),_vm._v(" "),_c('article',[_c('div',{staticClass:"circle small"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/blog/blog_image.png","alt":"post"}})]),_vm._v(" "),_c('a',{attrs:{"href":"post.html"}},[_c('img',{attrs:{"src":"/static/assets/images/plus-icon-small.png","alt":"plus-icon-small"}})])]),_vm._v(" "),_c('h6',[_c('a',{attrs:{"href":"post.html"}},[_vm._v("Touring Through The City")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])]),_vm._v(" "),_c('article',[_c('div',{staticClass:"circle small"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/blog/blog_image.png","alt":"post"}})]),_vm._v(" "),_c('a',{attrs:{"href":"post.html"}},[_c('img',{attrs:{"src":"/static/assets/images/plus-icon-small.png","alt":"plus-icon-small"}})])]),_vm._v(" "),_c('h6',[_c('a',{attrs:{"href":"post.html"}},[_vm._v("10 Easy Red Onion Recipes")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])]),_vm._v(" "),_c('article',[_c('div',{staticClass:"circle small"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/blog/blog_image.png","alt":"post"}})]),_vm._v(" "),_c('a',{attrs:{"href":"post.html"}},[_c('img',{attrs:{"src":"/static/assets/images/plus-icon-small.png","alt":"plus-icon-small"}})])]),_vm._v(" "),_c('h6',[_c('a',{attrs:{"href":"post.html"}},[_vm._v("Healthy Tea Benefits")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])])]),_vm._v(" "),_c('article',[_c('h5',[_vm._v("Flickr Widget")]),_vm._v(" "),_c('ul',{attrs:{"id":"flickr-w"}})]),_vm._v(" "),_c('article',[_c('h5',[_vm._v("Opening Hours")]),_vm._v(" "),_c('article',{staticClass:"op-hours"},[_c('div',[_c('h6',[_vm._v("Monday")]),_vm._v(" "),_c('h6',[_vm._v("7:00PM - 2:00AM")])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Tuesday")]),_vm._v(" "),_c('h6',[_c('span',[_vm._v("Closed")])])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Wednesday")]),_vm._v(" "),_c('h6',[_vm._v("7:00PM - 2:00AM")])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Thursday")]),_vm._v(" "),_c('h6',[_vm._v("7:00PM - 2:00AM")])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Friday")]),_vm._v(" "),_c('h6',[_vm._v("7:00PM - 2:00AM")])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Saturday")]),_vm._v(" "),_c('h6',[_vm._v("7:00PM - 2:00AM")])]),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Sunday")]),_vm._v(" "),_c('h6',[_vm._v("7:00PM - 2:00AM")])])])])]),_vm._v(" "),_c('section',{attrs:{"id":"copy"}},[_c('h5',[_c('span',[_vm._v("© 2019 Stanel World |")]),_vm._v(" All Rights Reserved")]),_vm._v(" "),_c('nav',[_c('ul',[_c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tour Places")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Contact")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Events")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"products"},[_c('div',{staticClass:"container"},[_vm._v("\n     vbvbvb "+_vm._s(_vm.products)+"bvbvbv\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),(_vm.loggedIn)?_c('div',{staticClass:"hidden-md hidden-lg"},[_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Your Profile")]),_vm._v(" "),_c('div',{staticClass:"profile-card"},[_c('img',{staticClass:"profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_vm._v(" "),_c('h5',[_c('a',{staticClass:"text-white",attrs:{"href":"timeline"}},[_vm._v(_vm._s(_vm.user.user_name))])]),_vm._v(" "),_vm._m(1),_c('br'),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._m(3)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suggestions",attrs:{"id":"sticky-sidebar"}},[_c('h4',{staticClass:"grey"},[_vm._v("Shops Followed")]),_vm._v(" "),_c('div',{staticClass:"follow-user"},[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_vm._v(" "),_c('div',[_c('h5',[_c('a',{attrs:{"href":"timeline#"}},[_vm._v("Simi Shapers")])]),_vm._v(" "),_c('a',{staticClass:"text-green",attrs:{"href":"#"}},[_vm._v("Follow Shop")])])]),_vm._v(" "),_c('div',{staticClass:"follow-user"},[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_vm._v(" "),_c('div',[_c('h5',[_c('a',{attrs:{"href":"timeline#"}},[_vm._v("Chris Foodstore")])]),_vm._v(" "),_c('a',{staticClass:"text-green",attrs:{"href":"#"}},[_vm._v("Follow Shop")])])]),_vm._v(" "),_c('div',{staticClass:"follow-user"},[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_vm._v(" "),_c('div',[_c('h5',[_c('a',{attrs:{"href":"timeline#"}},[_vm._v("Olafumi Jewellries")])]),_vm._v(" "),_c('a',{staticClass:"text-green",attrs:{"href":"#"}},[_vm._v("Follow Shop")])])]),_vm._v(" "),_c('div',{staticClass:"follow-user"},[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_vm._v(" "),_c('div',[_c('h5',[_c('a',{attrs:{"href":"timeline#"}},[_vm._v("Trish Hairs")])]),_vm._v(" "),_c('a',{staticClass:"text-green",attrs:{"href":"#"}},[_vm._v("Follow Shop")])])]),_vm._v(" "),_c('div',{staticClass:"follow-user"},[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_vm._v(" "),_c('div',[_c('h5',[_c('a',{attrs:{"href":"timeline#"}},[_vm._v("Nina Organics")])]),_vm._v(" "),_c('a',{staticClass:"text-green",attrs:{"href":"#"}},[_vm._v("Follow Shop")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-white",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" 62 shops")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-white",attrs:{"href":"#"}},[_c('i',{staticClass:"ion ion-android-person-add"}),_vm._v(" 1,500 friends")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-news-feed"},[_c('li',[_c('i',{staticClass:"icon ion-ios-paper"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tradefair Newsfeed")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon fa fa-shopping-cart"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Shops Following")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon ion-ios-people-outline"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Friends")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon ion-chatboxes"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Discussions / Messages")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon ion-images"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Orders")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon fa fa-bell"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("No6ifications")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loggedIn)?_c('div',{staticClass:"hidden-sm hidden-xs"},[_c('div',{staticClass:"profile-card"},[_c('img',{staticClass:"profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_vm._v(" "),_c('h5',[_c('a',{staticClass:"text-white",attrs:{"href":"timeline"}},[_vm._v(_vm._s(_vm.user.user_name))])]),_vm._v(" "),_vm._m(0),_c('br'),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-white",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" 62 shops")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-white",attrs:{"href":"#"}},[_c('i',{staticClass:"ion ion-android-person-add"}),_vm._v(" 1,500 friends")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-news-feed"},[_c('li',[_c('i',{staticClass:"icon ion-ios-paper"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tradefair Newsfeed")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon fa fa-shopping-cart"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Shops Following")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon ion-ios-people-outline"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Friends")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon ion-chatboxes"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Discussions / Messages")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon ion-images"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("Orders")])])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"icon fa fa-bell"}),_c('div',[_c('a',{attrs:{"href":"#"}},[_vm._v("No6ifications")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-xs"},[_c('div',{staticClass:"profile-card"},[_c('p',[_vm._v("Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …")])]),_vm._v(" "),_c('div',{attrs:{"id":"sticky-feeds"}},[_c('h4',{staticClass:"grey"},[_vm._v("Ongoing Activities")]),_vm._v(" "),_c('div',{staticClass:"feed-item"},[_c('div',{staticClass:"live-activity"},[_c('p',[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v("Olu Jane Stores")]),_vm._v(" Commented on a product")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("5 mins ago")])])]),_vm._v(" "),_c('div',{staticClass:"feed-item"},[_c('div',{staticClass:"live-activity"},[_c('p',[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v("Lami Fashion Store")]),_vm._v(" Has posted a product")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("an hour ago")])])]),_vm._v(" "),_c('div',{staticClass:"feed-item"},[_c('div',{staticClass:"live-activity"},[_c('p',[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v("Trish Hairs")]),_vm._v(" Liked friend's product")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("4 hours ago")])])]),_vm._v(" "),_c('div',{staticClass:"feed-item"},[_c('div',{staticClass:"live-activity"},[_c('p',[_c('img',{staticClass:"profile-photo-sm pull-left",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v("LuluBeads Crafts")]),_vm._v(" has shared a product")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("a day ago")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"title"},[_vm._v("Tradefair Talks")]),_vm._v(" "),_c('ul',{staticClass:"online-users list-inline"},[_c('li',[_c('a',{attrs:{"href":"#","title":"Cynthia Belonwu"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Jubril Sani"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Sandra Oseni"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Titilo Bass"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Jayden Ajibade"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Nonso Obi"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Efiong Dun"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Chika Nnabi"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Bolaji Adewale"}},[_c('img',{staticClass:"img-responsive profile-photo",attrs:{"src":"http://placehold.it/300x300","alt":"user"}}),_c('span',{staticClass:"online-dot"})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-post"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9 col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('img',{staticClass:"profile-photo-md",attrs:{"src":"http://placehold.it/300x300","alt":""}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_words),expression:"search_words"}],staticClass:"form-control",attrs:{"name":"texts","id":"exampleTextarea","cols":"100","rows":"1","placeholder":"Search: enter name or handle or hashtag"},domProps:{"value":(_vm.search_words)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search_words=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"padding-left":"5em"}},[_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_type),expression:"search_type"}],attrs:{"type":"radio","value":"business","id":"business"},domProps:{"checked":_vm._q(_vm.search_type,"business")},on:{"change":function($event){_vm.search_type="business"}}}),_vm._v("Business\n                  ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_type),expression:"search_type"}],attrs:{"type":"radio","value":"product","id":"product"},domProps:{"checked":_vm._q(_vm.search_type,"product")},on:{"change":function($event){_vm.search_type="product"}}}),_vm._v("Product/Service\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-3"},[_c('div',{staticClass:"tools"},[_c('button',{staticClass:"btn btn-primary pull-right",on:{"click":_vm.search}},[_vm._v("Search")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('main',[_c('aside',[_c('a',{attrs:{"href":"#"}},[_c('svg',{attrs:{"x":"0px","y":"0px","width":"150px","height":"40px"}},[_c('polygon',{attrs:{"fill":"#2d4c8b","points":"150,40 7.001,40 0,33 0,7 6.918,0 150,0 "}}),_vm._v(" "),_c('image',{attrs:{"xlink:href":"/static/assets/images/facebook.png","x":"23","y":"10","width":"9px","height":"18px"}}),_vm._v(" "),_c('text',{attrs:{"x":"55","y":"24"}},[_vm._v("Like Us!")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('svg',{attrs:{"x":"0px","y":"0px","width":"150px","height":"40px"}},[_c('polygon',{attrs:{"fill":"#34dfe6","points":"150,40 7.001,40 0,33 0,7 6.918,0 150,0 "}}),_vm._v(" "),_c('image',{attrs:{"xlink:href":"/static/assets/images/twitter.png","x":"17","y":"12","width":"23px","height":"16px"}}),_vm._v(" "),_c('text',{attrs:{"x":"55","y":"24"}},[_vm._v("Follow Us!")])])])]),_vm._v(" "),_c('component-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('section',{staticStyle:{"display":"none"},attrs:{"id":"map"}}),_vm._v(" "),_c('component-footer')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('ul',{staticClass:"main-slider"},[_c('li',{staticClass:"first"},[_c('h1',{staticStyle:{"color":"#ff6600"}},[_vm._v("One Stop")]),_vm._v(" "),_c('h6',[_vm._v("Get a taste of what you can find in our venue")]),_vm._v(" "),_c('a',{staticClass:"square-button",staticStyle:{"background":"#339900"},attrs:{"href":"#","target":"_blank"}},[_vm._v("Make a tour")])]),_vm._v(" "),_c('li',{staticClass:"second"},[_c('h2',{staticStyle:{"color":"#ff6600"}},[_vm._v("Touch Down")]),_vm._v(" "),_c('h6',[_vm._v("Get a taste of what you can find in our venue")]),_vm._v(" "),_c('a',{staticClass:"square-button",staticStyle:{"background":"#339900"},attrs:{"href":"#","target":"_blank"}},[_vm._v("Go to shop")])]),_vm._v(" "),_c('li',{staticClass:"third"},[_c('h2',{staticStyle:{"color":"#ff6600"}},[_vm._v("Full Events")]),_vm._v(" "),_c('h6',[_vm._v("Get a taste of what you can find in our venue")]),_vm._v(" "),_c('a',{staticClass:"square-button",staticStyle:{"background":"#339900"},attrs:{"href":"#","target":"_blank"}},[_vm._v("make a schedule")])])]),_vm._v(" "),_c('div',{staticClass:"pager-container"},[_c('a',{attrs:{"href":"","data-slide-index":"0"}}),_vm._v(" "),_c('a',{attrs:{"href":"","data-slide-index":"1"}}),_vm._v(" "),_c('a',{attrs:{"href":"","data-slide-index":"2"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"our-dishes"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v("Stanel World")]),_vm._v(" "),_c('p',{staticClass:"descr"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('article',{attrs:{"id":"dishes-left"}},[_c('article',[_c('div',[_c('h5',[_vm._v("Farmers Market")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/site1.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('span',{staticClass:"cta-words"},[_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]),_vm._v(" "),_c('span',{staticClass:"cta"},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"farmmarket"}},[_vm._v("visit")])])])]),_vm._v(" "),_c('article',[_c('div',[_c('h5',[_vm._v("P & J Supermarket ")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/site2.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('span',{staticClass:"cta-words"},[_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]),_vm._v(" "),_c('span',{staticClass:"cta"},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"pjsupermarket"}},[_vm._v("visit")])])])])]),_vm._v(" "),_c('article',{attrs:{"id":"dishes-right"}},[_c('article',[_c('div',[_c('h5',[_vm._v("Chicken Republic Drive Thru")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/site3.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('span',{staticClass:"cta-words"},[_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]),_vm._v(" "),_c('span',{staticClass:"cta"},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"chickenrepublic"}},[_vm._v("visit")])])])]),_vm._v(" "),_c('article',[_c('div',[_c('h5',[_vm._v("Essense Spa")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/site4.jpg","alt":"sandwiches"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('span',{staticClass:"cta-words"},[_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]),_vm._v(" "),_c('span',{staticClass:"cta"},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"essencespa"}},[_vm._v("visit")])])])])]),_vm._v(" "),_c('ul',{staticClass:"mobile-tabs"},[_c('li',[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"farmmarket"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/site1.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('h5',[_vm._v("Farmers Market")]),_vm._v(" "),_c('p',{staticClass:"visits"},[_vm._v("32 visits")]),_vm._v(" "),_c('p',[_vm._v("132 Reviews")])])])])]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"chickenrepublic"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/site3.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('h5',[_vm._v("Chicken Republic")]),_vm._v(" "),_c('p',{staticClass:"visits"},[_vm._v("32 visits")]),_vm._v(" "),_c('p',[_vm._v("132 Reviews")])])])])]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"pjsupermarket"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/site2.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('h5',[_vm._v("P & J Supermarket")]),_vm._v(" "),_c('p',{staticClass:"visits"},[_vm._v("32 visits")]),_vm._v(" "),_c('p',[_vm._v("132 Reviews")])])])])]),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"essencespa"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/site4.jpg"}}),_vm._v(" "),_c('div',{staticClass:"cta-card-md"},[_c('h5',[_vm._v("Essence Spa")]),_vm._v(" "),_c('p',{staticClass:"visits"},[_vm._v("32 visits")]),_vm._v(" "),_c('p',[_vm._v("132 Reviews")])])])])])]),_vm._v(" "),_c('section',{staticStyle:{"display":"none"},attrs:{"id":"showsmob"}},[_c('article',[_c('h3',[_vm._v("Live"),_c('span',[_vm._v("Shows")])]),_vm._v(" "),_c('p',[_vm._v("Every Saturday")]),_vm._v(" "),_c('a',{staticClass:"square-button",attrs:{"href":"events.html","target":"_blank"}},[_vm._v("Check all the events")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"shows"}},[_c('img',{staticStyle:{"width":"35%","padding-top":"-3em"},attrs:{"src":"/static/assets/images/december.png","alt":"show-model"}}),_vm._v(" "),_c('article',[_c('h3',[_vm._v("Live"),_c('span',[_vm._v("Shows")])]),_vm._v(" "),_c('p',[_vm._v("Every Saturday")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea  derma commodo consequat. ")]),_vm._v(" "),_c('a',{staticClass:"square-button",attrs:{"href":"events.html","target":"_blank"}},[_vm._v("Check all the events")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"popular-dishes"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v("Popular Dishes")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',{staticClass:"dishes"},[_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat1.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Mozzarella Cheeseburger")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$15.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat2.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Barbeque Steak Strips")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$35.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat1.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Golden Onion Rings")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$21.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat1.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Meltdown Nachos")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$17.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat4.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Wild Veggies Sandwich")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$15.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat3.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Garlic Capresse Pizza")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$43.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat2.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("Charcoal Chicken Wings")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$18.00")])]),_vm._v(" "),_c('li',[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/menu/menu_photo.png","alt":"menu-dish"}}),_vm._v(" "),_c('a',{attrs:{"href":"/static/assets/images/menu/full_size.png"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/menu-cat4.png","alt":"burger item"}}),_vm._v(" "),_c('h5',[_vm._v("The Volcano Sandwich")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]),_vm._v(" "),_c('p',[_vm._v("$12.00")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"specials"}},[_c('img',{attrs:{"src":"/static/assets/images/ivy.png","alt":"ivy"}}),_vm._v(" "),_c('figure',{attrs:{"id":"board"}},[_c('img',{attrs:{"src":"/static/assets/images/specials-title.png","alt":"specials-title"}}),_vm._v(" "),_c('article',[_c('article',[_c('h5',[_vm._v("Mozzarella Cheeseburger")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('p',[_vm._v("$15.00")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]),_vm._v(" "),_c('article',[_c('h5',[_vm._v("Dark Side Bacon Pizza")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('p',[_vm._v("$32.00")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]),_vm._v(" "),_c('article',[_c('h5',[_vm._v("Meltdown Nachos")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('p',[_vm._v("$17.00")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]),_vm._v(" "),_c('article',[_c('h5',[_vm._v("Golden Onion Rings")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('p',[_vm._v("$21.00")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"about"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v("About Mozzarella")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('article',[_c('h5',[_vm._v("How did we Become "),_c('span',[_vm._v("this Succesful")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incidid ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna. tem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Vintage Arcade Machines")]),_vm._v(" "),_c('li',[_vm._v("The Best 80's and 90's Music")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("5 New Pool Tables")]),_vm._v(" "),_c('li',[_vm._v("Happy Hour until 2AM")])])]),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/about-img.jpg","alt":"about-img"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quality-badge.png","alt":"quality-badge"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"video"}},[_c('p',[_vm._v("Find yourself at the")]),_vm._v(" "),_c('h2',[_vm._v("Last "),_c('span',[_vm._v("Friday")]),_vm._v(" Party")]),_vm._v(" "),_c('div',{staticClass:"radial-progress"},[_c('div',{staticClass:"r-circle"},[_c('div',{staticClass:"mask full"},[_c('div',{staticClass:"fill"})]),_vm._v(" "),_c('div',{staticClass:"mask half"},[_c('div',{staticClass:"fill"}),_vm._v(" "),_c('div',{staticClass:"fill fix"})])]),_vm._v(" "),_c('div',{staticClass:"inset"},[_c('img',{attrs:{"src":"/static/assets/images/play-button.png","alt":"play-button"}})])]),_vm._v(" "),_c('iframe',{attrs:{"src":"http://player.vimeo.com/video/109558222"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"reviews"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v("Customer Reviews")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',[_c('li',[_c('article',[_c('div',{staticClass:"circle tiny"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/customer-1.png","alt":"customer"}})])]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-empty-icon.png","alt":"star-empty"}})])]),_vm._v(" "),_c('h5',[_vm._v("James D.")]),_vm._v(" "),_c('p',[_vm._v("25 Years")])]),_vm._v(" "),_c('article',{staticClass:"quote"},[_c('img',{attrs:{"src":"/static/assets/images/quote-left.png","alt":"quote left"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-right.png","alt":"quote right"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-triangle.png","alt":"quote triangle"}}),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "),_c('span',[_vm._v("magna porem")]),_vm._v(" ed ipsum dolor sit amet, do lorem consectetur utend tempor magna. Lorem ipsum dolor sit amet, consectetur elar adipisicing elit.")])])]),_vm._v(" "),_c('li',[_c('article',[_c('div',{staticClass:"circle tiny"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/customer-2.png","alt":"customer"}})])]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star-empty"}})])]),_vm._v(" "),_c('h5',[_vm._v("Laura B.")]),_vm._v(" "),_c('p',[_vm._v("27 Years")])]),_vm._v(" "),_c('article',{staticClass:"quote"},[_c('img',{attrs:{"src":"/static/assets/images/quote-left.png","alt":"quote left"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-right.png","alt":"quote right"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-triangle.png","alt":"quote triangle"}}),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor.")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "),_c('span',[_vm._v("magna porem")]),_vm._v(" ed ipsum dolor.")])])]),_vm._v(" "),_c('li',[_c('article',[_c('div',{staticClass:"circle tiny"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/customer-3.png","alt":"customer"}})])]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star-empty"}})])]),_vm._v(" "),_c('h5',[_vm._v("Sarah H.")]),_vm._v(" "),_c('p',[_vm._v("22 Years")])]),_vm._v(" "),_c('article',{staticClass:"quote"},[_c('img',{attrs:{"src":"/static/assets/images/quote-left.png","alt":"quote left"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-right.png","alt":"quote right"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-triangle.png","alt":"quote triangle"}}),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor "),_c('span',[_vm._v("incididunt")]),_vm._v(" ut labore etorn dolore eu magna porem ed ipsum dolor sit amet, do lorem consectetur utend tempor magna.")])])]),_vm._v(" "),_c('li',[_c('article',[_c('div',{staticClass:"circle tiny"},[_c('figure',{staticClass:"imgLiquidFill"},[_c('img',{attrs:{"src":"/static/assets/images/customer-4.png","alt":"customer"}})])]),_vm._v(" "),_c('ul',[_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-icon.png","alt":"star"}})]),_vm._v(" "),_c('li',[_c('img',{attrs:{"src":"/static/assets/images/star-empty-icon.png","alt":"star-empty"}})])]),_vm._v(" "),_c('h5',[_vm._v("Jack S.")]),_vm._v(" "),_c('p',[_vm._v("22 Years")])]),_vm._v(" "),_c('article',{staticClass:"quote"},[_c('img',{attrs:{"src":"/static/assets/images/quote-left.png","alt":"quote left"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-right.png","alt":"quote right"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/assets/images/quote-triangle.png","alt":"quote triangle"}}),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "),_c('span',[_vm._v("magna porem")]),_vm._v(" ed ipsum dolor sit amet, do lorem consectetur utend tempor magna. Lorem ipsum dolor sit amet, consectetur elar adipisicing elit.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"news"}},[_c('p',[_vm._v("Do you wanna hear the latests news?")]),_vm._v(" "),_c('h4',[_vm._v("Subscribe to "),_c('span',[_vm._v("our Newsletter")])]),_vm._v(" "),_c('article',[_c('form',[_c('input',{attrs:{"type":"email","id":"subs_email","name":"subs_email","placeholder":"Enter your email to subscribe..."}}),_vm._v(" "),_c('input',{attrs:{"type":"submit","id":"subs","value":"Subscribe"}})]),_vm._v(" "),_c('p',{staticClass:"subs-error"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"none"},attrs:{"id":"contact"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v("Contact Us")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',[_c('input',{attrs:{"type":"text","id":"name","name":"name","placeholder":"Write your full name here..."}}),_vm._v(" "),_c('input',{attrs:{"type":"email","id":"email","name":"email","placeholder":"Write your email adress here..."}}),_vm._v(" "),_c('textarea',{attrs:{"id":"message","name":"message","placeholder":"Write your message here..."}}),_vm._v(" "),_c('input',{attrs:{"type":"submit","id":"ctc","name":"ctc","value":"Send your Message"}})]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Facebook"}},[_c('img',{attrs:{"src":"/static/assets/images/fb-icon.png","alt":"face-icon"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Twitter"}},[_c('img',{attrs:{"src":"/static/assets/images/twitter-icon.png","alt":"twitter-icon"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Flickr"}},[_c('img',{attrs:{"src":"/static/assets/images/flickr-icon.png","alt":"flickr-icon"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Rss"}},[_c('img',{attrs:{"src":"/static/assets/images/rss-icon.png","alt":"rss-icon"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Vimeo"}},[_c('img',{attrs:{"src":"/static/assets/images/vimeo-icon.png","alt":"vimeo-icon"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Businesses__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/businesses',
    name: 'Businesses',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Businesses__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c414f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49c414f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c414f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('component-header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"timeline"},[_c('div',{staticClass:"timeline-cover sp-page-banner"}),_vm._v(" "),_c('div',{attrs:{"id":"page-contents"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('left-sidebar')],1),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('h4',{staticClass:"grey"},[_vm._v("Participating Businesses")]),_vm._v(" "),_c('div',{staticClass:"friend-list"},[(_vm.loading)?_c('div',{staticClass:"row"},[_vm._m(0)]):_c('div',{staticClass:"row"},_vm._l((_vm.market.business_markets),function(sellpoint){return _c('div',{staticClass:"col-md-6 col-sm-6",staticStyle:{"min-height":"22em","max-height":"22em"}},[_c('a',{staticStyle:{"color":"inherit","text-decoration":"none"},attrs:{"href":'/'+sellpoint.business_username}},[_c('div',{staticClass:"friend-card",staticStyle:{"min-height":"20em","max-height":"20em","border-bottom-color":"rgb(182, 176, 176)"}},[_c('div',{staticStyle:{"height":"10em","background-size":"contain"},style:({ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url('+ sellpoint.business_banner_image + ')' })}),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('img',{staticClass:"profile-photo-lg",attrs:{"src":sellpoint.business_brand_image,"alt":"user"}}),_vm._v(" "),_c('div',{staticClass:"friend-info"},[_c('a',{staticClass:"pull-right text-green",attrs:{"href":"#"}},[_vm._v(_vm._s(sellpoint.business_category))]),_vm._v(" "),_c('h5',[_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v(_vm._s(sellpoint.business_name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(sellpoint.business_tagline))]),_vm._v(" "),_c('a',{staticClass:"pull-right",staticStyle:{"color":"rgb(41, 34, 88)","text-decoration":"none"},attrs:{"href":'/'+sellpoint.business_username}},[_c('i',{staticClass:"fa fa-circle"}),_vm._v(" visit stall")])])])])])])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 static"},[_c('right-sidebar')],1)])])])]),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-md-offset-2 col-sm-12 col-xs-12",staticStyle:{"padding":"5em"}},[_c('div',{staticClass:"wn-loader"}),_vm._v(" "),_c('p',[_vm._v("loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search__ = __webpack_require__(134);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Search__["a" /* default */]
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c3590a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54c3590a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c3590a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activeproducts_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ecd4140_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activeproducts_vue__ = __webpack_require__(137);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activeproducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ecd4140_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activeproducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friend-list"},[_c('div',{staticClass:"row"},[_c('h3',{staticStyle:{"color":"#ff5566","padding":"1em"}},[_vm._v("Top activity products")]),_vm._v(" "),_vm._l((_vm.products),function(product,index){return _c('div',{key:index,staticClass:"col-md-4 col-sm-4 col-xs-6"},[((product.product_items.length != 0))?_c('div',{staticStyle:{"min-height":"23em","max-height":"22em"}},[_c('a',{staticStyle:{"color":"inherit","text-decoration":"none"},attrs:{"href":'/'+product.product_business_username+'/'+product.product_url_name}},_vm._l((product.product_items),function(product_item,index2){return _c('div',{key:index2,staticClass:"friend-card",staticStyle:{"min-height":"22em","max-height":"22em","border-bottom-color":"rgb(182, 176, 176)"}},[(index2 == 0)?_c('div',[_c('div',{staticStyle:{"height":"10em"}},[_c('img',{staticClass:"sp-prd-img",attrs:{"src":product_item.product_item_image,"alt":"photo"}})]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"friend-info"},[_c('a',{staticClass:"pull-right text-green",staticStyle:{"font-size":"12px"},attrs:{"href":"#"}},[_vm._v("@"+_vm._s(product.product_business_name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{staticStyle:{"height":"3em"}},[_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v(_vm._s(product.product_name))])]),_vm._v(" "),_c('p',[_vm._v("₦"+_vm._s(product_item.product_item_price.toLocaleString('en', {useGrouping:true})))]),_vm._v(" "),_vm._m(0,true)])])]):_vm._e()])}))]):_vm._e()])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right",staticStyle:{"margin-bottom":"1em"}},[_c('a',{staticClass:"btn text-red",attrs:{"title":"Like"}},[_c('i',{staticClass:"fa fa-heart-o",staticStyle:{"font-size":"14px"}})]),_vm._v(" "),_c('a',{staticClass:"btn text-red",attrs:{"title":"Add to Cart"}},[_c('i',{staticClass:"fa fa-shopping-cart",staticStyle:{"font-size":"14px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('component-header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"timeline"},[_c('div',{staticClass:"timeline-cover sp-page-banner"}),_vm._v(" "),_c('div',{attrs:{"id":"page-contents"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('left-sidebar')],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('search-box'),_vm._v(" "),(!_vm.search_data != '')?_c('div',[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.search_data != '')?_c('h4',{staticClass:"grey"},[_vm._v("Products found in "+_vm._s(_vm.search_data))]):_vm._e(),_vm._v(" "),(_vm.products.length == 0)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("no matching products")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"friend-list"},[_c('div',{staticClass:"row"},_vm._l((_vm.products),function(product,index){return _c('div',{staticClass:"col-md-4 col-sm-4 col-xs-6"},[((product.product_items.length != 0))?_c('div',{staticStyle:{"min-height":"23em","max-height":"22em"}},[_c('a',{staticStyle:{"color":"inherit","text-decoration":"none"},attrs:{"href":'/'+product.product_business_username+'/'+product.product_url_name}},_vm._l((product.product_items),function(product_item,index2){return _c('div',{staticClass:"friend-card",staticStyle:{"min-height":"22em","max-height":"22em","border-bottom-color":"rgb(182, 176, 176)"}},[(index2 == 0)?_c('div',[_c('div',{staticStyle:{"height":"10em"}},[_c('img',{staticClass:"sp-prd-img",attrs:{"src":product_item.product_item_image,"alt":"photo"}})]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"friend-info"},[_c('a',{staticClass:"pull-right text-green",staticStyle:{"font-size":"12px"},attrs:{"href":"#"}},[_vm._v("@"+_vm._s(product.product_business_name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{staticStyle:{"height":"3em"}},[_c('a',{staticClass:"profile-link",attrs:{"href":"#"}},[_vm._v(_vm._s(product.product_name))])]),_vm._v(" "),_c('p',[_vm._v("₦"+_vm._s(product_item.product_item_price.toLocaleString('en', {useGrouping:true})))]),_vm._v(" "),_vm._m(1,true)])])]):_vm._e()])}))]):_vm._e()])}))]),_vm._v(" "),_c('active-products')],1)])])])]),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-md-offset-2 col-sm-12 col-xs-12",staticStyle:{"padding":"5em"}},[_c('div',{staticClass:"wn-loader"}),_vm._v(" "),_c('p',[_vm._v("loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right",staticStyle:{"margin-bottom":"1em"}},[_c('a',{staticClass:"btn text-red",attrs:{"title":"Like"}},[_c('i',{staticClass:"fa fa-heart-o",staticStyle:{"font-size":"14px"}})]),_vm._v(" "),_c('a',{staticClass:"btn text-red",attrs:{"title":"Add to Cart"}},[_c('i',{staticClass:"fa fa-shopping-cart",staticStyle:{"font-size":"14px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_GetStarted__ = __webpack_require__(140);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/getstarted/',
  name: 'GetStarted',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_GetStarted__["a" /* default */]
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a673672_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a673672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a673672_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('c-settings'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('component-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"pricing-style-one gw-mtp",staticStyle:{"background":"#aa076b"},attrs:{"id":"pricing"}},[_c('div',{staticClass:"container gw-mtp4"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane show active  animated fadeInUp",attrs:{"role":"tabpanel","id":"monthly"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one basic-pack"},[_c('div',{staticClass:"top-block"},[((_vm.plan1.product_items && _vm.plan1.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(_vm.plan1.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(_vm.plan1.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(4)]):_c('div',{staticClass:"bottom-block"},[_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.purchase_plan(_vm.plan1,'n')}}},[_vm._v("Purchase")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one pro-pack"},[_c('div',{staticClass:"top-block"},[((_vm.plan2.product_items && _vm.plan2.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(_vm.plan2.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(_vm.plan2.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_vm._m(5),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(6)]):_c('div',{staticClass:"bottom-block"},[_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.purchase_plan(_vm.plan2,'n')}}},[_vm._v("Purchase")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one biz-pack"},[_c('div',{staticClass:"top-block"},[((_vm.plan3.product_items && _vm.plan3.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(_vm.plan3.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(_vm.plan3.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_vm._m(7),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(8)]):_c('div',{staticClass:"bottom-block"},[_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.purchase_plan(_vm.plan3,'n')}}},[_vm._v("Purchase")])])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane animated fadeInUp",attrs:{"role":"tabpanel","id":"yearly"}})])])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('component-footer')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"banner-style-one home-page-two banner-hero",attrs:{"id":"banner"}},[_c('span',{staticClass:"bubble-1"}),_vm._v(" "),_c('span',{staticClass:"bubble-2"}),_vm._v(" "),_c('span',{staticClass:"bubble-3"}),_vm._v(" "),_c('span',{staticClass:"bubble-4"}),_vm._v(" "),_c('span',{staticClass:"bubble-5"}),_vm._v(" "),_c('span',{staticClass:"bubble-6"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"banner-hero-img-1 banner-mock",attrs:{"src":"/static/assets/images/banner-moc-1-2.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-8 banner-hero-intro"},[_c('div',{staticClass:"content-block"},[_c('h3',{staticClass:"gw-not-mobile",staticStyle:{"font-size":"38px","margin-bottom":"-8px"}},[_vm._v("Show your Best with the Best.")]),_vm._v(" "),_c('div',{staticClass:"hero-mobile"},[_c('img',{staticClass:"img-responsive",staticStyle:{"height":"15em"},attrs:{"src":"/static/assets/images/banner-mobile-2.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"1em"}},[_vm._v("Capture your moments "),_c('br'),_vm._v(" Save, Organise and "),_c('br'),_vm._v(" Make your work roll out like a gallery.")]),_vm._v(" "),_c('div',{staticClass:"button-block"},[_c('a',{staticClass:"banner-btn lengthy",attrs:{"href":"/demos"}},[_c('span',[_vm._v("View Live  Demos")])]),_vm._v(" "),_c('a',{staticClass:"banner-btn shorty",attrs:{"href":"/go/pricing"}},[_c('span',[_vm._v("Purchase")])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"feature-style-one",attrs:{"id":"features"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"image-block"},[_c('img',{attrs:{"src":"/static/assets/images/banner-mobile.jpg","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"content-block"},[_c('div',{staticClass:"block-title "},[_c('h2',[_vm._v("Showcase your awesome designs "),_c('br'),_vm._v(" with your Gallery Website.")])]),_vm._v(" "),_c('p',[_vm._v("We live in a visual world - "),_c('br'),_vm._v(" Make it easier for Clients to find and choose you. ")]),_vm._v(" "),_c('ul',{staticClass:"feature-lists"},[_c('li',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Choose a plan and create an account  ")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Arrange and organise your Services into Lookbooks")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Upload and describe Products and Services in Posts")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Easy to use Admin Area")])]),_vm._v(" "),_c('a',{staticClass:"feature-btn",attrs:{"href":"#more"}},[_vm._v("Learn More")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-title text-center"},[_c('h2',{staticStyle:{"color":"#ffffff"}},[_vm._v("Choose from these plans")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 2 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Max. of 5 posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Nil Custom domain ")]),_vm._v(" "),_c('li',[_vm._v("Nil custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or video")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 10 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl security")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl Security")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gw-customize",staticStyle:{"background-color":"#f7fbff"}},[_c('div',{staticClass:"container subscribe-style-one"},[_c('h2',{staticClass:"text-center gw-mtp3",staticStyle:{"font-size":"24px"}},[_vm._v("Customize your Gallery with your own designs.")]),_vm._v(" "),_c('form',{staticClass:"subscribe-form",staticStyle:{"margin-bottom":"-1em"},attrs:{"action":"#"}},[_c('input',{attrs:{"type":"text","name":"email","placeholder":"Interested? Enter your email, we will contact you"}}),_vm._v(" "),_c('button',{attrs:{"type":"submit"}},[_vm._v("Yes I'm Interested")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"faq-style-one",attrs:{"id":"more"}},[_c('div',{staticClass:"container gw-mtp3"},[_c('div',{staticClass:"block-title text-center gw-mtp2"},[_c('h2',{staticStyle:{"margin-bottom":"-1em"}},[_vm._v("Frequently Asked Questions")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-grp",attrs:{"data-grp-name":"faq-accrodion"}},[_c('div',{staticClass:"accrodion active"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v(" What is a Gallery Website?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Gallery Websites are simple, visual focused websites with products arranged like you wouldin a Product Catalogue with ecommerce functionality. The concept is that of the Fashion Lookbook\r\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("How does one get a Gallery Website?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("It’s simple. Just choose from any of our 3 plans above, subscribe, create an account and get started")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("What happens when my subscription expires?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Your account is archived for a month and permanently deleted afterwards if no further actionis taken. But if you wish to keep your contents/posts, you can pay for your Gallery Website to remain archived until the day you decide to make it Live again. "),_c('br'),_vm._v("Don’t worry, we would send you reminders.\r\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("How do I receive payments from Clients?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Payments on each Gallery Website is directly to the Site owner via an online payment gateway which we would help you setup but would be managed solely by you.")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("Will my website have my company name as the domain e.x www.mycompany.com?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Yes, all our paid plans have free custom .com.ng domains but you can easily pay for any domain of your choice to be added - .com, .ng etc")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("Will I be able to upload my products?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Yes, every account has its own Admin area where you have "),_c('b',[_vm._v("full control over your Gallery Website’s Look and Feel")]),_vm._v(" - manage your product and shipping details, upload and change images, update your Contact Us info etc.")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("Do you provide shipping partners?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("No, we don’t. It’s the responsibility of each Gallery Website owner to handle his/her shipping responsibilities. But feel free to browse through our Logistics category in ‘Our Gallery’ to find a shipping partner that sits your needs.")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("Do I get unlimited Storage space on my Gallery Website?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("No, every plan is capped but you can expand your space for an additional unremarkable yearly fee")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("I have a domain and hosting already, can my Gallery Website be moved there?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Unfortunately, this service is not yet available for now. All Gallery Websites are managed from a central host but you can use your already purchased domain name for your Gallery Website.")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("Can I have some additional features added to my Gallery Website?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Yes, you can. Just write to the team at "),_c('a',{attrs:{"href":"mailto:customfeatures@lookbookgallery.com"}},[_vm._v("customfeatures@lookbookgallery.com")]),_vm._v(" and start the discussion on how we can build you a custom Gallery Website")])])])]),_vm._v(" "),_c('div',{staticClass:"accrodion"},[_c('div',{staticClass:"accrodion-title"},[_c('h4',[_vm._v("I have registered and logged in, but don’t know what to do next?")])]),_vm._v(" "),_c('div',{staticClass:"accrodion-content"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Please watch our "),_c('b',[_vm._v("onboarding videos")]),_vm._v(" or read through our "),_c('b',[_vm._v("‘Getting Started Tutorials’")]),_vm._v(" to serve as a guide. And if you are still not clear on what to do next, you can give us a call on 0708 642 8158 or send us a mail at "),_c('a',{attrs:{"href":"mailto:onboarding@lookbookgallery.com"}},[_vm._v("onboarding@lookbookgallery.com")]),_vm._v(" to guide you through the process")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase__ = __webpack_require__(172);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/purchase/',
  name: 'Purchase',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase__["a" /* default */]
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30c41e7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30c41e7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30c41e7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('c-settings'),_vm._v(" "),_c('div',{staticClass:"page-wrapper",attrs:{"id":"topwrap"}},[_c('component-header'),_vm._v(" "),(_vm.set_upgrade_plans)?_c('section',{staticClass:"pricing-style-one",staticStyle:{"background":"#aa076b","margin-top":"5em"},attrs:{"id":"pricing"}},[_c('div',{staticStyle:{"margin-top":"-5em"}},[(!_vm.set_upgrade_plan_process)?_c('div',{staticClass:"container"},[(_vm.upgradable_plans.length == 0)?_c('div',{staticClass:"block-title text-center"},[_c('h2',{staticStyle:{"color":"#ffffff"}},[_vm._v("Sorry, no plans to upgrade to.")])]):_c('div',{staticClass:"block-title text-center"},[_c('h2',{staticStyle:{"color":"#ffffff"}},[_vm._v("Select a plan to upgrade")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane show active  animated fadeInUp",attrs:{"role":"tabpanel"}},[_c('div',{staticClass:"row"},_vm._l((_vm.upgradable_plans),function(plan){return _c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one upgrade-packs basic-pack"},[_c('div',{staticClass:"top-block"},[((plan.product_items && plan.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(plan.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(plan.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_c('div',{staticClass:"feature-list"},[(plan.product_url_name == _vm.plan1.product_url_name)?_c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 2 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Max. of 5 posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Nil Custom domain ")]),_vm._v(" "),_c('li',[_vm._v("Nil custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")])]):_vm._e(),_vm._v(" "),(plan.product_url_name == _vm.plan2.product_url_name)?_c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or video")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 10 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl security")])]):_vm._e(),_vm._v(" "),(plan.product_url_name == _vm.plan3.product_url_name)?_c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl Security")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom-block"},[_c('p',{staticClass:"sp-form-descr"},[_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]),_vm._v(" "),_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.upgrade_plan(plan)}}},[_vm._v("Purchase")])])])])}))])])]):_c('div',{staticClass:"container",staticStyle:{"margin-top":"10em"}},[_vm._m(1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(2)]):_c('div',{staticClass:"row onboarding-wrap"},[(_vm.setup_error_message != '')?_c('div',{staticClass:"row onboarding-head"},[_c('div',{staticClass:"col",staticStyle:{"margin":"5em","text-align":"center"}},[_c('p',{staticStyle:{"color":"#000000","font-size":"18px"}},[_vm._v(_vm._s(_vm.setup_error_message)+".")])])]):_c('div',[_c('div',{staticClass:"row onboarding-body"},[_c('div',{staticClass:"col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"},[_c('div',[_c('h6',{staticStyle:{"text-decoration":"underline"}},[_vm._v("Upgrade Plans")]),_vm._v(" "),(_vm.selected_plan && _vm.selected_plan.product_items)?_c('h4',[_c('b',[_vm._v(_vm._s(_vm.selected_plan.product_name)+"(₦"+_vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price))+")")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{},[_c('div',[_vm._l((_vm.selected_plan.product_items_upgrade_details),function(details){return _c('div',{},[(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id)?_c('div',[_c('p',[_vm._v("Your last Subscription was on:"),_c('b',[_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("You have "),_c('b',[_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]),_vm._v(" days before your subscription expires.")]),_vm._v(" "),_c('p',[_vm._v("To upgrade to this plan, the total sum to pay is "),_c('b',[_vm._v("₦"+_vm._s(details.subscription_new_product_total_amount_to_pay))])])]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{},[_c('form',{staticClass:"gw-form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Subscription Duration: "),_c('b',[_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]),_c('br'),_vm._v(" "),_c('label',[_c('p',{staticClass:"sp-form-descr"},[_c('b',[_vm._v("Total to pay: ₦"+_vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]),_vm._v(" "),(_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1))?_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"gw-btn-cta-light",staticStyle:{"color":"#ffffff"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('display-product_service_items','')}}},[_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"none","border":"#aa076b dashed","margin-top":"6px","padding":"5px"},attrs:{"id":"productServiceItems"}},_vm._l((_vm.selected_plan.product_items),function(pt){return _c('div',{staticClass:"radio-items"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_service_items_select),expression:"product_service_items_select"}],attrs:{"type":"radio","id":pt.product_item_id},domProps:{"value":pt.product_item_id,"checked":_vm._q(_vm.product_service_items_select,pt.product_item_id)},on:{"click":function($event){_vm.selectProductServiceItem(pt)},"change":function($event){_vm.product_service_items_select=pt.product_item_id}}}),_vm._v(_vm._s(pt.product_item_service_tag)+"\r\n                                                                ")])}))]):_vm._e(),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),(_vm.payment_successful)?_c('div',{},[_c('h3',{staticStyle:{"color":"#7c0b0b","font-size":"16px"}},[_vm._v(_vm._s(_vm.payment_successful_message))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"boarding-messages"},[_c('p',{staticStyle:{"color":"#4617c7"}},[_vm._v(_vm._s(_vm.data_boarding_message))])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn pull-left gw-btn-cta-light",staticStyle:{"cursor":"pointer","color":"#ffffff"},attrs:{"type":"button","disabled":_vm.disable_btn},on:{"click":function($event){_vm.proceedUpgradePlan()}}},[_vm._v(" Proceed")]),_vm._v(" "),_c('button',{staticClass:"btn pull-right",staticStyle:{"background":"#f0de3d","cursor":"pointer","color":"#000000"},attrs:{"type":"button"},on:{"click":_vm.reset}},[_vm._v(" Cancel")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2)])])])])])])])]):_c('section',{staticClass:"home-page-two gw-banner-plain",attrs:{"id":"banner"}},[_c('div',{staticClass:"container"},[(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(4)]):_c('div',{staticClass:"row onboarding-wrap"},[(_vm.setup_error_message != '')?_c('div',{staticClass:"row onboarding-head"},[_c('div',{staticClass:"col",staticStyle:{"margin":"5em","text-align":"center"}},[_c('p',{staticStyle:{"color":"#000000","font-size":"18px"}},[_vm._v(_vm._s(_vm.setup_error_message)+".")])])]):_c('div',[(!_vm.newBusinessForm)?_c('div',{staticClass:"row onboarding-body"},[_c('div',{staticClass:"col-6 onboarding-left"},[_c('h6',[_vm._v("Purchase Plans")]),_vm._v(" "),_c('p',[_vm._v("You are about to purchase "),_c('b',[_vm._v(_vm._s(_vm.selected_plan.product_name))]),_vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "),_c('span',{staticClass:"sp-mention-inline"},[_vm._v("Afiahub Sellpoint")]),_vm._v(" account. We use Afiahub to manage your acounts. \r\n                                        If you already have a Afiahub account, you can Sign Up with your details.")]),_vm._v(" "),_c('p',[_c('u',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.toggleDisplayFeatures}},[_vm._v("\r\n                                            See features of "+_vm._s(_vm.selected_plan.product_name)+" "),_c('i',{staticClass:"fa fa-caret-down",staticStyle:{"color":"#ff0055","font-size":"18px"}})])])]),_vm._v(" "),_c('div',{staticClass:"features-display",staticStyle:{"display":"none"},attrs:{"id":"seeFeatures"}},[_c('div',{staticClass:"feature-list"},[(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name)?_c('ul',[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 2 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Max. of 5 posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Nil Custom domain ")]),_vm._v(" "),_c('li',[_vm._v("Nil custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")])]):_vm._e(),_vm._v(" "),(_vm.selected_plan.product_url_name == _vm.plan2.product_url_name)?_c('ul',[_c('li',[_vm._v("Upload images or video")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 10 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl security")])]):_vm._e(),_vm._v(" "),(_vm.selected_plan.product_url_name == _vm.plan3.product_url_name)?_c('ul',[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl Security")])]):_vm._e()])]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"},[_c('div',[_c('h6',{staticClass:"gw-mobile",staticStyle:{"text-decoration":"underline"}},[_vm._v("Purchase Plans")]),_vm._v(" "),(_vm.selected_plan && _vm.selected_plan.product_items)?_c('h4',[_c('b',[_vm._v(_vm._s(_vm.selected_plan.product_name)+"(₦"+_vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price))+")")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{},[(!_vm.set_up_with_existing_account)?_c('div',[(!_vm.loggedIn)?_c('div',{},[_c('div',{staticClass:"gw-mobile"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn gw-btn-cta-light pu",staticStyle:{"cursor":"pointer","margin-bottom":"1em","color":"#ffffff"},on:{"click":function($event){_vm.setComponent('setup-existing','')}}},[_vm._v("Sign Up with Afiahub")])]),_vm._v(" "),_c('p',{staticStyle:{"color":"#aa076b","font-size":"14px","font-weight":"500"}},[_vm._v("Or Create an Afiahub account to proceed.")])]),_vm._v(" "),_c('div',{staticClass:"gw-not-mobile"},[_c('p',{staticClass:"pull-left",staticStyle:{"color":"#aa076b"}},[_vm._v("Create an Afiahub account to proceed.")]),_vm._v(" "),_c('a',{staticClass:"btn gw-btn-cta-light pull-right",staticStyle:{"cursor":"pointer","margin-bottom":"1em","color":"#ffffff"},on:{"click":function($event){_vm.setComponent('setup-existing','')}}},[_vm._v(" Or Sign Up with Afiahub")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{},[_c('form',{staticClass:"gw-form"},[(!_vm.loggedIn)?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_payer_name),expression:"payment_payer_name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Your full name"},domProps:{"value":(_vm.payment_payer_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payment_payer_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_payer_email),expression:"payment_payer_email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.payment_payer_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payment_payer_email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_payer_phone),expression:"payment_payer_phone"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Phone (format: 09088776655)"},domProps:{"value":(_vm.payment_payer_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payment_payer_phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_password),expression:"user.user_password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.user.user_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_password", $event.target.value)}}})])]):_c('div',[_c('label',[_c('b',[_vm._v("Name:")]),_vm._v(" "+_vm._s(_vm.user.user_name))]),_c('br'),_vm._v(" "),_c('label',[_c('b',[_vm._v("Email:")]),_vm._v(" "+_vm._s(_vm.user.user_email))]),_c('br'),_vm._v(" "),_c('label',[_c('b',[_vm._v("Phone:")]),_vm._v(" "+_vm._s(_vm.user.user_phone))]),_c('br')]),_vm._v(" "),(_vm.selected_plan_product_service_item.product_item_service_tag)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Subscription Duration: "),_c('b',[_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]),_c('br'),_vm._v(" "),_c('label',[_c('p',{staticClass:"sp-form-descr"},[_c('b',[_vm._v("Total to pay: ₦"+_vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]):_vm._e(),_vm._v(" "),(_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1))?_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"gw-btn-cta-light",staticStyle:{"color":"#ffffff"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('display-product_service_items','')}}},[_vm._v("\r\n                                                            Change Subscription Duration\r\n                                                        ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"none","border":"#aa076b dashed","margin-top":"6px","padding":"5px"},attrs:{"id":"productServiceItems"}},_vm._l((_vm.selected_plan.product_items),function(pt){return _c('div',{staticClass:"radio-items"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_service_items_select),expression:"product_service_items_select"}],attrs:{"type":"radio","id":pt.product_item_id},domProps:{"value":pt.product_item_id,"checked":_vm._q(_vm.product_service_items_select,pt.product_item_id)},on:{"click":function($event){_vm.selectProductServiceItem(pt)},"change":function($event){_vm.product_service_items_select=pt.product_item_id}}}),_vm._v(_vm._s(pt.product_item_service_tag)+"\r\n                                                            ")])}))]):_vm._e(),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),(_vm.payment_successful)?_c('div',{},[_c('h3',{staticStyle:{"color":"#7c0b0b","font-size":"16px"}},[_vm._v(_vm._s(_vm.payment_successful_message))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"boarding-messages"},[_c('p',{staticStyle:{"color":"#4617c7"}},[_vm._v(_vm._s(_vm.data_boarding_message))])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn pull-left gw-btn-cta-light",staticStyle:{"cursor":"pointer","color":"#ffffff"},attrs:{"type":"button","disabled":_vm.disable_btn},on:{"click":function($event){_vm.proceedNewAccount()}}},[_vm._v(" Proceed")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_c('div',[_vm._m(7),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"2em"}},[_c('form',{staticClass:"gw-form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_email),expression:"user.user_email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.user.user_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_password),expression:"user.user_password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.user.user_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sellpoint Username or Handle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_business),expression:"user.user_business"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Sellpoint Username/Handle"},domProps:{"value":(_vm.user.user_business)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_business", $event.target.value)}}})]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),(_vm.payment_successful)?_c('div',{},[_c('h3',{staticStyle:{"color":"#7c0b0b","font-size":"16px"}},[_vm._v(_vm._s(_vm.payment_successful_message))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"boarding-messages"},[_c('p',{staticStyle:{"color":"#4617c7"}},[_vm._v(_vm._s(_vm.data_boarding_message))])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn gw-btn-cta-light pull-left",staticStyle:{"cursor":"pointer","border-radius":"2p","color":"#ffffff"},attrs:{"type":"button","disabled":_vm.disable_btn},on:{"click":function($event){_vm.proceedWithAccount()}}},[_vm._v(" Proceed")])])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('hr'),_vm._v(" "),_c('a',{staticClass:"gw-btn-cta-light pull-left",staticStyle:{"cursor":"pointer","margin-bottom":"1em","color":"#ffffff"},on:{"click":function($event){_vm.setComponent('not-setup-existing','')}}},[_vm._v(" Or Create a new account")])])])])])])]):_c('div',{staticClass:"row onboarding-body"},[_c('div',{staticClass:"col-6 onboarding-left"},[_c('h6',[_vm._v("Purchase Plans")]),_vm._v(" "),_c('p',[_vm._v("You are about to purchase "),_c('b',[_vm._v(_vm._s(_vm.selected_plan.product_name))]),_vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "),_c('span',{staticClass:"sp-mention-inline"},[_vm._v("Afiahub Sellpoint")]),_vm._v(" account. We use Afiahub to manage your acounts. \r\n                                        If you already have a Afiahub account, you can Sign Up with your details.")]),_vm._v(" "),_c('p',[_c('u',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.toggleDisplayFeatures}},[_vm._v("\r\n                                            See features of "+_vm._s(_vm.selected_plan.product_name)+" "),_c('i',{staticClass:"fa fa-caret-down",staticStyle:{"color":"#ff0055","font-size":"18px"}})])])]),_vm._v(" "),_c('div',{staticClass:"features-display",staticStyle:{"display":"none"},attrs:{"id":"seeFeatures"}},[_c('div',{staticClass:"feature-list"},[(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name)?_c('ul',[_c('li',[_vm._v("cica1")])]):_vm._e(),_vm._v(" "),(_vm.selected_plan.product_url_name == _vm.plan2.product_url_name)?_c('ul',[_c('li',[_vm._v("cica2")])]):_vm._e(),_vm._v(" "),(_vm.selected_plan.product_url_name == _vm.plan3.product_url_name)?_c('ul',[_c('li',[_vm._v("cica3")])]):_vm._e()])]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"},[_vm._m(10),_vm._v(" "),_c('div',{},[_c('div',[_c('div',{staticStyle:{"margin-bottom":"2em"}},[_c('form',{staticClass:"gw-form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Business Name  ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_name),expression:"business.business_name"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":""},domProps:{"value":(_vm.business.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "business_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Business Username "),(_vm.validate_user_name_error)?_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.validate_user_name_message))]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_user_name),expression:"business.business_user_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.business.business_user_name)},on:{"change":_vm.validateUserName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "business_user_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Business Category Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_category_type),expression:"business_category_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.business_category_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Products")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Services")])])]),_vm._v(" "),(_vm.business_category_type == 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select a Product Category")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_category),expression:"business.business_category"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.business, "business_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.business_product_categories),function(category){return _c('option',{domProps:{"value":category.category_id}},[_vm._v(_vm._s(category.category_name))])})],2)]):_vm._e(),_vm._v(" "),(_vm.business_category_type == 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select a Service Category")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.business_category),expression:"business.business_category"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.business, "business_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.business_service_categories),function(category){return _c('option',{domProps:{"value":category.category_id}},[_vm._v(_vm._s(category.category_name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"boarding-messages"},[_c('p',{staticStyle:{"color":"#4617c7"}},[_vm._v(_vm._s(_vm.data_boarding_message))])]),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn gw-btn-cta-light",staticStyle:{"color":"#ffffff"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.setUpNewAccountBusiness}},[_vm._v("Create")])])])])])])])])])])]),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"container gw-mobile"},[_vm._m(11)]):_vm._e()]),_vm._v(" "),(!_vm.$route.query.upgrade)?_c('section',{staticClass:"pricing-style-one gw-mtp",attrs:{"id":"pricing"}},[_c('div',{staticClass:"container"},[_vm._m(12),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_vm._m(13)]):_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane show active  animated fadeInUp",attrs:{"role":"tabpanel","id":"monthly"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one basic-pack"},[_c('div',{staticClass:"top-block"},[((_vm.plan1.product_items && _vm.plan1.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(_vm.plan1.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(_vm.plan1.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('div',{staticClass:"bottom-block"},[_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.purchase_plan_2(_vm.plan1,'n')}}},[_vm._v("Purchase")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one pro-pack"},[_c('div',{staticClass:"top-block"},[((_vm.plan2.product_items && _vm.plan2.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(_vm.plan2.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(_vm.plan2.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('div',{staticClass:"bottom-block"},[_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.purchase_plan_2(_vm.plan2,'n')}}},[_vm._v("Purchase")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"single-pricing-one biz-pack"},[_c('div',{staticClass:"top-block"},[((_vm.plan3.product_items && _vm.plan3.product_items.length > 0))?_c('span',{staticClass:"price"},[_vm._v("₦"+_vm._s(_vm.plan3.product_description_name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"pack-name"},[_vm._v(_vm._s(_vm.plan3.product_name))]),_vm._v(" "),_c('div',{staticClass:"line"})]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:"bottom-block"},[_c('a',{staticClass:"price-btn",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.purchase_plan_2(_vm.plan3,'n')}}},[_vm._v("Purchase")])])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane animated fadeInUp",attrs:{"role":"tabpanel","id":"yearly"}})])])]):_vm._e(),_vm._v(" "),_c('component-footer')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-title text-center"},[_c('h2',{staticStyle:{"color":"#ffffff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('input',{attrs:{"type":"checkbox","checked":"true","disabled":"disabled"}}),_vm._v(" By proceeding, you agree with the "),_c('u',[_c('a',{staticStyle:{"cursor":"pointer","color":"#ff0055","font-weight":"bold"},attrs:{"data-toggle":"modal","data-backdrop":"false","data-target":"#terms-modal","href":"#"}},[_vm._v("Terms and Conditions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-top":"3em"}},[_c('a',{staticClass:"btn gw-btn-cta-01",attrs:{"href":"#pricing"}},[_vm._v("Checkout other plans")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('input',{attrs:{"type":"checkbox","checked":"true","disabled":"disabled"}}),_vm._v(" By proceeding, you agree with the "),_c('u',[_c('a',{staticStyle:{"cursor":"pointer","color":"#ff0055","font-weight":"bold"},attrs:{"data-toggle":"modal","data-backdrop":"false","data-target":"#terms-modal","href":"#"}},[_vm._v("Terms and Conditions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',{staticClass:"pull-left",staticStyle:{"color":"#aa076b"}},[_vm._v("Proceed with your Afiahub Account ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('input',{attrs:{"type":"checkbox","checked":"true","disabled":"disabled"}}),_vm._v(" By proceeding, you agree with the "),_c('u',[_c('a',{staticStyle:{"cursor":"pointer","color":"#ff0055","font-weight":"bold"},attrs:{"data-toggle":"modal","data-backdrop":"false","data-target":"#terms-modal","href":"#"}},[_vm._v("Terms and Conditions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-top":"3em"}},[_c('a',{staticClass:"btn gw-btn-cta-01",attrs:{"href":"#pricing"}},[_vm._v("Checkout other plans")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gw-mobile"},[_c('h6',{staticClass:"gw-mobile",staticStyle:{"text-decoration":"underline"}},[_vm._v("Setup New Afiahub")]),_vm._v(" "),_c('p',{staticClass:"sp-form-descr"},[_vm._v("Setup New Afiahub for your Business")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5 offset-sm-4",staticStyle:{"text-align":"center","margin-top":"3em"}},[_c('a',{staticClass:"btn gw-btn-cta-01",attrs:{"href":"#pricing"}},[_vm._v("Checkout other plans")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-title text-center"},[_c('h2',{staticStyle:{"color":"#aa076b"}},[_vm._v("Choose from these plans")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5 offset-sm-4"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 2 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Max. of 5 posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Nil Custom domain ")]),_vm._v(" "),_c('li',[_vm._v("Nil custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or video")]),_vm._v(" "),_c('li',[_vm._v("Maximum of 10 Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts per Lookbook")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Nil Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl security")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"feature-lists"},[_c('li',[_vm._v("Upload images or videos")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Lookbooks")]),_vm._v(" "),_c('li',[_vm._v("Unlimited Posts")]),_vm._v(" "),_c('li',[_vm._v("Free .com.ng domain")]),_vm._v(" "),_c('li',[_vm._v("Unlimited custom email addresses")]),_vm._v(" "),_c('li',[_vm._v("Online Store")]),_vm._v(" "),_c('li',[_vm._v("SSl Security")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register__ = __webpack_require__(176);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/register',
  name: 'register',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Register__["a" /* default */]
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b92fc8cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(178);
function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b92fc8cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b92fc8cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('component-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"sign-in-page"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 create-new-account"},[_c('h4',{staticClass:"checkout-subtitle"},[_vm._v("Create a new account")]),_vm._v(" "),_c('p',{staticClass:"text title-tag-line"},[_vm._v("Create your new account.")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_proccessing_message))]),_vm._v(" "),_c('form',{staticClass:"register-form outer-top-xs",attrs:{"role":"form"}},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],staticClass:"form-control unicase-form-control text-input",attrs:{"type":"email","id":"exampleInputEmail1"},domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control unicase-form-control text-input",attrs:{"type":"email","id":"exampleInputEmail2"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phone),expression:"user.phone"}],staticClass:"form-control unicase-form-control text-input",attrs:{"type":"number","id":"exampleInputEmail1"},domProps:{"value":(_vm.user.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control unicase-form-control text-input",attrs:{"type":"password","id":"exampleInputEmail1"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"info-title"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_purchase),expression:"user_purchase"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.user_purchase)?_vm._i(_vm.user_purchase,null)>-1:(_vm.user_purchase)},on:{"change":function($event){var $$a=_vm.user_purchase,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.user_purchase=$$a.concat([$$v]))}else{$$i>-1&&(_vm.user_purchase=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.user_purchase=$$c}}}}),_vm._v("Do you want to get a space to sell in this mall?\r\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"info-title"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.terms),expression:"terms"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.terms)?_vm._i(_vm.terms,null)>-1:(_vm.terms)},on:{"change":function($event){var $$a=_vm.terms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.terms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.terms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.terms=$$c}}}}),_vm._v("I agree to the"),_c('a',{attrs:{"href":"know#terms"}},[_vm._v("Terms and Conditions")])])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_proccessing_message))]),_vm._v(" "),_c('button',{staticClass:"btn-upper btn btn-primary checkout-page-button",attrs:{"type":"button","disabled":_vm.disable_btn},on:{"click":_vm.reg}},[_vm._v("Sign Up")])])])])])])]),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"breadcrumb-inner"},[_c('ul',{staticClass:"list-inline list-unstyled"},[_c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Sign-up")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-xs-12 hidden-xs"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"/static/assets/images/maller.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"info-title",attrs:{"for":"exampleInputEmail1"}},[_vm._v("Name "),_c('span',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"info-title",attrs:{"for":"exampleInputEmail2"}},[_vm._v("Email Address "),_c('span',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"info-title",attrs:{"for":"exampleInputEmail1"}},[_vm._v("Phone Number "),_c('span',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"info-title",attrs:{"for":"exampleInputEmail1"}},[_vm._v("Password "),_c('span',[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(180);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login__["a" /* default */]
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28321a20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(182);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28321a20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28321a20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('component-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"sign-in-page"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 sign-in"},[_c('h4',{},[_vm._v("Sign in")]),_vm._v(" "),_c('p',{},[_vm._v("Hello and Welcome back, login to continue.")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('form',{staticClass:"register-form outer-top-xs",attrs:{"role":"form"}},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control unicase-form-control text-input",attrs:{"type":"email","id":"exampleInputEmail1"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control unicase-form-control text-input",attrs:{"type":"password","id":"exampleInputPassword1"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('button',{staticClass:"btn-upper btn btn-primary checkout-page-button",attrs:{"type":"button"},on:{"click":_vm.login}},[_vm._v("Login")]),_vm._v(" | "),_c('a',{staticClass:"forgot-password pull-right",attrs:{"href":"register"}},[_vm._v("Hava an account? Sign In")])])])])])])]),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"breadcrumb-inner"},[_c('ul',{staticClass:"list-inline list-unstyled"},[_c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Login")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-xs-12 hidden-xs"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"/static/assets/images/maller.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-sign-in outer-top-xs",staticStyle:{"display":"none"}},[_c('a',{staticClass:"facebook-sign-in",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-facebook"}),_vm._v(" Sign In with Facebook")]),_vm._v(" "),_c('a',{staticClass:"twitter-sign-in",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-twitter"}),_vm._v(" Sign In with Twitter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"info-title",attrs:{"for":"exampleInputEmail1"}},[_vm._v("Email Address "),_c('span',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"info-title",attrs:{"for":"exampleInputPassword1"}},[_vm._v("Password "),_c('span',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio outer-xs"},[_c('label',[_c('input',{attrs:{"type":"radio","name":"optionsRadios","id":"optionsRadios2","value":"option2"}}),_vm._v("Remember me!\r\n                  ")]),_vm._v(" "),_c('a',{staticClass:"forgot-password pull-right",attrs:{"href":"#"}},[_vm._v("Forgot your Password?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account__ = __webpack_require__(184);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/account',
  name: 'Account',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Account__["a" /* default */]

});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d956d7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d956d7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d956d7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8 contact_form add-prd-item"},[_c('h6',[_vm._v("Add New Item ")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('ul',{staticClass:"row"},[_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Price\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_price),expression:"product.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Weight\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_weight),expression:"product.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_weight", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Quantity\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_quantity),expression:"product.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" Product Image")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*"},on:{"change":function($event){_vm.onFileChange($event)}}})]),_vm._v(" "),_c('li',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.addProductItem}},[_vm._v("Add")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('header',{staticClass:"site-header header-one home-page-one"},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light header-navigation stricky",staticStyle:{"background":"none"}},[_c('div',{staticClass:"container clearfix nav-head",staticStyle:{"background":"none"}},[_vm._m(0),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"right-side-box"},[_c('a',{staticClass:"header-btn",attrs:{"href":'/'+_vm.sellpoint.business_username}},[_vm._v("View Gallery")])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"vtd vtd-right-side-box"},[_c('a',{staticClass:"header-btn vtd-btn",attrs:{"href":'/'+_vm.sellpoint.business_username}},[_vm._v("View Gallery")])]):_vm._e()])])]),_vm._v(" "),_c('section',{staticStyle:{"height":"3em","background":"#ffffff"},attrs:{"id":"top"}},[_c('div',{staticClass:"container banner-menu"},[_c('div',{staticClass:"row menu-links"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('lookbooks')}}},[_vm._v("Lookbooks")])]),_vm._v(" "),_c('li',{staticClass:"gw-mobile"},[_c('a',{on:{"click":function($event){_vm.setMenuComponent('feeds')}}},[_vm._v("Feeds")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('profile')}}},[_vm._v("Profile")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('settings')}}},[_vm._v("Orders")])]),_vm._v(" "),(!_vm.loading)?_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-panel')}}},[_vm._v("Manage Gallery")])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('li',[_c('a',{attrs:{"href":"/getstarted"}},[_vm._v("Get a Mall Space")])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('settings')}}},[_vm._v("Settings")])])])])])]),_vm._v(" "),(!_vm.setPanel)?_c('section',{staticClass:"account-inner",staticStyle:{"background":"#f7fbff","margin-top":"2em"}},[(_vm.loading)?_c('div',{staticClass:"container"},[_vm._m(1)]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"row account-inner-row"},[_c('div',{staticClass:"col-md-4 col-sm-12"},[_c('div',{staticClass:"info-card",attrs:{"id":"profile"}},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"info-card-left"},[_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-left":"5px"}},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":'/'+_vm.sellpoint.business_username}},[_c('h5',[_vm._v(_vm._s(_vm.sellpoint.business_name))]),_vm._v(" "),_c('p',{staticClass:"sp-form-descr",staticStyle:{"color":"inherit","margin-top":"-1em"}},[_vm._v("@"+_vm._s(_vm.sellpoint.business_username))])])])]),_vm._v(" "),_c('div',{staticClass:"info-card-right",staticStyle:{"display":"none"}},[_c('div',[_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"},on:{"click":function($event){_vm.toggleSwitchBusiness()}}},[_c('i',{staticClass:"fa fa-cog"})])]),_vm._v(" "),_c('div',{staticClass:"show-business-list",staticStyle:{"display":"none"},attrs:{"id":"businessList"}},_vm._l((_vm.sellpoints),function(sellpoint){return _c('li',[_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"},on:{"click":function($event){_vm.switchBusiness(sellpoint)}}},[_vm._v(_vm._s(sellpoint.business_name))])])}))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-stats-top"},[_c('div',{staticClass:"col-xs-2 stats-block"},[_c('h5',{staticClass:"stats-num"},[_vm._v(_vm._s(_vm.sellpoint.business_total_gallery_posts))]),_vm._v(" "),_c('p',{staticClass:"stats-descr"},[_vm._v("Posts")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 stats-block stats-block-center"},[_c('h5',{staticClass:"stats-num"},[_vm._v(_vm._s(_vm.sellpoint.business_total_gallery))]),_vm._v(" "),_c('p',{staticClass:"stats-descr"},[_vm._v("Lookbooks")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 stats-block"},[_c('h5',{staticClass:"stats-num"},[_vm._v(_vm._s(_vm.sellpoint.business_total_views))]),_vm._v(" "),_c('p',{staticClass:"stats-descr"},[_vm._v("Views")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row info-stats-list"},[_c('p',[_c('span',[_vm._v("Category")]),_vm._v(_vm._s(_vm.sellpoint.business_category))])]),_vm._v(" "),_c('div',{staticClass:"row info-stats-list"},[_c('p',[_c('span',[_vm._v("Tagline:")]),_vm._v(_vm._s(_vm.sellpoint.business_tagline))])]),_vm._v(" "),_c('div',{staticClass:"row info-stats-list"},[_c('p',[_c('span',[_vm._v("Brief:")]),_vm._v(_vm._s(_vm.sellpoint.business_profile))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5px"}},[_c('a',{staticClass:"btn vtd-btn",staticStyle:{"float":"left","background":"#f1dee4","font-size":"14px"},attrs:{"href":'/'+_vm.sellpoint.business_username}},[_vm._v("View Gallery")]),_vm._v(" "),_c('button',{staticClass:"btn vtd-btn",staticStyle:{"float":"right","background":"#f1dee4","font-size":"14px"},on:{"click":function($event){_vm.setComponent('manage-panel','')}}},[_vm._v("Manage Gallery")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"lookbooks"}},[_c('div',{staticClass:"info-card"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-card-row"},[_c('div',{staticClass:"col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]),_vm._v(" "),_vm._l((_vm.galleria),function(gallery,gndex){return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"font-size":"12px","line-height":"1.2"}},[_c('div',{staticClass:"col-sm-3"},[(gallery.gallery_posts_group_posts_media.length > 0)?_c('div',{staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":gallery.gallery_posts_group_posts_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_name))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_posts.length)+" posts")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})])])])}),_vm._v(" "),(_vm.galleria.length == 0)?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(4)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"feeds"}},[_c('div',{staticClass:"info-card info-card-feeds"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-card-inner-row"},[(_vm.sellpoint.business_notifications && (_vm.sellpoint.business_notifications.length != 0))?_c('div',{staticClass:"notification-slide"},[_c('div',{staticClass:"pc-slider"},[_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-0","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-1","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-2","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-3","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-autoplay","type":"radio","checked":""}}),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"slide-description"},[_c('label',{staticClass:"slide-0"},[_c('p',{staticClass:"text-slide"},[_vm._v(_vm._s(_vm.sellpoint.business_notifications[0].notification_message))])]),_vm._v(" "),_c('label',{staticClass:"slide-1"},[_c('p',{staticClass:"text-slide"},[_vm._v(_vm._s(_vm.sellpoint.business_notifications[1].notification_message))])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])]):_c('div',[_vm._m(12)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"contact"}},[_c('div',{staticClass:"info-card"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-card-inner-row info-stats-list"},[_c('p',[_c('span',[_vm._v("Address")]),_vm._v(_vm._s(_vm.sellpoint.business_address))])]),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row info-stats-list"},[_c('p',[_c('span',[_vm._v("Email:")]),_vm._v(_vm._s(_vm.sellpoint.business_emails))])]),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row info-stats-list"},[_c('p',[_c('span',[_vm._v("Phone:")]),_vm._v(_vm._s(_vm.sellpoint.business_phones))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"subscription"}},[_c('div',{staticClass:"info-card"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"container info-card-body",staticStyle:{"padding":"0 1em"}},[_c('p',[_c('b',[_vm._v("Current Plan: ")]),_c('span',{staticStyle:{"color":"#ff0055","font-weight":"500"}},[_vm._v(_vm._s(_vm.sellpoint_gallery.business_market_subscription_name))])]),_vm._v(" "),(!_vm.can_add_more_lookbook)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"margin":"0","padding":"0"}},[_c('div',{staticClass:"manage-action-block"},[_c('h5',[_vm._v("You have reached the limit of your gallery")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"}},[_c('p',[_vm._v("To add more lookbooks to your gallery, "),_c('a',{staticClass:"btn",staticStyle:{"background":"#ff0055","color":"#ffffff"},attrs:{"href":'/purchase?upgrade='+_vm.sellpoint.business_username}},[_vm._v("Upgrade your Account")])])])])])]):_vm._e(),_vm._v(" "),(!_vm.can_add_product_lookbook)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"margin":"0","padding":"0"}},[_c('div',{staticClass:"manage-action-block"},[_c('h5',[_vm._v("Do you want to sell some Products or Services of your Gallery? ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"}},[_c('p',[_vm._v("Unlock this Package. "),_c('a',{staticClass:"btn",staticStyle:{"background":"#ff0055","color":"#ffffff"},attrs:{"href":'/purchase?upgrade='+_vm.sellpoint.business_username}},[_vm._v("Upgrade your Account to Unlock")])])])])])]):_vm._e(),_vm._v(" "),(_vm.can_add_more_lookbook && _vm.can_add_product_lookbook)?_c('div',[_vm._m(15)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"settings"}},[_c('div',{staticClass:"info-card info-card-feeds"},[_vm._m(16),_vm._v(" "),(_vm.setSettings)?_c('div',{staticClass:"container"},[(_vm.setting_details.editProfile)?_c('div',[_c('h6',[_vm._v("Edit Profile Details")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Name\r\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_name),expression:"user.user_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.user_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Phone Number\r\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_phone),expression:"user.user_phone"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.user_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_phone", $event.target.value)}}})])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","font-size":"12px"},attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.editProfileDetails}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e()]):_c('div',{staticClass:"container info-card-body"},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row"},[_c('a',{staticClass:"btn",staticStyle:{"cursor":"pointer","background":"#f1dee4","padding":"1em","color":"#000"},on:{"click":function($event){_vm.setComponent('set-settings-inner','editProfile')}}},[_vm._v("Edit Profile")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row",staticStyle:{"display":"none"}},[_c('a',{staticClass:"btn",staticStyle:{"cursor":"pointer","background":"#f1dee4","padding":"1em","color":"#000"},on:{"click":function($event){_vm.syncset(_vm.sellpoint.business_username)}}},[_vm._v("Manage Account on Sellpoint")])])])])])]),_vm._v(" "),_vm._m(18)])]):_vm._e(),_vm._v(" "),(_vm.managePanel)?_c('section',{staticClass:"account-inner-set-panel",staticStyle:{"background":"#f7fbff","margin-top":"2em"},attrs:{"id":"manage"}},[(_vm.loading)?_c('div',{staticClass:"container"},[_vm._m(19)]):_c('div',{staticClass:"container",staticStyle:{"background":"#ffffff","margin-top":"1em","padding":"1em"}},[_c('h5',[_vm._v("Manage Gallery")]),_vm._v(" "),_c('div',{staticClass:"container banner-menu manage-account-menu"},[_c('div',{staticClass:"row menu-links"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-businesses','')}}},[_vm._v("Business Settings")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-lookbooks','')}}},[_vm._v("Lookbooks Settings")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-products','')}}},[_vm._v("Products")])])])])]),_vm._v(" "),(_vm.manageBusinesses)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row card-row-controls"},[_c('div',[(_vm.manageBusinessDetails)?_c('button',{staticClass:"btn admin-btn",staticStyle:{"float":"right"},on:{"click":function($event){_vm.setComponent('reset-component-details','')}}},[_vm._v("Back")]):_vm._e()])]),_vm._v(" "),(!_vm.manageBusinessDetails)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"row cards-grids"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',0)}}},[_vm._m(20)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',1)}}},[_vm._m(21)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',2)}}},[_vm._m(22)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',3)}}},[_vm._m(23)])])])]):_c('div',{staticClass:"row"},[(_vm.businessComponents[0])?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-12 col-xs-12 col-md-8 offset-md-1 set-panel"},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c('h4',[_vm._v("Edit Business Details")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"gw-form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_name),expression:"sellpoint.business_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Tagline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_tagline),expression:"sellpoint.business_tagline"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_tagline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_tagline", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Brief")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_profile),expression:"sellpoint.business_profile"}],staticClass:"form-control",domProps:{"value":(_vm.sellpoint.business_profile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_profile", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_address),expression:"sellpoint.business_address"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Emails")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_emails),expression:"sellpoint.business_emails"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_emails", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_phones),expression:"sellpoint.business_phones"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_phones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_phones", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticStyle:{"color":"#4617c7"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"float":"left","background":"#f1dee4"},attrs:{"type":"button","disabled":_vm.disable_btn},on:{"click":function($event){_vm.editBusinessDetails('main')}}},[_vm._v("Save Details")]),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"float":"right","background":"#ecb989"},on:{"click":function($event){_vm.reset()}}},[_vm._v("Cancel")])])])])])]):_vm._e(),_vm._v(" "),(_vm.businessComponents[1])?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-12 col-xs-12 col-md-10  set-panel"},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"horizontal-cards"},[_vm._m(24),_vm._v(" "),(_vm.business_details.delivery_edit)?_c('div',{staticClass:"contact_form"},[_c('label',[_vm._v("Your Delivery Information")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_delivery_information),expression:"sellpoint.business_delivery_information"}],staticStyle:{"width":"70%"},domProps:{"value":(_vm.sellpoint.business_delivery_information)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_delivery_information", $event.target.value)}}}),_c('br'),_vm._v(" "),_c('button',{attrs:{"type":"submit"},on:{"click":function($event){_vm.editBusinessDetails('delivery')}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("save")]),_vm._v(" "),_c('button',{attrs:{"type":"btn"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" cancel")])]):_c('div',[(_vm.sellpoint.business_delivery_information)?_c('p',[_vm._v(_vm._s(_vm.sellpoint.business_delivery_information)+"\r\n                            "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('set-business-details','delivery_edit')}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("edit")]),_vm._v(" "),_c('br')]):_c('p',[_vm._v("You have not set any delivery information\r\n                            "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('set-business-details','delivery_edit')}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Set")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"horizontal-cards"},[_c('h6',{staticClass:"margin-t-40"},[_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]),_vm._v(" "),_c('p',[_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#363535"}},[_vm._v("How would your Business Shipping Fee be calculated?")]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_set_shipping_fee_status),expression:"business_set_shipping_fee_status"}],attrs:{"type":"radio","id":"9","value":"9"},domProps:{"checked":_vm._q(_vm.business_set_shipping_fee_status,"9")},on:{"click":function($event){_vm.setShippingFeeStatus()},"change":function($event){_vm.business_set_shipping_fee_status="9"}}}),_vm._v(" "),_c('span',[_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_set_shipping_fee_status),expression:"business_set_shipping_fee_status"}],attrs:{"type":"radio","id":"10","value":"10"},domProps:{"checked":_vm._q(_vm.business_set_shipping_fee_status,"10")},on:{"click":function($event){_vm.setShippingFeeStatus()},"change":function($event){_vm.business_set_shipping_fee_status="10"}}}),_vm._v(" "),_c('span',[_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_set_shipping_fee_status),expression:"business_set_shipping_fee_status"}],attrs:{"type":"radio","id":"11","value":"11"},domProps:{"checked":_vm._q(_vm.business_set_shipping_fee_status,"11")},on:{"click":function($event){_vm.setShippingFeeStatus()},"change":function($event){_vm.business_set_shipping_fee_status="11"}}}),_vm._v(" "),_c('span',[_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('br')]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Delivery Locations and Prices")]),_vm._v(" "),_c('div',[_c('div',[_vm._l((_vm.sellpoint.business_delivery_options),function(delivery_option){return _c('div',[(_vm.business_details.delivery_option_edit && delivery_option.edit_set)?_c('div',{staticClass:"contact_form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.business_delivery_state),expression:"delivery_option.business_delivery_state"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(delivery_option, "business_delivery_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getCities(delivery_option.business_delivery_state,'edit')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select State")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("City: "),_c('b',[_vm._v(_vm._s(delivery_option.business_delivery_option))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.city),expression:"delivery_option.city"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(delivery_option, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.setOtherOptions(delivery_option.city,'edit')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select City")]),_vm._v(" "),_c('option',{attrs:{"value":"all"}},[_vm._v("All Areas @Fixed Price")]),_vm._v(" "),_vm._l((_vm.cities),function(city){return _c('option',{domProps:{"value":city.city_id}},[_vm._v(_vm._s(city.city_name))])}),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v("Other Areas / Cities ")])],2)]),_vm._v(" "),(_vm.edit_other_delivery_option)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Other Areas / Cities")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.business_delivery_other_option),expression:"delivery_option.business_delivery_other_option"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Abuja"},domProps:{"value":(delivery_option.business_delivery_other_option)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(delivery_option, "business_delivery_other_option", $event.target.value)}}}),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Delivery Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.business_delivery_option_price),expression:"delivery_option.business_delivery_option_price"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(delivery_option.business_delivery_option_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(delivery_option, "business_delivery_option_price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"disabled":_vm.disable_btn,"title":"save","type":"submit"},on:{"click":_vm.editDeliveryOption}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"title":"cancel","type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_c('div',[(delivery_option.business_delivery_product == 0)?_c('p',[_vm._v("\r\n                                    "+_vm._s(delivery_option.business_delivery_option)+" - "+_vm._s(delivery_option.business_delivery_option_price)+" \r\n                                    "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('edit-delivery-option',delivery_option)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":function($event){_vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)}}},[_c('i',{staticClass:"fa fa-trash"})])]):_vm._e()])])}),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"submit"},on:{"click":function($event){_vm.setComponent('set-business-details','delivery_add')}}},[_vm._v("Add New Delivery Information")]),_vm._v(" "),_c('hr')],2),_vm._v(" "),(_vm.business_details.delivery_add)?_c('div',{staticClass:"contact_form col-md-12",staticStyle:{"padding-left":"0"}},[_c('h5',[_vm._v("Add a Delivery Location and Price")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.state),expression:"delivery_option.state"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.delivery_option, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getCities(_vm.delivery_option.state,'')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select State")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])})],2)]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),(_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city)?_c('div',[_c('label',[_vm._v("City")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.city),expression:"delivery_option.city"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.delivery_option, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.setOtherOptions(_vm.delivery_option.city,'')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select City")]),_vm._v(" "),_c('option',{attrs:{"value":"all"}},[_vm._v("All Areas @Fixed Price")]),_vm._v(" "),_vm._l((_vm.cities),function(city){return _c('option',{domProps:{"value":city.city_id}},[_vm._v(_vm._s(city.city_name))])}),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v("Other Areas / Cities ")])],2)]):_vm._e(),_vm._v(" "),(_vm.other_delivery_option)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Other Areas / Cities")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.delivery_other_option),expression:"delivery_option.delivery_other_option"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Abuja"},domProps:{"value":(_vm.delivery_option.delivery_other_option)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.delivery_option, "delivery_other_option", $event.target.value)}}}),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Delivery Charge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.delivery_option_price),expression:"delivery_option.delivery_option_price"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"eg. 1000"},domProps:{"value":(_vm.delivery_option.delivery_option_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.delivery_option, "delivery_option_price", $event.target.value)}}}),_c('br')]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","font-size":"12px"},attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.addDeliveryOption}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e()]),_vm._v(" "),_c('div')])])])])]):_vm._e(),_vm._v(" "),(_vm.businessComponents[2])?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-12 col-xs-12 col-md-10  set-panel"},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c('div',{},[_c('div',{staticClass:"horizontal-cards"},[_c('h6',{staticClass:"margin-t-40"},[_vm._v("Set My Sellpoint's Discounts and Coupons")]),_vm._v(" "),_c('p',[_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                          You can set individual Product Discounts on thier product pages.\r\n                      ")]),_vm._v(" "),_c('span',[(_vm.business_details.setDiscount)?_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('view-discounts','')}}},[_vm._v("View your Discounts")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('set-business-details','setDiscount')}}},[_vm._v("Set New Discount Or Coupon")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.business_details.setDiscount)?_c('div',[_c('div',{staticClass:"contact-form col-md-6",staticStyle:{"padding-left":"0"}},[(_vm.sellpoint.business_discounts_active == 1)?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have an ongoing active Discount")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Set Coupon Or Discount")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.is_discount_coupon),expression:"discount_coupon.is_discount_coupon"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "is_discount_coupon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"D"}},[_vm._v("Discount")]),_vm._v(" "),_c('option',{attrs:{"value":"C"}},[_vm._v("Coupon")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label'),_vm._v(" "),(_vm.sellpoint.business_discounts_active != 1)?_c('label',[_vm._v("Select Discount Category")]):_c('label',[_vm._v("Select Coupon Discount Category")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_category),expression:"discount_coupon.discount_category"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "discount_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select Category")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("All Categories")]),_vm._v(" "),_vm._l((_vm.sellpoint.business_categories),function(cat){return _c('option',{domProps:{"value":cat.business_category_id}},[_vm._v(_vm._s(cat.business_category))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.setDiscountsAndCoupons()}}},[_vm._v("SET")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]),_vm._v(" "),_vm._m(25)]):_vm._e(),_vm._v(" "),(_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount))?_c('div',[_c('h5',{staticStyle:{"font-size":"13px"}},[_vm._v("Edit Discount")]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_category),expression:"discount_coupon.discount_category"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "discount_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select Another Category")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("All Categories")]),_vm._v(" "),_vm._l((_vm.sellpoint.business_categories),function(cat){return _c('option',{domProps:{"value":cat.business_category_id}},[_vm._v(_vm._s(cat.business_category))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date: "+_vm._s(_vm.discount_coupon.discount_start_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date: "+_vm._s(_vm.discount_coupon.discount_end_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.editDiscountsAndCoupons()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])])]):_vm._e(),_vm._v(" "),((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons)?_c('div',[_c('h5',{staticStyle:{"font-size":"13px"}},[_vm._v("View Discounts")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.sellpoint.business_discounts_coupons),function(dc,index){return _c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticStyle:{"border":"#f1dee4 solid 1px","padding":"1em"}},[_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('p',[_c('b',[_vm._v("Type: ")]),_vm._v(_vm._s(dc.discount_type_name))]):_c('p',[_c('b',[_vm._v("Type: ")]),_vm._v(_vm._s(dc.discount_category_name))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),((dc.discount_type == 2) || (dc.discount_type == 3))?_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setComponent('edit-discount-coupon',dc)}}},[_vm._v("\r\n                                    Edit Coupon")]),_vm._v("    \r\n                                "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.deactivateDiscountsAndCoupons(dc)}}},[_vm._v("\r\n                                    Deactivate Coupon")])]):_vm._e()]):_vm._e(),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Edit/Deactivate at Product Settings")]):_vm._e()])])}))]):_vm._e()])])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.manageProducts)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"float":"left"}},[_c('h6',{staticStyle:{"margin-left":"1em","margin-right":"2em"}},[_vm._v("Products ("+_vm._s(_vm.sellpoint.business_total_products)+")")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.component_view.viewProducts)?_c('div',{staticClass:"row"},_vm._l((_vm.products),function(product,gndex){return _c('div',{staticClass:"col-md-2 col-sm-3 col-xs-3"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('products',product,'')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(product.product_images.length > 0)?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(product.product_images[0].product_image))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":product.product_images[0].product_image}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(product.product_name))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])})):_vm._e(),_vm._v(" "),(_vm.component_view.viewProduct)?_c('div',{staticClass:"row col-md-12",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"container"},[(_vm.is_viewing_lookbook)?_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('switch-to-viewing-loobook','','')}}},[_vm._v("<< Back to Lookbook")])]):_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('products','','')}}},[_vm._v("<< Back ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-5 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('h4',[_vm._v(_vm._s(_vm.product.product_name))]),_vm._v(" "),_c('p',[_vm._v("Category: "+_vm._s(_vm.product.product_category_name))]),_vm._v(" "),(_vm.product.product_set_items == 0)?_c('div',[(_vm.product.product_items[0].product_item_actual_price != 0)?_c('div',[_c('p',[_vm._v("Price: ₦"+_vm._s(_vm.product.product_items[0].product_item_actual_price))]),_vm._v(" "),_c('p',[_vm._v("Discounted Price: ₦"+_vm._s(_vm.product.product_items[0].product_item_price))])]):_c('div',[_c('p',[_vm._v("Price: ₦"+_vm._s(_vm.product.product_items[0].product_item_price))])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('p',[_vm._v("Weight: "+_vm._s(_vm.product.product_items[0].product_item_weight)+"(kg)")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Quantity: "+_vm._s(_vm.product.product_items[0].product_item_quantity))])]):_vm._e(),_vm._v(" "),(_vm.product_details.editProductSingleProductItem)?_c('div',{staticClass:"row col-md-12"},[_c('h6',{staticStyle:{"font-size":"14px","text-decoration":"underline"}},[_vm._v("Reset Product Details")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4 col-xs-4"},[_c('label',[_vm._v(" Price\r\n                          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_items[0].product_item_price),expression:"product.product_items[0].product_item_price"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.product.product_items[0].product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.product_items[0], "product_item_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group col-md-4 col-xs-4"},[_c('label',[_vm._v(" Weight\r\n                          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_items[0].product_item_weight),expression:"product.product_items[0].product_item_weight"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.product.product_items[0].product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.product_items[0], "product_item_weight", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 col-xs-4"},[_c('label',[_vm._v(" Quantity\r\n                          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_items[0].product_item_quantity),expression:"product.product_items[0].product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.product.product_items[0].product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.product_items[0], "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-2",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editProductSingleProductItem}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-2",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_c('button',{staticClass:"btn btn-xs admin-btn-tiny",staticStyle:{"line-height":"0.8","margin-bottom":"5px"},on:{"click":function($event){_vm.setProductComponent('editProductSingleProductItem','')}}},[_vm._v("Edit Price/Weight/Quantity")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.product_description))]),_vm._v(" "),(_vm.product_details.editProduct)?_c('div',{staticClass:"row col-md-12"},[_c('h6',[_vm._v("Edit Product")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" *Product Name\r\n                                      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_name),expression:"product.product_name"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":""},domProps:{"value":(_vm.product.product_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_vm._v("Category:- "+_vm._s(_vm.product.product_category_name)+" ")]),_vm._v(" "),(_vm.sellpoint_categories.length > 0)?_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v(" Select from My Shop Categories\r\n                                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_category),expression:"product.product_category"}],staticClass:"form-control",attrs:{"id":"category-type-1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "product_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.trackevent('category-type-1')}]}},[_c('option',{attrs:{"value":"0","disabled":_vm.category_type_1}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.sellpoint_categories),function(category){return _c('option',{key:category.business_category_id,attrs:{"disabled":_vm.category_type_1},domProps:{"value":category.business_category_id}},[_vm._v(_vm._s(category.business_category))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[(_vm.sellpoint_categories.length > 0)?_c('span',[_c('b',[_vm._v("Or ")])]):_vm._e(),_vm._v(" Select from Related Categories\r\n                                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.main_category),expression:"main_category"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.main_category=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getSubCategories(_vm.main_category)}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('option',{key:category.category_id,domProps:{"value":category}},[_vm._v(_vm._s(category.category_name))])})],2)]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.sub_categories.length != 0)?_c('label',[_vm._v(" Select a Category\r\n                                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_sub_category),expression:"product.product_sub_category"}],staticClass:"form-control category-type-2",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "product_sub_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.trackevent('category-type-2')}]}},[_c('option',{attrs:{"value":"0","disabled":_vm.category_type_2}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.sub_categories),function(category){return _c('option',{key:category.sub_category_id,attrs:{"disabled":_vm.category_type_2},domProps:{"value":category.sub_category_id}},[_vm._v(_vm._s(category.sub_category_name))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('label',[_c('b',[_vm._v("Or ")]),_vm._v(" Enter a specific Category\r\n                                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_listed_category),expression:"product.product_listed_category"}],staticClass:"form-control",attrs:{"disabled":_vm.category_type_3,"type":"text","placeholder":"","id":"category-type-3"},domProps:{"value":(_vm.product.product_listed_category)},on:{"change":function($event){_vm.trackevent('category-type-3')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_listed_category", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v(" *Product Description\r\n                                  "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_description),expression:"product.product_description"}],staticClass:"form-control txtarea",domProps:{"value":(_vm.product.product_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editProduct}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_c('button',{staticClass:"btn btn-xs admin-btn",staticStyle:{"line-height":"0.8","margin-bottom":"5px"},on:{"click":function($event){_vm.setProductComponent('editProduct','')}}},[_vm._v("Edit Product Details")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("Product Images")]),_vm._v(" "),_c('div',{staticClass:"img-row",staticStyle:{"margin-bottom":"5px"}},[_vm._l((_vm.product.product_images),function(pt){return _c('div',{staticClass:"img-column"},[_c('a',{staticStyle:{"cursor":"pointer","float":"left"},on:{"click":function($event){_vm.setComponent('set-product-item',pt)}}},[_c('img',{staticClass:"sp-prd-img",staticStyle:{"height":"50px","width":"80px"},attrs:{"src":_vm.img_product_url + pt.product_image,"alt":""}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn pull-right",staticStyle:{"margin-top":"-3em","font-size":"10px","padding":"6px","float":"right"},attrs:{"type":"button"},on:{"click":function($event){_vm.deleteProductImage(pt.product_image_id)}}},[_c('i',{staticClass:"fa fa-trash"})])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[(_vm.action_loading && _vm.product_details.uploading_image)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.6","font-size":"12px"}},[_vm._v("Add new Photo")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*"},on:{"change":function($event){_vm.onFileChange($event,'products',_vm.product.product_id)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"0"}},[(!_vm.product_details.removeProduct)?_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"2em","float":"right"},on:{"click":function($event){_vm.setProductComponent('removeProduct','')}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Delete this Product")]):_vm._e(),_vm._v(" "),(_vm.product_details.removeProduct)?_c('span',{},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to remove this Product?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.removeProduct}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 col-xs-12",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"product-detail-card"},[_c('h6',[_vm._v("Product Items and Variations")]),_vm._v(" "),(_vm.product_details.setProductSettings)?_c('div',[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticStyle:{"display":"inline"}},[_c('b',[_vm._v("Group Name: ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_groups_set_name),expression:"product.product_groups_set_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product.product_groups_set_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_groups_set_name", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_set_items > 0)?_c('div',{staticClass:"form-group col-md-6"},[_c('b',[_vm._v("Group Items Name: ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_groups_items_set_name),expression:"product.product_groups_items_set_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product.product_groups_items_set_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_groups_items_set_name", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":_vm.editProductSettings}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('h5',{staticStyle:{"font-size":"10px","text-transform":"capitalize"}},[_c('b',[_vm._v("Name of Group: ")]),_vm._v(_vm._s(_vm.product.product_groups_set_name)+"\r\n                    "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('setProductSettings','','')}}},[_vm._v(" Change")])]),_vm._v(" "),(((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0)))?_c('div',_vm._l((_vm.product.product_item_groups),function(pg){return _c('div',{staticClass:"row col-xs-12",staticStyle:{"border-bottom":"1px solid #e9e6e6","margin-bottom":"1em"}},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id))?_c('div',{staticClass:"col-sm-12",attrs:{"id":"editProductItemGroup"}},[_c('h6',[_vm._v("Edit Product Item Group")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Name\r\n                                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item_group.product_item_group_name),expression:"product_item_group.product_item_group_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product_item_group.product_item_group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item_group, "product_item_group_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"box-cube col-xs-2"},[(_vm.product_item_group.product_item_group_is_color_image == 'IMG')?_c('div',{},[((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":_vm.product_item_group.product_item_group_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(_vm.product_item_group.product_item_group_is_color_image == 'COL')?_c('div',[_c('div',{staticClass:"box-color-cube",style:({background: pg.product_item_group_color})})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v(" Pick Colour\r\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item_group.product_item_group_color_new),expression:"product_item_group.product_item_group_color_new"}],staticClass:"form-control",staticStyle:{"width":"4em"},attrs:{"type":"color"},domProps:{"value":(_vm.product_item_group.product_item_group_color_new)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item_group, "product_item_group_color_new", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Or Pick Image")]),_vm._v(" "),_c('div',{staticClass:"row img-row"},_vm._l((_vm.product.product_images),function(img,index){return _c('div',{key:index,staticClass:"col-xs-1",staticStyle:{"height":"40px","width":"100px","margin-bottom":"5px"},attrs:{"id":"groupImage"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-product-item-group-image',img.product_image_id)}}},[_c('img',{staticClass:"product-item-group-image sp-prd-img",attrs:{"id":img.product_image_id+'PRTG',"src":img.product_image,"alt":""}})])])})),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"},attrs:{"id":"uploadDiv"}},[_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.6"}},[_vm._v("Or Add new Image")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*"},on:{"change":function($event){_vm.onFileChange($event,'products',_vm.product.product_id)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.editProductItemGroup}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id))?_c('span',{staticClass:"pull-left col-sm-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to remove this Item Group?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.removeProductItemGroup()}}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('div',{staticStyle:{"padding":"1em"}},[_c('h4',{staticStyle:{"font-weight":"bold","text-transform":"capitalize","font-size":"12px"}},[_vm._v(_vm._s(pg.product_item_group_name))]),_vm._v(" "),_c('div',{staticClass:"box-cube"},[(pg.product_item_group_is_color_image == 'IMG')?_c('div',{staticStyle:{"height":"40px"}},[((pg.product_item_group_image && (pg.product_item_group_image != 'error')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":pg.product_item_group_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(pg.product_item_group_is_color_image == 'COL')?_c('div',[_c('div',{staticClass:"box-color-cube",style:({background: pg.product_item_group_color})})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('editProductItemGroup','productitemgroup',pg)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Edit")]),_vm._v(" "),(_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1)?_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('removeItemGroup','productitemgroup',pg)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Delete")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('div',{staticStyle:{"padding":"1em"}},[_c('h5',{staticStyle:{"font-size":"10px","text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.product.product_groups_items_set_name)+"\r\n                            "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('setProductSettings','','')}}},[_vm._v(" Change")])]),_vm._v(" "),_vm._l((pg.product_items),function(pt){return _c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[_c('div',[(_vm.product.product_service == 'P'  && (pt.product_item_size))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(pt.product_item_size))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'S' && (pt.product_item_service_tag))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(pt.product_item_service_tag))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('li',[_c('span',[_vm._v("w(kg):")]),_vm._v(_vm._s(pt.product_item_weight))]):_vm._e(),_vm._v(" "),(pt.product_item_actual_price != 0)?_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(pt.product_item_actual_price))]):_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(pt.product_item_price))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Qty:")]),_vm._v(_vm._s(pt.product_item_quantity))]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('editProductItem','productitem',pt)}}},[_c('i',{staticClass:"fa fa-pencil"})])]),_vm._v(" "),(_vm.product.product_items.length > 1)?_c('li',[_c('a',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('removeProductItem','productitem',pt)}}},[_c('i',{staticClass:"fa fa-trash"})])]):_vm._e()]),_vm._v(" "),(_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id))?_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"1em"},attrs:{"id":"editProductItem"}},[_c('h6',[_vm._v("Edit Product Item")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *"),(_vm.product.product_service == 'P')?_c('span',[_vm._v("Product Item Size")]):_vm._e(),(_vm.product.product_service == 'S')?_c('span',[_vm._v("Product Item tYPE")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_size),expression:"product_item.product_item_size"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":""},domProps:{"value":(_vm.product_item.product_item_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_size", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'S')?_c('div',{staticClass:"form-group",attrs:{"cla":""}},[_c('label',[_vm._v(" *Service Tag\r\n                                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_service_tag),expression:"product_item.product_item_service_tag"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product_item.product_item_service_tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_service_tag", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Product Item Price\r\n                                          "),(_vm.product_item.product_item_actual_price != 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_actual_price),expression:"product_item.product_item_actual_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product_item.product_item_actual_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_actual_price", $event.target.value)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_price),expression:"product_item.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product_item.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Product Item Weight\r\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_weight),expression:"product_item.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product_item.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_weight", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Product Item Quantity\r\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_quantity),expression:"product_item.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product_item.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.editProductItem}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])]),_vm._v(" "),_c('br')])])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id))?_c('span',{staticClass:"pull-left col-sm-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to remove this Item?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.removeProductItem()}}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('addProductItemToGroup','productitemgroup',pg)}}},[_vm._v(" Add New Item")])],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id))?_c('div',{staticClass:"row col-md-12"},[(_vm.product.product_service == 'S')?_c('div',{staticClass:"col-md-4 col-xs-3"},[_c('label',[_vm._v(" Service Tag\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_service_tag),expression:"product.product_item_service_tag"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_service_tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_service_tag", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Price\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_price),expression:"product.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Weight(KG)\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_weight),expression:"product.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_weight", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Quantity\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_quantity),expression:"product.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_size),expression:"product.product_item_size"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_size", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"data-error-message"},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),_c('p',{staticClass:"data-success-message"},[_vm._v(_vm._s(_vm.data_success_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"background":"#e7e8e9"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.addProductItem}},[_vm._v("Add Item")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e()])})):_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have not set any product item variation")])]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]),_vm._v(" "),(_vm.product.product_set_groups == 0)?_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.product.product_groups_set_name))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('setProductSettings','','')}}},[_vm._v(" Change this Name")])])]):_vm._e(),_vm._v(" "),(!_vm.product_details.addProductItemPanel)?_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setProductComponent('addProductItemPanel','','')}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Product Variation")]):_c('div',[(_vm.product_details.addProductItemPanel)?_c('div',{staticClass:"col-sm-12"},[_c('h6',[_vm._v("Add New Variation "),(_vm.product.product_groups_set_name)?_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("(Set "+_vm._s(_vm.product.product_groups_set_name)+")")]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"gw-form",staticStyle:{"margin-top":"1em","width":"100%"}},[_c('div',{staticClass:"row"},[(_vm.product.product_set_groups > 0)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"line-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showProductItemGroups),expression:"showProductItemGroups"}],staticStyle:{"height":"1em"},attrs:{"type":"radio","value":"showtrue"},domProps:{"checked":_vm._q(_vm.showProductItemGroups,"showtrue")},on:{"change":function($event){_vm.showProductItemGroups="showtrue"}}}),_vm._v(" "),_vm._v("\r\n                                               Add new Items to "),_c('span',[_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"line-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showProductItemGroups),expression:"showProductItemGroups"}],staticStyle:{"height":"1em"},attrs:{"type":"radio","value":"showfalse"},domProps:{"checked":_vm._q(_vm.showProductItemGroups,"showfalse")},on:{"change":function($event){_vm.showProductItemGroups="showfalse"}}}),_vm._v("\r\n                                                   Or Add new "+_vm._s(_vm.product.product_groups_set_name)+"\r\n                                           ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.showProductItemGroups == 'showtrue')?_c('div',[((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0))?_c('div',{staticClass:"row col-md-12",staticStyle:{"width":"100%"}},[_vm._l((_vm.product.product_item_groups),function(pg,pgdex){return _c('div',{key:pgdex,staticClass:"col-xs-2"},[_c('div',{staticStyle:{"padding":"5px","margin-bottom":"5px","width":"10%"}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":pg.product_item_group_name},on:{"click":function($event){_vm.setInnerComponent('set-product-item-group',pg.product_item_group_id)}}},[(pg.product_item_group_is_color_image == 'IMG')?_c('div',[_c('div',{staticClass:"box-color-cube"},[_c('img',{staticClass:"product-item-group sp-prd-img",attrs:{"src":pg.product_item_group_image,"id":pg.product_item_group_id+'PRTGR'}})])]):_vm._e(),_vm._v(" "),(pg.product_item_group_is_color_image == 'COL')?_c('div',[_c('div',{staticClass:"product-item-group",attrs:{"id":pg.product_item_group_id+'PRTGR'}},[_c('div',{staticClass:"box-color-cube",staticStyle:{"height":"3em","width":"85%"},style:({background: pg.product_item_group_color})})])]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold","font-size":"12px","line-height":"1.2"}},[_vm._v("Add to "+_vm._s(pg.product_item_group_name)+" ")])])])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showProductItemGroups == 'showfalse')?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name of new "+_vm._s(_vm.product.product_groups_set_name)+"\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_group_name),expression:"product.product_item_group_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product.product_item_group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_group_name", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{},[_c('label',[_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v(" Pick Colour\r\n                                                       "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_group_color),expression:"product.product_item_group_color"}],staticClass:"form-control",staticStyle:{"width":"4em"},attrs:{"type":"color"},domProps:{"value":(_vm.product.product_item_group_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_group_color", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"border":"1px dashed #eeccee","padding":"1em"}},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v(" Or Pick Media")]),_vm._v(" "),_c('div',{staticClass:"row img-row"},_vm._l((_vm.product.product_images),function(img,index){return _c('div',{key:index,staticClass:"col-xs-1",staticStyle:{"height":"50px","width":"70px"},attrs:{"id":"groupImage"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setInnerComponent('set-product-item-group-image',img.product_image_id)}}},[_c('img',{staticClass:"product-item-group-image sp-prd-img",attrs:{"id":img.product_image_id+'PRTG',"src":img.product_image,"alt":""}})])])})),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"z-index":"9"}},[_c('p',{staticClass:"p-tiny-info"},[_vm._v(_vm._s(_vm.max_media_info))]),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.4","font-size":"14px"}},[_vm._v("Or Add new Image or Video ")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"video/*,image/*","capture":""},on:{"change":function($event){_vm.onFileChangeProductItems($event,'products',_vm.product.product_id)}}})]),_vm._v(" "),_c('p',{staticClass:"data-error-message"},[_vm._v(_vm._s(_vm.data_media_error_message))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('br')]),_vm._v(" "),((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse'))?_c('div',{staticClass:"row col-md-12"},[(_vm.product.product_service == 'S')?_c('div',{staticClass:"col-md-4 col-xs-3"},[_c('label',[_vm._v(" Service Tag\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_service_tag),expression:"product.product_item_service_tag"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_service_tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_service_tag", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Price\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_price),expression:"product.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Weight(KG)\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_weight),expression:"product.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_weight", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Quantity\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_quantity),expression:"product.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_size),expression:"product.product_item_size"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_size", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"data-error-message"},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),_c('p',{staticClass:"data-success-message"},[_vm._v(_vm._s(_vm.data_success_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"background":"#e7e8e9"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.addProductItem}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('h6',[_vm._v("DISCOUNTS AND COUPONS")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount)?_c('div',[_c('div',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"form-group"},[(_vm.product_details.setProductDiscount)?_c('label',[_vm._v("Set Product Coupon Or Discount")]):_vm._e(),_vm._v(" "),(_vm.product_details.setProductItemDiscount)?_c('label',[_vm._v("Set Product Item Coupon Or Discount")]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.is_discount_coupon),expression:"discount_coupon.is_discount_coupon"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "is_discount_coupon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"D"}},[_vm._v("Discount")]),_vm._v(" "),_c('option',{attrs:{"value":"C"}},[_vm._v("Coupon")])])]),_vm._v(" "),(((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1)))?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have an active Discount")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.setDiscountsAndCoupons()}}},[_vm._v("SET")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]),_vm._v(" "),_vm._m(26)]):_vm._e(),_vm._v(" "),(_vm.product_details.editDiscount)?_c('div',{staticClass:"col-md-12"},[_c('h5',{staticStyle:{"font-size":"13px"}},[_vm._v("Edit Discount")]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date: "+_vm._s(_vm.discount_coupon.discount_start_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date: "+_vm._s(_vm.discount_coupon.discount_end_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"2em"},attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.editDiscountsAndCoupons()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])])]):_vm._e(),_vm._v(" "),(!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount)?_c('div',[_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('viewProductDiscounts','','')}}},[_vm._v("View Product Discounts and Coupons")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('viewProductItemsDiscounts','','')}}},[_vm._v("View Product Items Discounts and Coupons")])]):_vm._e(),_vm._v(" "),(_vm.product_details.viewCoupons)?_c('div',{staticStyle:{"margin-top":"2em","border":"#e9e6e6 dashed 1px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('h6',{staticClass:"pull-left",staticStyle:{"text-transform":"uppercase","font-size":"14px"}},[_vm._v("Item Coupons and Discounts")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny pull-right",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[(_vm.product_item.product_item_group_is_color_image == 'IMG')?_c('li',[((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image  != 'error')))?_c('img',{staticStyle:{"height":"30px"},attrs:{"src":_vm.product_item.product_item_group_image}}):_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(_vm.product_item.product_item_group_is_color_image == 'COL')?_c('li',[_c('a',{staticClass:"btn box-color-cube",style:({background: _vm.product_item.product_item_group_color})})]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P'  && (_vm.product_item.product_item_size))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(_vm.product_item.product_item_size))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('li',[_c('span',[_vm._v("w(kg):")]),_vm._v(_vm._s(_vm.product_item.product_item_weight))]):_vm._e(),_vm._v(" "),_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(_vm.product_item.product_item_actual_price))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Qty:")]),_vm._v(_vm._s(_vm.product_item.product_item_quantity))]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr')]),_vm._v(" "),_vm._l((_vm.product_item.product_item_discounts),function(dc){return _c('div',[(dc.discount_type == 5)?_c('div',[_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setProductComponent('editDiscount','',dc)}}},[_vm._v("\r\n                                  Edit Discount")]),_vm._v("    \r\n                                "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.setProductComponent('deactivateDiscount',_vm.product_item,dc)}}},[_vm._v("\r\n                                  Deactivate Discount")])]):_vm._e(),(_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id))?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p')]),_vm._v(" "),_c('hr')]):_vm._e()])}),_vm._v(" "),_c('div',[(_vm.product_item.product_item_only_coupon_discount_count == 0)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("No set discount or coupon")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setProductComponent('setProductItemDiscount','productitem',_vm.product_item)}}},[_vm._v("Set New Item Discount Or Coupon")])])],2):_vm._e(),_vm._v(" "),(_vm.product_details.viewProductItemsDiscounts)?_c('div',{staticStyle:{"margin-top":"1em","border":"#0d022b dashed 1px"}},[_c('div',{staticStyle:{"margin":"1em"}},[_c('h6',{staticClass:"pull-left",staticStyle:{"text-transform":"uppercase","font-size":"14px"}},[_vm._v("Items in this Product")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny pull-right",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_vm._l((_vm.product.product_items),function(productItem){return _c('div',{staticStyle:{"border":"dashed #d1ddf1","padding":"5px","margin-bottom":"1em"}},[_c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[(productItem.product_item_group_is_color_image == 'IMG')?_c('li',[((productItem.product_item_group_image && (productItem.product_item_group_image  != 'error')))?_c('img',{staticStyle:{"height":"30px"},attrs:{"src":productItem.product_item_group_image}}):_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(productItem.product_item_group_is_color_image == 'COL')?_c('li',[_c('a',{staticClass:"btn box-color-cube",style:({background: productItem.product_item_group_color})})]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P'  && (productItem.product_item_size))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(productItem.product_item_size))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'S' && (productItem.product_item_service_tag))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(productItem.product_item_service_tag))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('li',[_c('span',[_vm._v("w(kg):")]),_vm._v(_vm._s(productItem.product_item_weight))]):_vm._e(),_vm._v(" "),_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(productItem.product_item_actual_price))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Qty:")]),_vm._v(_vm._s(productItem.product_item_quantity))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id))?_c('div',{staticStyle:{"display":"none"}},[_c('div',[_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setProductComponent('setProductItemDiscount','productitem',productItem)}}},[_vm._v("Set New Item Discount Or Coupon")])]),_vm._v(" "),_vm._l((productItem.product_item_discounts),function(dc){return _c('div',[_c('div',[((dc.discount_type == 5))?_c('p',[_c('b',[_vm._v("Product Item Discount")])]):_vm._e(),_vm._v(" "),((dc.discount_type == 4))?_c('p',[_c('b',[_vm._v("General Product Discount")])]):_vm._e(),_vm._v(" "),(!(dc.discount_type == 4) && !(dc.discount_type == 5))?_c('p',[_c('b',[_vm._v("General Sellpoint Discount")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setProductComponent('editDiscount','',dc)}}},[_vm._v("\r\n                                    Edit Discount")]),_vm._v("    \r\n                                  "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.setProductComponent('deactivateDiscount',productItem,dc)}}},[_vm._v("\r\n                                    Deactivate Discount")])]):_vm._e(),(_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id))?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p')]):_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Edit/Deactivate at Business Settings")]),_vm._v(" "),_c('hr')])])}),_vm._v(" "),_c('div',[(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("No set discount or coupon")]):_vm._e()])],2):_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('viewCoupons','productitem',productItem)}}},[_vm._v("View Coupons and Discounts")])])})],2):_vm._e(),_vm._v(" "),(_vm.product_details.viewProductDiscounts)?_c('div',{staticStyle:{"margin-top":"2em"}},[(_vm.product.product_items[0])?_c('div',[_c('div',{staticStyle:{"margin":"5px"}},[_c('h6',{staticClass:"pull-left",staticStyle:{"text-transform":"uppercase","font-size":"14px"}},[_vm._v("Product Coupons and Discounts")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny pull-right",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_vm._l((_vm.product.product_items[0].product_item_discounts),function(dc){return _c('div',[((dc.discount_type == 4))?_c('div',[_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setProductComponent('editDiscount','',dc)}}},[_vm._v("\r\n                                    Edit Discount")]),_vm._v("    \r\n                                  "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.setProductComponent('deactivateDiscount',_vm.product.product_items[0],dc)}}},[_vm._v("\r\n                                    Deactivate Discount")])]):_vm._e(),(_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id))?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p')]):_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Edit/Deactivate at Business Settings")]),_vm._v(" "),_c('hr')]):_vm._e()])}),_vm._v(" "),(_vm.product.product_only_coupon_discount_count == 0)?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("No set discount or coupon")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('setProductDiscount','','')}}},[_vm._v("Set New Product Discount Or Coupon")])]):_vm._e()]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('div',[_c('h6',[_vm._v("DELIVERY & RETURNS INFORMATION")]),_vm._v(" "),(_vm.product_details.edit_product_delivery)?_c('div',{},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_delivery_returns),expression:"product.product_delivery_returns"}],domProps:{"value":(_vm.product.product_delivery_returns)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_delivery_returns", $event.target.value)}}}),_c('br'),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.disable_btn,"type":"submit"},on:{"click":function($event){_vm.setProductDelivery()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("submit")]),_vm._v(" "),_c('button',{attrs:{"type":"btn"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" cancel")])])]):_c('div',[_c('p',{staticStyle:{"color":"#ff0000","line-height":"1.2","font-size":"13px"}},[_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                      "),(_vm.product.product_delivery_returns)?_c('span',[_vm._v(_vm._s(_vm.product.product_delivery_returns))]):_vm._e(),_c('br'),_vm._v(" "),_c('button',{staticStyle:{"font-size":"13px"},attrs:{"type":"btn admin-btn","title":"Edit"},on:{"click":function($event){_vm.setProductComponent('edit_product_delivery','','')}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Set Delivery & Return Information")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{},[_c('h6',{staticClass:"margin-t-40"},[_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_set_shipping_fee_status),expression:"product_set_shipping_fee_status"}],attrs:{"type":"radio","id":"12","value":"12"},domProps:{"checked":_vm._q(_vm.product_set_shipping_fee_status,"12")},on:{"click":function($event){_vm.setProductShippingFeeStatus()},"change":function($event){_vm.product_set_shipping_fee_status="12"}}}),_vm._v(" "),_c('span',[_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_set_shipping_fee_status),expression:"product_set_shipping_fee_status"}],attrs:{"type":"radio","id":"13","value":"13"},domProps:{"checked":_vm._q(_vm.product_set_shipping_fee_status,"13")},on:{"click":function($event){_vm.setProductShippingFeeStatus()},"change":function($event){_vm.product_set_shipping_fee_status="13"}}}),_vm._v(" "),_c('span',[_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]),_vm._v(" "),(_vm.set_shipping_fee_status_track && _vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('br'),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('h6',[_vm._v("Product Delivery Location Fees")]),_vm._v(" "),((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0))?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have set some general delivery settings")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("You can set a different delivery fee for this product")]),_vm._v(" "),_vm._l((_vm.product.product_business_delivery_options),function(delivery){return _c('li',[_c('b',[_vm._v(_vm._s(delivery.business_delivery_option))]),_vm._v(" "),(delivery.business_products_delivery_fees.length > 0)?_c('span',_vm._l((delivery.business_products_delivery_fees),function(fee,fdex){return _c('span',[((fee.product_delivery_product == _vm.product.product_id))?_c('span',[_vm._v(" -  ₦"+_vm._s(fee.product_delivery_fee)+"\r\n                            ")]):_vm._e()])})):_c('span'),_vm._v(" "),(_vm.product_details.setProductDeliveryInformation && delivery.edit_set)?_c('div',{staticClass:"contact_form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Delivery Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(delivery.product_delivery_fee),expression:"delivery.product_delivery_fee"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(delivery.product_delivery_fee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(delivery, "product_delivery_fee", $event.target.value)}}}),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Business Set Shipping Fee: ₦"+_vm._s(delivery.business_delivery_option_price))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.product_details.setProductDeliveryInformation && _vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"disabled":_vm.disable_btn,"title":"save","type":"submit"},on:{"click":_vm.setProductDeliveryOption}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"title":"cancel","type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e(),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"10px"},attrs:{"type":"btn","title":"Set Product Delivery Fee"},on:{"click":function($event){_vm.setProductComponent('setProductDeliveryInformation',delivery)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Set Fee")])])})],2):_c('div',[_c('p',[_vm._v("You have not set your Business Delivery Locations")])])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.manageLookbooks)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"float":"left"}},[_c('h6',{staticStyle:{"margin-left":"1em","margin-right":"2em"}},[_vm._v("Lookbooks ("+_vm._s(_vm.sellpoint.business_total_gallery)+")")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.component_view.viewLookbooks)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{directives:[{name:"drag-and-drop",rawName:"v-drag-and-drop:options",value:(_vm.drag_options),expression:"drag_options",arg:"options"}]},[_c('ul',{staticClass:"row"},_vm._l((_vm.galleria),function(gallery,gndex){return _c('li',{key:gallery.gallery_posts_group_id,staticClass:"col-md-2 col-sm-3 col-xs-3"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',gallery,'viewLookbook')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(gallery.gallery_posts_group_posts_media.length > 0)?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":gallery.gallery_posts_group_posts_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_posts.length)+" posts")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])}))]),_vm._v(" "),(_vm.galleria.length == 0)?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(27)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),(_vm.component_view.viewLookbook)?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('lookbooks','','viewLookbooks')}}},[_vm._v("<< Back ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row col-md-12",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-5 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))]),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 1)?_c('p',[_vm._v("Type: Posts Lookbook")]):_vm._e(),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 2)?_c('p',[_vm._v("Type: Product Lookbook")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","white-space":"pre-line"}},[_vm._v("Description: "+_vm._s(_vm.lookbook.gallery_posts_group_text))]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"float":"right"}},[_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('editLookbook','lookbook',_vm.lookbook)}}},[_vm._v("Edit Lookbook ")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('deleteLookbook','lookbook',_vm.lookbook)}}},[_vm._v("Delete ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),(_vm.lookbook_details.editLookbook)?_c('div',{staticClass:"row col-md-12"},[_c('h6',[_vm._v("Edit Lookbook")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" Lookbook Name\r\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook.gallery_posts_group_name),expression:"lookbook.gallery_posts_group_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.lookbook.gallery_posts_group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook, "gallery_posts_group_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" Details ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook.gallery_posts_group_text),expression:"lookbook.gallery_posts_group_text"}],staticClass:"form-control",staticStyle:{"width":"100%","height":"250px"},domProps:{"value":(_vm.lookbook.gallery_posts_group_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook, "gallery_posts_group_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editLookbook}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.lookbook_details.deleteLookbook)?_c('div',{staticClass:"row col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to delete this Lookbook?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.deleteLookbook}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),_c('hr')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 col-xs-12"},[_c('div',{staticClass:"row product-detail-card"},[_c('h5',{staticClass:"col-md-12"},[_vm._v("Posts in Lookbook")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.lookbook.gallery_posts_group_posts),function(post,pndex){return _c('div',{staticClass:"col-md-4 col-xs-4"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',post,'viewLookbookPost')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(post.gallery_post_media && (post.gallery_post_media.length > 0))?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":post.gallery_post_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(post.gallery_post_caption))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])}),_vm._v(" "),(_vm.lookbook.gallery_posts_group_posts.length == 0)?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(28)]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),(_vm.component_view.viewLookbookPost)?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('lookbooks',_vm.lookbook,'viewLookbook')}}},[_vm._v("<< Back ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row col-md-12",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-8 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"float":"right"}},[(_vm.lookbook.gallery_posts_group_type == 1)?_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('editLookbookPost','postlookbook',_vm.lookbook_post)}}},[_vm._v("Edit Post ")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('deleteLookbookPost','postlookbook',_vm.lookbook_post)}}},[_vm._v("Delete Post ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 2)?_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('viewProductLookbookPost','productlookbook',_vm.lookbook_post)}}},[_vm._v("Edit Product Post")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('deleteLookbookPost','postlookbook',_vm.lookbook_post)}}},[_vm._v("Delete Product Post ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v(_vm._s(_vm.lookbook_post.gallery_post_caption))]),_vm._v(" "),_c('p',[_vm._v("Description: "+_vm._s(_vm.lookbook_post.gallery_post_details))]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.lookbook_details.editLookbookPost)?_c('div',{staticClass:"row col-md-12"},[_c('h6',[_vm._v("Edit Post")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" *Post Caption\r\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook_post.gallery_post_caption),expression:"lookbook_post.gallery_post_caption"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.lookbook_post.gallery_post_caption)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook_post, "gallery_post_caption", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" *Post Details\r\n                            "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook_post.gallery_post_details),expression:"lookbook_post.gallery_post_details"}],staticClass:"form-control",domProps:{"value":(_vm.lookbook_post.gallery_post_details)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook_post, "gallery_post_details", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editLookbookPost}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.lookbook_details.deleteLookbookPost)?_c('div',{staticClass:"row col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to delete this Post?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.deleteLookbookPost}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("Post Images")]),_vm._v(" "),((_vm.lookbook_post.gallery_post_media) && (_vm.lookbook_post.gallery_post_media.length > 0))?_c('div',{staticClass:"row img-row",staticStyle:{"margin-bottom":"5px"}},[_vm._l((_vm.lookbook_post.gallery_post_media),function(pm){return _c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"0","border":"#eeccee 1px solid"}},[_c('div',{staticClass:"img-row"},[(_vm.lookbook_post.gallery_post_media && (_vm.lookbook_post.gallery_post_media.length > 0))?_c('div',{staticClass:"img-column",staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"col-xs-8",staticStyle:{"z-index":"1"}},[(_vm.checkIfVideo(pm.gallery_post_media))?_c('div',[_c('img',{staticClass:"sp-prd-img",staticStyle:{"z-index":"1","height":"50px","width":"80px"},attrs:{"src":"/static/assets/images/video-placeholder.png"}})]):_c('div',[((pm.gallery_post_media && (pm.gallery_post_media != 'error')))?_c('img',{staticClass:"img-1 sp-prd-img",staticStyle:{"z-index":"1","height":"50px","width":"80px"},attrs:{"src":pm.gallery_post_media}}):_c('img',{staticStyle:{"z-index":"1","height":"50px","width":"80px"},attrs:{"src":"/static/assets/images/dummy-image.png"}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 1)?_c('a',{staticClass:"col-xs-2 btn pull-right",staticStyle:{"z-index":"9","margin-top":"4em","font-size":"10px","padding":"6px"},attrs:{"type":"button"},on:{"click":function($event){_vm.deletePostImage(pm.gallery_post_media_id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2):_vm._e(),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 1)?_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.6","font-size":"12px"}},[_vm._v("Add new Media")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*,video/*"},on:{"change":function($event){_vm.onFileChangeLookbook($event,'gallery_media',_vm.lookbook_post.gallery_post_id)}}})]):_vm._e(),_vm._v(" "),_c('hr')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"row product-detail-card"},[_c('h5',{staticClass:"col-md-12"},[_vm._v("Other Posts in \r\n                  "),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',_vm.lookbook,'viewLookbook')}}},[_c('u',[_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))])]),_vm._v(" Lookbook")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.lookbook.gallery_posts_group_posts),function(post,pndex){return _c('div',{staticClass:"col-md-6 col-xs-6"},[(post.gallery_post_id != _vm.lookbook_post.gallery_post_id)?_c('div',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',post,'viewLookbookPost')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(post.gallery_post_media && (post.gallery_post_media.length > 0))?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":post.gallery_post_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(post.gallery_post_caption))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])]):_vm._e()])}),_vm._v(" "),(_vm.lookbook.gallery_posts_group_posts && (_vm.lookbook.gallery_posts_group_posts.length == 0))?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(29)]):_vm._e()],2)])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.managePosts)?_c('div',{staticClass:"container"}):_vm._e(),_vm._v(" "),(_vm.manageOrders)?_c('div',{staticClass:"container"}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-box clearfix"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/assets/images/logo.png","alt":"Gallery"}})]),_vm._v(" "),_c('button',{staticClass:"menu-toggler",attrs:{"data-target":"#main-nav-bar"}},[_c('span',{staticClass:"fa fa-bars"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"float":"left"}},[_c('i',{staticClass:"fa fa-briefcase info-profile"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('h5',[_vm._v("Lookbooks")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your Gallery is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Lookbooks to your gallery")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',{staticStyle:{"text-align":"center"}},[_c('i',{staticClass:"fa fa-bell"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"slide-0",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-1",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-2",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-3",staticStyle:{"display":"none"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"slide-2"},[_c('p',{staticClass:"text-slide"},[_vm._v("We hope you love your lookbook Gallery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"slide-3"},[_c('p',{staticClass:"text-slide"},[_vm._v("Welcome to your lookbook Gallery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-slider-arrow-prev"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-slider-arrow-next"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-slider-dot"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-slide"},[_c('div',{staticClass:"pc-slider"},[_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-0","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-1","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-2","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-3","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-autoplay","type":"radio","checked":""}}),_vm._v(" "),_c('ul',[_c('li',{staticClass:"slide-0",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-1",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-2",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-3",staticStyle:{"display":"none"}})]),_vm._v(" "),_c('div',{staticClass:"slide-description"},[_c('label',{staticClass:"slide-0"},[_c('p',{staticClass:"text-slide"},[_vm._v("If you have any issues setting up your Gallery Lookbooks, please do not hesitate to contact support")])]),_vm._v(" "),_c('label',{staticClass:"slide-1"},[_c('p',{staticClass:"text-slide"},[_vm._v("Upgrade or Customize your account to unlock more features")])]),_vm._v(" "),_c('label',{staticClass:"slide-2"},[_c('p',{staticClass:"text-slide"},[_vm._v("We hope you love your lookbook Gallery")])]),_vm._v(" "),_c('label',{staticClass:"slide-3"},[_c('p',{staticClass:"text-slide"},[_vm._v("Welcome to your lookbook Gallery")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"pc-slider-arrow-prev"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})]),_vm._v(" "),_c('div',{staticClass:"pc-slider-arrow-next"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})]),_vm._v(" "),_c('div',{staticClass:"pc-slider-dot"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',[_vm._v("CONTACT DETAILS")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',[_vm._v("SUBSCRIPTION STATUS")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"margin":"0","padding":"0"}},[_c('div',{staticClass:"manage-action-block"},[_c('h5',[_vm._v("Your Subscription is Active ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"}},[_c('p',[_vm._v("Would you love to Customize your Gallery? "),_c('a',{staticClass:"btn",staticStyle:{"background":"#ff0055","color":"#ffffff"},attrs:{"href":"/customize"}},[_vm._v("Talk to your Web Gallery Assistant")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',[_vm._v("SETTINGS")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row info-card-inner-row"},[_c('a',{staticClass:"btn",staticStyle:{"cursor":"pointer","background":"#f1dee4","padding":"1em","color":"#000"},attrs:{"href":"login"}},[_vm._v("Logout from Account")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col",staticStyle:{"margin-top":"5em","margin-bottom":"5em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("View and Update Business Details")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("Set Business Delivery and Shipping Information")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("Set Business Coupons and Vouchers")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("Connect to your Business Payment Receival Portal")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',[_vm._v("Your Sellpoint's Delivery Information")]),_vm._v(" "),_c('p',{staticClass:"p-tiny",staticStyle:{"color":"#ff0000"}},[_vm._v("This is the general shipping Information that would be shown to buyers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('p',{staticStyle:{"color":"#363535","font-size":"14px"}},[_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                button.\r\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('p',{staticStyle:{"color":"#363535","line-height":"1.2"}},[_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                          If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your Gallery is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Lookbooks to your gallery")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This Lookbook is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Posts to your lookbook")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This Lookbook is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Posts to your lookbook")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__ = __webpack_require__(208);
//import Index from '@/pages/Sellpoint/Index'
// import Sellpoint from '@/pages/Sellpoint/Sellpoint'
// export default {
//   path: '/:id',
//   name: 'Sellpoint',
//   component: Sellpoint
// }

// import Product from '@/pages/Sellpoint/Product'

// export default {
//     path: '/:id',
//     component: Sellpoint,
//     children: [
//       {
//         path: '',
//         name: 'Sellpoint',
//         component: Sellpoint
//       },

//     ]
// }




/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__["a" /* default */],
  children: [{
    path: '',
    name: 'Sellpoint',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__["a" /* default */]
  }, {
    path: ':id1',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__["a" /* default */]
  }]
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b995704_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b995704"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b995704_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.product_info)?_c('div',{staticClass:"margin-top-50 pretty-banner"},[_c('h5',{staticStyle:{"font-size":"18px"}},[_vm._v("Same product but different variations")]),_vm._v(" "),_c('p',[_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]),_vm._v(" "),_c('p',{staticClass:"center"},[_c('i',{staticClass:"fa fa-arrow-right"}),_c('a',{attrs:{"href":_vm.product_url}},[_vm._v("Proceed to this Product's View ")])])]):_vm._e(),_vm._v(" "),(!_vm.product_info)?_c('div',{staticClass:"col-sm-10 col-sm-offset-4"},[_c('h6',[_vm._v("Add Product / Service")]),_vm._v(" "),_c('form',[_c('ul',{staticClass:"row"},[_c('li',{staticClass:"col-sm-12"},[_c('label',[_vm._v(" *Product Name\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_name),expression:"product.product_name"}],attrs:{"type":"text","value":"","placeholder":""},domProps:{"value":(_vm.product.product_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_name", $event.target.value)}}})])]),_vm._v(" "),(_vm.sellpoint_categories.length != 0)?_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" Select Product Category\n                        "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_category),expression:"product.product_category"}],attrs:{"id":"category-type-1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "product_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.trackevent('category-type-1')}]}},[_c('option',{attrs:{"value":"0","disabled":_vm.category_type_1}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.sellpoint_categories),function(category){return _c('option',{key:category.business_category_id,attrs:{"disabled":_vm.category_type_1},domProps:{"value":category.business_category_id}},[_vm._v(_vm._s(category.business_category))])})],2)])]):_vm._e(),_vm._v(" "),(_vm.sellpoint_categories.length != 0)?_c('li',{staticClass:"col-sm-4 col-sm-offset-4"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v("Select from related Shop Categories\n                        "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_sub_category),expression:"product.product_sub_category"}],staticClass:"category-type-2",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "product_sub_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.trackevent('category-type-2')}]}},[_c('option',{attrs:{"value":"0","disabled":_vm.category_type_2}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.sub_categories),function(category){return _c('option',{key:category.sub_category_id,attrs:{"disabled":_vm.category_type_2},domProps:{"value":category.sub_category_id}},[_vm._v(_vm._s(category.sub_category_name))])})],2)])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_c('b',[_vm._v(" *Or ")]),_vm._v(" Enter a specific Category\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_listed_category),expression:"product.product_listed_category"}],attrs:{"disabled":_vm.category_type_3,"type":"text","placeholder":"","id":"category-type-3"},domProps:{"value":(_vm.product.product_listed_category)},on:{"change":function($event){_vm.trackevent('category-type-3')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_listed_category", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Description\n                            "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_description),expression:"product.product_description"}],domProps:{"value":(_vm.product.product_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_description", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Price\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_price),expression:"product.product_item_price"}],attrs:{"type":"number","placeholder":"","required":""},domProps:{"value":(_vm.product.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Weight\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_weight),expression:"product.product_item_weight"}],attrs:{"type":"number","step":"any","placeholder":"","required":""},domProps:{"value":(_vm.product.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_weight", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('label',[_vm._v(" *Product Quantity\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_quantity),expression:"product.product_item_quantity"}],attrs:{"type":"number","placeholder":"","required":""},domProps:{"value":(_vm.product.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('li',{staticClass:"col-md-12"},[_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[_c('button',{staticClass:"upload-btn"},[_vm._v("Add Product Image")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*"},on:{"change":function($event){_vm.onFileChange($event)}}}),_vm._v(" "),(_vm.file_info[0])?_c('span',[_c('b',[_vm._v("Added "+_vm._s(_vm.file_info[0].name))])]):_vm._e()])]),_vm._v(" "),_c('li',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.addProduct}},[_vm._v("Add")])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v(" *Or ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCartActions_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac61838_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCartActions_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCartActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac61838_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCartActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productMainView == 'cartactions')?_c('span',[(_vm.canAdd)?_c('button',{staticClass:"cart-btn cart-btn-sm",on:{"click":_vm.addToCart}},[_vm._v("Add to Cart")]):_c('div',[_c('div',{staticClass:"hidden-sm hidden-xs"},[_c('div',{staticClass:"cart-cta-box"},[_c('button',{staticClass:"cart-btn cart-btn-sm",on:{"click":function($event){_vm.redir('cart')}}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" View Cart")])])]),_vm._v(" "),_c('div',{staticClass:"hidden-md hidden-lg"},[_c('button',{staticClass:"cart-btn cart-btn-sm",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.redir('cart')}}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" View Cart")])])])]):_c('div',{staticStyle:{"clear":"right","float":"right"}},[(_vm.canAdd)?_c('button',{staticClass:"cart-btn",on:{"click":_vm.addToCart}},[_vm._v("Add to Cart")]):_c('div',[_c('div',{staticClass:"hidden-sm hidden-xs"},[_c('div',{staticClass:"cart-cta-box"},[_c('li',[_c('a',{staticClass:"cart-btn btn-white remove-btn",on:{"click":function($event){_vm.removeFromCart(_vm.productItem)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Remove from Cart")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"cart-btn btn-black view-btn",on:{"click":function($event){_vm.redir('cart')}}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" View Cart")])]),_vm._v(" "),_c('li',{staticStyle:{"margin-top":"2em"}},[_c('a',{staticClass:"cart-btn btn-white btn-primary",on:{"click":function($event){_vm.redir('')}}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" Continue Shopping")])])])]),_vm._v(" "),_c('div',{staticClass:"hidden-md hidden-lg"},[_c('button',{staticClass:"cart-btn remove-btn",staticStyle:{"background":"#e05024"},on:{"click":function($event){_vm.removeFromCart(_vm.productItem)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Remove from Cart")]),_vm._v(" "),_c('button',{staticClass:"cart-btn view-btn",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.redir('cart')}}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" View Cart")]),_vm._v(" "),_c('button',{staticClass:"cart-btn btn-primary",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.redir('')}}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" Continue Shopping")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCTAActions_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eedd5116_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCTAActions_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCTAActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eedd5116_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCTAActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAdd)?_c('div',[(_vm.productMainView == 'cartactions')?_c('button',{staticClass:"cta-btn cta-btn-sm",on:{"click":_vm.addToCart}},[_vm._v(" Buy Now")]):_c('button',{staticClass:"cta-btn",on:{"click":_vm.addToCart}},[_vm._v(" Buy Now")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('section',{staticStyle:{"background":"#ffffff","margin-bottom":"5em"},attrs:{"id":"menu"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.product.product_name))]),_vm._v(" "),_c('p',[_c('span',{staticStyle:{"text-transform":"uppercase"}},[_c('u',[_vm._v(_vm._s(_vm.product.product_business_name))])]),_vm._v(" / "+_vm._s(_vm.product.product_category_name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"width":"100%","margin":"1em"}},[_c('div',{staticClass:"card-left",staticStyle:{"width":"40%","float":"left"}},[_c('h4',{staticClass:"hidden-md hidden-lg"},[_vm._v(_vm._s(_vm.product.product_name))]),_vm._v(" "),_c('div',{staticClass:"images-slider img-main-frame"},[(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error')?_c('img',{staticClass:"img-responsive sp-prd-img",attrs:{"src":_vm.img_product_url + _vm.product_display_image.product_image,"alt":""}}):_c('img',{staticClass:"img-responsive sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"img-row"},_vm._l((_vm.product.product_images),function(img){return _c('div',{staticClass:"img-column"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-product-display-image',img)}}},[_c('img',{attrs:{"src":_vm.img_product_url + img.product_image,"alt":""}})])])})),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"card sp-p-main",staticStyle:{"width":"60%","float":"right","padding":"0 2em"}},[_c('div',{staticClass:"sp-prd-intro-block"},[_c('h4',{staticClass:"hidden-sm hidden-xs"},[_vm._v(_vm._s(_vm.product.product_name))]),_vm._v(" "),_c('p',{staticClass:"p-bold"},[_vm._v(_vm._s(_vm.product.product_description))]),_vm._v(" "),_c('p',{staticClass:"p-bold"},[_vm._v("Category: "),_c('span',[_c('b',[_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"},on:{"click":function($event){_vm.redir(_vm.product.product_business_ownername)}}},[_vm._v(_vm._s(_vm.product.product_category_name))])])])]),_vm._v(" "),_c('div',{staticClass:"hozontal-flat-block"},[_c('p',{staticClass:"pull-left"},[_vm._v("reviews")]),_vm._v(" "),_c('p',{staticClass:"pull-right"},[_vm._v("@"),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.redir(_vm.product.product_business_ownername)}}},[_vm._v(_vm._s(_vm.product.product_business_ownername))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"sp-prd-attr-block"},[_c('div',{staticClass:"info-block col-xs-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"info-right col-xs-8"},[(_vm.product_item.product_item_actual_price != 0)?_c('p',{staticClass:"attr-intro-desc prd-price prd-discounted-price"},[_c('del',[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]):_c('p',{staticClass:"attr-intro-desc prd-price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(_vm.product_item.product_item_price))])])]),_vm._v(" "),(_vm.product_item.product_item_actual_price != 0)?_c('div',{staticClass:"info-block col-xs-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"info-right col-xs-8"},[_c('p',{staticClass:"attr-intro-desc prd-discount-price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(_vm.product_item.product_item_price))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"info-block col-xs-12"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"info-right col-xs-8"},[_c('p',{staticClass:"attr-intro-desc"},[_vm._v(_vm._s(_vm.product_item.product_item_weight)+" (Kg)")])])]),_vm._v(" "),(( (_vm.product.product_set_groups != 0)))?_c('div',{staticClass:"info-block col-xs-12"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"info-right col-xs-8"},[_vm._l((_vm.product.product_item_groups),function(pg){return _c('div',{staticClass:"prd-color-block"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-product-item-group',pg)}}},[_c('div',{staticClass:"box-cube col-xs-2"},[(pg.product_item_group_is_color_image == 'IMG')?_c('div',{staticClass:"product-item-group"},[_c('div',{staticClass:"product-item-group",attrs:{"id":pg.product_item_group_id+'PRTGR'}},[((pg.product_item_group_image && (pg.product_item_group_image != 'error')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":pg.product_item_group_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})])]):_vm._e(),_vm._v(" "),(pg.product_item_group_is_color_image == 'COL')?_c('div',{},[_c('div',{staticClass:"product-item-group box-color-cube",style:({background: pg.product_item_group_color}),attrs:{"id":pg.product_item_group_id+'PRTGR'}})]):_vm._e()])])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.data_cart_group_message)?_c('p',{staticClass:"p-tiny-info",staticStyle:{"margin-top":"-1em","float":"left"}},[_vm._v(_vm._s(_vm.data_cart_group_message))]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0)))?_c('div',{staticClass:"info-block col-xs-12"},[(( (_vm.product.product_set_items != 0) && (_vm.product.product_set_items_params_check != 0) ))?_c('div',[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"info-right col-xs-8"},[_c('div',{staticClass:"prd-color-block"},_vm._l((_vm.product_item_group.product_items),function(pt){return _c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[_c('li',{staticClass:"product-item",attrs:{"id":pt.product_item_id+'PRT'}},[(_vm.product.product_service == 'P')?_c('a',{staticClass:"box-wrap",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-product-item',pt)}}},[_vm._v(_vm._s(pt.product_item_size))]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"product-item",attrs:{"id":pt.product_item_id+'PRT'}},[(_vm.product.product_service == 'S')?_c('a',{staticClass:"box-wrap",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-product-item',pt)}}},[_vm._v(_vm._s(pt.product_item_service_tag))]):_vm._e()])])})),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.data_cart_item_message)?_c('p',{staticClass:"p-tiny-info",staticStyle:{"margin-top":"-0.1em","float":"left"}},[_vm._v(_vm._s(_vm.data_cart_item_message))]):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.product_item.product_item_total_discount != 0)?_c('div',{staticClass:"on-sale"},[_vm._v(" \r\n              "+_vm._s(_vm.product_item.product_item_total_discount)+"% "),_c('span',[_vm._v("OFF")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"some-info"},[(!_vm.edit_mode)?_c('div',[_c('div',[_c('div',{staticClass:"info-block col-xs-12"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"info-right col-xs-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_order_quantity),expression:"product_item.product_item_order_quantity"}],staticClass:"form-control",staticStyle:{"max-width":"102px"},attrs:{"type":"number"},domProps:{"value":(_vm.product_item.product_item_order_quantity)},on:{"change":function($event){_vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_order_quantity", $event.target.value)}}}),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.check_order_quantity))])])]),_vm._v(" "),_c('hr')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inner-info"},[_c('div',{staticClass:"info-blocks"},[_c('div',{staticClass:"info-block col-xs-12",staticStyle:{"border":"solid 1px #eeddcc","padding":"1em","background":"#fcf7f3"}},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"info-right-2 col-xs-8"},[_c('div',{staticClass:"tiny-notice"},[(_vm.product.product_delivery_returns != ' ')?_c('p',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.product.product_delivery_returns)+"\r\n                      ")]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                        Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                        partners to make transactions seamless.\r\n                      ")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"info-blocks"},[_c('div',{staticClass:"info-block col-md-12 col-xs-12",staticStyle:{"border":"solid 1px #eeddcc","padding":"1em","background":"#fcf7f3"}},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"info-right-2 col-md-8 col-xs-12"},[_c('div',{staticClass:"prd-delivery-list",staticStyle:{"display":"none"}},[(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0)))?_c('div',_vm._l((_vm.product.product_delivery_options),function(delivery){return _c('li',[_c('b',[_vm._v(_vm._s(delivery.business_delivery_option))]),_vm._v(" - ₦"+_vm._s(delivery.business_delivery_option_price)+"\r\n                          ")])})):_c('div',_vm._l((_vm.product.product_business_delivery_options),function(delivery){return _c('li',[_c('b',[_vm._v(_vm._s(delivery.business_delivery_option))]),_vm._v(" - ₦"+_vm._s(delivery.business_delivery_option_price)+" \r\n                            ")])}))]),_vm._v(" "),_c('div',{staticClass:"prd-delivery-list"},_vm._l((_vm.product.product_business_delivery_options),function(delivery){return _c('li',[_c('b',[_vm._v(_vm._s(delivery.business_delivery_option))]),_vm._v(" - ₦\r\n                          "),(delivery.business_products_delivery_fees.length > 0)?_c('span',_vm._l((delivery.business_products_delivery_fees),function(fee,fdex){return _c('span',[((fee.product_delivery_product == _vm.product.product_id))?_c('span',[_vm._v(_vm._s(fee.product_delivery_fee)+"\r\n                              ")]):_vm._e()])})):_c('span',[_vm._v("\r\n                            "+_vm._s(delivery.business_delivery_option_price)+"\r\n                          ")])])}))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('h6',[_vm._v("SHARE THIS PRODUCT")]),_vm._v(" "),_c('ul',{staticClass:"social_icons"},[_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]),_vm._v(" "),_c('li',[_c('button',{staticClass:"btn btn-xs linky",staticStyle:{"cursor":"pointer","padding":"10px 30px"},attrs:{"title":"Copy Link. Paste and Share Anywhere"},on:{"click":function($event){_vm.copyLink()}}},[_vm._v("Copy Link\r\n                    ")]),_vm._v(" "),(_vm.copied)?_c('span',{staticStyle:{"background":"rgb(240, 227, 157)"}},[_vm._v("Copied, Paste anywhere you want to share to")]):_vm._e()])])])])])]),_vm._v(" "),_c('ul',{staticClass:"dishes v2"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left col-xs-2"},[_c('p',{staticClass:"attr-intro-head"},[_vm._v("Price: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left col-xs-2"},[_c('p',{staticClass:"attr-intro-head"},[_vm._v("Discount Price: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left col-xs-2"},[_c('p',{staticClass:"attr-intro-head"},[_vm._v("Weight: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left col-xs-2"},[_c('p',{staticClass:"attr-intro-head"},[_vm._v("Groups/Types: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left col-xs-2"},[_c('p',{staticClass:"attr-intro-head"},[_vm._v("Select: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left col-xs-2"},[_c('p',{staticClass:"attr-intro-head"},[_vm._v("Quantity:  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left-2 col-xs-2"},[_c('h6',[_vm._v("DELIVERY & RETURNS INFORMATION")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-left-2 col-md-2 col-xs-12"},[_c('h6',[_vm._v("PRODUCT DELIVERY LOCATIONS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3fe5af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(207);
function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b3fe5af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3fe5af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sellpoint.business_banner_image != _vm.default_banner_image)?_c('article',{style:({ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')' }),attrs:{"id":"menu-banner"}},[_c('h1',[_vm._v(_vm._s(_vm.sellpoint.business_name))]),_vm._v(" "),_c('h6',{staticStyle:{"background-color":"#ffffff","color":"#000000","font-weight":"bolder","text-align":"center"}},[_vm._v(_vm._s(_vm.sellpoint.business_category))])]):_vm._e(),_vm._v(" "),_c('section',{attrs:{"id":"menu"}},[_c('img',{attrs:{"src":"/static/assets/images/title-detail.png","alt":"title-detail"}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.sellpoint.business_tagline))]),_vm._v(" "),(_vm.sellpoint.business_profile && (_vm.sellpoint.business_profile != ''))?_c('p',{staticStyle:{"height":"80px","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.sellpoint.business_profile))]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dishes v2"},_vm._l((_vm.products),function(product,prdex){return _c('li',[_c('div',[(product.product_images[0])?_c('div',[_c('a',{attrs:{"href":'/'+_vm.sellpoint.business_username+'/'+product.product_url_name}},[_c('img',{staticClass:"sp-prd-img",attrs:{"src":product.product_images[0].product_image,"alt":"featured"}})])]):_vm._e(),_vm._v(" "),_vm._m(1,true)]),_vm._v(" "),_c('div',{staticClass:"cat-con"},[_c('span',[_c('i',[_vm._v(_vm._s(product.product_category_name))])])]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(product.product_name))]),_vm._v(" "),_c('p',{staticStyle:{"height":"40px","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(product.product_description))]),_vm._v(" "),(product.product_items && (product.product_items.length > 0))?_c('p',[_vm._v("₦"+_vm._s(product.product_items[0].product_item_price))]):_vm._e()])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"img-nav",staticStyle:{"display":"none"},attrs:{"id":"menu-nav"}},[_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Fast Food and Entrees"}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Steak and Chicken"}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Pizzas and Calzones"}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Sandwiches and Subs"}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Drinks and Beverages"}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"tooltip",attrs:{"href":"#","title":"Sweets and Desserts"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('div',[_c('img',{attrs:{"src":"/static/assets/images/plus-icon.png","alt":"plus-icon"}}),_vm._v(" "),_c('p',[_vm._v("Click to enlarge")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c74dd5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45c74dd5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c74dd5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('component-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__ = __webpack_require__(212);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/buypoint',
  name: 'Buypoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__["a" /* default */]

});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a8d4f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07a8d4f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a8d4f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('header',{staticClass:"site-header header-one home-page-one"},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light header-navigation stricky",staticStyle:{"background":"none"}},[_c('div',{staticClass:"container clearfix nav-head",staticStyle:{"background":"none"}},[_vm._m(0),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"right-side-box"},[_c('a',{staticClass:"header-btn",attrs:{"href":'/'+_vm.sellpoint.business_username}},[_vm._v("View Gallery")])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"vtd vtd-right-side-box"},[_c('a',{staticClass:"header-btn vtd-btn",attrs:{"href":'/'+_vm.sellpoint.business_username}},[_vm._v("View Gallery")])]):_vm._e()])])]),_vm._v(" "),_c('section',{staticStyle:{"height":"3em","background":"#ffffff"},attrs:{"id":"top"}},[_c('div',{staticClass:"container banner-menu"},[_c('div',{staticClass:"row menu-links"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('lookbooks')}}},[_vm._v("Lookbooks")])]),_vm._v(" "),_c('li',{staticClass:"gw-mobile"},[_c('a',{on:{"click":function($event){_vm.setMenuComponent('feeds')}}},[_vm._v("Feeds")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('profile')}}},[_vm._v("Profile")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('settings')}}},[_vm._v("Orders")])]),_vm._v(" "),(!_vm.loading)?_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-panel')}}},[_vm._v("Manage Gallery")])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('li',[_c('a',{attrs:{"href":"/getstarted"}},[_vm._v("Get a Mall Space")])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setMenuComponent('settings')}}},[_vm._v("Settings")])])])])])]),_vm._v(" "),(!_vm.setPanel)?_c('section',{staticClass:"account-inner",staticStyle:{"background":"#f7fbff","margin-top":"2em"}},[(_vm.loading)?_c('div',{staticClass:"container"},[_vm._m(1)]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"row account-inner-row"},[_c('div',{staticClass:"col-md-4 col-sm-12"},[_c('div',{staticClass:"info-card",attrs:{"id":"profile"}},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"info-card-left"},[_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-left":"5px"}},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":'/'+_vm.sellpoint.business_username}},[_c('h5',[_vm._v(_vm._s(_vm.sellpoint.business_name))]),_vm._v(" "),_c('p',{staticClass:"sp-form-descr",staticStyle:{"color":"inherit","margin-top":"-1em"}},[_vm._v("@"+_vm._s(_vm.sellpoint.business_username))])])])]),_vm._v(" "),_c('div',{staticClass:"info-card-right",staticStyle:{"display":"none"}},[_c('div',[_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"},on:{"click":function($event){_vm.toggleSwitchBusiness()}}},[_c('i',{staticClass:"fa fa-cog"})])]),_vm._v(" "),_c('div',{staticClass:"show-business-list",staticStyle:{"display":"none"},attrs:{"id":"businessList"}},_vm._l((_vm.sellpoints),function(sellpoint){return _c('li',[_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"},on:{"click":function($event){_vm.switchBusiness(sellpoint)}}},[_vm._v(_vm._s(sellpoint.business_name))])])}))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-stats-top"},[_c('div',{staticClass:"col-xs-2 stats-block"},[_c('h5',{staticClass:"stats-num"},[_vm._v(_vm._s(_vm.sellpoint.business_total_gallery_posts))]),_vm._v(" "),_c('p',{staticClass:"stats-descr"},[_vm._v("Posts")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 stats-block stats-block-center"},[_c('h5',{staticClass:"stats-num"},[_vm._v(_vm._s(_vm.sellpoint.business_total_gallery))]),_vm._v(" "),_c('p',{staticClass:"stats-descr"},[_vm._v("Lookbooks")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 stats-block"},[_c('h5',{staticClass:"stats-num"},[_vm._v(_vm._s(_vm.sellpoint.business_total_views))]),_vm._v(" "),_c('p',{staticClass:"stats-descr"},[_vm._v("Views")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row info-stats-list"},[_c('p',[_c('span',[_vm._v("Category")]),_vm._v(_vm._s(_vm.sellpoint.business_category))])]),_vm._v(" "),_c('div',{staticClass:"row info-stats-list"},[_c('p',[_c('span',[_vm._v("Tagline:")]),_vm._v(_vm._s(_vm.sellpoint.business_tagline))])]),_vm._v(" "),_c('div',{staticClass:"row info-stats-list"},[_c('p',[_c('span',[_vm._v("Brief:")]),_vm._v(_vm._s(_vm.sellpoint.business_profile))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5px"}},[_c('a',{staticClass:"btn vtd-btn",staticStyle:{"float":"left","background":"#f1dee4","font-size":"14px"},attrs:{"href":'/'+_vm.sellpoint.business_username}},[_vm._v("View Gallery")]),_vm._v(" "),_c('button',{staticClass:"btn vtd-btn",staticStyle:{"float":"right","background":"#f1dee4","font-size":"14px"},on:{"click":function($event){_vm.setComponent('manage-panel','')}}},[_vm._v("Manage Gallery")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"lookbooks"}},[_c('div',{staticClass:"info-card"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-card-row"},[_c('div',{staticClass:"col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]),_vm._v(" "),_vm._l((_vm.galleria),function(gallery,gndex){return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"font-size":"12px","line-height":"1.2"}},[_c('div',{staticClass:"col-sm-3"},[(gallery.gallery_posts_group_posts_media.length > 0)?_c('div',{staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":gallery.gallery_posts_group_posts_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_name))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_posts.length)+" posts")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})])])])}),_vm._v(" "),(_vm.galleria.length == 0)?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(4)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"feeds"}},[_c('div',{staticClass:"info-card info-card-feeds"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-card-inner-row"},[(_vm.sellpoint.business_notifications && (_vm.sellpoint.business_notifications.length != 0))?_c('div',{staticClass:"notification-slide"},[_c('div',{staticClass:"pc-slider"},[_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-0","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-1","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-2","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-3","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-autoplay","type":"radio","checked":""}}),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"slide-description"},[_c('label',{staticClass:"slide-0"},[_c('p',{staticClass:"text-slide"},[_vm._v(_vm._s(_vm.sellpoint.business_notifications[0].notification_message))])]),_vm._v(" "),_c('label',{staticClass:"slide-1"},[_c('p',{staticClass:"text-slide"},[_vm._v(_vm._s(_vm.sellpoint.business_notifications[1].notification_message))])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])]):_c('div',[_vm._m(12)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"contact"}},[_c('div',{staticClass:"info-card"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"row info-card-inner-row info-stats-list"},[_c('p',[_c('span',[_vm._v("Address")]),_vm._v(_vm._s(_vm.sellpoint.business_address))])]),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row info-stats-list"},[_c('p',[_c('span',[_vm._v("Email:")]),_vm._v(_vm._s(_vm.sellpoint.business_emails))])]),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row info-stats-list"},[_c('p',[_c('span',[_vm._v("Phone:")]),_vm._v(_vm._s(_vm.sellpoint.business_phones))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"subscription"}},[_c('div',{staticClass:"info-card"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"container info-card-body",staticStyle:{"padding":"0 1em"}},[_c('p',[_c('b',[_vm._v("Current Plan: ")]),_c('span',{staticStyle:{"color":"#ff0055","font-weight":"500"}},[_vm._v(_vm._s(_vm.sellpoint_gallery.business_market_subscription_name))])]),_vm._v(" "),(!_vm.can_add_more_lookbook)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"margin":"0","padding":"0"}},[_c('div',{staticClass:"manage-action-block"},[_c('h5',[_vm._v("You have reached the limit of your gallery")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"}},[_c('p',[_vm._v("To add more lookbooks to your gallery, "),_c('a',{staticClass:"btn",staticStyle:{"background":"#ff0055","color":"#ffffff"},attrs:{"href":'/purchase?upgrade='+_vm.sellpoint.business_username}},[_vm._v("Upgrade your Account")])])])])])]):_vm._e(),_vm._v(" "),(!_vm.can_add_product_lookbook)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"margin":"0","padding":"0"}},[_c('div',{staticClass:"manage-action-block"},[_c('h5',[_vm._v("Do you want to sell some Products or Services of your Gallery? ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"}},[_c('p',[_vm._v("Unlock this Package. "),_c('a',{staticClass:"btn",staticStyle:{"background":"#ff0055","color":"#ffffff"},attrs:{"href":'/purchase?upgrade='+_vm.sellpoint.business_username}},[_vm._v("Upgrade your Account to Unlock")])])])])])]):_vm._e(),_vm._v(" "),(_vm.can_add_more_lookbook && _vm.can_add_product_lookbook)?_c('div',[_vm._m(15)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12",attrs:{"id":"settings"}},[_c('div',{staticClass:"info-card info-card-feeds"},[_vm._m(16),_vm._v(" "),(_vm.setSettings)?_c('div',{staticClass:"container"},[(_vm.setting_details.editProfile)?_c('div',[_c('h6',[_vm._v("Edit Profile Details")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Name\r\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_name),expression:"user.user_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.user_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Phone Number\r\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_phone),expression:"user.user_phone"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.user_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_phone", $event.target.value)}}})])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","font-size":"12px"},attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.editProfileDetails}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e()]):_c('div',{staticClass:"container info-card-body"},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row"},[_c('a',{staticClass:"btn",staticStyle:{"cursor":"pointer","background":"#f1dee4","padding":"1em","color":"#000"},on:{"click":function($event){_vm.setComponent('set-settings-inner','editProfile')}}},[_vm._v("Edit Profile")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row info-card-inner-row",staticStyle:{"display":"none"}},[_c('a',{staticClass:"btn",staticStyle:{"cursor":"pointer","background":"#f1dee4","padding":"1em","color":"#000"},on:{"click":function($event){_vm.syncset(_vm.sellpoint.business_username)}}},[_vm._v("Manage Account on Sellpoint")])])])])])]),_vm._v(" "),_vm._m(18)])]):_vm._e(),_vm._v(" "),(_vm.managePanel)?_c('section',{staticClass:"account-inner-set-panel",staticStyle:{"background":"#f7fbff","margin-top":"2em"},attrs:{"id":"manage"}},[(_vm.loading)?_c('div',{staticClass:"container"},[_vm._m(19)]):_c('div',{staticClass:"container",staticStyle:{"background":"#ffffff","margin-top":"1em","padding":"1em"}},[_c('h5',[_vm._v("Manage Gallery")]),_vm._v(" "),_c('div',{staticClass:"container banner-menu manage-account-menu"},[_c('div',{staticClass:"row menu-links"},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-businesses','')}}},[_vm._v("Business Settings")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-lookbooks','')}}},[_vm._v("Lookbooks Settings")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){_vm.setComponent('manage-products','')}}},[_vm._v("Products")])])])])]),_vm._v(" "),(_vm.manageBusinesses)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row card-row-controls"},[_c('div',[(_vm.manageBusinessDetails)?_c('button',{staticClass:"btn admin-btn",staticStyle:{"float":"right"},on:{"click":function($event){_vm.setComponent('reset-component-details','')}}},[_vm._v("Back")]):_vm._e()])]),_vm._v(" "),(!_vm.manageBusinessDetails)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"row cards-grids"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',0)}}},[_vm._m(20)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',1)}}},[_vm._m(21)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',2)}}},[_vm._m(22)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6",attrs:{"id":"businessprofile"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-business-card-details',3)}}},[_vm._m(23)])])])]):_c('div',{staticClass:"row"},[(_vm.businessComponents[0])?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-12 col-xs-12 col-md-8 offset-md-1 set-panel"},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c('h4',[_vm._v("Edit Business Details")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"gw-form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_name),expression:"sellpoint.business_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Tagline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_tagline),expression:"sellpoint.business_tagline"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_tagline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_tagline", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Brief")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_profile),expression:"sellpoint.business_profile"}],staticClass:"form-control",domProps:{"value":(_vm.sellpoint.business_profile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_profile", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_address),expression:"sellpoint.business_address"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Emails")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_emails),expression:"sellpoint.business_emails"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_emails", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Business Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_phones),expression:"sellpoint.business_phones"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sellpoint.business_phones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_phones", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticStyle:{"color":"#4617c7"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"float":"left","background":"#f1dee4"},attrs:{"type":"button","disabled":_vm.disable_btn},on:{"click":function($event){_vm.editBusinessDetails('main')}}},[_vm._v("Save Details")]),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"float":"right","background":"#ecb989"},on:{"click":function($event){_vm.reset()}}},[_vm._v("Cancel")])])])])])]):_vm._e(),_vm._v(" "),(_vm.businessComponents[1])?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-12 col-xs-12 col-md-10  set-panel"},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"horizontal-cards"},[_vm._m(24),_vm._v(" "),(_vm.business_details.delivery_edit)?_c('div',{staticClass:"contact_form"},[_c('label',[_vm._v("Your Delivery Information")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint.business_delivery_information),expression:"sellpoint.business_delivery_information"}],staticStyle:{"width":"70%"},domProps:{"value":(_vm.sellpoint.business_delivery_information)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sellpoint, "business_delivery_information", $event.target.value)}}}),_c('br'),_vm._v(" "),_c('button',{attrs:{"type":"submit"},on:{"click":function($event){_vm.editBusinessDetails('delivery')}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("save")]),_vm._v(" "),_c('button',{attrs:{"type":"btn"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" cancel")])]):_c('div',[(_vm.sellpoint.business_delivery_information)?_c('p',[_vm._v(_vm._s(_vm.sellpoint.business_delivery_information)+"\r\n                            "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('set-business-details','delivery_edit')}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("edit")]),_vm._v(" "),_c('br')]):_c('p',[_vm._v("You have not set any delivery information\r\n                            "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('set-business-details','delivery_edit')}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Set")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"horizontal-cards"},[_c('h6',{staticClass:"margin-t-40"},[_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]),_vm._v(" "),_c('p',[_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#363535"}},[_vm._v("How would your Business Shipping Fee be calculated?")]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_set_shipping_fee_status),expression:"business_set_shipping_fee_status"}],attrs:{"type":"radio","id":"9","value":"9"},domProps:{"checked":_vm._q(_vm.business_set_shipping_fee_status,"9")},on:{"click":function($event){_vm.setShippingFeeStatus()},"change":function($event){_vm.business_set_shipping_fee_status="9"}}}),_vm._v(" "),_c('span',[_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_set_shipping_fee_status),expression:"business_set_shipping_fee_status"}],attrs:{"type":"radio","id":"10","value":"10"},domProps:{"checked":_vm._q(_vm.business_set_shipping_fee_status,"10")},on:{"click":function($event){_vm.setShippingFeeStatus()},"change":function($event){_vm.business_set_shipping_fee_status="10"}}}),_vm._v(" "),_c('span',[_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business_set_shipping_fee_status),expression:"business_set_shipping_fee_status"}],attrs:{"type":"radio","id":"11","value":"11"},domProps:{"checked":_vm._q(_vm.business_set_shipping_fee_status,"11")},on:{"click":function($event){_vm.setShippingFeeStatus()},"change":function($event){_vm.business_set_shipping_fee_status="11"}}}),_vm._v(" "),_c('span',[_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('br')]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Delivery Locations and Prices")]),_vm._v(" "),_c('div',[_c('div',[_vm._l((_vm.sellpoint.business_delivery_options),function(delivery_option){return _c('div',[(_vm.business_details.delivery_option_edit && delivery_option.edit_set)?_c('div',{staticClass:"contact_form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.business_delivery_state),expression:"delivery_option.business_delivery_state"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(delivery_option, "business_delivery_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getCities(delivery_option.business_delivery_state,'edit')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select State")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("City: "),_c('b',[_vm._v(_vm._s(delivery_option.business_delivery_option))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.city),expression:"delivery_option.city"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(delivery_option, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.setOtherOptions(delivery_option.city,'edit')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select City")]),_vm._v(" "),_c('option',{attrs:{"value":"all"}},[_vm._v("All Areas @Fixed Price")]),_vm._v(" "),_vm._l((_vm.cities),function(city){return _c('option',{domProps:{"value":city.city_id}},[_vm._v(_vm._s(city.city_name))])}),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v("Other Areas / Cities ")])],2)]),_vm._v(" "),(_vm.edit_other_delivery_option)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Other Areas / Cities")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.business_delivery_other_option),expression:"delivery_option.business_delivery_other_option"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Abuja"},domProps:{"value":(delivery_option.business_delivery_other_option)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(delivery_option, "business_delivery_other_option", $event.target.value)}}}),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Delivery Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(delivery_option.business_delivery_option_price),expression:"delivery_option.business_delivery_option_price"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(delivery_option.business_delivery_option_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(delivery_option, "business_delivery_option_price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"disabled":_vm.disable_btn,"title":"save","type":"submit"},on:{"click":_vm.editDeliveryOption}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"title":"cancel","type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_c('div',[(delivery_option.business_delivery_product == 0)?_c('p',[_vm._v("\r\n                                    "+_vm._s(delivery_option.business_delivery_option)+" - "+_vm._s(delivery_option.business_delivery_option_price)+" \r\n                                    "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('edit-delivery-option',delivery_option)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":function($event){_vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)}}},[_c('i',{staticClass:"fa fa-trash"})])]):_vm._e()])])}),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"submit"},on:{"click":function($event){_vm.setComponent('set-business-details','delivery_add')}}},[_vm._v("Add New Delivery Information")]),_vm._v(" "),_c('hr')],2),_vm._v(" "),(_vm.business_details.delivery_add)?_c('div',{staticClass:"contact_form col-md-12",staticStyle:{"padding-left":"0"}},[_c('h5',[_vm._v("Add a Delivery Location and Price")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.state),expression:"delivery_option.state"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.delivery_option, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getCities(_vm.delivery_option.state,'')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select State")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])})],2)]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),(_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city)?_c('div',[_c('label',[_vm._v("City")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.city),expression:"delivery_option.city"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.delivery_option, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.setOtherOptions(_vm.delivery_option.city,'')}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select City")]),_vm._v(" "),_c('option',{attrs:{"value":"all"}},[_vm._v("All Areas @Fixed Price")]),_vm._v(" "),_vm._l((_vm.cities),function(city){return _c('option',{domProps:{"value":city.city_id}},[_vm._v(_vm._s(city.city_name))])}),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v("Other Areas / Cities ")])],2)]):_vm._e(),_vm._v(" "),(_vm.other_delivery_option)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Other Areas / Cities")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.delivery_other_option),expression:"delivery_option.delivery_other_option"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"eg. Abuja"},domProps:{"value":(_vm.delivery_option.delivery_other_option)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.delivery_option, "delivery_other_option", $event.target.value)}}}),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Delivery Charge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delivery_option.delivery_option_price),expression:"delivery_option.delivery_option_price"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"eg. 1000"},domProps:{"value":(_vm.delivery_option.delivery_option_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.delivery_option, "delivery_option_price", $event.target.value)}}}),_c('br')]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","font-size":"12px"},attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.addDeliveryOption}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e()]),_vm._v(" "),_c('div')])])])])]):_vm._e(),_vm._v(" "),(_vm.businessComponents[2])?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-12 col-xs-12 col-md-10  set-panel"},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c('div',{},[_c('div',{staticClass:"horizontal-cards"},[_c('h6',{staticClass:"margin-t-40"},[_vm._v("Set My Sellpoint's Discounts and Coupons")]),_vm._v(" "),_c('p',[_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                          You can set individual Product Discounts on thier product pages.\r\n                      ")]),_vm._v(" "),_c('span',[(_vm.business_details.setDiscount)?_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('view-discounts','')}}},[_vm._v("View your Discounts")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('set-business-details','setDiscount')}}},[_vm._v("Set New Discount Or Coupon")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.business_details.setDiscount)?_c('div',[_c('div',{staticClass:"contact-form col-md-6",staticStyle:{"padding-left":"0"}},[(_vm.sellpoint.business_discounts_active == 1)?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have an ongoing active Discount")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Set Coupon Or Discount")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.is_discount_coupon),expression:"discount_coupon.is_discount_coupon"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "is_discount_coupon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"D"}},[_vm._v("Discount")]),_vm._v(" "),_c('option',{attrs:{"value":"C"}},[_vm._v("Coupon")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label'),_vm._v(" "),(_vm.sellpoint.business_discounts_active != 1)?_c('label',[_vm._v("Select Discount Category")]):_c('label',[_vm._v("Select Coupon Discount Category")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_category),expression:"discount_coupon.discount_category"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "discount_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select Category")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("All Categories")]),_vm._v(" "),_vm._l((_vm.sellpoint.business_categories),function(cat){return _c('option',{domProps:{"value":cat.business_category_id}},[_vm._v(_vm._s(cat.business_category))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.setDiscountsAndCoupons()}}},[_vm._v("SET")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]),_vm._v(" "),_vm._m(25)]):_vm._e(),_vm._v(" "),(_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount))?_c('div',[_c('h5',{staticStyle:{"font-size":"13px"}},[_vm._v("Edit Discount")]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_category),expression:"discount_coupon.discount_category"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "discount_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select Another Category")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("All Categories")]),_vm._v(" "),_vm._l((_vm.sellpoint.business_categories),function(cat){return _c('option',{domProps:{"value":cat.business_category_id}},[_vm._v(_vm._s(cat.business_category))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date: "+_vm._s(_vm.discount_coupon.discount_start_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date: "+_vm._s(_vm.discount_coupon.discount_end_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.editDiscountsAndCoupons()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])])]):_vm._e(),_vm._v(" "),((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons)?_c('div',[_c('h5',{staticStyle:{"font-size":"13px"}},[_vm._v("View Discounts")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.sellpoint.business_discounts_coupons),function(dc,index){return _c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticStyle:{"border":"#f1dee4 solid 1px","padding":"1em"}},[_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('p',[_c('b',[_vm._v("Type: ")]),_vm._v(_vm._s(dc.discount_type_name))]):_c('p',[_c('b',[_vm._v("Type: ")]),_vm._v(_vm._s(dc.discount_category_name))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),((dc.discount_type == 2) || (dc.discount_type == 3))?_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setComponent('edit-discount-coupon',dc)}}},[_vm._v("\r\n                                    Edit Coupon")]),_vm._v("    \r\n                                "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.deactivateDiscountsAndCoupons(dc)}}},[_vm._v("\r\n                                    Deactivate Coupon")])]):_vm._e()]):_vm._e(),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Edit/Deactivate at Product Settings")]):_vm._e()])])}))]):_vm._e()])])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.manageProducts)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"float":"left"}},[_c('h6',{staticStyle:{"margin-left":"1em","margin-right":"2em"}},[_vm._v("Products ("+_vm._s(_vm.sellpoint.business_total_products)+")")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.component_view.viewProducts)?_c('div',{staticClass:"row"},_vm._l((_vm.products),function(product,gndex){return _c('div',{staticClass:"col-md-2 col-sm-3 col-xs-3"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('products',product,'')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(product.product_images.length > 0)?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(product.product_images[0].product_image))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":product.product_images[0].product_image}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(product.product_name))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])})):_vm._e(),_vm._v(" "),(_vm.component_view.viewProduct)?_c('div',{staticClass:"row col-md-12",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"container"},[(_vm.is_viewing_lookbook)?_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('switch-to-viewing-loobook','','')}}},[_vm._v("<< Back to Lookbook")])]):_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('products','','')}}},[_vm._v("<< Back ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-5 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('h4',[_vm._v(_vm._s(_vm.product.product_name))]),_vm._v(" "),_c('p',[_vm._v("Category: "+_vm._s(_vm.product.product_category_name))]),_vm._v(" "),(_vm.product.product_set_items == 0)?_c('div',[(_vm.product.product_items[0].product_item_actual_price != 0)?_c('div',[_c('p',[_vm._v("Price: ₦"+_vm._s(_vm.product.product_items[0].product_item_actual_price))]),_vm._v(" "),_c('p',[_vm._v("Discounted Price: ₦"+_vm._s(_vm.product.product_items[0].product_item_price))])]):_c('div',[_c('p',[_vm._v("Price: ₦"+_vm._s(_vm.product.product_items[0].product_item_price))])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('p',[_vm._v("Weight: "+_vm._s(_vm.product.product_items[0].product_item_weight)+"(kg)")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Quantity: "+_vm._s(_vm.product.product_items[0].product_item_quantity))])]):_vm._e(),_vm._v(" "),(_vm.product_details.editProductSingleProductItem)?_c('div',{staticClass:"row col-md-12"},[_c('h6',{staticStyle:{"font-size":"14px","text-decoration":"underline"}},[_vm._v("Reset Product Details")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4 col-xs-4"},[_c('label',[_vm._v(" Price\r\n                          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_items[0].product_item_price),expression:"product.product_items[0].product_item_price"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.product.product_items[0].product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.product_items[0], "product_item_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group col-md-4 col-xs-4"},[_c('label',[_vm._v(" Weight\r\n                          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_items[0].product_item_weight),expression:"product.product_items[0].product_item_weight"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.product.product_items[0].product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.product_items[0], "product_item_weight", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 col-xs-4"},[_c('label',[_vm._v(" Quantity\r\n                          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_items[0].product_item_quantity),expression:"product.product_items[0].product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.product.product_items[0].product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product.product_items[0], "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-2",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editProductSingleProductItem}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-2",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_c('button',{staticClass:"btn btn-xs admin-btn-tiny",staticStyle:{"line-height":"0.8","margin-bottom":"5px"},on:{"click":function($event){_vm.setProductComponent('editProductSingleProductItem','')}}},[_vm._v("Edit Price/Weight/Quantity")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.product_description))]),_vm._v(" "),(_vm.product_details.editProduct)?_c('div',{staticClass:"row col-md-12"},[_c('h6',[_vm._v("Edit Product")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" *Product Name\r\n                                      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_name),expression:"product.product_name"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":""},domProps:{"value":(_vm.product.product_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_vm._v("Category:- "+_vm._s(_vm.product.product_category_name)+" ")]),_vm._v(" "),(_vm.sellpoint_categories.length > 0)?_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v(" Select from My Shop Categories\r\n                                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_category),expression:"product.product_category"}],staticClass:"form-control",attrs:{"id":"category-type-1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "product_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.trackevent('category-type-1')}]}},[_c('option',{attrs:{"value":"0","disabled":_vm.category_type_1}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.sellpoint_categories),function(category){return _c('option',{key:category.business_category_id,attrs:{"disabled":_vm.category_type_1},domProps:{"value":category.business_category_id}},[_vm._v(_vm._s(category.business_category))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[(_vm.sellpoint_categories.length > 0)?_c('span',[_c('b',[_vm._v("Or ")])]):_vm._e(),_vm._v(" Select from Related Categories\r\n                                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.main_category),expression:"main_category"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.main_category=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getSubCategories(_vm.main_category)}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('option',{key:category.category_id,domProps:{"value":category}},[_vm._v(_vm._s(category.category_name))])})],2)]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.sub_categories.length != 0)?_c('label',[_vm._v(" Select a Category\r\n                                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_sub_category),expression:"product.product_sub_category"}],staticClass:"form-control category-type-2",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.product, "product_sub_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.trackevent('category-type-2')}]}},[_c('option',{attrs:{"value":"0","disabled":_vm.category_type_2}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.sub_categories),function(category){return _c('option',{key:category.sub_category_id,attrs:{"disabled":_vm.category_type_2},domProps:{"value":category.sub_category_id}},[_vm._v(_vm._s(category.sub_category_name))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8"},[_c('label',[_c('b',[_vm._v("Or ")]),_vm._v(" Enter a specific Category\r\n                                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_listed_category),expression:"product.product_listed_category"}],staticClass:"form-control",attrs:{"disabled":_vm.category_type_3,"type":"text","placeholder":"","id":"category-type-3"},domProps:{"value":(_vm.product.product_listed_category)},on:{"change":function($event){_vm.trackevent('category-type-3')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_listed_category", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v(" *Product Description\r\n                                  "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_description),expression:"product.product_description"}],staticClass:"form-control txtarea",domProps:{"value":(_vm.product.product_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editProduct}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_c('button',{staticClass:"btn btn-xs admin-btn",staticStyle:{"line-height":"0.8","margin-bottom":"5px"},on:{"click":function($event){_vm.setProductComponent('editProduct','')}}},[_vm._v("Edit Product Details")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("Product Images")]),_vm._v(" "),_c('div',{staticClass:"img-row",staticStyle:{"margin-bottom":"5px"}},[_vm._l((_vm.product.product_images),function(pt){return _c('div',{staticClass:"img-column"},[_c('a',{staticStyle:{"cursor":"pointer","float":"left"},on:{"click":function($event){_vm.setComponent('set-product-item',pt)}}},[_c('img',{staticClass:"sp-prd-img",staticStyle:{"height":"50px","width":"80px"},attrs:{"src":_vm.img_product_url + pt.product_image,"alt":""}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn pull-right",staticStyle:{"margin-top":"-3em","font-size":"10px","padding":"6px","float":"right"},attrs:{"type":"button"},on:{"click":function($event){_vm.deleteProductImage(pt.product_image_id)}}},[_c('i',{staticClass:"fa fa-trash"})])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[(_vm.action_loading && _vm.product_details.uploading_image)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.6","font-size":"12px"}},[_vm._v("Add new Photo")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*"},on:{"change":function($event){_vm.onFileChange($event,'products',_vm.product.product_id)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"0"}},[(!_vm.product_details.removeProduct)?_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"2em","float":"right"},on:{"click":function($event){_vm.setProductComponent('removeProduct','')}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Delete this Product")]):_vm._e(),_vm._v(" "),(_vm.product_details.removeProduct)?_c('span',{},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to remove this Product?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.removeProduct}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 col-xs-12",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"product-detail-card"},[_c('h6',[_vm._v("Product Items and Variations")]),_vm._v(" "),(_vm.product_details.setProductSettings)?_c('div',[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticStyle:{"display":"inline"}},[_c('b',[_vm._v("Group Name: ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_groups_set_name),expression:"product.product_groups_set_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product.product_groups_set_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_groups_set_name", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_set_items > 0)?_c('div',{staticClass:"form-group col-md-6"},[_c('b',[_vm._v("Group Items Name: ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_groups_items_set_name),expression:"product.product_groups_items_set_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product.product_groups_items_set_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_groups_items_set_name", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":_vm.editProductSettings}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('h5',{staticStyle:{"font-size":"10px","text-transform":"capitalize"}},[_c('b',[_vm._v("Name of Group: ")]),_vm._v(_vm._s(_vm.product.product_groups_set_name)+"\r\n                    "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('setProductSettings','','')}}},[_vm._v(" Change")])]),_vm._v(" "),(((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0)))?_c('div',_vm._l((_vm.product.product_item_groups),function(pg){return _c('div',{staticClass:"row col-xs-12",staticStyle:{"border-bottom":"1px solid #e9e6e6","margin-bottom":"1em"}},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id))?_c('div',{staticClass:"col-sm-12",attrs:{"id":"editProductItemGroup"}},[_c('h6',[_vm._v("Edit Product Item Group")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Name\r\n                                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item_group.product_item_group_name),expression:"product_item_group.product_item_group_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product_item_group.product_item_group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item_group, "product_item_group_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"box-cube col-xs-2"},[(_vm.product_item_group.product_item_group_is_color_image == 'IMG')?_c('div',{},[((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":_vm.product_item_group.product_item_group_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(_vm.product_item_group.product_item_group_is_color_image == 'COL')?_c('div',[_c('div',{staticClass:"box-color-cube",style:({background: pg.product_item_group_color})})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v(" Pick Colour\r\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item_group.product_item_group_color_new),expression:"product_item_group.product_item_group_color_new"}],staticClass:"form-control",staticStyle:{"width":"4em"},attrs:{"type":"color"},domProps:{"value":(_vm.product_item_group.product_item_group_color_new)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item_group, "product_item_group_color_new", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Or Pick Image")]),_vm._v(" "),_c('div',{staticClass:"row img-row"},_vm._l((_vm.product.product_images),function(img,index){return _c('div',{key:index,staticClass:"col-xs-1",staticStyle:{"height":"40px","width":"100px","margin-bottom":"5px"},attrs:{"id":"groupImage"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('set-product-item-group-image',img.product_image_id)}}},[_c('img',{staticClass:"product-item-group-image sp-prd-img",attrs:{"id":img.product_image_id+'PRTG',"src":img.product_image,"alt":""}})])])})),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"},attrs:{"id":"uploadDiv"}},[_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.6"}},[_vm._v("Or Add new Image")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*"},on:{"change":function($event){_vm.onFileChange($event,'products',_vm.product.product_id)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.editProductItemGroup}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id))?_c('span',{staticClass:"pull-left col-sm-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to remove this Item Group?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.removeProductItemGroup()}}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('div',{staticStyle:{"padding":"1em"}},[_c('h4',{staticStyle:{"font-weight":"bold","text-transform":"capitalize","font-size":"12px"}},[_vm._v(_vm._s(pg.product_item_group_name))]),_vm._v(" "),_c('div',{staticClass:"box-cube"},[(pg.product_item_group_is_color_image == 'IMG')?_c('div',{staticStyle:{"height":"40px"}},[((pg.product_item_group_image && (pg.product_item_group_image != 'error')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":pg.product_item_group_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(pg.product_item_group_is_color_image == 'COL')?_c('div',[_c('div',{staticClass:"box-color-cube",style:({background: pg.product_item_group_color})})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('editProductItemGroup','productitemgroup',pg)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Edit")]),_vm._v(" "),(_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1)?_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('removeItemGroup','productitemgroup',pg)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Delete")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('div',{staticStyle:{"padding":"1em"}},[_c('h5',{staticStyle:{"font-size":"10px","text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.product.product_groups_items_set_name)+"\r\n                            "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('setProductSettings','','')}}},[_vm._v(" Change")])]),_vm._v(" "),_vm._l((pg.product_items),function(pt){return _c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[_c('div',[(_vm.product.product_service == 'P'  && (pt.product_item_size))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(pt.product_item_size))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'S' && (pt.product_item_service_tag))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(pt.product_item_service_tag))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('li',[_c('span',[_vm._v("w(kg):")]),_vm._v(_vm._s(pt.product_item_weight))]):_vm._e(),_vm._v(" "),(pt.product_item_actual_price != 0)?_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(pt.product_item_actual_price))]):_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(pt.product_item_price))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Qty:")]),_vm._v(_vm._s(pt.product_item_quantity))]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('editProductItem','productitem',pt)}}},[_c('i',{staticClass:"fa fa-pencil"})])]),_vm._v(" "),(_vm.product.product_items.length > 1)?_c('li',[_c('a',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",attrs:{"type":"button"},on:{"click":function($event){_vm.setProductComponent('removeProductItem','productitem',pt)}}},[_c('i',{staticClass:"fa fa-trash"})])]):_vm._e()]),_vm._v(" "),(_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id))?_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"1em"},attrs:{"id":"editProductItem"}},[_c('h6',[_vm._v("Edit Product Item")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *"),(_vm.product.product_service == 'P')?_c('span',[_vm._v("Product Item Size")]):_vm._e(),(_vm.product.product_service == 'S')?_c('span',[_vm._v("Product Item tYPE")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_size),expression:"product_item.product_item_size"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":""},domProps:{"value":(_vm.product_item.product_item_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_size", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'S')?_c('div',{staticClass:"form-group",attrs:{"cla":""}},[_c('label',[_vm._v(" *Service Tag\r\n                                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_service_tag),expression:"product_item.product_item_service_tag"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product_item.product_item_service_tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_service_tag", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Product Item Price\r\n                                          "),(_vm.product_item.product_item_actual_price != 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_actual_price),expression:"product_item.product_item_actual_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product_item.product_item_actual_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_actual_price", $event.target.value)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_price),expression:"product_item.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product_item.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Product Item Weight\r\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_weight),expression:"product_item.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product_item.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_weight", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" *Product Item Quantity\r\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_item.product_item_quantity),expression:"product_item.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product_item.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product_item, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.editProductItem}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])]),_vm._v(" "),_c('br')])])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id))?_c('span',{staticClass:"pull-left col-sm-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to remove this Item?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.removeProductItem()}}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('addProductItemToGroup','productitemgroup',pg)}}},[_vm._v(" Add New Item")])],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id))?_c('div',{staticClass:"row col-md-12"},[(_vm.product.product_service == 'S')?_c('div',{staticClass:"col-md-4 col-xs-3"},[_c('label',[_vm._v(" Service Tag\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_service_tag),expression:"product.product_item_service_tag"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_service_tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_service_tag", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Price\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_price),expression:"product.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Weight(KG)\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_weight),expression:"product.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_weight", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Quantity\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_quantity),expression:"product.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_size),expression:"product.product_item_size"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_size", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"data-error-message"},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),_c('p',{staticClass:"data-success-message"},[_vm._v(_vm._s(_vm.data_success_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"background":"#e7e8e9"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.addProductItem}},[_vm._v("Add Item")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e()])})):_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have not set any product item variation")])]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]),_vm._v(" "),(_vm.product.product_set_groups == 0)?_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.product.product_groups_set_name))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"0.8"},on:{"click":function($event){_vm.setProductComponent('setProductSettings','','')}}},[_vm._v(" Change this Name")])])]):_vm._e(),_vm._v(" "),(!_vm.product_details.addProductItemPanel)?_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setProductComponent('addProductItemPanel','','')}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Product Variation")]):_c('div',[(_vm.product_details.addProductItemPanel)?_c('div',{staticClass:"col-sm-12"},[_c('h6',[_vm._v("Add New Variation "),(_vm.product.product_groups_set_name)?_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("(Set "+_vm._s(_vm.product.product_groups_set_name)+")")]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"gw-form",staticStyle:{"margin-top":"1em","width":"100%"}},[_c('div',{staticClass:"row"},[(_vm.product.product_set_groups > 0)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"line-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showProductItemGroups),expression:"showProductItemGroups"}],staticStyle:{"height":"1em"},attrs:{"type":"radio","value":"showtrue"},domProps:{"checked":_vm._q(_vm.showProductItemGroups,"showtrue")},on:{"change":function($event){_vm.showProductItemGroups="showtrue"}}}),_vm._v(" "),_vm._v("\r\n                                               Add new Items to "),_c('span',[_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"line-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showProductItemGroups),expression:"showProductItemGroups"}],staticStyle:{"height":"1em"},attrs:{"type":"radio","value":"showfalse"},domProps:{"checked":_vm._q(_vm.showProductItemGroups,"showfalse")},on:{"change":function($event){_vm.showProductItemGroups="showfalse"}}}),_vm._v("\r\n                                                   Or Add new "+_vm._s(_vm.product.product_groups_set_name)+"\r\n                                           ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.showProductItemGroups == 'showtrue')?_c('div',[((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0))?_c('div',{staticClass:"row col-md-12",staticStyle:{"width":"100%"}},[_vm._l((_vm.product.product_item_groups),function(pg,pgdex){return _c('div',{key:pgdex,staticClass:"col-xs-2"},[_c('div',{staticStyle:{"padding":"5px","margin-bottom":"5px","width":"10%"}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":pg.product_item_group_name},on:{"click":function($event){_vm.setInnerComponent('set-product-item-group',pg.product_item_group_id)}}},[(pg.product_item_group_is_color_image == 'IMG')?_c('div',[_c('div',{staticClass:"box-color-cube"},[_c('img',{staticClass:"product-item-group sp-prd-img",attrs:{"src":pg.product_item_group_image,"id":pg.product_item_group_id+'PRTGR'}})])]):_vm._e(),_vm._v(" "),(pg.product_item_group_is_color_image == 'COL')?_c('div',[_c('div',{staticClass:"product-item-group",attrs:{"id":pg.product_item_group_id+'PRTGR'}},[_c('div',{staticClass:"box-color-cube",staticStyle:{"height":"3em","width":"85%"},style:({background: pg.product_item_group_color})})])]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold","font-size":"12px","line-height":"1.2"}},[_vm._v("Add to "+_vm._s(pg.product_item_group_name)+" ")])])])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showProductItemGroups == 'showfalse')?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name of new "+_vm._s(_vm.product.product_groups_set_name)+"\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_group_name),expression:"product.product_item_group_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.product.product_item_group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_group_name", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{},[_c('label',[_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v(" Pick Colour\r\n                                                       "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_group_color),expression:"product.product_item_group_color"}],staticClass:"form-control",staticStyle:{"width":"4em"},attrs:{"type":"color"},domProps:{"value":(_vm.product.product_item_group_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_group_color", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"border":"1px dashed #eeccee","padding":"1em"}},[_c('label',{staticStyle:{"font-size":"12px"}},[_vm._v(" Or Pick Media")]),_vm._v(" "),_c('div',{staticClass:"row img-row"},_vm._l((_vm.product.product_images),function(img,index){return _c('div',{key:index,staticClass:"col-xs-1",staticStyle:{"height":"50px","width":"70px"},attrs:{"id":"groupImage"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setInnerComponent('set-product-item-group-image',img.product_image_id)}}},[_c('img',{staticClass:"product-item-group-image sp-prd-img",attrs:{"id":img.product_image_id+'PRTG',"src":img.product_image,"alt":""}})])])})),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"z-index":"9"}},[_c('p',{staticClass:"p-tiny-info"},[_vm._v(_vm._s(_vm.max_media_info))]),_vm._v(" "),_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.4","font-size":"14px"}},[_vm._v("Or Add new Image or Video ")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"video/*,image/*","capture":""},on:{"change":function($event){_vm.onFileChangeProductItems($event,'products',_vm.product.product_id)}}})]),_vm._v(" "),_c('p',{staticClass:"data-error-message"},[_vm._v(_vm._s(_vm.data_media_error_message))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('br')]),_vm._v(" "),((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse'))?_c('div',{staticClass:"row col-md-12"},[(_vm.product.product_service == 'S')?_c('div',{staticClass:"col-md-4 col-xs-3"},[_c('label',[_vm._v(" Service Tag\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_service_tag),expression:"product.product_item_service_tag"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_service_tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_service_tag", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Price\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_price),expression:"product.product_item_price"}],staticClass:"form-control",attrs:{"type":"number","value":"","placeholder":""},domProps:{"value":(_vm.product.product_item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Weight(KG)\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_weight),expression:"product.product_item_weight"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":""},domProps:{"value":(_vm.product.product_item_weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_weight", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v(" Quantity\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_quantity),expression:"product.product_item_quantity"}],staticClass:"form-control",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.product.product_item_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_quantity", $event.target.value)}}})])]),_vm._v(" "),(_vm.product.product_service == 'P')?_c('div',{staticClass:"col-md-3 col-xs-3"},[_c('label',[_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_item_size),expression:"product.product_item_size"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.product.product_item_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_item_size", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"data-error-message"},[_vm._v(_vm._s(_vm.data_error_message))]),_vm._v(" "),_c('p',{staticClass:"data-success-message"},[_vm._v(_vm._s(_vm.data_success_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"background":"#e7e8e9"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.addProductItem}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('h6',[_vm._v("DISCOUNTS AND COUPONS")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount)?_c('div',[_c('div',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"form-group"},[(_vm.product_details.setProductDiscount)?_c('label',[_vm._v("Set Product Coupon Or Discount")]):_vm._e(),_vm._v(" "),(_vm.product_details.setProductItemDiscount)?_c('label',[_vm._v("Set Product Item Coupon Or Discount")]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.is_discount_coupon),expression:"discount_coupon.is_discount_coupon"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.discount_coupon, "is_discount_coupon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"D"}},[_vm._v("Discount")]),_vm._v(" "),_c('option',{attrs:{"value":"C"}},[_vm._v("Coupon")])])]),_vm._v(" "),(((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1)))?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have an active Discount")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.setDiscountsAndCoupons()}}},[_vm._v("SET")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]),_vm._v(" "),_vm._m(26)]):_vm._e(),_vm._v(" "),(_vm.product_details.editDiscount)?_c('div',{staticClass:"col-md-12"},[_c('h5',{staticStyle:{"font-size":"13px"}},[_vm._v("Edit Discount")]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Percentage Discount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_percentage),expression:"discount_coupon.discount_percentage"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"100"},domProps:{"value":(_vm.discount_coupon.discount_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_percentage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Start Date: "+_vm._s(_vm.discount_coupon.discount_start_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_start_date),expression:"discount_coupon.discount_start_date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.discount_coupon.discount_start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_start_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("End Date: "+_vm._s(_vm.discount_coupon.discount_end_date))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount_coupon.discount_end_date),expression:"discount_coupon.discount_end_date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.discount_coupon.discount_end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.discount_coupon, "discount_end_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"2em"},attrs:{"disabled":_vm.disable_btn},on:{"click":function($event){_vm.editDiscountsAndCoupons()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])])]):_vm._e(),_vm._v(" "),(!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount)?_c('div',[_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('viewProductDiscounts','','')}}},[_vm._v("View Product Discounts and Coupons")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('viewProductItemsDiscounts','','')}}},[_vm._v("View Product Items Discounts and Coupons")])]):_vm._e(),_vm._v(" "),(_vm.product_details.viewCoupons)?_c('div',{staticStyle:{"margin-top":"2em","border":"#e9e6e6 dashed 1px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('h6',{staticClass:"pull-left",staticStyle:{"text-transform":"uppercase","font-size":"14px"}},[_vm._v("Item Coupons and Discounts")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny pull-right",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[(_vm.product_item.product_item_group_is_color_image == 'IMG')?_c('li',[((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image  != 'error')))?_c('img',{staticStyle:{"height":"30px"},attrs:{"src":_vm.product_item.product_item_group_image}}):_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(_vm.product_item.product_item_group_is_color_image == 'COL')?_c('li',[_c('a',{staticClass:"btn box-color-cube",style:({background: _vm.product_item.product_item_group_color})})]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P'  && (_vm.product_item.product_item_size))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(_vm.product_item.product_item_size))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('li',[_c('span',[_vm._v("w(kg):")]),_vm._v(_vm._s(_vm.product_item.product_item_weight))]):_vm._e(),_vm._v(" "),_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(_vm.product_item.product_item_actual_price))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Qty:")]),_vm._v(_vm._s(_vm.product_item.product_item_quantity))]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('hr')]),_vm._v(" "),_vm._l((_vm.product_item.product_item_discounts),function(dc){return _c('div',[(dc.discount_type == 5)?_c('div',[_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setProductComponent('editDiscount','',dc)}}},[_vm._v("\r\n                                  Edit Discount")]),_vm._v("    \r\n                                "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.setProductComponent('deactivateDiscount',_vm.product_item,dc)}}},[_vm._v("\r\n                                  Deactivate Discount")])]):_vm._e(),(_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id))?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p')]),_vm._v(" "),_c('hr')]):_vm._e()])}),_vm._v(" "),_c('div',[(_vm.product_item.product_item_only_coupon_discount_count == 0)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("No set discount or coupon")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setProductComponent('setProductItemDiscount','productitem',_vm.product_item)}}},[_vm._v("Set New Item Discount Or Coupon")])])],2):_vm._e(),_vm._v(" "),(_vm.product_details.viewProductItemsDiscounts)?_c('div',{staticStyle:{"margin-top":"1em","border":"#0d022b dashed 1px"}},[_c('div',{staticStyle:{"margin":"1em"}},[_c('h6',{staticClass:"pull-left",staticStyle:{"text-transform":"uppercase","font-size":"14px"}},[_vm._v("Items in this Product")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny pull-right",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_vm._l((_vm.product.product_items),function(productItem){return _c('div',{staticStyle:{"border":"dashed #d1ddf1","padding":"5px","margin-bottom":"1em"}},[_c('div',{staticClass:"items-list-tiny",staticStyle:{"display":"inline"}},[(productItem.product_item_group_is_color_image == 'IMG')?_c('li',[((productItem.product_item_group_image && (productItem.product_item_group_image  != 'error')))?_c('img',{staticStyle:{"height":"30px"},attrs:{"src":productItem.product_item_group_image}}):_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/static/assets/images/dummy-image.png"}})]):_vm._e(),_vm._v(" "),(productItem.product_item_group_is_color_image == 'COL')?_c('li',[_c('a',{staticClass:"btn box-color-cube",style:({background: productItem.product_item_group_color})})]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P'  && (productItem.product_item_size))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(productItem.product_item_size))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'S' && (productItem.product_item_service_tag))?_c('li',{staticClass:"box-wrap"},[_vm._v(_vm._s(productItem.product_item_service_tag))]):_vm._e(),_vm._v(" "),(_vm.product.product_service == 'P')?_c('li',[_c('span',[_vm._v("w(kg):")]),_vm._v(_vm._s(productItem.product_item_weight))]):_vm._e(),_vm._v(" "),_c('li',[_c('span',[_vm._v("Price:")]),_vm._v(_vm._s(productItem.product_item_actual_price))]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Qty:")]),_vm._v(_vm._s(productItem.product_item_quantity))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id))?_c('div',{staticStyle:{"display":"none"}},[_c('div',[_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setProductComponent('setProductItemDiscount','productitem',productItem)}}},[_vm._v("Set New Item Discount Or Coupon")])]),_vm._v(" "),_vm._l((productItem.product_item_discounts),function(dc){return _c('div',[_c('div',[((dc.discount_type == 5))?_c('p',[_c('b',[_vm._v("Product Item Discount")])]):_vm._e(),_vm._v(" "),((dc.discount_type == 4))?_c('p',[_c('b',[_vm._v("General Product Discount")])]):_vm._e(),_vm._v(" "),(!(dc.discount_type == 4) && !(dc.discount_type == 5))?_c('p',[_c('b',[_vm._v("General Sellpoint Discount")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setProductComponent('editDiscount','',dc)}}},[_vm._v("\r\n                                    Edit Discount")]),_vm._v("    \r\n                                  "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.setProductComponent('deactivateDiscount',productItem,dc)}}},[_vm._v("\r\n                                    Deactivate Discount")])]):_vm._e(),(_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id))?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p')]):_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Edit/Deactivate at Business Settings")]),_vm._v(" "),_c('hr')])])}),_vm._v(" "),_c('div',[(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("No set discount or coupon")]):_vm._e()])],2):_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('viewCoupons','productitem',productItem)}}},[_vm._v("View Coupons and Discounts")])])})],2):_vm._e(),_vm._v(" "),(_vm.product_details.viewProductDiscounts)?_c('div',{staticStyle:{"margin-top":"2em"}},[(_vm.product.product_items[0])?_c('div',[_c('div',{staticStyle:{"margin":"5px"}},[_c('h6',{staticClass:"pull-left",staticStyle:{"text-transform":"uppercase","font-size":"14px"}},[_vm._v("Product Coupons and Discounts")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs v-tiny-btn admin-btn-tiny pull-right",staticStyle:{"line-height":"1.2"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Close")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_vm._l((_vm.product.product_items[0].product_item_discounts),function(dc){return _c('div',[((dc.discount_type == 4))?_c('div',[_c('div',{staticStyle:{"background":"#d1ddf1","text-align":"center"}},[(dc.discount_coupon == 'D')?_c('p',[_c('b',[_vm._v("Discount")])]):_vm._e(),_vm._v(" "),(dc.discount_coupon == 'C')?_c('p',[_c('b',[_vm._v("Coupon:")]),_vm._v(" (Code: "+_vm._s(dc.discount_coupon_code)+" )")]):_vm._e()]),_vm._v(" "),_c('p',[_c('b',[_vm._v("%Discount: ")]),_vm._v(_vm._s(dc.discount_percentage)+"%")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Start Date: ")]),_vm._v(_vm._s(dc.discount_start_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("End Date: ")]),_vm._v(_vm._s(dc.discount_end_date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Status: ")]),_vm._v(_vm._s(dc.discount_status))]),_vm._v(" "),((dc.discount_type == 4) || (dc.discount_type == 5))?_c('div',[(dc.discount_status_id == 5)?_c('p',[_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"Edit"},on:{"click":function($event){_vm.setProductComponent('editDiscount','',dc)}}},[_vm._v("\r\n                                    Edit Discount")]),_vm._v("    \r\n                                  "),_c('a',{staticStyle:{"cursor":"pointer","text-decoration":"underline","font-size":"13px","color":"#448aff"},attrs:{"title":"De-Activate"},on:{"click":function($event){_vm.setProductComponent('deactivateDiscount',_vm.product.product_items[0],dc)}}},[_vm._v("\r\n                                    Deactivate Discount")])]):_vm._e(),(_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id))?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p')]):_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Edit/Deactivate at Business Settings")]),_vm._v(" "),_c('hr')]):_vm._e()])}),_vm._v(" "),(_vm.product.product_only_coupon_discount_count == 0)?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("No set discount or coupon")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn-tiny",staticStyle:{"line-height":"2em"},on:{"click":function($event){_vm.setProductComponent('setProductDiscount','','')}}},[_vm._v("Set New Product Discount Or Coupon")])]):_vm._e()]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('div',[_c('h6',[_vm._v("DELIVERY & RETURNS INFORMATION")]),_vm._v(" "),(_vm.product_details.edit_product_delivery)?_c('div',{},[_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.product_delivery_returns),expression:"product.product_delivery_returns"}],domProps:{"value":(_vm.product.product_delivery_returns)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "product_delivery_returns", $event.target.value)}}}),_c('br'),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.disable_btn,"type":"submit"},on:{"click":function($event){_vm.setProductDelivery()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("submit")]),_vm._v(" "),_c('button',{attrs:{"type":"btn"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" cancel")])])]):_c('div',[_c('p',{staticStyle:{"color":"#ff0000","line-height":"1.2","font-size":"13px"}},[_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                      "),(_vm.product.product_delivery_returns)?_c('span',[_vm._v(_vm._s(_vm.product.product_delivery_returns))]):_vm._e(),_c('br'),_vm._v(" "),_c('button',{staticStyle:{"font-size":"13px"},attrs:{"type":"btn admin-btn","title":"Edit"},on:{"click":function($event){_vm.setProductComponent('edit_product_delivery','','')}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Set Delivery & Return Information")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{},[_c('h6',{staticClass:"margin-t-40"},[_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_set_shipping_fee_status),expression:"product_set_shipping_fee_status"}],attrs:{"type":"radio","id":"12","value":"12"},domProps:{"checked":_vm._q(_vm.product_set_shipping_fee_status,"12")},on:{"click":function($event){_vm.setProductShippingFeeStatus()},"change":function($event){_vm.product_set_shipping_fee_status="12"}}}),_vm._v(" "),_c('span',[_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]),_vm._v(" "),_c('span',[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product_set_shipping_fee_status),expression:"product_set_shipping_fee_status"}],attrs:{"type":"radio","id":"13","value":"13"},domProps:{"checked":_vm._q(_vm.product_set_shipping_fee_status,"13")},on:{"click":function($event){_vm.setProductShippingFeeStatus()},"change":function($event){_vm.product_set_shipping_fee_status="13"}}}),_vm._v(" "),_c('span',[_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]),_vm._v(" "),(_vm.set_shipping_fee_status_track && _vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('br'),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('h6',[_vm._v("Product Delivery Location Fees")]),_vm._v(" "),((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0))?_c('div',[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("You have set some general delivery settings")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("You can set a different delivery fee for this product")]),_vm._v(" "),_vm._l((_vm.product.product_business_delivery_options),function(delivery){return _c('li',[_c('b',[_vm._v(_vm._s(delivery.business_delivery_option))]),_vm._v(" "),(delivery.business_products_delivery_fees.length > 0)?_c('span',_vm._l((delivery.business_products_delivery_fees),function(fee,fdex){return _c('span',[((fee.product_delivery_product == _vm.product.product_id))?_c('span',[_vm._v(" -  ₦"+_vm._s(fee.product_delivery_fee)+"\r\n                            ")]):_vm._e()])})):_c('span'),_vm._v(" "),(_vm.product_details.setProductDeliveryInformation && delivery.edit_set)?_c('div',{staticClass:"contact_form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Delivery Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(delivery.product_delivery_fee),expression:"delivery.product_delivery_fee"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(delivery.product_delivery_fee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(delivery, "product_delivery_fee", $event.target.value)}}}),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Business Set Shipping Fee: ₦"+_vm._s(delivery.business_delivery_option_price))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.product_details.setProductDeliveryInformation && _vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"disabled":_vm.disable_btn,"title":"save","type":"submit"},on:{"click":_vm.setProductDeliveryOption}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",staticStyle:{"line-height":"1.6","padding":"10px"},attrs:{"title":"cancel","type":"submit"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])])]):_vm._e(),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"10px"},attrs:{"type":"btn","title":"Set Product Delivery Fee"},on:{"click":function($event){_vm.setProductComponent('setProductDeliveryInformation',delivery)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Set Fee")])])})],2):_c('div',[_c('p',[_vm._v("You have not set your Business Delivery Locations")])])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.manageLookbooks)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"float":"left"}},[_c('h6',{staticStyle:{"margin-left":"1em","margin-right":"2em"}},[_vm._v("Lookbooks ("+_vm._s(_vm.sellpoint.business_total_gallery)+")")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.component_view.viewLookbooks)?_c('div',{staticStyle:{"width":"100%"}},[_c('div',{directives:[{name:"drag-and-drop",rawName:"v-drag-and-drop:options",value:(_vm.drag_options),expression:"drag_options",arg:"options"}]},[_c('ul',{staticClass:"row"},_vm._l((_vm.galleria),function(gallery,gndex){return _c('li',{key:gallery.gallery_posts_group_id,staticClass:"col-md-2 col-sm-3 col-xs-3"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',gallery,'viewLookbook')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(gallery.gallery_posts_group_posts_media.length > 0)?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":gallery.gallery_posts_group_posts_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(gallery.gallery_posts_group_posts.length)+" posts")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])}))]),_vm._v(" "),(_vm.galleria.length == 0)?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(27)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),(_vm.component_view.viewLookbook)?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('lookbooks','','viewLookbooks')}}},[_vm._v("<< Back ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row col-md-12",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-5 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))]),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 1)?_c('p',[_vm._v("Type: Posts Lookbook")]):_vm._e(),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 2)?_c('p',[_vm._v("Type: Product Lookbook")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","white-space":"pre-line"}},[_vm._v("Description: "+_vm._s(_vm.lookbook.gallery_posts_group_text))]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"float":"right"}},[_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('editLookbook','lookbook',_vm.lookbook)}}},[_vm._v("Edit Lookbook ")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('deleteLookbook','lookbook',_vm.lookbook)}}},[_vm._v("Delete ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),(_vm.lookbook_details.editLookbook)?_c('div',{staticClass:"row col-md-12"},[_c('h6',[_vm._v("Edit Lookbook")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" Lookbook Name\r\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook.gallery_posts_group_name),expression:"lookbook.gallery_posts_group_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.lookbook.gallery_posts_group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook, "gallery_posts_group_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" Details ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook.gallery_posts_group_text),expression:"lookbook.gallery_posts_group_text"}],staticClass:"form-control",staticStyle:{"width":"100%","height":"250px"},domProps:{"value":(_vm.lookbook.gallery_posts_group_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook, "gallery_posts_group_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editLookbook}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.lookbook_details.deleteLookbook)?_c('div',{staticClass:"row col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to delete this Lookbook?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.deleteLookbook}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),_c('hr')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 col-xs-12"},[_c('div',{staticClass:"row product-detail-card"},[_c('h5',{staticClass:"col-md-12"},[_vm._v("Posts in Lookbook")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.lookbook.gallery_posts_group_posts),function(post,pndex){return _c('div',{staticClass:"col-md-4 col-xs-4"},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',post,'viewLookbookPost')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(post.gallery_post_media && (post.gallery_post_media.length > 0))?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":post.gallery_post_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(post.gallery_post_caption))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])}),_vm._v(" "),(_vm.lookbook.gallery_posts_group_posts.length == 0)?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(28)]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),(_vm.component_view.viewLookbookPost)?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setComponentView('lookbooks',_vm.lookbook,'viewLookbook')}}},[_vm._v("<< Back ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row col-md-12",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"col-md-8 col-xs-12"},[_c('div',{staticClass:"product-detail-card"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"float":"right"}},[(_vm.lookbook.gallery_posts_group_type == 1)?_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('editLookbookPost','postlookbook',_vm.lookbook_post)}}},[_vm._v("Edit Post ")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('deleteLookbookPost','postlookbook',_vm.lookbook_post)}}},[_vm._v("Delete Post ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 2)?_c('div',[_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('viewProductLookbookPost','productlookbook',_vm.lookbook_post)}}},[_vm._v("Edit Product Post")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.setLookbookComponent('deleteLookbookPost','postlookbook',_vm.lookbook_post)}}},[_vm._v("Delete Product Post ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v(_vm._s(_vm.lookbook_post.gallery_post_caption))]),_vm._v(" "),_c('p',[_vm._v("Description: "+_vm._s(_vm.lookbook_post.gallery_post_details))]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.lookbook_details.editLookbookPost)?_c('div',{staticClass:"row col-md-12"},[_c('h6',[_vm._v("Edit Post")]),_vm._v(" "),_c('form',{staticClass:"sp-forms-one"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" *Post Caption\r\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook_post.gallery_post_caption),expression:"lookbook_post.gallery_post_caption"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.lookbook_post.gallery_post_caption)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook_post, "gallery_post_caption", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(" *Post Details\r\n                            "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookbook_post.gallery_post_details),expression:"lookbook_post.gallery_post_details"}],staticClass:"form-control",domProps:{"value":(_vm.lookbook_post.gallery_post_details)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lookbook_post, "gallery_post_details", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":_vm.editLookbookPost}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn admin-btn col-md-4",staticStyle:{"line-height":"1.2","margin-right":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.lookbook_details.deleteLookbookPost)?_c('div',{staticClass:"row col-md-12"},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Do you really want to delete this Post?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",attrs:{"disabled":_vm.disable_btn},on:{"click":_vm.deleteLookbookPost}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs admin-btn-tiny",on:{"click":function($event){_vm.setComponent('reset-edit','')}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("Post Images")]),_vm._v(" "),((_vm.lookbook_post.gallery_post_media) && (_vm.lookbook_post.gallery_post_media.length > 0))?_c('div',{staticClass:"row img-row",staticStyle:{"margin-bottom":"5px"}},[_vm._l((_vm.lookbook_post.gallery_post_media),function(pm){return _c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"0","border":"#eeccee 1px solid"}},[_c('div',{staticClass:"img-row"},[(_vm.lookbook_post.gallery_post_media && (_vm.lookbook_post.gallery_post_media.length > 0))?_c('div',{staticClass:"img-column",staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"col-xs-8",staticStyle:{"z-index":"1"}},[(_vm.checkIfVideo(pm.gallery_post_media))?_c('div',[_c('img',{staticClass:"sp-prd-img",staticStyle:{"z-index":"1","height":"50px","width":"80px"},attrs:{"src":"/static/assets/images/video-placeholder.png"}})]):_c('div',[((pm.gallery_post_media && (pm.gallery_post_media != 'error')))?_c('img',{staticClass:"img-1 sp-prd-img",staticStyle:{"z-index":"1","height":"50px","width":"80px"},attrs:{"src":pm.gallery_post_media}}):_c('img',{staticStyle:{"z-index":"1","height":"50px","width":"80px"},attrs:{"src":"/static/assets/images/dummy-image.png"}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 1)?_c('a',{staticClass:"col-xs-2 btn pull-right",staticStyle:{"z-index":"9","margin-top":"4em","font-size":"10px","padding":"6px"},attrs:{"type":"button"},on:{"click":function($event){_vm.deletePostImage(pm.gallery_post_media_id)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2):_vm._e(),_vm._v(" "),(_vm.lookbook.gallery_posts_group_type == 1)?_c('div',{staticClass:"upload-btn-wrapper",staticStyle:{"cursor":"pointer"}},[(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_processing_message))]),_vm._v(" "),_c('button',{staticClass:"upload-btn",staticStyle:{"line-height":"0.6","font-size":"12px"}},[_vm._v("Add new Media")]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-file","accept":"image/*,video/*"},on:{"change":function($event){_vm.onFileChangeLookbook($event,'gallery_media',_vm.lookbook_post.gallery_post_id)}}})]):_vm._e(),_vm._v(" "),_c('hr')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"row product-detail-card"},[_c('h5',{staticClass:"col-md-12"},[_vm._v("Other Posts in \r\n                  "),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',_vm.lookbook,'viewLookbook')}}},[_c('u',[_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))])]),_vm._v(" Lookbook")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.lookbook.gallery_posts_group_posts),function(post,pndex){return _c('div',{staticClass:"col-md-6 col-xs-6"},[(post.gallery_post_id != _vm.lookbook_post.gallery_post_id)?_c('div',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponentView('lookbooks',post,'viewLookbookPost')}}},[_c('div',{staticClass:"info-card info-card-lookbook"},[_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-lookbook-row"},[_c('div',{},[(post.gallery_post_media && (post.gallery_post_media.length > 0))?_c('div',{staticClass:"info-card-lookbook-image",staticStyle:{"margin":"5px"}},[(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media))?_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/video-placeholder.png"}}):_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":post.gallery_post_media[0].gallery_post_media}})]):_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{staticClass:"sp-prd-img-cs",attrs:{"src":"/static/assets/images/dummy-image.png","alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"0.8"}},[_c('p',[_vm._v(_vm._s(post.gallery_post_caption))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])]):_vm._e()])}),_vm._v(" "),(_vm.lookbook.gallery_posts_group_posts && (_vm.lookbook.gallery_posts_group_posts.length == 0))?_c('div',{staticStyle:{"margin":"1em"}},[_vm._m(29)]):_vm._e()],2)])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.managePosts)?_c('div',{staticClass:"container"}):_vm._e(),_vm._v(" "),(_vm.manageOrders)?_c('div',{staticClass:"container"}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-box clearfix"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/assets/images/logo.png","alt":"Gallery"}})]),_vm._v(" "),_c('button',{staticClass:"menu-toggler",attrs:{"data-target":"#main-nav-bar"}},[_c('span',{staticClass:"fa fa-bars"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"float":"left"}},[_c('i',{staticClass:"fa fa-briefcase info-profile"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('h5',[_vm._v("Lookbooks")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your Gallery is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Lookbooks to your gallery")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',{staticStyle:{"text-align":"center"}},[_c('i',{staticClass:"fa fa-bell"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"slide-0",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-1",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-2",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-3",staticStyle:{"display":"none"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"slide-2"},[_c('p',{staticClass:"text-slide"},[_vm._v("We hope you love your lookbook Gallery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"slide-3"},[_c('p',{staticClass:"text-slide"},[_vm._v("Welcome to your lookbook Gallery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-slider-arrow-prev"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-slider-arrow-next"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-slider-dot"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-slide"},[_c('div',{staticClass:"pc-slider"},[_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-0","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-1","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-2","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide input-slide-num",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-3","type":"radio"}}),_vm._v(" "),_c('input',{staticClass:"input-slide",staticStyle:{"display":"none"},attrs:{"name":"input-slider","id":"input-slide-autoplay","type":"radio","checked":""}}),_vm._v(" "),_c('ul',[_c('li',{staticClass:"slide-0",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-1",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-2",staticStyle:{"display":"none"}}),_vm._v(" "),_c('li',{staticClass:"slide-3",staticStyle:{"display":"none"}})]),_vm._v(" "),_c('div',{staticClass:"slide-description"},[_c('label',{staticClass:"slide-0"},[_c('p',{staticClass:"text-slide"},[_vm._v("If you have any issues setting up your Gallery Lookbooks, please do not hesitate to contact support")])]),_vm._v(" "),_c('label',{staticClass:"slide-1"},[_c('p',{staticClass:"text-slide"},[_vm._v("Upgrade or Customize your account to unlock more features")])]),_vm._v(" "),_c('label',{staticClass:"slide-2"},[_c('p',{staticClass:"text-slide"},[_vm._v("We hope you love your lookbook Gallery")])]),_vm._v(" "),_c('label',{staticClass:"slide-3"},[_c('p',{staticClass:"text-slide"},[_vm._v("Welcome to your lookbook Gallery")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"pc-slider-arrow-prev"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})]),_vm._v(" "),_c('div',{staticClass:"pc-slider-arrow-next"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})]),_vm._v(" "),_c('div',{staticClass:"pc-slider-dot"},[_c('label',{staticClass:"slide-0",attrs:{"for":"input-slide-0"}}),_vm._v(" "),_c('label',{staticClass:"slide-1",attrs:{"for":"input-slide-1"}}),_vm._v(" "),_c('label',{staticClass:"slide-2",attrs:{"for":"input-slide-2"}}),_vm._v(" "),_c('label',{staticClass:"slide-3",attrs:{"for":"input-slide-3"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',[_vm._v("CONTACT DETAILS")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',[_vm._v("SUBSCRIPTION STATUS")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"margin":"0","padding":"0"}},[_c('div',{staticClass:"manage-action-block"},[_c('h5',[_vm._v("Your Subscription is Active ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","color":"inherit"}},[_c('p',[_vm._v("Would you love to Customize your Gallery? "),_c('a',{staticClass:"btn",staticStyle:{"background":"#ff0055","color":"#ffffff"},attrs:{"href":"/customize"}},[_vm._v("Talk to your Web Gallery Assistant")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"row info-card-inner-row"},[_c('h5',[_vm._v("SETTINGS")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row info-card-inner-row"},[_c('a',{staticClass:"btn",staticStyle:{"cursor":"pointer","background":"#f1dee4","padding":"1em","color":"#000"},attrs:{"href":"login"}},[_vm._v("Logout from Account")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col",staticStyle:{"margin-top":"5em","margin-bottom":"5em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"loading-md"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("View and Update Business Details")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("Set Business Delivery and Shipping Information")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("Set Business Coupons and Vouchers")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card info-card-mini"},[_c('div',{staticClass:"info-card-header"},[_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"container info-card-body"},[_c('div',{staticClass:"info-card-row info-card-mini-row"},[_c('p',[_vm._v("Connect to your Business Payment Receival Portal")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',[_vm._v("Your Sellpoint's Delivery Information")]),_vm._v(" "),_c('p',{staticClass:"p-tiny",staticStyle:{"color":"#ff0000"}},[_vm._v("This is the general shipping Information that would be shown to buyers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('p',{staticStyle:{"color":"#363535","font-size":"14px"}},[_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                button.\r\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('p',{staticStyle:{"color":"#363535","line-height":"1.2"}},[_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                          If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your Gallery is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Lookbooks to your gallery")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This Lookbook is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Posts to your lookbook")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This Lookbook is empty, click on "),_c('b',[_vm._v("Manage")]),_vm._v(" to add Posts to your lookbook")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__ = __webpack_require__(234);





/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__["a" /* default */],
    children: [{
        path: '/cart',
        name: 'Cart',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__["a" /* default */]
    }, {
        path: '/checkout',
        name: 'Checkout',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__["a" /* default */]
    }, {
        path: '/checkout/:ckid',
        name: 'CheckoutOrderURL',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__["a" /* default */]
    }, {
        path: '/orders',
        name: 'Orders',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__["a" /* default */]
    }, {
        path: '/order',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__["a" /* default */]
    }]
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82e8810a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(218);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82e8810a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82e8810a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('component-header'),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('section',{attrs:{"id":"banner"}},[_c('div',{staticClass:"row"},[_c('router-view')],1)])]),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7b47fd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(227);
function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7b47fd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7b47fd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.path == '/cart')?_c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cart-summ"},[_c('div',{staticClass:" cart-summ-card-left card col-sm-1",staticStyle:{"float":"left"}},[_c('p',{staticStyle:{"text-align":"center"}},[_c('b',[_vm._v(_vm._s(_vm.cart.length)),_c('br'),_vm._v("items")])])]),_vm._v(" "),_c('div',{staticClass:" cart-summ-card-right card col-md-8",staticStyle:{"float":"right"}},[_vm._m(1),_vm._v(" "),_c('li',[_vm._v("₦"+_vm._s(_vm.total_order_amt))]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Shipping Fee: ")]),_vm._v("₦"+_vm._s(_vm.total_delivery_fee))]),_vm._v(" "),_c('li',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.process_orders()}}},[_vm._v("Process Orders")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12  text-center",staticStyle:{"background":"#ffffff"}},_vm._l((_vm.sorted_cart),function(group,index){return _c('div',{staticClass:"row group-row",staticStyle:{"margin-bottom":"6em"}},[_c('h5',{attrs:{"align":"left"}},[_vm._v(_vm._s(group[0])+"'s Sellpoint")]),_c('br'),_vm._v(" "),_c('div',{},[_vm._l((group[1]),function(item,index2){return _c('ul',{staticClass:"row cart-details"},[_c('li',{staticClass:"col-md-6 col-sm-12"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('div',{staticClass:"pull-left"},[(item.product_checked)?_c('button',{staticClass:"btn order-btn",on:{"click":function($event){_vm.removeFromCheckout(item,index,index2)}}},[_c('del',[_vm._v("Selected")])]):_c('button',{staticClass:"btn order-btn",on:{"click":function($event){_vm.addToCheckout(item,index,index2)}}},[_vm._v("Select "),_c('br'),_vm._v("Order")])]),_vm._v(" "),_c('a',{staticClass:"item-img cart-img",staticStyle:{"cursor":"pointer"},attrs:{"href":item.product_url}},[((item.product_item_image && (item.product_item_image != '')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":_vm.img_product_url + item.product_item_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('h5',[_vm._v(_vm._s(item.product_name))])])]),_vm._v(" "),_c('li',{staticClass:"col-sm-1"},[_c('div',{},[_c('div',{staticClass:"quinty"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.product_item_order_quantity),expression:"item.product_item_order_quantity"}],staticStyle:{"max-width":"52px","max-height":"32px"},attrs:{"type":"number"},domProps:{"value":(item.product_item_order_quantity)},on:{"change":function($event){_vm.refreshCheckout(item,index,index2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "product_item_order_quantity", $event.target.value)}}})])])]),_vm._v(" "),_c('li',{staticClass:"col-sm-2"},[_c('div',{},[_c('label',{staticStyle:{"display":"inline"}},[_vm._v("Price: ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(item.product_item_price))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{staticStyle:{"display":"inline"}},[_vm._v("Total: ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])])]),_vm._v(" "),_c('li',{staticClass:"col-sm-2"},[(group.selected_business_delivery_option && item.product_checked)?_c('p',[(!group.selected_business_delivery_option.has_product_delivery_fee)?_c('span',_vm._l((group.selected_business_delivery_option.business_products_delivery_fees),function(pd_fee){return _c('span',[(item.product_main_id == pd_fee.product_delivery_product)?_c('span',[_vm._v("\r\n                          ₦"+_vm._s(pd_fee.product_delivery_fee)+"\r\n                      ")]):_vm._e()])})):_vm._e()]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"col-sm-1"},[(item.can_remove)?_c('div',{},[_c('label',[_vm._v("Remove: ")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","background":"#000000","color":"#ffffff"},on:{"click":function($event){_vm.removeFromCart(item._id,index,item)}}},[_c('i',{staticClass:"fa fa-close"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],2),_vm._v(" "),(group.items_in_checkout > 0)?_c('div',{staticClass:"row"},[(group.items_in_checkout > 0)?_c('div',[(group[4])?_c('div',{staticClass:"pull-left coupons-sec"},[_vm._m(2,true),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_vm._l((group[4]),function(coupon){return _c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coupon_code),expression:"coupon_code"}],attrs:{"type":"checkbox"},domProps:{"value":coupon.discount_id,"checked":Array.isArray(_vm.coupon_code)?_vm._i(_vm.coupon_code,coupon.discount_id)>-1:(_vm.coupon_code)},on:{"click":function($event){_vm.set_coupons(index,coupon,coupon.discount_percentage)},"change":function($event){var $$a=_vm.coupon_code,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=coupon.discount_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.coupon_code=$$a.concat([$$v]))}else{$$i>-1&&(_vm.coupon_code=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.coupon_code=$$c}}}}),_vm._v(" "+_vm._s(coupon.discount_coupon_code)+" - "+_vm._s(coupon.discount_percentage)+"% Off "),_c('b',[_vm._v("From "+_vm._s(coupon.discount_provider))])])})],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pull-right"},[(group.products_without_delivery_details_count >= 1)?_c('div',[(group[2])?_c('div',[(group[2].length != 0 && !group.delivery_option)?_c('span',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Please select a delivery option"),_c('br')]):_vm._e(),_vm._v(" "),(group[2].length != 0)?_c('div',[_c('div',{staticClass:"dropdown"},[(group.selected_business_delivery_option)?_c('button',{staticClass:"dropbtn"},[(group.selected_business_delivery_option.has_product_delivery_fee)?_c('span',[_vm._v("\r\n                        "+_vm._s(group.selected_business_delivery_option.business_delivery_option)+" -  ₦"+_vm._s(group.selected_business_delivery_option.business_product_delivery_fee)+"▼\r\n                      ")]):_c('span',[_vm._v("\r\n                          "+_vm._s(group.selected_business_delivery_option.business_delivery_option)+" -  ₦"+_vm._s(group.selected_business_delivery_option.business_delivery_option_price)+"▼\r\n                      ")])]):_c('button',{staticClass:"dropbtn"},[_vm._v("Select Delivery Option "+_vm._s(group[0])+" Orders▼")]),_vm._v(" "),_c('div',{staticClass:"dropdown-content"},_vm._l((group[2]),function(option){return _c('div',[(option.business_delivery_product == 0)?_c('span',[_c('label',[((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0))?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint_delivery_fee),expression:"sellpoint_delivery_fee"}],attrs:{"type":"radio"},domProps:{"value":option.business_delivery_option_id,"checked":_vm._q(_vm.sellpoint_delivery_fee,option.business_delivery_option_id)},on:{"click":function($event){_vm.calc_sellpoint_delivery_fee(index,option)},"change":function($event){_vm.sellpoint_delivery_fee=option.business_delivery_option_id}}})]):_vm._e(),_vm._v(" "),(option.has_product_delivery_fee)?_c('span',[_vm._v("\r\n                              "+_vm._s(option.business_delivery_option)+" -  ₦"+_vm._s(option.business_product_delivery_fee)+"\r\n                            ")]):_c('span',[_vm._v("\r\n                              "+_vm._s(option.business_delivery_option)+" -  ₦"+_vm._s(option.business_delivery_option_price)+"\r\n                            ")])])]):_vm._e()])}))])]):_c('div',[_c('p',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Free Delivery")])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',[_c('p',{staticClass:"tiny-part"},[_vm._v("Total Orders from "),_c('b',[_vm._v(_vm._s(group[0])+":")]),_vm._v(" ₦"+_vm._s(group.total_order_amt))]),_vm._v(" "),(group[2])?_c('span',[_c('p',{staticClass:"tiny-part"},[_vm._v("Shipping Fee:  ₦"+_vm._s(group.total_delivery_charge))]),_vm._v(" "),_c('p',{staticClass:"tiny-part"},[_vm._v("Total: ₦"+_vm._s(group.total_order_amt + group.total_delivery_charge))])]):_c('span',[_c('p',{staticClass:"tiny-part"},[_c('b',[_vm._v("Shipping Details:")]),_vm._v(" "+_vm._s(group.delivery_option))])]),_vm._v(" "),(group[3])?_c('div',{staticClass:"row"},[_vm._m(4,true),_vm._v(" "),(!group.payment_mode)?_c('span',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Please select a payment option"),_c('br')]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_option),expression:"payment_option"}],attrs:{"type":"radio","value":"pay_on_delivrey"},domProps:{"checked":_vm._q(_vm.payment_option,"pay_on_delivrey")},on:{"click":function($event){_vm.setPaymentOption(index,2)},"change":function($event){_vm.payment_option="pay_on_delivrey"}}}),_c('label',[_vm._v("Pay On Delivery")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_option),expression:"payment_option"}],attrs:{"type":"radio","value":"pay_now"},domProps:{"checked":_vm._q(_vm.payment_option,"pay_now")},on:{"click":function($event){_vm.setPaymentOption(index,1)},"change":function($event){_vm.payment_option="pay_now"}}}),_c('label',[_vm._v("Pay Now")])]):_c('div',{staticClass:"row"},[_vm._m(5,true)]),_vm._v(" "),(_vm.buy_now_order && (_vm.checked_out.length != 0))?_c('div',{staticClass:"text-align"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"background":"#000000"},on:{"click":function($event){_vm.process_orders()}}},[_vm._v("Process Orders")])]):_vm._e()])])]):_vm._e()])})),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.buy_now_order)?_c('div',[(_vm.checked_out.length != 0)?_c('div',{staticClass:"col-sm-12 orders-panel pull-right",staticStyle:{"margin-bottom":"2em"}},[_c('span',{staticClass:"col-sm-3"},[_c('h5',[_vm._v("Your Orders")]),_vm._v(" "),_c('p',[_vm._v("₦"+_vm._s(_vm.total_order_amt))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Shipping Fee: ")]),_vm._v("₦"+_vm._s(_vm.total_delivery_fee))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.process_orders()}}},[_vm._v("Process Orders")])])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(this.$route.path == '/order')?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12",staticStyle:{"background":"#ffffff"}},[_c('h2',{attrs:{"align":"center"}},[_vm._v("Process your Order")]),_vm._v(" "),_vm._l((_vm.sorted_cart),function(group,index){return _c('div',{staticClass:"row group-row",staticStyle:{"margin-top":"4em","margin-bottom":"6em"}},_vm._l((group[1]),function(item,index2){return _c('ul',{staticClass:"col-md-8 col-md-offset-4 col-sm-12"},[(item.active_order)?_c('div',[_c('div',[_c('li',{staticClass:"col-md-4 col-sm-12"},[_c('div',{},[_c('a',{staticClass:"item-img cart-img",staticStyle:{"cursor":"pointer"},attrs:{"href":item.product_url}},[((item.product_item_image && (item.product_item_image != '')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":_vm.img_product_url + item.product_item_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})])])]),_vm._v(" "),_c('li',{staticClass:"col-md-8"},[_c('div',{},[_c('h4',[_vm._v(_vm._s(item.product_name))]),_vm._v(" "),_c('label',{staticStyle:{"display":"inline"}},[_vm._v("Price: ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(item.product_item_price))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"quinty"},[_c('label',{staticStyle:{"display":"inline"}},[_vm._v("Qty: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.product_item_order_quantity),expression:"item.product_item_order_quantity"}],staticStyle:{"max-width":"52px","max-height":"32px"},attrs:{"type":"number"},domProps:{"value":(item.product_item_order_quantity)},on:{"change":function($event){_vm.refreshCheckout(item,index,index2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "product_item_order_quantity", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"display":"inline"}},[_vm._v("Total: ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])]),_vm._v(" "),_c('div',[(item.product_checked)?_c('a',{staticClass:"btn order-btn",staticStyle:{"margin-top":"3px","float":"right"},attrs:{"href":"/"}},[_vm._v("Cancel Order")]):_c('button',{staticClass:"btn order-btn",on:{"click":function($event){_vm.addToCheckout(item,index,index2)}}},[_vm._v("Process Order")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":item.index2+'PRT_CART'}},[(group.items_in_checkout > 0)?_c('div',{staticClass:"col-md-4"},[(group[4] && (group[4].length > 0))?_c('div',{},[_vm._m(6,true),_vm._v(" "),_vm._m(7,true),_vm._v(" "),_vm._l((group[4]),function(coupon){return _c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coupon_code),expression:"coupon_code"}],attrs:{"type":"checkbox"},domProps:{"value":coupon.discount_id,"checked":Array.isArray(_vm.coupon_code)?_vm._i(_vm.coupon_code,coupon.discount_id)>-1:(_vm.coupon_code)},on:{"click":function($event){_vm.set_coupons(index,coupon,coupon.discount_percentage)},"change":function($event){var $$a=_vm.coupon_code,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=coupon.discount_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.coupon_code=$$a.concat([$$v]))}else{$$i>-1&&(_vm.coupon_code=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.coupon_code=$$c}}}}),_vm._v(" "+_vm._s(coupon.discount_coupon_code)+" - "+_vm._s(coupon.discount_percentage)+"% Off "),_c('b',[_vm._v("From "+_vm._s(coupon.discount_provider))])])})],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(group.products_without_delivery_details_count >= 1)?_c('div',[(group[2])?_c('div',[(group[2].length != 0 && !group.delivery_option)?_c('span',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Please select a delivery option"),_c('br')]):_vm._e(),_vm._v(" "),(group[2].length != 0)?_c('div',[_c('div',{staticClass:"dropdown"},[(group.selected_business_delivery_option)?_c('button',{staticClass:"dropbtn"},[_vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option)+" -  ₦"+_vm._s(group.selected_business_delivery_option.business_delivery_option_price)+"▼")]):_c('button',{staticClass:"dropbtn"},[_vm._v("Select Delivery Location▼")]),_vm._v(" "),_c('div',{staticClass:"dropdown-content"},_vm._l((group[2]),function(option){return _c('div',[(option.business_delivery_product == 0)?_c('span',[_c('label',[((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0))?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sellpoint_delivery_fee),expression:"sellpoint_delivery_fee"}],attrs:{"type":"radio"},domProps:{"value":option.business_delivery_option_id,"checked":_vm._q(_vm.sellpoint_delivery_fee,option.business_delivery_option_id)},on:{"click":function($event){_vm.calc_sellpoint_delivery_fee(index,option)},"change":function($event){_vm.sellpoint_delivery_fee=option.business_delivery_option_id}}})]):_vm._e(),_vm._v("\r\n                                  "+_vm._s(option.business_delivery_option)+" -  ₦"+_vm._s(option.business_delivery_option_price)+"\r\n                                ")])]):_vm._e()])}))])]):_c('div',[_c('p',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Free Delivery")])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',[(group[2])?_c('span',[_c('p',{staticClass:"tiny-part"},[_vm._v("Shipping Fee:  ₦"+_vm._s(group.total_delivery_charge))]),_vm._v(" "),_c('p',{staticClass:"tiny-part"},[_vm._v("Total: ₦"+_vm._s(group.total_order_amt + group.total_delivery_charge))])]):_c('span',[_c('p',{staticClass:"tiny-part"},[_c('b',[_vm._v("Shipping Details:")]),_vm._v(" "+_vm._s(group.delivery_option))])]),_vm._v(" "),(group[3])?_c('div',{},[_vm._m(8,true),_vm._v(" "),(!group.payment_mode)?_c('span',{staticStyle:{"color":"#ff0000","font-size":"12px"}},[_vm._v("Please select a payment option"),_c('br')]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_option),expression:"payment_option"}],attrs:{"type":"radio","value":"pay_on_delivrey"},domProps:{"checked":_vm._q(_vm.payment_option,"pay_on_delivrey")},on:{"click":function($event){_vm.setPaymentOption(index,2)},"change":function($event){_vm.payment_option="pay_on_delivrey"}}}),_c('label',[_vm._v("Pay On Delivery")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_option),expression:"payment_option"}],attrs:{"type":"radio","value":"pay_now"},domProps:{"checked":_vm._q(_vm.payment_option,"pay_now")},on:{"click":function($event){_vm.setPaymentOption(index,1)},"change":function($event){_vm.payment_option="pay_now"}}}),_c('label',[_vm._v("Pay Now")])]):_c('div',{},[_vm._m(9,true)]),_vm._v(" "),(_vm.buy_now_order && (_vm.checked_out.length != 0))?_c('div',{staticClass:"text-align"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"background":"#000000"},on:{"click":function($event){_vm.process_orders()}}},[_vm._v("Proceed")])]):_vm._e()])])])]):_vm._e()])}))})],2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-summ",staticStyle:{"text-align":"center","width":"100%","margin-bottom":"2em"}},[_c('h3',{staticClass:"cart-title",attrs:{"align":"center"}},[_vm._v("Your Cart")]),_vm._v(" "),_c('p',{},[_vm._v("Checkout items from each sellpoint, then click *Process Orders* to continue.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Total to checkout")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Applied Coupons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"color":"#ff0000","font-size":"14px"}},[_vm._v("Please select coupons"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tiny-part"},[_c('b',[_vm._v("Payment Mode")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tiny-part"},[_vm._v("Payment Mode: "),_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v("Pay Now")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Applied Coupons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"color":"#ff0000","font-size":"14px"}},[_vm._v("Please select coupons"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tiny-part"},[_c('b',[_vm._v("Payment Mode")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tiny-part"},[_vm._v("Payment Mode: "),_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v("Pay Now")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-wrap-route sp-cart-wrap",staticStyle:{"width":"98.8%"},attrs:{"id":"wrap"}},[(_vm.loading)?_c('div',{attrs:{"id":"loader"}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('section',{staticStyle:{"border":"1px dashed #8a8787"}},[_c('div',{staticClass:"container"},[(!_vm.cart.length)?_c('div',{staticClass:"col-md-6 col-md-offset-3 col-sm-12 chart-card",staticStyle:{"margin-top":"2em"}},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_c('div',{staticClass:"col-sm-12 chart-card"},[_c('cart-widget')],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-center-center"},[_c('div',{staticClass:"ldr"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 pull-left"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"static/assets/images/empty-lonely-cart.gif"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('b',[_vm._v("I'm Lonely and Sad, please "),_c('a',{staticStyle:{"color":"rgb(252, 16, 75)"},attrs:{"href":"tour"}},[_vm._v("fill me up")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 pull-right",staticStyle:{"text-align":"center"}},[_c('h5',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._v("Your cart is sad and empty,")]),_vm._v(" "),_c('a',{staticClass:"btn",staticStyle:{"background":"rgb(252, 16, 75)","color":"#ffffff"},attrs:{"href":"tour"}},[_vm._v("Start Buying")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","font-size":"18px","margin-top":"6px"}},[_c('a',{staticStyle:{"color":"rgb(252, 16, 75)"},attrs:{"href":"login"}},[_vm._v("Login")]),_vm._v(" to see products you added to your cart")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99887da2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99887da2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99887da2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gw-info-wrap",staticStyle:{"background":"#ffffff"}},[(_vm.loading)?_c('div',{staticClass:"col-md-6 col-md-offset-4 col-xs-12"},[_c('div',{staticClass:"loading-md"})]):_c('div',[(!_vm.checkout_processed)?_c('div',{staticClass:"container",staticStyle:{"margin-top":"1em"}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Checkout")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"3em"}},[_c('p',{staticStyle:{"color":"#000000","margin-left":"10px"}},[_vm._v("Enter the details below to Checkout"),_c('br'),_vm._v(" "),(_vm.new_account)?_c('span',[_vm._v("Do you have a "),_c('b',[_vm._v("Buypoint Account? ")]),_vm._v(" "),_c('u',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('login','')}}},[_vm._v("Please Provide")])])]):_c('span',[_vm._v("Don't have a "),_c('b',[_vm._v("Buypoint Account? ")]),_vm._v(" "),_c('u',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setComponent('new-account','')}}},[_vm._v("Click Here")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 gw-left-pan"},[_c('div',{staticClass:"gw-form",staticStyle:{"margin-top":"-1em"}},[(_vm.new_account)?_c('form',{attrs:{"name":"","id":""}},[_c('div',{staticClass:"row"},[_c('h4',{staticStyle:{"margin":"1em 1em 2.2em 0.5em"}},[_vm._v("Personal Details")]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_name),expression:"user.user_name"}],staticClass:"form-control input-group-lg",attrs:{"type":"text","placeholder":"Your Name"},domProps:{"value":(_vm.user.user_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_email),expression:"user.user_email"}],staticClass:"form-control input-group-lg",attrs:{"type":"text","placeholder":"Your Email"},domProps:{"value":(_vm.user.user_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_phone),expression:"user.user_phone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Phone Number"},domProps:{"value":(_vm.user.user_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"-5em","display":"none"}},[_c('h4',{staticStyle:{"margin":"1em 1em 2.2em 0.5em"}},[_vm._v("Shipping Details")]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"-2em"}},[_c('label',[_vm._v("Select State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_shipping_details_state),expression:"user.user_shipping_details_state"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.user, "user_shipping_details_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"0.3em"}},[_c('label',[_vm._v("Shipping Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_shipping_details_address),expression:"user.user_shipping_details_address"}],staticClass:"form-control input-group-lg",attrs:{"type":"text","placeholder":"Shipping Address"},domProps:{"value":(_vm.user.user_shipping_details_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_shipping_details_address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.data_success_message)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_success_message))]):_vm._e(),_vm._v(" "),(_vm.data_error_message)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]):_vm._e(),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"background":"#000000"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.prep_process_checkout}},[_vm._v("Process Checkout")])])]):_c('form',{attrs:{"name":"","id":""}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h5',{staticStyle:{"margin":"1em 1em 3em 0.5em"}},[_vm._v("Enter your Buypoint Login Details Below")]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_email),expression:"user.user_email"}],staticClass:"form-control input-group-lg",attrs:{"type":"text","placeholder":"Your Email"},domProps:{"value":(_vm.user.user_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.user_password),expression:"user.user_password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Your Password"},domProps:{"value":(_vm.user.user_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "user_password", $event.target.value)}}})])]),_vm._v(" "),(_vm.data_success_message)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_success_message))]):_vm._e(),_vm._v(" "),(_vm.data_error_message)?_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v(_vm._s(_vm.data_error_message))]):_vm._e(),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"background":"#000000"},attrs:{"disabled":_vm.disable_btn,"type":"button"},on:{"click":_vm.login}},[_vm._v("Process Checkout")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7 gw-right-pan"},[_c('div',{staticClass:"gw-right-pan",staticStyle:{"margin":"-5em 0 0 1em"}},[_c('h4',{staticStyle:{"margin":"1em","text-transform":"uppercase","font-weight":"500"}},[_vm._v("Items to Checkout")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"1em","padding":"1em","border":"#000000 solid 1px"}},_vm._l((_vm.checkout_orders),function(group,index){return _c('div',{staticClass:"group-row",staticStyle:{"margin-bottom":"6em"}},_vm._l((group.order_items),function(item){return _c('div',{staticClass:"row cart-details"},[_c('div',{staticClass:"col-xs-2",staticStyle:{"width":"50px","height":"50px"}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"href":item.product_url}},[((item.product_item_image && (item.product_item_image != '')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":_vm.img_product_url + item.product_item_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('h5',[_vm._v(_vm._s(item.product_name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_vm._v("\r\n                                        QTY: "+_vm._s(item.product_item_order_quantity)+"\r\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('label',{staticStyle:{"display":"inline"}},[_vm._v("Price: ")]),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(item.product_item_price))])])])}))}))])])])]):_c('div',{staticClass:"container",staticStyle:{"margin-top":"1em"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 col-xs-12"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Checkout")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"border":"solid 1px #e0dfdf","padding":"2em"}},[_c('div',{staticClass:"row cktop ck-card-row"},[_c('div',{staticClass:"pull-left"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]),_vm._v(" "),_c('div',{staticClass:"pull-right "},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.payment_details.payment_ref))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("₦"+_vm._s(_vm.total_orders_amount))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ckbody"},_vm._l((_vm.checkout_orders),function(group,index){return _c('div',{staticClass:"group-row",staticStyle:{"margin-bottom":"6em"}},[_vm._l((group.order_items),function(item){return _c('div',{staticClass:"row ck-card-row"},[_c('div',{staticClass:"col-md-2",staticStyle:{"width":"75px","height":"75px"}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"href":item.product_url}},[((item.product_item_group_image && (item.product_item_group_image != '')))?_c('img',{staticClass:"sp-prd-img",attrs:{"src":item.product_item_group_image}}):_c('img',{staticClass:"sp-prd-img",attrs:{"src":"/static/assets/images/dummy-image.png"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('h5',[_vm._v(_vm._s(item.product_name))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_vm._v("\r\n                                            QTY: "+_vm._s(item.order_item_quantity)+"\r\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('span',{staticClass:"price"},[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(item.product_item_price))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(item.order_item_delivery_fee != 0)?_c('div',{staticClass:"row pull-right",staticStyle:{"margin-right":"3px"}},[_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v("Product Shipping Fee: ")]),_vm._v("₦"+_vm._s(item.order_item_delivery_fee)+"\r\n                                        ")]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"pull-left col-md-6"},[_vm._m(0,true),_vm._v(" "),((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0)))?_c('div',[_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"-2em"}},[_c('label',[_vm._v("Select State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_order_shipping_details_state),expression:"selected_order_shipping_details_state"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_order_shipping_details_state=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getCities()}]}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])})],2)]),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e(),_vm._v(" "),(_vm.cities.length != 0)?_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"-2em"}},[_c('label',[_vm._v("Select Location")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_order_shipping_details_city),expression:"selected_order_shipping_details_city"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_order_shipping_details_city=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.cities),function(city){return _c('option',{domProps:{"value":city.city_id}},[_vm._v(_vm._s(city.city_name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"0.3em"}},[_c('label',[_vm._v("Shipping Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_order_shipping_details_address),expression:"selected_order_shipping_details_address"}],staticClass:"form-control input-group-lg",attrs:{"type":"text","placeholder":"Shipping Address"},domProps:{"value":(_vm.selected_order_shipping_details_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected_order_shipping_details_address=$event.target.value}}})])]):_c('div',[_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"-2em"}},[_c('label',[_vm._v("Select State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_order_shipping_details_state),expression:"selected_order_shipping_details_state"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_order_shipping_details_state=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getCities(_vm.selected_order_shipping_details_state)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{domProps:{"value":state.state_id}},[_vm._v(_vm._s(state.name))])})],2),_vm._v(" "),(_vm.action_loading)?_c('div',{staticClass:"loading-sm"}):_vm._e()]),_vm._v(" "),(_vm.cities.length != 0)?_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"1em"}},[_c('label',[_vm._v("Select Location")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_order_shipping_details_city),expression:"selected_order_shipping_details_city"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_order_shipping_details_city=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":undefined}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.cities),function(city){return _c('option',{domProps:{"value":city.city_id}},[_vm._v(_vm._s(city.city_name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"0.3em"}},[_c('label',[_vm._v("Shipping Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_order_shipping_details_address),expression:"selected_order_shipping_details_address"}],staticClass:"form-control input-group-lg",attrs:{"type":"text","placeholder":"Shipping Address"},domProps:{"value":(_vm.selected_order_shipping_details_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected_order_shipping_details_address=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('div',[_c('p',{staticClass:"tiny-part"},[_vm._v("Total Orders ₦"+_vm._s(_vm.total_orders_amount))]),_vm._v(" "),(_vm.checkout_orders)?_c('span',[_c('p',{staticClass:"tiny-part"},[_vm._v("Shipping Fee:  ₦"+_vm._s(_vm.total_shipping_fee))]),_vm._v(" "),_c('p',{staticClass:"tiny-part"},[_vm._v("Total: ₦"+_vm._s(_vm.total_orders_amount + _vm.total_shipping_fee))])]):_c('span',[_vm._m(1,true)])])])])],2)}))]),_vm._v(" "),((_vm.selected_order_shipping_details_state != '') && (_vm.selected_order_shipping_details_city != '') && (_vm.selected_order_shipping_details_address != ''))?_c('div',{staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"background":"#000000"},on:{"click":_vm.processPaymentMini}},[_vm._v("Make Payment")])]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticStyle:{"margin":"1em 1em 2.2em 0.5em"}},[_vm._v("Shipping Details\r\n                                                    "),_c('p',{staticStyle:{"color":"#ff0000"}},[_vm._v("Please enter your Shipping Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tiny-part"},[_c('b',[_vm._v("Shipping Details:")]),_vm._v(" {{}}")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f32d14a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f32d14a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f32d14a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gw-info-wrap",staticStyle:{"background":"#ffffff"}},[(_vm.loading)?_c('div',{staticClass:"col-md-6 col-md-offset-4 col-xs-12"},[_c('div',{staticClass:"loading-md"})]):_c('div',[_c('div',{staticClass:"container",staticStyle:{"margin-top":"1em"}},[(_vm.orders.set)?_c('div',{staticClass:"col-sm-12 card",staticStyle:{"margin-bottom":"2em"}},[_c('h1',{staticClass:"card-title"},[_vm._v("Your Orders")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"orders-panel"},[_c('table',{staticClass:"table table-striped"},[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Ordered From")]),_vm._v(" "),_c('th',[_vm._v("Order Total")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_vm._l((_vm.orders),function(order){return _c('tr',[_c('td',[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"modal","data-backdrop":"false","data-target":"#ordersModal"},on:{"click":function($event){_vm.setOrder(order)}}},[_c('span',{staticStyle:{"color":"#df4d4d"}},[_c('u',[_c('b',[_vm._v(_vm._s(order.order_no))])])]),_c('br'),_vm._v("\r\n                        "+_vm._s(order.order_date)+"\r\n                        "),_c('br'),_vm._v(" "),_c('span',{staticClass:"p-tiny"},[_vm._v("Tap to view")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.order_business))]),_vm._v(" "),_c('td',[_c('small',[_vm._v("₦")]),_vm._v(_vm._s(order.order_total))]),_vm._v(" "),_c('td',[_c('span',{style:({color:order.order_payment_status_color})},[_vm._v(_vm._s(order.order_payment_status))])])])})],2)])]):_c('p',[_vm._v("No orders yet")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"margin-top":"7em"},attrs:{"id":"ordersModal","role":"dialog"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Order No "+_vm._s(_vm.order.order_no))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_c('b',[_vm._v("Order No: ")]),_vm._v(_vm._s(_vm.order.order_no))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Order Date: ")]),_vm._v(_vm._s(_vm.order.order_date))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('th',[_vm._v(" ")]),_vm._v(" "),_c('th',[_vm._v("Item")]),_vm._v(" "),_vm._l((_vm.order.order_items),function(item){return _c('tr',[_c('td',[_c('img',{attrs:{"src":_vm.img_product_url + item.product_item_group_image,"height":"50","width":"50"}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.product_name)+" - "+_vm._s(item.order_delivery_city))])])})],2),_vm._v(" "),_c('p',[_c('b',[_vm._v("Order Payment Mode: ")]),_c('span',{style:({color:_vm.order.order_payment_status_color})},[_vm._v(_vm._s(_vm.order.order_payment_status))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Order Status: ")]),_c('span',{style:({color:_vm.order.order_payment_status_color})},[_vm._v(_vm._s(_vm.order.order_payment_status))])]),_vm._v(" "),_c('div',[_c('p',[_c('b',[_vm._v("Delivery Fee Details:  ")]),_vm._v(_vm._s(_vm.order.order_delivery_not_set))])]),_vm._v(" "),_c('div',[_c('p',[_c('b',[_vm._v("Delivery Location:  ")]),_vm._v(_vm._s(_vm.order.order_delivery_city))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Delivery Address:  ")]),_vm._v(_vm._s(_vm.order.order_user_delivery_address))])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Order Items")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2abcc14f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2abcc14f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2abcc14f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-offset-2 col-md-8",staticStyle:{"margin-top":"4em"}},[_c('cart-widget')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(250);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    reducer: function reducer(state) {
        return {
            cart: state.cart
            // keepThisModuleToo: state.keepThisModuleToo
            // getRidOfThisModule: state.getRidOfThisModule (No one likes it.)
        };
    }
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        //all users
        //users: [],
        //all sellpoints
        sellpoints: [],
        //a sellpoint
        sellpoint: {},
        //all products
        products: [],
        //a product
        product: {},
        // bought items
        cart: [],
        // ajax loader
        showLoader: false
    },
    // GETTERS
    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__getters__["b" /* productGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["c" /* sellpointGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* cartGetters */]),
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* productMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* sellpointMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* cartMutations */]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* productActions */], __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* sellpointActions */])
}));

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sellpointGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cartGetters; });
//sellpoints
var sellpointGetters = {
  // All sellpoints
  allSellpoints: function allSellpoints(state, getters) {
    return state.sellpoints;
  },

  // Get Sellpoint by ID
  sellpointById: function sellpointById(state, getters) {
    return function (id) {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.sellpoint;
      }
    };
  }

  //products
};var productGetters = {
  // All products
  allProducts: function allProducts(state, getters) {
    return state.products;
  },
  // Get Product by ID
  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.product;
      }
    };
  }

  //cart
};var cartGetters = {
  //return cart
  cartProducts: function cartProducts(state) {
    return state.added.map(function (_ref) {
      var id = _ref.id,
          quantity = _ref.quantity;

      var product_item = state.all.find(function (p) {
        return p._id === id;
      });

      return {
        name: product.name,
        price: product.price,
        quantity: quantity
      };
    });
  }
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sellpointMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cartMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(10);


var _sellpointMutations, _productMutations, _cartMutations;



//

//sellpoints
var sellpointMutations = (_sellpointMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ALL_SELLPOINTS */], function (state) {
  state.showLoader = true;
  // this[]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ALL_SELLPOINTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.sellpoints = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* ERROR_MSG */], function (state, payload) {}), _sellpointMutations);

//products
var productMutations = (_productMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ALL_PRODUCTS */], function (state) {
  state.showLoader = true;
  // this[]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PRODUCT_BY_ID */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* ERROR_MSG */], function (state, payload) {}), _productMutations);

//cart
var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* VIEW_CART */], function (state) {
  return state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ADD_TO_CART */], function (state, payload) {
  state.cart.push(payload);
  state.cart = state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* REMOVE_FROM_CART */], function (state, payload) {
  var index = state.cart.findIndex(function (p) {
    return p._id === payload;
  });
  state.cart.splice(index, 1);
}), _cartMutations);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);





//sellpoint
var sellpointActions = {
  allSellpoints: function allSellpoints(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* ALL_SELLPOINTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/businesses', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* ALL_SELLPOINTS_SUCCESS */], response.data);
    });
  }
};

//product
var productActions = {
  allProducts: function allProducts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ALL_PRODUCTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/products', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ALL_PRODUCTS_SUCCESS */], response.data);
    });
  }
};

//CART

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASE; });
/* unused harmony export imageURL */
var API_BASE = 'http://localhost/kokoeco/dev/koko/v1/api/';
var imageURL = 'http://localhost/kokoeco/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

/***/ })
],[104]);


// WEBPACK FOOTER //
// static/js/app.31961c7879478688278f.js